webpackJsonp([1],{

/***/ "+/eX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue__ = __webpack_require__("oipo");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfbe625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCpf_vue__ = __webpack_require__("ZIfE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCpf_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3bfbe625_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCpf_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+1Ym":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue__ = __webpack_require__("3IQc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adbf0da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCodigoNcmTabela_vue__ = __webpack_require__("h5eE");
function injectStyle (ssrContext) {
  __webpack_require__("PXE4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcmTabela_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6adbf0da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCodigoNcmTabela_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+50g":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-veiculo',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#veiculoDescricao').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.descricao);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#veiculoDescricao').val(clean.descricao);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/buscarVeiculosAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "+9oD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatoriosTelemetria"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.length > 0)?[_c('div',{attrs:{"id":"relatorioTelemetriaViagemGeral"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"table-layout":"fixed"},attrs:{"id":"tableRelatorioTelemetriaViagemGeral"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeInicio),expression:"dados.latitudeInicio"}],attrs:{"id":'latitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeInicio),expression:"dados.longitudeInicio"}],attrs:{"id":'longitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeFim),expression:"dados.latitudeFim"}],attrs:{"id":'latitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeFim", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeFim),expression:"dados.longitudeFim"}],attrs:{"id":'longitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeFim", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.veiculoDescricao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataInicial))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataFinal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemDistancia))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemTempo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoParado))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoParadoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoMovimento))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoMovimentoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoExcessoVelocidade))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoExcessoVelocidadePercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMaxima))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMedia))])]),_vm._v(" "),_c('td',[(dados.motoristaNome !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motoristaNome))])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade'),expression:"'Excesso de Velocidade'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidade))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso Velocidade na Chuva'),expression:"'Excesso Velocidade na Chuva'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeChuva))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade dentro de cerca'),expression:"'Excesso de Velocidade dentro de cerca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeCerca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Aceleração Brusca'),expression:"'Aceleração Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaAceleracaoBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Freada Brusca'),expression:"'Freada Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaFreadaBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Mudança Faixa Brusca'),expression:"'Mudança Faixa Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMudancaFaixaBrusca))])])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Total de Transgressões'),expression:"'Total de Transgressões'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaTotalTransgressoes))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMediaPorKm))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaClassificacao))])])])}))])])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Telemetria - Viagem Geral")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v("Fenix Sat Ltda\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"250"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Periodo")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Distância")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Tempo")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. Parado")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Movimento\t")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Excesso")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Max")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Média")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Motorista")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Transgressões")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Média por km")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Classificação")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+Gxq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__ = __webpack_require__("/Put");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("/1Lr")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_table_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "+ewa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.clienteNomeFantasia))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.clienteNome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.rg))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+ghM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-data-hora-picker',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('99/99/9999 99:99:99');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99/99/9999 99:99:99');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "+hW6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoVeiculo","to":"/veiculos"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab1"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Placa:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.placa),expression:"model.placa"}],staticClass:"pula form-control placa",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.placa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "placa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8 col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"pula form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Data Cadastro:")]),_c('br'),_vm._v(" "),(_vm.model.id === 0)?[_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataCadastroRastreamento),callback:function ($$v) {_vm.$set(_vm.model, "dataCadastroRastreamento", $$v)},expression:"model.dataCadastroRastreamento"}})]:[_c('input-data-picker',{staticClass:"pula data form-control",attrs:{"readonly":"readonly"},model:{value:(_vm.model.dataCadastroRastreamento),callback:function ($$v) {_vm.$set(_vm.model, "dataCadastroRastreamento", $$v)},expression:"model.dataCadastroRastreamento"}})]],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Modelo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.modelo),expression:"model.modelo"}],staticClass:"pula form-control",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.modelo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "modelo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Marca:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.marca),expression:"model.marca"}],staticClass:"pula form-control",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.marca)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "marca", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-1 col-md-1"},[_c('label',{staticClass:"control-label"},[_vm._v("Ano Fab.:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.anoFabricacao),expression:"model.anoFabricacao"}],staticClass:"pula form-control",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.anoFabricacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "anoFabricacao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-1 col-md-1"},[_c('label',{staticClass:"control-label"},[_vm._v("Ano Mod.:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.anoModelo),expression:"model.anoModelo"}],staticClass:"pula form-control",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.anoModelo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "anoModelo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Km Atual:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.kmAtual),expression:"model.kmAtual"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.kmAtual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "kmAtual", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta de Roubo Ativado:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.alertaRoubo),expression:"model.alertaRoubo"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "alertaRoubo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}}),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}})])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                          Rastreamento\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Senha Identificação:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.senhaIdentificacao),expression:"model.senhaIdentificacao"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.senhaIdentificacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "senhaIdentificacao", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                          Análises\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Velocidade Máxima:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.velocidadeMaxima),expression:"model.velocidadeMaxima"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.velocidadeMaxima)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "velocidadeMaxima", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Tensao Bateria Minima:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tensaoBateriaMinima),expression:"model.tensaoBateriaMinima"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.tensaoBateriaMinima)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tensaoBateriaMinima", $event.target.value)}}})])])])])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tab1","data-toggle":"tab"}},[_vm._v("Geral")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+j2k":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoCliente","to":"/motoristas"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tabGeral"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Ativo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ativo),expression:"model.ativo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Data Nascimento:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataNascimento),callback:function ($$v) {_vm.$set(_vm.model, "dataNascimento", $$v)},expression:"model.dataNascimento"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Tipo Jornada:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoJornadaAjudante),expression:"model.tipoJornadaAjudante"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tipoJornadaAjudante", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"T","label":"Total"}},[_vm._v("Total")])])])]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.clienteId),expression:"model.clienteId"}],attrs:{"type":"hidden","id":"clienteId"},domProps:{"value":(_vm.model.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"clienteNome","name":"clienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarCliente,"on-blur":_vm.verificarCliente},model:{value:(_vm.model.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.model, "clienteNomeFantasia", $$v)},expression:"model.clienteNomeFantasia"}})],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label",attrs:{"id":"label-documento"}},[_vm._v("Documento:")]),_c('br'),_vm._v(" "),_c('input-cpf',{staticClass:"pula form-control",model:{value:(_vm.model.documento),callback:function ($$v) {_vm.$set(_vm.model, "documento", $$v)},expression:"model.documento"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("RG:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.rg),expression:"model.rg"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.rg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rg", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-10 col-md-10"},[_c('label',{staticClass:"control-label"},[_vm._v("Endereço:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.endereco),expression:"model.endereco"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.endereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "endereco", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Número:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numero),expression:"model.numero"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-8 col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Complemento:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.complemento),expression:"model.complemento"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "complemento", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Bairro:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bairro),expression:"model.bairro"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "bairro", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Cidade:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cidadeId),expression:"model.cidadeId"}],attrs:{"type":"hidden","id":"cidadeId"},domProps:{"value":(_vm.model.cidadeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cidadeId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cidade',{attrs:{"type":"search","id":"cidadeNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarCidade,"on-blur":_vm.verificarCidade},model:{value:(_vm.model.cidadeNome),callback:function ($$v) {_vm.$set(_vm.model, "cidadeNome", $$v)},expression:"model.cidadeNome"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("CEP:")]),_c('br'),_vm._v(" "),_c('input-cep',{staticClass:"pula form-control",attrs:{"id":"cidadeCep"},model:{value:(_vm.model.cep),callback:function ($$v) {_vm.$set(_vm.model, "cep", $$v)},expression:"model.cep"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Estado:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.estado),expression:"model.estado"}],staticClass:"pula form-control",attrs:{"id":"cidadeEstado"},domProps:{"value":(_vm.model.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "estado", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Telefone:")]),_c('br'),_vm._v(" "),_c('input-telefone',{staticClass:"pula form-control",model:{value:(_vm.model.telefone),callback:function ($$v) {_vm.$set(_vm.model, "telefone", $$v)},expression:"model.telefone"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Celular:")]),_c('br'),_vm._v(" "),_c('input-telefone-celular',{staticClass:"pula form-control",model:{value:(_vm.model.celular),callback:function ($$v) {_vm.$set(_vm.model, "celular", $$v)},expression:"model.celular"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-1 col-md-1"},[_c('label',{staticClass:"control-label"},[_vm._v("WhatsApp:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.whatsapp),expression:"model.whatsapp"}],staticClass:"pula",attrs:{"id":"whatsapp","name":"whatsapp","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.whatsapp)?_vm._i(_vm.model.whatsapp,null)>-1:(_vm.model.whatsapp)},on:{"change":function($event){var $$a=_vm.model.whatsapp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "whatsapp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "whatsapp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "whatsapp", $$c)}}}}),_vm._v(" "),_vm._m(2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Operadora:")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"#","id":"consultaOperadora"},on:{"click":function($event){_vm.buscarOperadora(_vm.model.celular)}}},[_c('img',{attrs:{"src":"/static/images/buscar.png"}})]),_vm._v(" "),_c('img',{attrs:{"id":"logoCelularOperadora","src":'/static/images/'+_vm.model.celularOperadora+'.png'}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.celularOperadora),expression:"model.celularOperadora"}],staticClass:"pula form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.model.celularOperadora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "celularOperadora", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("E-mail:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("CNH:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cnh),expression:"model.cnh"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.cnh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cnh", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Primeira CNH:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.primeiraCnh),expression:"model.primeiraCnh"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.primeiraCnh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "primeiraCnh", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Tipo CNH:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoCnh),expression:"model.tipoCnh"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.tipoCnh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "tipoCnh", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Vencimento CNH:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vencimentoCnh),expression:"model.vencimentoCnh"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.vencimentoCnh)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "vencimentoCnh", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Cód. Empresa:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.codigoEmpresa),expression:"model.codigoEmpresa"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.codigoEmpresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "codigoEmpresa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Cód. Rastreador:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.codigoRastreador),expression:"model.codigoRastreador"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.codigoRastreador)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "codigoRastreador", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Login:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.login),expression:"model.login"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Senha:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.senha),expression:"model.senha"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.senha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "senha", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Número Pis:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numeroPis),expression:"model.numeroPis"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.numeroPis)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numeroPis", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-4"},[_c('label',[_vm._v("Cargo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cargo),expression:"model.cargo"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.cargo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cargo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Empresa CNPJ:")]),_c('br'),_vm._v(" "),_c('input-cnpj',{staticClass:"pula form-control",model:{value:(_vm.model.empresaCnpj),callback:function ($$v) {_vm.$set(_vm.model, "empresaCnpj", $$v)},expression:"model.empresaCnpj"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-5 col-md-5"},[_c('label',[_vm._v("Empresa Nome:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.empresaNome),expression:"model.empresaNome"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.empresaNome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empresaNome", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-5 col-md-5"},[_c('label',[_vm._v("Empresa Endereço:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.empresaEndereco),expression:"model.empresaEndereco"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.empresaEndereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empresaEndereco", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Observação:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao),expression:"model.observacao"}],staticClass:"pula form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.model.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabJornada"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Horário da Jornada Controlado:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.jornadaHorarioControlado),expression:"model.jornadaHorarioControlado"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "jornadaHorarioControlado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Tolerancia Inicio Fim de Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioFimJornadaTolerancia),callback:function ($$v) {_vm.$set(_vm.model, "inicioFimJornadaTolerancia", $$v)},expression:"model.inicioFimJornadaTolerancia"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Macro Fora Horário Almoço:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.macroForaMargemHorarioAlmoco),expression:"model.macroForaMargemHorarioAlmoco"}],staticClass:"form-control",attrs:{"required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "macroForaMargemHorarioAlmoco", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"03"}},[_vm._v("03 - Espera")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05 - Descanso Direcao")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("34 - Diaria")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Tipo Controle Jornada:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoControleJornada),expression:"model.tipoControleJornada"}],staticClass:"form-control",attrs:{"required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tipoControleJornada", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("I-button")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Teclado virtual")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Código Motorista Cadastro Empresa:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.codigoCadastroEmpresa),expression:"model.codigoCadastroEmpresa"}],staticClass:"form-control pula hora",domProps:{"value":(_vm.model.codigoCadastroEmpresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "codigoCadastroEmpresa", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Segunda a Quinta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSegundaQuinta", $$v)},expression:"model.inicioJornadaSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Fim Jornada Segunda a Quinta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSegundaQuinta", $$v)},expression:"model.fimJornadaSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSegundaQuinta", $$v)},expression:"model.margemInicioAlmocoSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSegundaQuinta", $$v)},expression:"model.margemFinalAlmocoSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSegundaQuinta", $$v)},expression:"model.jornadaDuracaoSegundaQuinta"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Sexta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSexta),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSexta", $$v)},expression:"model.inicioJornadaSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Fim Jornada Sexta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSexta),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSexta", $$v)},expression:"model.fimJornadaSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSexta),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSexta", $$v)},expression:"model.margemInicioAlmocoSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSexta),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSexta", $$v)},expression:"model.margemFinalAlmocoSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSexta),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSexta", $$v)},expression:"model.jornadaDuracaoSexta"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Sábado:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSabado),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSabado", $$v)},expression:"model.inicioJornadaSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Final Jornada Sábado:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSabado),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSabado", $$v)},expression:"model.fimJornadaSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSabado),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSabado", $$v)},expression:"model.margemInicioAlmocoSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSabado),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSabado", $$v)},expression:"model.margemFinalAlmocoSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSabado),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSabado", $$v)},expression:"model.jornadaDuracaoSabado"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Domingo:")]),_c('br'),_vm._v(" "),_c('input-hora-picker',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaDomingo),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaDomingo", $$v)},expression:"model.inicioJornadaDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Final Jornada Domingo:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaDomingo),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaDomingo", $$v)},expression:"model.fimJornadaDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoDomingo", $$v)},expression:"model.margemInicioAlmocoDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoDomingo", $$v)},expression:"model.margemFinalAlmocoDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoDomingo", $$v)},expression:"model.jornadaDuracaoDomingo"}})],1)])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Motorista")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tabGeral","data-toggle":"tab"}},[_vm._v("Geral")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabJornada","data-toggle":"tab"}},[_vm._v("Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"id":"abrirWhatsApp","href":"#"}},[_c('img',{attrs:{"src":"/static/images/whatsapp.png"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+uNH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    }
  }
};

/***/ }),

/***/ "/1Lr":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/J54":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{ref:"input",attrs:{"type":"text","placeholder":_vm.placeholder},domProps:{"value":_vm.value}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/Muj":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "/NIs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue__ = __webpack_require__("SMuX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08303dc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTelefoneCelular_vue__ = __webpack_require__("cCPU");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefoneCelular_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_08303dc4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTelefoneCelular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "/Put":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _table = __webpack_require__("fnDg");

var _table2 = _interopRequireDefault(_table);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _table2.default;

/***/ }),

/***/ "/XTD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"auth-layout"},[_c('div',{staticClass:"nav hidden-lg-up"},[_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1),_vm._v(" "),_c('div',{staticClass:"main row"},[_c('div',{staticClass:"auth-content col-lg-6 col-12"},[_c('router-view')],1),_vm._v(" "),_c('div',{staticClass:"auth-wallpaper col-6 hidden-md-down"},[_c('div',{staticClass:"oblique"}),_vm._v(" "),_c('router-link',{staticClass:"i-vuestic",attrs:{"to":{path: '/'}}})],1)])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/bd8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-hora-picker',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('99:99:99');
    $(this.$el).timepicker({
      dateFormat: '',
      timeFormat: 'HH:mm:ss',
      closeText: 'Fechar',
      prevText: '&#x3c;Anterior',
      nextText: 'Pr&oacute;ximo&#x3e;',
      currentText: 'Agora',
      monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      weekHeader: 'Sm',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
      onSelect: function onSelect(date) {
        vmm.$emit('input', date);
      }
    });
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  methods: {
    setValue: function setValue(date) {
      $(this.$el).val(date);
    }
  },
  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99:99:99');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "/nOG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var entrada = this.$route.params.entrada;
      var entradaVelocidade = this.$route.params.entradaVelocidade;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDeAnaliseTrabalhoProducaoSintetico?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&entrada=' + entrada + '&entradaVelocidade=' + entradaVelocidade;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    }
  }
};

/***/ }),

/***/ "/pYe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-financeiro',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,
    readonly: Boolean,
    errors: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#' + this.id).val(val);
    },

    verificarLancamentoFinanceiro: function verificarLancamentoFinanceiro() {
      if ($(this.$el).find('#clienteId').val() === 0) {
        this.clienteId = 0;
        this.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.clienteId = 0;
        this.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      console.log($(this.$el).find('#clienteNome').val());
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        var novoId = this.id.split('_')[1];
        this.onBlur(e, novoId);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeLancamento);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        var novoId = this.id.split('_')[1];
        this.onSelect(clean, novoId);
        $(this.$el).find('#' + this.id).val(clean.nomeLancamento);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarFinanceiroMovimentos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "/yRs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__ = __webpack_require__("gkTP");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__ = __webpack_require__("X/gF");
function injectStyle (ssrContext) {
  __webpack_require__("EhHL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_streetViewPanorama_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_50f7f8d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_streetViewPanorama_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ 0:
/***/ (function(module, exports) {

/* (ignored) */

/***/ }),

/***/ "0L0x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue__ = __webpack_require__("VUMS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fae0a1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCidade_vue__ = __webpack_require__("k/fU");
function injectStyle (ssrContext) {
  __webpack_require__("1SYf")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCidade_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0fae0a1b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0Ln6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue__ = __webpack_require__("nUSz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37daf491_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTexto_vue__ = __webpack_require__("OSPL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTexto_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_37daf491_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTexto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "0mNe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      macro: {
        id: '0',
        dataHora: '',
        serial: '',
        latitude: 0,
        longitude: 0,
        macro: '',
        macroTexto: '',
        motoristaId: 0,
        motoristaNome: '',
        veiculoId: 0,
        veiculoDescricao: '',
        bateria: '',
        mac: '',
        tipoTextoLivre: '',
        textoLivre: ''
      },
      botaoProcessando: false,
      showModalEditarMacro: false,
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      inicioJornadaManual: false,
      finalJornadaManual: false,
      dataHoraInicialJornadaManual: '',
      dataHoraFinalJornadaManual: '',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosAnalise: [],
      dadosAnaliseMacros: [],
      dadosAnaliseProblemas: '',
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.gerarAnalise();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    gerarAnalise: function gerarAnalise() {
      var self = this;
      self.processando = true;
      var jornadaMacroId = this.$route.params.jornadaMacroId;
      var dataHoraInicial = this.$route.params.dataInicial;
      var dataHoraFinal = this.$route.params.dataFinal;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/v2/gestaoJornadas/gerarJornadaMacros?jornadaMacroId=' + jornadaMacroId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
      });
    },
    gravarAnalise: function gravarAnalise() {
      var self = this;
      var jornadaMacroId = this.$route.params.jornadaMacroId;
      var dataHoraInicial = this.$route.params.dataInicial;
      var dataHoraFinal = this.$route.params.dataFinal;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      self.processando = true;
      var url = '/api/v2/gestaoJornadas/gerarJornadaMacrosGravar?jornadaMacroId=' + jornadaMacroId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
        self.$router.replace('/gestaoJornada');
      });
    },
    editarMacro: function editarMacro(macroId) {
      var self = this;
      self.buscarMacro(macroId);
      self.showModalEditarMacro = true;
    },
    buscarMacro: function buscarMacro(macroId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/v2/gestaoJornadas/' + macroId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        var dados = response.data;
        self.macro.id = dados.id;
        self.macro.dataHora = dados.dataHora;
        self.macro.serial = dados.serial;
        self.macro.latitude = dados.latitude;
        self.macro.longitude = dados.longitude;
        self.macro.macro = dados.macro;
        self.macro.macroTexto = dados.macroTexto;
        self.macro.motoristaId = dados.motoristaId;
        self.macro.motoristaNome = dados.motoristaNome;
        self.macro.veiculoId = dados.veiculoId;
        self.macro.veiculoDescricao = dados.veiculoDescricao;
        self.macro.bateria = dados.bateria;
        self.macro.mac = dados.mac;
        self.macro.tipoTextoLivre = dados.tipoTextoLivre;
        self.macro.textoLivre = dados.textoLivre;
        console.log(self.macro);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deletarMacro: function deletarMacro(id) {
      var _this = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Macro?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/v2/gestaoJornadas/' + id;
          _axios2.default.delete(url, config).then(function (response) {
            console.log(response);
            if (response.status === 200) {
              self.$toastr('success', 'Macro deletada com sucesso.', 'Atenção');
              self.gerarAnalise();
              dialog.close();
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.macro.motoristaId = motorista.id;
      this.macro.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.macro.motoristaId = 0;
        this.macro.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.macro.motoristaId = 0;
        this.macro.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.macro.veiculoId = veiculo.id;
      this.macro.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.macro.veiculoId = 0;
        this.macro.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.macro.veiculoId = 0;
        this.macro.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    adicionarMacro: function adicionarMacro() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '';
      if (self.macro.id === 0) {
        url = '/api/v2/gestaoJornadas/salvar';
        _axios2.default.post(url, (0, _stringify2.default)(self.macro), config).then(function (response) {
          console.log(response);
          if (response.status === 201) {
            self.processando = false;
            self.gerarAnalise();
            self.showModalEditarMacro = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        url = '/api/v2/gestaoJornadas/editar';
        _axios2.default.put(url, (0, _stringify2.default)(self.macro), config).then(function (response) {
          console.log(response);
          if (response.status === 200) {
            self.processando = false;
            self.gerarAnalise();
            self.showModalEditarMacro = false;
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
};

/***/ }),

/***/ "1+km":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"readonly":_vm.readonly,"autocomplete":"off","on-blur":_vm.verificarLancamentoFinanceiro},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.titular))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nomeLancamento))]),_vm._v(" - "),_c('small',[_vm._v("Lanc.: "+_vm._s(data.dataLancamento))]),_vm._v(" - "),_c('small',[_vm._v("Venc.: "+_vm._s(data.dataVencimento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "15F0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue__ = __webpack_require__("k9zN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699039f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoNovo_vue__ = __webpack_require__("2IOv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoNovo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_699039f9_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoNovo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1QwG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1SYf":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "1TUT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue__ = __webpack_require__("JpoZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637b0ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesObdTripView_vue__ = __webpack_require__("ycH7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdTripView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_637b0ad2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesObdTripView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1WfN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue__ = __webpack_require__("mHzP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2120dcf5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosLista_vue__ = __webpack_require__("sUT7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2120dcf5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "1nNA":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "2IOv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotorista)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motoristaId),expression:"motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motoristaId=$event.target.value}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.motoristaNome),callback:function ($$v) {_vm.motoristaNome=$$v},expression:"motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotorista}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotorista = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.dividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.dividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Recalcular e Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/gestaoJornada"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Data: ")]),_vm._v("De: "+_vm._s(_vm.jornada.dataHoraInicial)+" até "+_vm._s(_vm.jornada.dataHoraFinal)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.jornada.veiculoDescricao)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(" "+_vm._s(_vm.jornada.motoristaNome)),_c('br'),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.showModalMudarMotorista = true}}},[_vm._v("Mudar motorista")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(7),_vm._v(" "),_vm._l((_vm.jornadaItens),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_c('small',[_vm._v(_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.observacao))])]),_vm._v(" "),_c('td',[(grid.statusVeiculo === 'VEICULO PARADO')?[_vm._m(8,true)]:_vm._e()],2)])])})],2),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAbastecimento)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAdicionalNoturno)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAlimentacao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoCargaDescarga)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDescansoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoFiscalizacao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraIndenizada)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoJornada)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoManutencao)+" ")]),_c('br')])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dividir Tempo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motivo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"onclick":"dividirJornada(500209)","href":"#"}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 text-center"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('strong',[_vm._v("TOTAIS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-11 text-right"},[_vm._v("\n              Tempo em Abastecimento: "),_c('br'),_vm._v("\n              Tempo em Adicional Noturno: "),_c('br'),_vm._v("\n              Tempo em Alimentação: "),_c('br'),_vm._v("\n              Tempo em Carga e Descarga: "),_c('br'),_vm._v("\n              Tempo em Descanso de Dirção: "),_c('br'),_vm._v("\n              Tempo em Direção: "),_c('br'),_vm._v("\n              Tempo em Fiscalização: "),_c('br'),_vm._v("\n              Tempo em Hora Extra Normal 1:"),_c('br'),_vm._v("\n              Tempo em Hora Extra Normal 2: "),_c('br'),_vm._v("\n              Tempo em Hora Extra Noturna 1:"),_c('br'),_vm._v("\n              Tempo em Hora Extra Noturna 2: "),_c('br'),_vm._v("\n              Tempo em Hora Indenizada: "),_c('br'),_vm._v("\n              Tempo em Jornada: "),_c('br'),_vm._v("\n              Tempo em Manutenção: "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2QPb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__ = __webpack_require__("a5Lw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a045e286_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__ = __webpack_require__("ED8O");
function injectStyle (ssrContext) {
  __webpack_require__("1nNA")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a045e286"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a045e286_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseTrabalhoProducaoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2Rxb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatoriosTelemetria"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.length > 0)?[_c('div',{attrs:{"id":"relatorioTelemetriaViagemGeral"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"table-layout":"fixed"},attrs:{"id":"tableRelatorioTelemetriaViagemGeral"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeInicio),expression:"dados.latitudeInicio"}],attrs:{"id":'latitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeInicio),expression:"dados.longitudeInicio"}],attrs:{"id":'longitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeFim),expression:"dados.latitudeFim"}],attrs:{"id":'latitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeFim", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeFim),expression:"dados.longitudeFim"}],attrs:{"id":'longitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeFim", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.veiculoDescricao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataInicial))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataFinal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemDistancia))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemTempo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoParado))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoParadoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoMovimento))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoMovimentoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoExcessoVelocidade))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoExcessoVelocidadePercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMaxima))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMedia))])]),_vm._v(" "),_c('td',[(dados.motoristaNome !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motoristaNome))])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade'),expression:"'Excesso de Velocidade'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidade))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso Velocidade na Chuva'),expression:"'Excesso Velocidade na Chuva'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeChuva))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade dentro de cerca'),expression:"'Excesso de Velocidade dentro de cerca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeCerca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Aceleração Brusca'),expression:"'Aceleração Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaAceleracaoBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Freada Brusca'),expression:"'Freada Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaFreadaBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Mudança Faixa Brusca'),expression:"'Mudança Faixa Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMudancaFaixaBrusca))])])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Total de Transgressões'),expression:"'Total de Transgressões'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaTotalTransgressoes))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMediaPorKm))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaClassificacao))])])])}))])])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Telemetria - Viagem por Veiculo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v("Fenix Sat Ltda\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"250"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Periodo")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Distância")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Tempo")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. Parado")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Movimento\t")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Excesso")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Max")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Média")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Motorista")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Transgressões")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Média por km")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Classificação")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "2Sb2":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue__ = __webpack_require__("+50g");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd59de7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarVeiculo_vue__ = __webpack_require__("F0rU");
function injectStyle (ssrContext) {
  __webpack_require__("5QDE")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVeiculo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5fd59de7_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarVeiculo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2m9g":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue__ = __webpack_require__("LmXX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226209c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesObdView_vue__ = __webpack_require__("VYFL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesObdView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_226209c2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesObdView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "2s0f":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "387/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue__ = __webpack_require__("/bd8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d6b77a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputHoraPicker_vue__ = __webpack_require__("fUAX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_95d6b77a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputHoraPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3CUm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue__ = __webpack_require__("zewB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_017ffdf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarMotorista_vue__ = __webpack_require__("+ewa");
function injectStyle (ssrContext) {
  __webpack_require__("SCsL")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarMotorista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_017ffdf8_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarMotorista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "3IPf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.showModalMensagem)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('br'),_c('br'),_vm._v(" "),_c('h1',{staticClass:"text-center"},[_vm._v(_vm._s(_vm.mensagemAlerta))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMensagem = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{attrs:{"id":"veiculoPeriodo"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"lista-veiculos"}},[_c('h3',{staticClass:"panel-title"},[_vm._v("Veículo:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.veiculoId),expression:"veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.veiculoId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clienteId),expression:"clienteId"}],staticClass:"form-control",attrs:{"id":"clienteId","type":"hidden"},domProps:{"value":(_vm.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clienteId=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscaVeiculo),expression:"buscaVeiculo"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","placeholder":"Filtrar veículo","type":"text"},domProps:{"value":(_vm.buscaVeiculo)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarGrid($event)},"input":function($event){if($event.target.composing){ return; }_vm.buscaVeiculo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-lock",on:{"click":_vm.buscarGrid}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{attrs:{"id":"dados-analise-jornada-lista-veiculos"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dadosGrid),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosGrid[i].clienteIdVeiculo != _vm.dadosGrid[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))])])])],2)})],2)])])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"opcoesRelatorio"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataInicial),callback:function ($$v) {_vm.dataInicial=$$v},expression:"dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Hora inicial: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker',{staticClass:"form-control pula hora",model:{value:(_vm.horaInicial),callback:function ($$v) {_vm.horaInicial=$$v},expression:"horaInicial"}})],1)]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Análise\n                      ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$auth.check('P116'))?[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-danger btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarAnaliseFrota}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Análise Frota\n                        ")])])]:_vm._e()],2)])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Análise de Jornadas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Análise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Período:")]),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('small',[_vm._v("*Os dados de rastreamento ficam armazenados por 90 dias.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "3IQc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-codigoncmtabela',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#codigoNcmNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#codigoNcmNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarCodigosNcmsTabelas?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "3kV7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":{'Data': 'data', 'Parado': 'tempoParadoTotal',  'Deslocamento': 'tempoDeslocamentoTotal',
              'Distância': 'kmRodadosTotal', 'Distância Odômetro': 'kmRodadosTotalOdometro', 'Velocidade Máxima': 'velocidadeMaximaTotal', 'Velocidade Média': 'velocidadeMediaTotal' },"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Parado : ' + _vm.dadosRelatorios.tempoParadoTotal  + '  Deslocamento : ' + _vm.dadosRelatorios.tempoDeslocamentoTotal + '  Distância Percorrida: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosTotal) + 'Km' + '\n  Distância Percorrida GPS: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosTotalOdometro) + ' Km ' + '\n  Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMediaTotal) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaximaTotal) + ' Km/h ',"worksheet":"My Worksheet","name":"filename.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+" \n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.data))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoParadoTotal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoDeslocamentoTotal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.kmRodadosTotal))+" / "+_vm._s(_vm.formatarVelocidade(dados.kmRodadosTotalOdometro))+" Km")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMaximaTotal))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMediaTotal))+" Km/h")])])])}))]),_vm._v(" "),_c('div',{staticClass:"pull-right"},[_c('strong',[_vm._v("Parado:")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.tempoParadoTotal)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Deslocamento:")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.tempoDeslocamentoTotal)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Distância Percorrida:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosTotal))+" Km "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Velocidade Média:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMediaTotal))+" Km/h "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Velocidade Máxima:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaximaTotal))+" Km/h "),_c('br')])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Análise de Trabalho Sintético")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"100"}},[_vm._v("DATA")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}},[_vm._v("PARADO")]),_vm._v(" "),_c('th',{attrs:{"width":"180"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',[_vm._v("DISTANCIA")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("VEL MAX")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("VEL MEDIA")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4+kY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue__ = __webpack_require__("L6Ed");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfc60d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputQuantidade10_vue__ = __webpack_require__("i6Kr");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade10_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_adfc60d2_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputQuantidade10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "4/sl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"id":"btnNovoVeiculo","to":"/pontos/novo"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_vm._m(1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaPontos","width":"100%"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(ponto){return _c('tr',{class:{ 'selecionado': _vm.selecionado(ponto) },on:{"click":function($event){_vm.selecionarItem(ponto)},"dblclick":function($event){_vm.editar(ponto.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":ponto.id}}),_vm._v(" "),(ponto.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(ponto.id))]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(ponto.codigo))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(ponto.descricao))]),_vm._v(" "),_c('br')]),_vm._v(" "),_c('td',{staticClass:"text-right",attrs:{"width":"80"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'PontosEditar', params: { id: ponto.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),(false)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(ponto.id)}}})]:_vm._e()],2)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Pontos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Descricao")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4De/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: true,
        nome: '',
        avisoVenda: false,
        bloqueadoVenda: false
      }
    };
  },

  created: function created() {
    this.buscar();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadasConvencoes/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;
        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.nome = dados.nome;
        self.model.avisoVenda = dados.avisoVenda;
        self.model.bloqueadoVenda = dados.bloqueadoVenda;
      });
    },
    salvar: function salvar() {
      var self = this;
      console.log((0, _stringify2.default)(self.model));
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/jornadasConvencoes/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.$router.replace('/conceitos');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ "4Teq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('span',{domProps:{"textContent":_vm._s(_vm.label)}}),_vm._v(" "),_c('input',{ref:"input",class:_vm.className,attrs:{"type":"text","placeholder":_vm.placeholder}})])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "4yen":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default
  },
  data: function data() {
    return {
      model: {
        id: '0',
        erpId: '0',
        mobileId: '0',
        ativo: true,
        tipoCliente: 'F',
        tipoCadastro: '',
        dataCadastro: '',
        dataAniversario: '',
        nomeFantasia: '',
        nome: '',
        documento: '',
        rg: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        inscricaoSuframa: '',
        inscricaoEstadualSubTributario: '',
        regimeTributario: '1',
        tipoConsumidor: '0',
        contribuinteIcms: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '0',
        cidadeNome: '',
        cep: '',
        estado: '',
        contato: '',
        telefone: '',
        celular: '',
        whatsapp: '',
        celularOperadora: '',
        email: '',
        vendedorId: '0',
        vendedor: '',
        conceitoId: '1',
        conceito: {},
        formaPagamentoPadrao: '0',
        produtoTabelaPrecoPadrao: '0',
        site: '',
        observacao: '',
        enderecos: [],
        contatos: [],
        controlaFinanceiro: true,
        creditoFinanceiroMovimento: '',
        limiteCredito: '',
        limiteCreditoUtilizado: '',
        pontosFidelidade: 0,
        possuiDebito: false,
        bloqueadoSpc: false,
        ecommerceAtivo: false,
        ecommerceId: '',
        ecommerceEmail: '',
        ecommerceNome: '',
        ecommerceSobrenome: '',
        ecommerceDocumento: '',
        ecommerceTelefone: '',
        ecommerceCreditoLoja: '0',
        status: ''
      },
      isentoInscricaoEstadual: false,
      isentoInscricaoMunicipal: false,
      conceitos: [],
      formasPagamentos: [],
      tabelasPrecos: [],
      vendedores: [],
      clienteCreditoFinanceiro: [],
      historicoFinanceiro: [],
      historicoCheques: [],
      vendasProdutos: [],
      vendasServicos: [],
      interacoes: [],
      perfilClienteGraficoVendas: null,
      vendasPeriodo: '12',
      vendasPeriodoAgrupamento: 'S',
      vendasProdutosMaisVendidosPeriodo: '12',
      vendasProdutosMaisVendidosPeriodoAgrupamento: 'V',
      vendasPeriodoLabels: [],
      vendasPeriodoDados: [],
      vendasProdutosMaisVendidosPeriodoDados: [],
      exibirFinanceiro: 30,
      exibirFinanceiroCredito: 30,
      exibirFinanceiroCheques: 30,
      showModalProdutosRelacionados: false,
      selecionadosFinanceiros: [],
      selecionadosCreditos: [],
      selecionadosCheques: []
    };
  },

  created: function created() {
    this.buscar();
    this.buscarConceitos();
    this.buscarFormasPagamentos();
    this.buscarTabelasPrecos();
    this.buscarVendedores();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token, 'connection': 'keep-alive' }
      };
      var url = '/api/clientes/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        console.log(response.data.nomeFantasia);
        var dados = response.data;
        self.model.id = dados.id;
        self.model.erpId = dados.erpId;
        self.model.mobileId = dados.mobileId;
        self.model.ativo = dados.ativo;
        self.model.tipoCliente = dados.tipoCliente;
        self.model.tipoCadastro = dados.tipoCadastro;
        self.model.dataCadastro = dados.dataCadastro;
        self.model.dataAniversario = dados.dataAniversario;
        self.model.nomeFantasia = dados.nomeFantasia;
        self.model.nome = dados.nome;
        self.model.documento = dados.documento;
        self.model.rg = dados.rg;
        self.model.inscricaoEstadual = dados.inscricaoEstadual;
        if (self.model.inscricaoEstadual === 'ISENTO') {
          self.isentoInscricaoEstadual = true;
        }
        self.model.inscricaoMunicipal = dados.inscricaoMunicipal;
        if (self.model.inscricaoMunicipal === 'ISENTO') {
          self.isentoInscricaoMunicipal = true;
        }
        self.model.inscricaoSuframa = dados.inscricaoSuframa;
        self.model.inscricaoEstadualSubTributario = dados.inscricaoEstadualSubTributario;
        self.model.regimeTributario = dados.regimeTributario;
        self.model.tipoConsumidor = dados.tipoConsumidor;
        self.model.contribuinteIcms = dados.contribuinteIcms;
        self.model.endereco = dados.endereco;
        self.model.numero = dados.numero;
        self.model.complemento = dados.complemento;
        self.model.bairro = dados.bairro;
        if (dados.cidade !== null) {
          self.model.cidadeId = dados.cidade.id;
          self.model.cidadeNome = dados.cidade.cidade;
        }
        self.model.cep = dados.cep;
        self.model.estado = dados.estado;
        self.model.contato = dados.contato;
        self.model.telefone = dados.telefone;
        self.model.celular = dados.celular;
        self.model.whatsapp = dados.whatsapp;
        self.model.celularOperadora = dados.celularOperadora;
        self.model.email = dados.email;
        if (dados.vendedor !== null) {
          self.model.vendedorId = dados.vendedor.id;
          self.model.vendedorNome = dados.vendedor.nomeFantasia;
        }
        if (dados.conceito !== null) {
          self.model.conceitoId = dados.conceito.id;
          self.model.conceitoNome = dados.conceito.nome;
        }
        if (dados.formaPagamentoPadrao !== null) {
          self.model.formaPagamentoPadrao = dados.formaPagamentoPadrao.id;
        }
        if (dados.produtoTabelaPrecoPadrao !== null) {
          self.model.produtoTabelaPrecoPadrao = dados.produtoTabelaPrecoPadrao.id;
        }
        self.model.site = dados.site;
        self.model.observacao = dados.observacao;

        self.model.controlaFinanceiro = dados.controlaFinanceiro;
        self.model.creditoFinanceiroMovimento = dados.creditoFinanceiroMovimento;
        self.model.limiteCredito = dados.limiteCredito;
        self.model.limiteCreditoUtilizado = dados.limiteCreditoUtilizado;
        self.model.pontosFidelidade = dados.pontosFidelidade;
        self.model.possuiDebito = dados.possuiDebito;
        self.model.bloqueadoSpc = dados.bloqueadoSpc;
        self.model.ecommerceAtivo = dados.ecommerceAtivo;
        self.model.ecommerceId = dados.ecommerceId;
        self.model.ecommerceEmail = dados.ecommerceEmail;
        self.model.ecommerceNome = dados.ecommerceNome;
        self.model.ecommerceSobrenome = dados.ecommerceSobrenome;
        self.model.ecommerceDocumento = dados.ecommerceDocumento;
        self.model.ecommerceTelefone = dados.ecommerceTelefone;
        self.model.ecommerceCreditoLoja = dados.ecommerceCreditoLoja;
        self.model.status = dados.status;
        self.model.conceito = dados.conceito;
      });
    },
    buscarConceitos: function buscarConceitos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarConceitos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.conceitos = dados;
      });
    },
    buscarFormasPagamentos: function buscarFormasPagamentos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarFormasPagamentos?busca=&tipo=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.formasPagamentos = dados;
      });
    },
    buscarTabelasPrecos: function buscarTabelasPrecos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarProdutosTabelasPrecos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.tabelasPrecos = dados;
      });
    },
    buscarVendedores: function buscarVendedores() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVendedores?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.vendedores = dados;
      });
    },
    buscarEnderecos: function buscarEnderecos() {
      var self = this;
      if (self.model.enderecos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesEnderecos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.model.enderecos = dados;
        });
      }
    },
    buscarContatos: function buscarContatos() {
      var self = this;
      if (self.model.contatos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesContatos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.model.contatos = dados;
        });
      }
    },
    buscarHistoricoCredito: function buscarHistoricoCredito() {
      var self = this;
      if (self.clienteCreditoFinanceiro.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesCreditos?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCredito;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.clienteCreditoFinanceiro = dados;
        });
      }
    },
    selecionarCreditoItem: function selecionarCreditoItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCreditos.includes(item)) {
          var p = this.selecionadosCreditos.indexOf(item);
          this.selecionadosCreditos.splice(p, 1);
        } else {
          this.selecionadosCreditos.push(item);
        }
      } else {
        this.selecionadosCreditos = [];
        this.selecionadosCreditos.push(item);
      }
    },
    selecionadoCredito: function selecionadoCredito(item) {
      return this.selecionadosCreditos.includes(item);
    },
    buscarHistoricoFinanceiro: function buscarHistoricoFinanceiro() {
      var self = this;

      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/clienteHistoricoFinanceiro?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiro;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.historicoFinanceiro = dados;
      });
    },
    selecionarFinanceiroItem: function selecionarFinanceiroItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosFinanceiros.includes(item)) {
          var p = this.selecionadosFinanceiros.indexOf(item);
          this.selecionadosFinanceiros.splice(p, 1);
        } else {
          this.selecionadosFinanceiros.push(item);
        }
      } else {
        this.selecionadosFinanceiros = [];
        this.selecionadosFinanceiros.push(item);
      }
    },
    selecionadoFinanceiro: function selecionadoFinanceiro(item) {
      return this.selecionadosFinanceiros.includes(item);
    },
    buscarHistoricoCheque: function buscarHistoricoCheque() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/clienteHistoricoCheque?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCheques;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.historicoCheques = dados;
      });
    },
    selecionarChequeItem: function selecionarChequeItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCheques.includes(item)) {
          var p = this.selecionadosCheques.indexOf(item);
          this.selecionadosCheques.splice(p, 1);
        } else {
          this.selecionadosCheques.push(item);
        }
      } else {
        this.selecionadosCheques = [];
        this.selecionadosCheques.push(item);
      }
    },
    selecionadoCheque: function selecionadoCheque(item) {
      return this.selecionadosCheques.includes(item);
    },
    valorTotalPagarFinanceiro: function valorTotalPagarFinanceiro(financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor;
          }
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor;
          }
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalPagoFinanceiro: function valorTotalPagoFinanceiro(financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago;
          }
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago;
          }
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalCredito: function valorTotalCredito(financeiroMovimento) {
      if (this.selecionadosCreditos.length > 1) {
        return this.selecionadosCreditos.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalCheque: function valorTotalCheque(financeiroMovimento) {
      if (this.selecionadosCheques.length > 1) {
        return this.selecionadosCheques.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      }
    },
    buscarHistoricoVendas: function buscarHistoricoVendas() {
      var self = this;
      if (self.vendasProdutos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/clientesHistoricoVendasProdutos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.vendasProdutos = dados;
        });
      }
      if (self.vendasServicos.length === 0) {
        url = '/api/clientesHistoricoVendasServicos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.vendasServicos = dados;
        });
      }
    },
    buscarHistoricoInteracoes: function buscarHistoricoInteracoes() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/clientesHistoricoInteracoes/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.interacoes = dados;
      });
    },
    buscarOperadora: function buscarOperadora(numero) {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/consutarOperadora?celular=' + numero;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.model.celularOperadora = response.data;
      });
    },
    setIsentoInscricaoEstadual: function setIsentoInscricaoEstadual() {
      if (this.isentoInscricaoEstadual === false) {
        this.model.inscricaoEstadual = 'ISENTO';
      } else {
        this.model.inscricaoEstadual = '';
      }
    },
    setIsentoInscricaoMunicipal: function setIsentoInscricaoMunicipal() {
      if (this.isentoInscricaoMunicipal === false) {
        this.model.inscricaoMunicipal = 'ISENTO';
      } else {
        this.model.inscricaoMunicipal = '';
      }
    },
    setarCidade: function setarCidade(cidade) {
      this.model.cidadeId = cidade.id;
      this.model.cidadeNome = cidade.cidade;
      this.model.cep = cidade.cep;
      this.model.estado = cidade.estado;
      $(this.$el).find('#cidadeNome').val(cidade.cidade);
      $(this.$el).find('#cidadeCep').val(cidade.cep);
      $(this.$el).find('#cidadeEstado').val(cidade.estado);
    },
    verificarCidade: function verificarCidade() {
      if ($(this.$el).find('#cidadeId').val() === '0') {
        this.model.cidadeId = 0;
        this.model.cidadeNome = '';
        this.model.cep = '';
        this.model.estado = '';
        $(this.$el).find('#cidadeId').val(0);
        $(this.$el).find('#cidadeNome').val('');
        $(this.$el).find('#cidadeCep').val('');
        $(this.$el).find('#cidadeEstado').val('');
      }
      if ($(this.$el).find('#cidadeNome').val() === '') {
        this.model.cidadeId = 0;
        this.model.cidadeNome = '';
        this.model.cep = '';
        this.model.estado = '';
        $(this.$el).find('#cidadeId').val(0);
        $(this.$el).find('#cidadeNome').val('');
        $(this.$el).find('#cidadeCep').val('');
        $(this.$el).find('#cidadeEstado').val('');
      }
    },
    setarCidadeEndereco: function setarCidadeEndereco(cidade, i) {
      console.log('Item: ' + i);
      this.model.enderecos[i].cidadeId = cidade.id;
      this.model.enderecos[i].cidadeNome = cidade.cidade;
      this.model.enderecos[i].cep = cidade.cep;
      this.model.enderecos[i].estado = cidade.estado;
      $(this.$el).find('#enderecosCidadeNome_' + i).val(cidade.cidade);
      $(this.$el).find('#enderecosCidadeCep_' + i).val(cidade.cep);
      $(this.$el).find('#enderecosCidadeEstado_' + i).val(cidade.estado);
    },
    adicionarEndereco: function adicionarEndereco() {
      var self = this;
      self.model.enderecos.push({
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        pontoReferencia: '',
        cidadeId: '0',
        cidade: '',
        cep: '',
        tipoEnderecoId: '0'
      });
    },
    removerEndereco: function removerEndereco(i) {
      var self = this;
      self.model.enderecos.splice(i, 1);
    },
    adicionarContato: function adicionarContato() {
      var self = this;
      self.model.contatos.push({
        nome: '',
        telefone: '',
        email: ''
      });
    },
    removerContato: function removerContato(i) {
      var self = this;
      self.model.contatos.splice(i, 1);
    },
    buscarPerfilCliente: function buscarPerfilCliente() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/vendasPeriodo?periodo=' + this.vendasPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento + '&clienteId=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var periodos = [];
        for (var i = 0; i < response.data.length; i++) {
          periodos.push(response.data[i].periodo + '/' + response.data[i].ano);
        }
        var valores = [];
        for (var _i = 0; _i < response.data.length; _i++) {
          valores.push(response.data[_i].valorTotalVenda);
        }
        self.perfilClienteGraficoVendas = {
          labels: periodos,
          datasets: [{
            label: 'Vendas',
            backgroundColor: '#79c447',
            data: valores
          }]
        };
      });
      url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento + '&clienteId=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.vendasProdutosMaisVendidosPeriodoDados = response.data;
      });
    },
    imprimirVendaProduto: function imprimirVendaProduto(vendaProdutoId) {
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/vendas/imprimirVenda?id=' + vendaProdutoId + '&exibirCliente=1&exibirMarca=1&exibirPreco=1&exibirPrecoPadrao=0&exibirPromissoria=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
      });
    },
    visualizarFinanceiro: function visualizarFinanceiro(movimento) {
      window.open('/financeiroMovimentoVisualizar/' + movimento.id, '_blank');
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/clientes/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Cliente gravado com sucesso.', 'Atenção');
              self.$router.replace('/clientes');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "5PFb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        dataInicial: this.$store.state.filtrosGestaoJornada.dataInicial === '' ? this.primeiroDiaMes('') : this.$store.state.filtrosGestaoJornada.dataInicial,
        dataFinal: this.$store.state.filtrosGestaoJornada.dataFinal === '' ? this.ultimoDiaMes('') : this.$store.state.filtrosGestaoJornada.dataFinal,
        buscas: this.$store.state.filtrosGestaoJornada.buscas,
        status: this.$store.state.filtrosGestaoJornada.status
      },
      jornada: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        veiculoId: '0',
        veiculoDescricao: '',
        tipoJornada: '1'
      },
      relatorio: {
        tipo: '1',
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        buscas: ''
      },
      exportarPontos: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes('')
      },
      dadosTabela: [],
      selecionadas: [],
      motoristas: [],
      motoristasSelecionados: [],
      dadosMotoristas: [],
      selecionadasMotoristas: [],
      selecionada: '',
      processando: false,
      botaoProcessando: false,
      showModalNovaJornada: false,
      showModalRelatorioSintetico: false,
      showModalExportarPontos: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
    this.buscar();
    this.buscarTodosMotoristas();
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item;
      if (event.ctrlKey || event.metaKey) {
        this.selecionadas.push(item);
      } else {
        this.selecionadas = [];
        this.selecionadas.push(item);
      }
    },
    selecionado: function selecionado(item) {
      for (var i = 0; i < this.selecionadas.length; i++) {
        if (this.selecionadas[i].id === item.id) {
          return true;
        }
      }
      return false;
    },
    buscarTodosMotoristasRelatorio: function buscarTodosMotoristasRelatorio() {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/buscarMotoristasAtivos?busca=' + self.relatorio.buscas;
      _axios2.default.get(url, config).then(function (response) {
        self.dadosMotoristas = response.data.slice();
        self.selecionadasMotoristas = response.data.slice();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    selecionarMotoristaItem: function selecionarMotoristaItem(item, event) {
      this.selecionadaMotorista = item;
      if (this.selecionadoMotorista(item)) {
        this.removerMotorista(item);
      } else {
        this.selecionadasMotoristas.push(item);
      }
    },
    selecionadoMotorista: function selecionadoMotorista(item) {
      for (var i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          return true;
        }
      }
      return false;
    },
    removerMotorista: function removerMotorista(item) {
      for (var i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          console.log('Remove ' + item);
          this.selecionadasMotoristas.splice(i, 1);
        }
      }
    },
    selecionadoMotoristaTodos: function selecionadoMotoristaTodos() {
      this.selecionadasMotoristas = this.dadosMotoristas.slice();
    },
    selecionadoMotoristaLimpar: function selecionadoMotoristaLimpar() {
      this.selecionadasMotoristas = [];
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar() {
      var self = this;
      this.$store.commit('SET_FILTROS_GESTAO_JORNADA', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.processando = false;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/gestaoJornada/editar/' + id);
    },
    juntarJornada: function juntarJornada(id) {
      var _this = this;

      var self = this;
      if (self.selecionadas.length !== 2) {
        self.$toastr('error', 'Selecione duas Jornadas para Combinar.', 'Atenção');
        return;
      }
      var message = 'Deseja realmente combinar essas Jornadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/juntarJornada?jornadaUmId=' + self.selecionadas[0].id + '&jornadaDoisId=' + self.selecionadas[1].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas combinadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao combinar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    abrirModalRelatorioSintetico: function abrirModalRelatorioSintetico() {
      this.buscarTodosMotoristasRelatorio();
      this.showModalRelatorioSintetico = true;
    },
    duplicarJornada: function duplicarJornada(id) {
      var _this2 = this;

      var self = this;
      if (self.selecionadas.length === 0) {
        return;
      }
      if (self.selecionadas.length > 1) {
        return;
      }
      var message = 'Deseja realmente duplicar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this2.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/duplicar?id=' + self.selecionadas[0].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornada duplicada com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao duplicar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    deletarMultiplas: function deletarMultiplas(id) {
      var _this3 = this;

      var self = this;
      var message = 'Deseja realmente deletar todas as Jornada listadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this3.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/deletarMultiplas?buscas=' + _this3.filtros.buscas + '&dataInicial=' + _this3.filtros.dataInicial + '&dataFinal=' + _this3.filtros.dataFinal + '&status=' + _this3.filtros.status;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas deletadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao deletar as Jornadas', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    recalcularJornadas: function recalcularJornadas(id) {
      var _this4 = this;

      var self = this;
      var message = 'Deseja realmente recalcular todas as Jornada listadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this4.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/recalcularJornadas?buscas=' + _this4.filtros.buscas + '&dataInicial=' + _this4.filtros.dataInicial + '&dataFinal=' + _this4.filtros.dataFinal + '&status=' + _this4.filtros.status;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas recalculadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao recalcular as Jornadas', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.relatorio.motoristaId = motorista.id;
      this.relatorio.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    setarMotoristaNovaJornada: function setarMotoristaNovaJornada(motorista) {
      this.jornada.motoristaId = motorista.id;
      this.jornada.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNovaJornadaNome').val(motorista.nome);
    },
    verificarMotoristaNovaJornada: function verificarMotoristaNovaJornada() {
      if ($(this.$el).find('#motoristaNovaJornadaId').val() === '0') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
      if ($(this.$el).find('#motoristaNovaJornadaNome').val() === '') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
    },
    buscarTodosMotoristas: function buscarTodosMotoristas() {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/buscarMotoristasAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        self.motoristas = response;
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    setarVeiculoNovaJornada: function setarVeiculoNovaJornada(veiculo) {
      this.jornada.veiculoId = veiculo.idVeiculo;
      this.jornada.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoNovaJornadaDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculoNovaJornada: function verificarVeiculoNovaJornada() {
      if ($(this.$el).find('#veiculoNovaJornadaId').val() === '0') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
      if ($(this.$el).find('#veiculoNovaJornadaDescricao').val() === '') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
    },
    imprimir: function imprimir(id) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarRelatorioSintetico: function gerarRelatorioSintetico(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '';
      if (this.relatorio.tipo === 1 || this.relatorio.tipo === '1') {
        url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      } else {
        url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      }
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarRelatorioSinteticoMotoristas: function gerarRelatorioSinteticoMotoristas() {
      var _this5 = this;

      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };

      var _loop = function _loop(i) {
        url = '';

        if (_this5.relatorio.tipo === 1 || _this5.relatorio.tipo === '1') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + _this5.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this5.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        } else if (_this5.relatorio.tipo === 2 || _this5.relatorio.tipo === '2') {
          url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + _this5.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this5.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        } else if (_this5.relatorio.tipo === 3 || _this5.relatorio.tipo === '3') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?teste=1&dataHoraInicio=' + _this5.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this5.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        }
        _axios2.default.get(url, config).then(function (response) {
          var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf;name=document.pdf;' }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('filename', 'file.pdf');
          if (self.relatorio.tipo === 1 || self.relatorio.tipo === '1') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          } else if (self.relatorio.tipo === 3 || self.relatorio.tipo === '3') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          } else {
            link.setAttribute('download', 'RelatorioTempoAlimentacao_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          }
          link.setAttribute('target', '_blank');
          document.getElementById('imprimirLinks').appendChild(link);
          link.click();
          self.processando = false;
          self.botaoProcessando = false;
        }).catch(function (error) {
          console.log(error);
          self.processando = false;
          self.botaoProcessando = false;
        });
      };

      for (var i = 0; i < self.selecionadasMotoristas.length; i++) {
        var url;

        _loop(i);
      }
    },
    gerarNovaJornada: function gerarNovaJornada(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/novo?dataHoraInicio=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId + '&tipoJornada=' + this.jornada.tipoJornada;
      _axios2.default.get(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.showModalNovaJornada = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarJornadaAjudante: function gerarJornadaAjudante(jornada, ajudante) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/gravarJornadaAjudante?jornada=' + jornada + '&ajudante=' + ajudante;
      _axios2.default.get(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarExportarPontos: function gerarExportarPontos() {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/exportarPontos?dataInicial=' + self.exportarPontos.dataInicial + '&dataFinal=' + self.exportarPontos.dataFinal;
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/text' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('download', 'ExportacaoPonto_' + self.exportarPontos.dataInicial.replace('/', '') + '_' + self.exportarPontos.dataFinal.replace('/', '') + '.txt');
        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    deletar: function deletar(id) {
      var _this6 = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this6.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/gestaoJornadas/deletar?id=' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção');
              self.buscar();
              dialog.close();
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "5QDE":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5TR5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-fornecedor',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#fornecedorNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#fornecedorNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarFornecedoresAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "5ZbH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__ = __webpack_require__("GY//");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__ = __webpack_require__("zfG0");
function injectStyle (ssrContext) {
  __webpack_require__("Liod")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_map_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_6839df3e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_map_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5cLx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__ = __webpack_require__("El0Z");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__ = __webpack_require__("NuQ6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_infoWindow_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_25e3f758_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_infoWindow_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "5vBt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue__ = __webpack_require__("DS/V");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555b7c07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadas_vue__ = __webpack_require__("3IPf");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadas_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_555b7c07_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadas_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "61q0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      context: 'login context',
      isLoading: false,
      mensagem: '',
      loaded: false,
      data: {
        body: {
          username: '',
          password: ''
        },
        rememberMe: true,
        fetchUser: true
      },
      error: null
    };
  },
  ready: function ready() {
    var _this = this;

    setTimeout(function () {
      _this.loaded = true;
    }, 500);
  },
  mounted: function mounted() {
    console.log(this.$auth.redirect());
  },

  methods: {
    login: function login() {
      var _this2 = this;

      this.isLoading = true;
      var redirect = this.$auth.redirect();
      this.$auth.login({
        body: this.data.body,
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: { name: redirect ? redirect.from.name : 'account' },
        fetchUser: this.data.fetchUser
      }).then(function () {
        var token = _this2.$auth.token();
        _this2.$store.commit('SET_AUTH_TOKEN', token);
        _this2.isLoading = false;
      }, function (res) {
        console.log('error ' + _this2.context);
        _this2.error = res.data;
        console.log(_this2.error);
        _this2.mensagem = 'Usuário ou Senha incorretos. Verifique e tente novamente.';
        _this2.isLoading = false;
      });
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    },
    unimpersonate: function unimpersonate() {
      this.$auth.unimpersonate({
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    }
  }
};

/***/ }),

/***/ "6KT8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__ = __webpack_require__("QYRB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25892d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__ = __webpack_require__("FLhB");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_layout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25892d78_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_layout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6Ucv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"login-backgroud"},[_c('div',{staticClass:"vertical-center"},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 col-sm-3"}),_vm._v(" "),_c('div',{staticClass:"col-md-6 col-sm-6"},[_c('div',{staticClass:"login-card card card-default"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('form',{attrs:{"name":"loginForm","data-toggle":"validator","role":"form"},on:{"submit":function($event){$event.preventDefault();_vm.login()}}},[_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticStyle:{"color":"red","word-wrap":"break-word"}}),_vm._v(" "),_c('div',{staticClass:"form-group has-feedback inner-addon left-addon"},[_c('label',[_vm._v("Usuário")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],staticClass:"form-control",attrs:{"placeholder":"Usuário","autofocus":"","type":"text","name":"username","required":""},domProps:{"value":(_vm.data.body.username)},on:{"click":function($event){_vm.mensagem = ''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "username", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-user"})]),_vm._v(" "),_c('div',{staticClass:"form-group inner-addon left-addon"},[_c('label',[_vm._v("Senha")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],staticClass:"form-control",attrs:{"placeholder":"Senha","type":"password","value":"","name":"password","required":""},domProps:{"value":(_vm.data.body.password)},on:{"click":function($event){_vm.mensagem = ''},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "password", $event.target.value)}}}),_vm._v(" "),_c('i',{staticClass:"fa fa-lock"})]),_vm._v(" "),_c('div',{staticClass:"form-group"},[(_vm.mensagem !== '')?[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(_vm.mensagem))])]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.rememberMe),expression:"data.rememberMe"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.data.rememberMe)?_vm._i(_vm.data.rememberMe,null)>-1:(_vm.data.rememberMe)},on:{"change":function($event){var $$a=_vm.data.rememberMe,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.data, "rememberMe", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.data, "rememberMe", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.data, "rememberMe", $$c)}}}}),_vm._v(" Lembrar ")])],2),_vm._v(" "),_c('div',{staticClass:"form-group"},[_c('input',{attrs:{"type":"hidden","name":"${_csrf.parameterName}","value":"${_csrf.token}"}}),_vm._v(" "),_c('button',{staticClass:"btn btn-primary btn-block",attrs:{"type":"submit"}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Login\n                  ")])])]),_vm._v(" "),_vm._m(1)])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3 col-sm-3"})])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-header text-center"},[_c('img',{staticClass:"img img-fluid",attrs:{"src":"/static/images/logo.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('span',{staticClass:"copyright"},[_c('small',[_vm._v("Spark Software. Todos os direitos reservados")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6bfs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"value":"0"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "6gxo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue__ = __webpack_require__("EiHW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1080a035_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarVendedor_vue__ = __webpack_require__("pTu9");
function injectStyle (ssrContext) {
  __webpack_require__("NBAS")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarVendedor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1080a035_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarVendedor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6kCs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue__ = __webpack_require__("SJXc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e6fa35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatoriosTelemetria_vue__ = __webpack_require__("CDVM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatoriosTelemetria_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_69e6fa35_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatoriosTelemetria_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "6pwD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalMudarMotivo: false,
      showModalEditarMacro: false,
      macro: {
        id: '0',
        dataHora: '',
        serial: '',
        latitude: 0,
        longitude: 0,
        macro: '',
        macroTexto: '',
        motoristaId: 0,
        motoristaNome: '',
        veiculoId: 0,
        veiculoDescricao: '',
        bateria: '',
        mac: '',
        tipoTextoLivre: '',
        textoLivre: ''
      },
      botaoProcessando: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: '',
      mudarMotivoId: '0',
      selecionada: '0',
      selecionados: [],
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      places: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  created: function created() {
    this.buscar();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        this.selecionados = [];
        this.selecionados.push(item);
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/v2/gestaoJornadas/buscarJornadaMacros?motoristaId=' + this.$route.params.motoristaId + '&dataHoraInicial=' + this.$route.params.dataInicial + '&dataHoraFinal=' + this.$route.params.dataFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornada = dados;
      });
    },
    mudarMotorista: function mudarMotorista() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotorista = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    editarMacro: function editarMacro(macroId) {
      var self = this;
      self.buscarMacro(macroId);
      self.showModalEditarMacro = true;
    },
    buscarMacro: function buscarMacro(macroId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/v2/gestaoJornadas/' + macroId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        var dados = response.data;
        self.macro.id = dados.id;
        self.macro.dataHora = dados.dataHora;
        self.macro.serial = dados.serial;
        self.macro.latitude = dados.latitude;
        self.macro.longitude = dados.longitude;
        self.macro.macro = dados.macro;
        self.macro.macroTexto = dados.macroTexto;
        self.macro.motoristaId = dados.motoristaId;
        self.macro.motoristaNome = dados.motoristaNome;
        self.macro.veiculoId = dados.veiculoId;
        self.macro.veiculoDescricao = dados.veiculoDescricao;
        self.macro.bateria = dados.bateria;
        self.macro.mac = dados.mac;
        self.macro.tipoTextoLivre = dados.tipoTextoLivre;
        self.macro.textoLivre = dados.textoLivre;
        console.log(self.macro);
      }).catch(function (error) {
        console.log(error);
      });
    },
    deletarMacro: function deletarMacro(id) {
      var _this = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Macro?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/v2/gestaoJornadas/' + id;
          _axios2.default.delete(url, config).then(function (response) {
            console.log(response);
            if (response.status === 200) {
              self.$toastr('success', 'Macro deletada com sucesso.', 'Atenção');
              self.buscar();
              dialog.close();
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.macro.motoristaId = motorista.id;
      this.macro.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.macro.motoristaId = 0;
        this.macro.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.macro.motoristaId = 0;
        this.macro.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      console.log('selecionado: ' + veiculo);
      this.macro.veiculoId = veiculo.idVeiculo;
      this.macro.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.macro.veiculoId = 0;
        this.macro.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.macro.veiculoId = 0;
        this.macro.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    adicionarMacro: function adicionarMacro() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '';
      if (self.macro.id === 0) {
        url = '/api/v2/gestaoJornadas/salvar';
        _axios2.default.post(url, (0, _stringify2.default)(self.macro), config).then(function (response) {
          console.log(response);
          if (response.status === 201) {
            self.processando = false;
            self.buscar();
          }
        }).catch(function (error) {
          console.log(error);
        });
      } else {
        url = '/api/v2/gestaoJornadas/editar';
        _axios2.default.put(url, (0, _stringify2.default)(self.macro), config).then(function (response) {
          console.log(response);
          if (response.status === 200) {
            self.processando = false;
            self.buscar();
            console.log(self.macro.macro);
            if (self.macro.macro === '0' || self.macro.macro === '1') {
              self.$router.replace('/analiseJornadaTabela');
            } else {
              self.showModalEditarMacro = false;
            }
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    }
  }
};

/***/ }),

/***/ "6rdH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue__ = __webpack_require__("7SWe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4bcbb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPercentual_vue__ = __webpack_require__("N1PV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPercentual_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4a4bcbb6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPercentual_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7Blq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7SWe":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-percentual',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: '',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: '.',
      affixesStay: true
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "7UY5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue__ = __webpack_require__("kOYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffbeb394_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputMonetario_vue__ = __webpack_require__("LcV4");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ffbeb394_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputMonetario_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7uFO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__ = __webpack_require__("jdWM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a74545_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__ = __webpack_require__("Y5Fq");
function injectStyle (ssrContext) {
  __webpack_require__("Jjzc")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Index_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33a74545_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Index_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "7z+T":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue__ = __webpack_require__("5PFb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b30e1f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasLista_vue__ = __webpack_require__("EP7J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b30e1f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "8ZWN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue__ = __webpack_require__("Qx6j");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e3f074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAcionamentoDeEntradaView_vue__ = __webpack_require__("RkKk");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_61e3f074_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAcionamentoDeEntradaView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "90Hy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue__ = __webpack_require__("mx+7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15651520_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoEditar_vue__ = __webpack_require__("TiHD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_15651520_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "98li":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotorista)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motoristaId),expression:"motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motoristaId=$event.target.value}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.motoristaNome),callback:function ($$v) {_vm.motoristaNome=$$v},expression:"motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotorista}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotorista = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalEditarMacro)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.macro.dataHora),callback:function ($$v) {_vm.$set(_vm.macro, "dataHora", $$v)},expression:"macro.dataHora"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.macro),expression:"macro.macro"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.macro, "macro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("01 - INICIO JORNADA")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("02 - FIM JORNADA")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("03 - ESPERA")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("04 - ALIMENTACAO")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("05 - DESCANSO DIRECAO")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("06 - ABASTECIMENTO")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("07 - FISCALIZACAO")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("08 - MANUTECAO")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("21 - EMBARQUE")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("22 - DESEMBARQUE")]),_vm._v(" "),_c('option',{attrs:{"value":"33"}},[_vm._v("34 - EM ATIVIDADE")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("51 - TEXTO")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("101 - MOVIMENTO")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.motoristaId),expression:"macro.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.macro.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.macro, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.macro.motoristaNome),callback:function ($$v) {_vm.$set(_vm.macro, "motoristaNome", $$v)},expression:"macro.motoristaNome"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.veiculoId),expression:"macro.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.macro.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.macro, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('buscar-veiculo',{attrs:{"type":"search","id":"veiculoDescricao","placeholder":"Selecione um veículo..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarVeiculo,"on-blur":_vm.verificarVeiculo},model:{value:(_vm.macro.veiculoDescricao),callback:function ($$v) {_vm.$set(_vm.macro, "veiculoDescricao", $$v)},expression:"macro.veiculoDescricao"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.adicionarMacro}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalEditarMacro = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-primary",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Adicionar Macro"},on:{"click":function($event){_vm.showModalEditarMacro = true}}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/analiseJornadaTabela"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row row-margin"}),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(4),_vm._v(" "),_vm._l((_vm.jornada),function(grid,i){return _c('tbody',[_c('tr',{class:{ 'selecionado': _vm.selecionado(grid), 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') },on:{"click":function($event){_vm.selecionarItem(grid, $event)}}},[_c('td',{attrs:{"width":"140"}},[_c('small',[_vm._v(_vm._s(grid.id))])]),_vm._v(" "),_c('td',{attrs:{"width":"150"}},[_c('small',[_vm._v(_vm._s(grid.dataHora))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.macro)+" - "+_vm._s(grid.macroTexto))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motoristaNome))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.veiculoDescricao))])]),_vm._v(" "),_c('td',[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"src":"/static/images/editar.png"},on:{"click":function($event){_vm.editarMacro(grid.id)}}})]),_vm._v(" "),_c('td',[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletarMacro(grid.id)}}})])])])})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Adicionar Macro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Visualizar Macros Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("ID")]),_vm._v(" "),_c('th',[_vm._v("DATA HORA")]),_vm._v(" "),_c('th',[_vm._v("MACRO")]),_vm._v(" "),_c('th',[_vm._v("MOTORISTA")]),_vm._v(" "),_c('th',[_vm._v("VEICULO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "9Trd":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      model: {
        id: '0',
        ativo: false,
        ativoRastreamento: false,
        ativoMonitoramento: false,
        placa: '',
        descricao: '',
        dataCadastroRastreamento: '',
        clienteId: '0',
        clienteNomeFantasia: '',
        modelo: '',
        marca: '',
        anoFabricacao: '',
        anoModelo: '',
        veiculoTipoId: '0',
        veiculoCombustivelId: '0',
        renavam: '',
        chassi: '',
        kmAtual: '0',
        numeroEquipamento: '',
        marcaEquipamento: '',
        modeloEquipamento: '',
        operadoraChipEquipamento: '',
        dddChipEquipamento: '',
        numeroChipEquipamento: '',
        dataInstalacao: '',
        ativoObd: '',
        numeroObd: '',
        marcaObd: '',
        modeloObd: '',
        operadoraChipObd: '',
        dddChipObd: '',
        numeroChipObd: '',
        dataInstalacaoObd: '',
        ativoTeclado: '',
        tipoUsoTeclado: '',
        clientePagaId: '',
        clientePagaNomeFantasia: '',
        clienteRedirecionamento1Id: '',
        clienteRedirecionamento1NomeFantasia: '',
        clienteRedirecionamento2Id: '',
        clienteRedirecionamento2NomeFantasia: '',
        clienteRedirecionamento3Id: '',
        clienteRedirecionamento3NomeFantasia: '',
        senhaIdentificacao: '',
        observacaoInstalacao: '',
        observacaoGerais: '',
        analisarIgnicao: true,
        analisarTransmissso: true,
        analisarDAC: true,
        analisarEvento: true,
        emOperacao: true,
        intervaloMovimento: '0',
        limiteGPS: '0',
        limiteTempo: '0',
        limiteTransmissoesDiarias: '0',
        velocidadeMaxima: '0',
        limiteExcessoVelocidade: '0',
        tensaoBateriaMinima: '0',
        jornadaTrabalho: true,
        jornadaTrabalhoIgnicao: true,
        jornadaTrabalhoVelocidade: '',
        jornadaTrabalhoParadoAposPosicoes: '',
        macroAutomatica: '',
        tipoNegociacao: '',
        vendedorRastreamento: '',
        tipoPagamentoRastreamento: '',
        mesVencimentoAnualRastreamento: '',
        tipoVencimentoRastreamento: 'C',
        diaVencimentoRastreamento: '1',
        sascarId: '0',
        valorRepasse: '0',
        valorMensalidadeRastreamento: '0',
        extra24Horas: '0',
        extraSeguro: '0',
        extraWeb: '0',
        valorTotalMensalidadeRastreamento: '0',
        alertaRoubo: false,
        possuiBloqueioBau: false,
        possuiBloqueioVeiculo: false,
        possuiEventoArea: false,
        eventoAreaDistancia: '0',
        eventoAreaLatitude: '0',
        eventoAreaLongitude: '0',
        possuiEventoBateria: false,
        possuiEventoIgnicao: false,
        possuiEventoVelocidade: false,
        estaBloqueioBau: false,
        estaBloqueioVeiculo: false,
        estaEventoArea: false,
        estaEventoBateria: false,
        estaEventoIgnicao: false,
        estaEventoVelocidade: false
      },
      veiculosCombustiveis: [],
      veiculosTipos: [],
      vendedores: [],
      duracaoDesativarBateria: '1',
      showModalDuracaoDesativarBateria: false
    };
  },

  created: function created() {
    this.buscar();

    this.buscarVendedores();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      self.processando = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;

        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.ativoRastreamento = dados.ativoRastreamento;
        self.model.ativoMonitoramento = dados.ativoMonitoramento;
        self.model.placa = dados.placa;
        self.model.descricao = dados.descricao;
        self.model.dataCadastroRastreamento = dados.dataCadastroRastreamento;
        self.model.clienteId = dados.clienteId;
        self.model.clienteNomeFantasia = dados.clienteNome;
        self.model.modelo = dados.modelo;
        self.model.marca = dados.marca;
        self.model.anoFabricacao = dados.anoFabricacao;
        self.model.anoModelo = dados.anoModelo;
        self.model.veiculoTipoId = dados.veiculoTipoId;
        self.model.veiculoCombustivelId = dados.veiculoCombustivelId;
        self.model.renavam = dados.renavam;
        self.model.chassi = dados.chassi;
        self.model.kmAtual = dados.kmAtual;
        self.model.numeroEquipamento = dados.numeroEquipamento;
        self.model.marcaEquipamento = dados.marcaEquipamento;
        self.model.modeloEquipamento = dados.modeloEquipamento;
        self.model.operadoraChipEquipamento = dados.operadoraChipEquipamento;
        self.model.dddChipEquipamento = dados.dddChipEquipamento;
        self.model.numeroChipEquipamento = dados.numeroChipEquipamento;
        self.model.dataInstalacao = dados.dataInstalacao;
        self.model.ativoObd = dados.ativoObd;
        self.model.numeroObd = dados.numeroObd;
        self.model.marcaObd = dados.marcaObd;
        self.model.modeloObd = dados.modeloObd;
        self.model.operadoraChipObd = dados.operadoraChipObd;
        self.model.dddChipObd = dados.dddChipObd;
        self.model.numeroChipObd = dados.numeroChipObd;
        self.model.dataInstalacaoObd = dados.dataInstalacaoObd;
        self.model.ativoTeclado = dados.ativoTeclado;
        self.model.tipoUsoTeclado = dados.tipoUsoTeclado;
        self.model.clientePagaId = dados.clientePagaId;
        self.model.clientePagaNomeFantasia = dados.clientePagaNome;
        self.model.clienteRedirecionamento1Id = dados.clienteRedirecionamento1Id;
        self.model.clienteRedirecionamento1NomeFantasia = dados.clienteRedirecionamento1Nome;
        self.model.clienteRedirecionamento2Id = dados.clienteRedirecionamento2Id;
        self.model.clienteRedirecionamento2NomeFantasia = dados.clienteRedirecionamento2Nome;
        self.model.clienteRedirecionamento3Id = dados.clienteRedirecionamento3Id;
        self.model.clienteRedirecionamento3NomeFantasia = dados.clienteRedirecionamento3Nome;
        self.model.senhaIdentificacao = dados.senhaIdentificacao;
        self.model.observacaoInstalacao = dados.observacaoInstalacao;
        self.model.observacaoGerais = dados.observacaoGerais;
        self.model.analisarIgnicao = dados.analisarIgnicao;
        self.model.analisarTransmissso = dados.analisarTransmissso;
        self.model.analisarDAC = dados.analisarDAC;
        self.model.analisarEvento = dados.analisarEvento;
        self.model.emOperacao = dados.emOperacao;
        self.model.intervaloMovimento = dados.intervaloMovimento;
        self.model.limiteGPS = dados.limiteGPS;
        self.model.limiteTempo = dados.limiteTempo;
        self.model.limiteTransmissoesDiarias = dados.limiteTransmissoesDiarias;
        self.model.velocidadeMaxima = dados.velocidadeMaxima;
        self.model.limiteExcessoVelocidade = dados.limiteExcessoVelocidade;
        self.model.tensaoBateriaMinima = dados.tensaoBateriaMinima;
        self.model.jornadaTrabalho = dados.jornadaTrabalho;
        self.model.jornadaTrabalhoIgnicao = dados.jornadaTrabalhoIgnicao;
        self.model.jornadaTrabalhoVelocidade = dados.jornadaTrabalhoVelocidade;
        self.model.jornadaTrabalhoParadoAposPosicoes = dados.jornadaTrabalhoParadoAposPosicoes;
        self.model.macroAutomatica = dados.macroAutomatica;
        self.model.tipoNegociacao = dados.tipoNegociacao;
        self.model.vendedorRastreamento = dados.vendedorRastreamento;
        self.model.tipoPagamentoRastreamento = dados.tipoPagamentoRastreamento;
        self.model.mesVencimentoAnualRastreamento = dados.mesVencimentoAnualRastreamento;
        self.model.tipoVencimentoRastreamento = dados.tipoVencimentoRastreamento;
        self.model.diaVencimentoRastreamento = dados.diaVencimentoRastreamento;
        self.model.sascarId = dados.sascarId;
        self.model.valorRepasse = dados.valorRepasse;
        self.model.valorMensalidadeRastreamento = dados.valorMensalidadeRastreamento;
        self.model.extra24Horas = dados.extra24Horas;
        self.model.extraSeguro = dados.extraSeguro;
        self.model.extraWeb = dados.extraWeb;
        self.model.valorTotalMensalidadeRastreamento = dados.valorTotalMensalidadeRastreamento;
        self.model.alertaRoubo = dados.alertaRoubo;
        self.model.possuiBloqueioBau = dados.possuiBloqueioBau;
        self.model.possuiBloqueioVeiculo = dados.possuiBloqueioVeiculo;
        self.model.possuiEventoArea = dados.possuiEventoArea;
        self.model.eventoAreaDistancia = dados.eventoAreaDistancia;
        self.model.eventoAreaLatitude = dados.eventoAreaLatitude;
        self.model.eventoAreaLongitude = dados.eventoAreaLongitude;
        self.model.possuiEventoBateria = dados.possuiEventoBateria;
        self.model.possuiEventoIgnicao = dados.possuiEventoIgnicao;
        self.model.possuiEventoVelocidade = dados.possuiEventoVelocidade;
        self.model.estaBloqueioBau = dados.estaBloqueioBau;
        self.model.estaBloqueioVeiculo = dados.estaBloqueioVeiculo;
        self.model.estaEventoArea = dados.estaEventoArea;
        self.model.estaEventoBateria = dados.estaEventoBateria;
        self.model.estaEventoIgnicao = dados.estaEventoIgnicao;
        self.model.estaEventoVelocidade = dados.estaEventoVelocidade;
        self.processando = false;
      });
    },
    buscarVeiculosCombustivel: function buscarVeiculosCombustivel() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVeiculosCombustiveisAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.veiculosCombustiveis = dados;
      });
    },
    buscarVeiculosTipos: function buscarVeiculosTipos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVeiculosTiposAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.veiculosTipos = dados;
      });
    },
    buscarVendedores: function buscarVendedores() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVendedoresAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.vendedores = dados;
      });
    },
    setarCliente: function setarCliente(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarCliente: function verificarCliente() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClientePaga: function setarClientePaga(cliente) {
      this.model.clientePagaId = cliente.id;
      this.model.clientePagaNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clientePagaNome').val(cliente.nomeFantasia);
    },
    verificarClientePaga: function verificarClientePaga() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clientePagaId = 0;
        this.model.clientePagaNome = '';
        $(this.$el).find('#clientePagaId').val(0);
        $(this.$el).find('#clientePagaNome').val('');
      }
      if ($(this.$el).find('#clientePagaNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clientePagaId').val(0);
        $(this.$el).find('#clientePagaNome').val('');
      }
    },
    setarClienteRedirecionamento1: function setarClienteRedirecionamento1(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento1: function verificarClienteRedirecionamento1() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClienteRedirecionamento2: function setarClienteRedirecionamento2(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento2: function verificarClienteRedirecionamento2() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClienteRedirecionamento3: function setarClienteRedirecionamento3(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento3: function verificarClienteRedirecionamento3() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    bloquearVeiculo: function bloquearVeiculo(message) {
      var _this = this;

      var self = this;

      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/apimobile/comandoBloqueioVeiculo?veiculo=' + self.model.id;
          _axios2.default.post(url, '', config).then(function (response) {
            console.log(response);
            self.buscar();
            dialog.close();
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    ativarAlertaRoubo: function ativarAlertaRoubo(message) {
      var _this2 = this;

      var self = this;

      var options = {
        html: true,
        loader: true,
        reverse: false,
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this2.$store.state.token
            }
          };
          self.loading = true;
          var url = '/apimobile/eventoRoubo?veiculo=' + self.model.id;
          _axios2.default.post(url, '', config).then(function (response) {
            console.log(response);
            self.buscar();
            dialog.close();
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    ativarAlertaIgnicao: function ativarAlertaIgnicao(message) {
      var _this3 = this;

      var self = this;

      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this3.$store.state.token
            }
          };
          self.loading = true;
          var url = '/apimobile/eventoIgnicao?veiculo=' + self.model.id;
          _axios2.default.post(url, '', config).then(function (response) {
            console.log(response);
            self.buscar();
            dialog.close();
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    ativarAlertaArea: function ativarAlertaArea(message) {
      var _this4 = this;

      var self = this;

      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this4.$store.state.token
            }
          };
          self.loading = true;
          var url = '/apimobile/eventoArea?veiculo=' + self.model.id + '&distancia=' + self.model.eventoAreaDistancia + '&latitude=' + self.model.eventoAreaLatitude + '&longitude=' + self.model.eventoAreaLongitude;
          _axios2.default.post(url, '', config).then(function (response) {
            console.log(response);
            self.buscar();
            dialog.close();
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    modificarLocalArea: function modificarLocalArea() {
      var self = this;
      var marker = {};
      marker = {
        lat: parseFloat(self.model.eventoAreaLatitude),
        lng: parseFloat(self.model.eventoAreaLongitude)
      };
      self.markers.push({ position: marker });
      this.mostrarModalArea = true;

      var bounds = new window.google.maps.LatLngBounds();

      console.log('LAT: ' + marker.lat);
      console.log('LONG: ' + marker.lng);
      var myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
      bounds.extend(myLatLng);
    },
    ativarAlertaBateria: function ativarAlertaBateria(message) {
      var self = this;
      if (self.model.estaEventoBateria) {
        self.showModalDuracaoDesativarBateria = true;
      } else {
        var options = {
          html: false,
          loader: true,
          reverse: false,
          okText: 'SIM',
          cancelText: 'NÃO',
          animation: 'zoom',
          type: 'basic',
          verification: 'continue',
          clicksCount: 3 };
        this.$dialog.confirm(message, options).then(function (dialog) {
          self.confirmarAtivarAlertaBateria();
          dialog.close();
        });
      }
    },
    confirmarAtivarAlertaBateria: function confirmarAtivarAlertaBateria(message) {
      var self = this;
      self.showModalDuracaoDesativarBateria = false;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.loading = true;
      var url = '/apimobile/eventoBateria?veiculo=' + self.model.id + '&duracao=' + self.duracaoDesativarBateria;
      _axios2.default.post(url, '', config).then(function (response) {
        console.log(response);
        self.buscar();
      });
    },
    ativarAlertaVelocidade: function ativarAlertaVelocidade(message) {
      var _this5 = this;

      var self = this;

      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'SIM',
        cancelText: 'NÃO',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this5.$store.state.token
            }
          };
          self.loading = true;
          var url = '/apimobile/eventoVelocidade?veiculo=' + self.model.id + '&velocidade=' + self.model.velocidadeMaxima;
          _axios2.default.post(url, '', config).then(function (response) {
            console.log(response);
            self.buscar();
            dialog.close();
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    salvar: function salvar() {
      var _this6 = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          self.processando = true;
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this6.$store.state.token
            }
          };
          var url = '/api/veiculos/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.processando = false;
              self.$toastr('success', 'Veículo gravado com sucesso.', 'Atenção');
              self.$router.replace('/veiculos');
            }
          }).catch(function (error) {
            self.processando = false;
            console.log(error);
          });
        } else {
          _this6.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "9osO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Periodo: ")]),_vm._v(" De: "+_vm._s(_vm.dadosAnalise.dataInicial)+" até "+_vm._s(_vm.dadosAnalise.dataFinal)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosAnalise.veiculo)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosAnalise.empresa)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.kmRodados).toFixed(2))+" Km \n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMedia).toFixed(2))+" Km/h\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMaxima).toFixed(2))+" Km/h \n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inicioJornadaManual),expression:"inicioJornadaManual"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.inicioJornadaManual)?_vm._i(_vm.inicioJornadaManual,null)>-1:(_vm.inicioJornadaManual)},on:{"change":function($event){var $$a=_vm.inicioJornadaManual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inicioJornadaManual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inicioJornadaManual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inicioJornadaManual=$$c}}}}),_vm._v(" Informar inicio de Jornada Manual")]),_vm._v(" "),(_vm.inicioJornadaManual)?[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data hora Inicial Jornada: ")]),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataHoraInicialJornadaManual),callback:function ($$v) {_vm.dataHoraInicialJornadaManual=$$v},expression:"dataHoraInicialJornadaManual"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.finalJornadaManual),expression:"finalJornadaManual"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.finalJornadaManual)?_vm._i(_vm.finalJornadaManual,null)>-1:(_vm.finalJornadaManual)},on:{"change":function($event){var $$a=_vm.finalJornadaManual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.finalJornadaManual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.finalJornadaManual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.finalJornadaManual=$$c}}}}),_vm._v(" Informar final de Jornada Manual")]),_vm._v(" "),(_vm.finalJornadaManual)?[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data hora Final Jornada: ")]),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataHoraFinalJornadaManual),callback:function ($$v) {_vm.dataHoraFinalJornadaManual=$$v},expression:"dataHoraFinalJornadaManual"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(_vm._s(_vm.dadosAnalise.motorista)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('div',[_c('strong',[_vm._v("Problemas encontrados na Análise")]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.dadosAnaliseProblemas)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success ",attrs:{"id":"gravarAnalise","type":"button"},on:{"click":_vm.gravarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-save",attrs:{"aria-hidden":"true"}}),_vm._v(" Gravar Análise\n                ")])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.dadosAnaliseMacros),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(grid.dataHoraInicio))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grid.macro))])])])})],2),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dadosAnalise.dados),function(grid,i){return _c('tbody',[(i > 0 && _vm.dadosAnalise.dados[i].data !== _vm.dadosAnalise.dados[i-1].data)?[_vm._m(3,true)]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }},[_c('td',{attrs:{"width":"140"}},[_c('small',[_vm._v(_vm._s(grid.data)+" "+_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.data)+" "+_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',{attrs:{"width":"85"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))]),_vm._v(" "),(grid.statusVeiculo === 'VEICULO EM MOVIMENTO')?[_c('small',[_vm._v(" - "+_vm._s(_vm.formatarVelocidadeMetros(grid.kmRodados))+" metros ")])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.observacao))])])])],2)})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("MACRO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"background-color":"#FF0400","height":"20px"}},[_c('td',{attrs:{"colspan":"6"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "A2U7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue__ = __webpack_require__("6pwD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dee93c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabelaEditar_vue__ = __webpack_require__("98li");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_53dee93c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabelaEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AQx4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue__ = __webpack_require__("QgcD");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729e68da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCodigoNcm_vue__ = __webpack_require__("kc16");
function injectStyle (ssrContext) {
  __webpack_require__("S4sO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCodigoNcm_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_729e68da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCodigoNcm_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ATiK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__ = __webpack_require__("eof4");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5528106e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__ = __webpack_require__("fQ06");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Logout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5528106e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Logout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "AiPH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-produto',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    tipoCadastro: {
      type: [String, Number],
      default: 'C'
    },
    tipoCadastroId: {
      type: [String, Number],
      default: '0'
    },
    tipoBusca: {
      type: [String, Number],
      default: 'S'
    },
    tabelaPreco: {
      type: [String, Number],
      default: '0'
    },
    deposito: {
      type: [String, Number],
      default: '0'
    },
    venda: {
      type: [String, Number],
      default: '0'
    },
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,
    readonly: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      console.log('handleInput');
      var value = e.target.value;

      this.json = [];
      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 79 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 79 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);

          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      console.log('setValue');
      $(this.$el).find('#' + this.id).val(val);
    },

    verificarProduto: function verificarProduto() {
      if ($(this.$el).find('#clienteId').val() === 0) {
        this.clienteId = 0;
        this.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.clienteId = 0;
        this.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      console.log($(this.$el).find('#clienteNome').val());
    },

    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        var novoId = this.id.split('_')[1];
        this.onBlur(e, novoId);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nome);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        var novoId = this.id.split('_')[1];
        this.onSelect(clean, novoId);
        $(this.$el).find('#' + this.id).val(clean.nome);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      this.json = [];
      this.focusList = 0;
      $(this.$el).find('.autocomplete ul').animate({ scrollTop: 0 }, 50);

      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '';
      if (this.tipoBusca === 'S') {
        url = '/api/buscarProdutosAtivos?busca=' + val;
      } else if (this.tipoBusca === 'D') {
        if (this.tipoCadastro === 'C') {
          url = '/api/buscarProdutosParaDevolucao?busca=' + val + '&clienteId=' + this.tipoCadastroId;
        } else {
          url = '/api/buscarProdutosParaDevolucao?busca=' + val + '&fornecedorId=' + this.tipoCadastroId;
        }
      } else if (this.tipoBusca === 'C') {
        url = '/api/buscarProdutosParaCompra?busca=' + val;
      } else if (this.tipoBusca === 'B') {
        url = '/api/buscarProdutosParaBalanco?busca=' + val + '&depositoId=' + this.deposito;
      } else {
        if (this.tabelaPreco === '0') {
          url = '/api/buscarProdutosParaVenda?busca=' + val;
        } else {
          url = '/api/buscarProdutosParaVenda?busca=' + val + '&clienteId=' + this.tipoCadastroId + '&tabelaPrecoId=' + this.tabelaPreco + '&vendaId=' + this.venda;
        }
      }
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    console.log(this.id);
    console.log(this.value);
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "AmAx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: false,
        ativoRastreamento: false,
        ativoMonitoramento: false,
        placa: '',
        descricao: '',
        dataCadastroRastreamento: '',
        clienteId: '0',
        clienteNomeFantasia: '',
        modelo: '',
        marca: '',
        anoFabricacao: '',
        anoModelo: '',
        veiculoTipoId: '0',
        veiculoCombustivelId: '0',
        renavam: '',
        chassi: '',
        kmAtual: '0',
        numeroEquipamento: '',
        marcaEquipamento: '',
        modeloEquipamento: '',
        operadoraChipEquipamento: '',
        dddChipEquipamento: '',
        numeroChipEquipamento: '',
        dataInstalacao: '',
        ativoObd: '',
        numeroObd: '',
        marcaObd: '',
        modeloObd: '',
        operadoraChipObd: '',
        dddChipObd: '',
        numeroChipObd: '',
        dataInstalacaoObd: '',
        ativoTeclado: '',
        tipoUsoTeclado: '',
        clientePagaId: '',
        clientePagaNomeFantasia: '',
        clienteRedirecionamento1Id: '',
        clienteRedirecionamento1NomeFantasia: '',
        clienteRedirecionamento2Id: '',
        clienteRedirecionamento2NomeFantasia: '',
        clienteRedirecionamento3Id: '',
        clienteRedirecionamento3NomeFantasia: '',
        senhaIdentificacao: '',
        observacaoInstalacao: '',
        observacaoGerais: '',
        analisarIgnicao: true,
        analisarTransmissso: true,
        analisarDAC: true,
        analisarEvento: true,
        emOperacao: true,
        intervaloMovimento: '0',
        limiteGPS: '0',
        limiteTempo: '0',
        limiteTransmissoesDiarias: '0',
        velocidadeMaxima: '0',
        limiteExcessoVelocidade: '0',
        tensaoBateriaMinima: '0',
        jornadaTrabalho: true,
        jornadaTrabalhoIgnicao: true,
        jornadaTrabalhoVelocidade: '',
        jornadaTrabalhoParadoAposPosicoes: '',
        tipoNegociacao: '',
        vendedorRastreamento: '',
        tipoPagamentoRastreamento: '',
        mesVencimentoAnualRastreamento: '',
        tipoVencimentoRastreamento: 'C',
        diaVencimentoRastreamento: '1',
        sascarId: '0',
        valorRepasse: '0',
        valorMensalidadeRastreamento: '0',
        extra24Horas: '0',
        extraSeguro: '0',
        extraWeb: '0',
        valorTotalMensalidadeRastreamento: '0'
      },
      veiculosCombustiveis: [],
      veiculosTipos: [],
      vendedores: []
    };
  },

  created: function created() {
    this.buscar();
    this.buscarVeiculosTipos();
    this.buscarVeiculosCombustivel();
    this.buscarVendedores();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;

        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.ativoRastreamento = dados.ativoRastreamento;
        self.model.ativoMonitoramento = dados.ativoMonitoramento;
        self.model.placa = dados.placa;
        self.model.descricao = dados.descricao;
        self.model.dataCadastroRastreamento = dados.dataCadastroRastreamento;
        self.model.clienteId = dados.clienteId;
        self.model.clienteNomeFantasia = dados.clienteNome;
        self.model.modelo = dados.modelo;
        self.model.marca = dados.marca;
        self.model.anoFabricacao = dados.anoFabricacao;
        self.model.anoModelo = dados.anoModelo;
        self.model.veiculoTipoId = dados.veiculoTipoId;
        self.model.veiculoCombustivelId = dados.veiculoCombustivelId;
        self.model.renavam = dados.renavam;
        self.model.chassi = dados.chassi;
        self.model.kmAtual = dados.kmAtual;
        self.model.numeroEquipamento = dados.numeroEquipamento;
        self.model.marcaEquipamento = dados.marcaEquipamento;
        self.model.modeloEquipamento = dados.modeloEquipamento;
        self.model.operadoraChipEquipamento = dados.operadoraChipEquipamento;
        self.model.dddChipEquipamento = dados.dddChipEquipamento;
        self.model.numeroChipEquipamento = dados.numeroChipEquipamento;
        self.model.dataInstalacao = dados.dataInstalacao;
        self.model.ativoObd = dados.ativoObd;
        self.model.numeroObd = dados.numeroObd;
        self.model.marcaObd = dados.marcaObd;
        self.model.modeloObd = dados.modeloObd;
        self.model.operadoraChipObd = dados.operadoraChipObd;
        self.model.dddChipObd = dados.dddChipObd;
        self.model.numeroChipObd = dados.numeroChipObd;
        self.model.dataInstalacaoObd = dados.dataInstalacaoObd;
        self.model.ativoTeclado = dados.ativoTeclado;
        self.model.tipoUsoTeclado = dados.tipoUsoTeclado;
        self.model.clientePagaId = dados.clientePagaId;
        self.model.clientePagaNomeFantasia = dados.clientePagaNome;
        self.model.clienteRedirecionamento1Id = dados.clienteRedirecionamento1Id;
        self.model.clienteRedirecionamento1NomeFantasia = dados.clienteRedirecionamento1Nome;
        self.model.clienteRedirecionamento2Id = dados.clienteRedirecionamento2Id;
        self.model.clienteRedirecionamento2NomeFantasia = dados.clienteRedirecionamento2Nome;
        self.model.clienteRedirecionamento3Id = dados.clienteRedirecionamento3Id;
        self.model.clienteRedirecionamento3NomeFantasia = dados.clienteRedirecionamento3Nome;
        self.model.senhaIdentificacao = dados.senhaIdentificacao;
        self.model.observacaoInstalacao = dados.observacaoInstalacao;
        self.model.observacaoGerais = dados.observacaoGerais;
        self.model.analisarIgnicao = dados.analisarIgnicao;
        self.model.analisarTransmissso = dados.analisarTransmissso;
        self.model.analisarDAC = dados.analisarDAC;
        self.model.analisarEvento = dados.analisarEvento;
        self.model.emOperacao = dados.emOperacao;
        self.model.intervaloMovimento = dados.intervaloMovimento;
        self.model.limiteGPS = dados.limiteGPS;
        self.model.limiteTempo = dados.limiteTempo;
        self.model.limiteTransmissoesDiarias = dados.limiteTransmissoesDiarias;
        self.model.velocidadeMaxima = dados.velocidadeMaxima;
        self.model.limiteExcessoVelocidade = dados.limiteExcessoVelocidade;
        self.model.tensaoBateriaMinima = dados.tensaoBateriaMinima;
        self.model.jornadaTrabalho = dados.jornadaTrabalho;
        self.model.jornadaTrabalhoIgnicao = dados.jornadaTrabalhoIgnicao;
        self.model.jornadaTrabalhoVelocidade = dados.jornadaTrabalhoVelocidade;
        self.model.jornadaTrabalhoParadoAposPosicoes = dados.jornadaTrabalhoParadoAposPosicoes;
        self.model.tipoNegociacao = dados.tipoNegociacao;
        self.model.vendedorRastreamento = dados.vendedorRastreamento;
        self.model.tipoPagamentoRastreamento = dados.tipoPagamentoRastreamento;
        self.model.mesVencimentoAnualRastreamento = dados.mesVencimentoAnualRastreamento;
        self.model.tipoVencimentoRastreamento = dados.tipoVencimentoRastreamento;
        self.model.diaVencimentoRastreamento = dados.diaVencimentoRastreamento;
        self.model.sascarId = dados.sascarId;
        self.model.valorRepasse = dados.valorRepasse;
        self.model.valorMensalidadeRastreamento = dados.valorMensalidadeRastreamento;
        self.model.extra24Horas = dados.extra24Horas;
        self.model.extraSeguro = dados.extraSeguro;
        self.model.extraWeb = dados.extraWeb;
        self.model.valorTotalMensalidadeRastreamento = dados.valorTotalMensalidadeRastreamento;
      });
    },
    buscarVeiculosCombustivel: function buscarVeiculosCombustivel() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVeiculosCombustiveisAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.veiculosCombustiveis = dados;
      });
    },
    buscarVeiculosTipos: function buscarVeiculosTipos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVeiculosTiposAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.veiculosTipos = dados;
      });
    },
    buscarVendedores: function buscarVendedores() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVendedoresAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.vendedores = dados;
      });
    },
    setarCliente: function setarCliente(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarCliente: function verificarCliente() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClientePaga: function setarClientePaga(cliente) {
      this.model.clientePagaId = cliente.id;
      this.model.clientePagaNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clientePagaNome').val(cliente.nomeFantasia);
    },
    verificarClientePaga: function verificarClientePaga() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clientePagaId = 0;
        this.model.clientePagaNome = '';
        $(this.$el).find('#clientePagaId').val(0);
        $(this.$el).find('#clientePagaNome').val('');
      }
      if ($(this.$el).find('#clientePagaNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clientePagaId').val(0);
        $(this.$el).find('#clientePagaNome').val('');
      }
    },
    setarClienteRedirecionamento1: function setarClienteRedirecionamento1(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento1: function verificarClienteRedirecionamento1() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClienteRedirecionamento2: function setarClienteRedirecionamento2(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento2: function verificarClienteRedirecionamento2() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarClienteRedirecionamento3: function setarClienteRedirecionamento3(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      this.model.descontoPercentual = cliente.descontoPadrao;
      if (cliente.produtoTabelaPrecoPadrao !== null) {
        this.model.produtoTabelaPrecoId = cliente.produtoTabelaPrecoPadrao;
      }
      if (cliente.formaPagamentoPadrao !== null) {
        this.model.formaPagamentoId = cliente.formaPagamentoPadrao;
        this.setarFormaPagamento();
      }
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarClienteRedirecionamento3: function verificarClienteRedirecionamento3() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        this.model.descontoPercentual = 0;
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/veiculos/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo gravado com sucesso.', 'Atenção');
              self.$router.replace('/veiculos');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "BpKa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalTratarEvento)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Mensagem Evento:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.tratarEvento.mensagemEventoDisparado),expression:"tratarEvento.mensagemEventoDisparado"}],staticClass:"form-control",attrs:{"type":"text"},domProps:{"value":(_vm.tratarEvento.mensagemEventoDisparado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.tratarEvento, "mensagemEventoDisparado", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Adiar evento até:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tratarEvento.adiarEventoDisparado),expression:"tratarEvento.adiarEventoDisparado"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tratarEvento, "adiarEventoDisparado", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","label":""}}),_vm._v(" "),_c('option',{attrs:{"value":"1h","label":"Adiar por 1:00h"}},[_vm._v("Adiar por 1:00h")]),_vm._v(" "),_c('option',{attrs:{"value":"6h","label":"Adiar por 6:00hs"}},[_vm._v("Adiar por 6:00hs")]),_vm._v(" "),_c('option',{attrs:{"value":"1d","label":"Adiar por 01 dia"}},[_vm._v("Adiar por 01 dia")]),_vm._v(" "),_c('option',{attrs:{"value":"5d","label":"Adiar por 05 dias"}},[_vm._v("Adiar por 05 dias")]),_vm._v(" "),_c('option',{attrs:{"value":"10d","label":"Adiar por 10 dias"}},[_vm._v("Adiar por 10 dias")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Tratar todos os Eventos:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.tratarEvento.tratarTodosEventos),expression:"tratarEvento.tratarTodosEventos"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.tratarEvento, "tratarTodosEventos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":_vm.gravarTratarEvento}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalTratarEvento = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 58px)","height":"calc(100vh - 58px)"},attrs:{"center":_vm.center,"zoom":4}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMapa = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalRelatorio)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataInicial", $$v)},expression:"relatorio.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataFinal", $$v)},expression:"relatorio.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.motoristaId),expression:"relatorio.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.relatorio.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "motoristaId", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarRelatorio}},[_vm._v("Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorio = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.tratarEventoModal}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Tratar Evento\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalRelatorio = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatório\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Periodo:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Veiculo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-md-3"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Evento:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.eventoId),expression:"filtros.eventoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "eventoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","selected":"selected"}},[_vm._v("Todos")]),_vm._v(" "),_vm._l((_vm.eventos),function(evento){return _c('option',{domProps:{"value":evento.id}},[_vm._v(_vm._s(evento.nome))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Tratados:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"L","label":"Apenas Tratados"}},[_vm._v("Apenas Tratados")]),_vm._v(" "),_c('option',{attrs:{"value":"NL","label":"Apenas Não Tratados"}},[_vm._v("Apenas Não Tratados")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-limpo"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"overflow-x":"auto"},attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(eventoDisparado){return _c('tr',{class:{ 'selecionado': _vm.selecionado(eventoDisparado) },on:{"click":function($event){_vm.selecionarItem(eventoDisparado, $event)}}},[_c('td',{attrs:{"width":"100"}},[_vm._v(_vm._s(eventoDisparado.dataHoraEvento))]),_vm._v(" "),_c('td',{attrs:{"width":"230"}},[_c('strong',[_vm._v(_vm._s(eventoDisparado.veiculoDescricao))])]),_vm._v(" "),_c('td',{attrs:{"width":"300"}},[_vm._v(_vm._s(eventoDisparado.eventoNome))]),_vm._v(" "),_c('td',[(eventoDisparado.latitude !== 0 && eventoDisparado.latitude !== null)?[_c('img',{attrs:{"src":"/static/images/ponto.png"}})]:_vm._e(),_vm._v("\n                      "+_vm._s(eventoDisparado.pontoDescricao)+"\n                    ")],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[(eventoDisparado.lido === true)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:(eventoDisparado.lidoUsuarioNome + '<br>' + eventoDisparado.dataHoraEventoLido),expression:"eventoDisparado.lidoUsuarioNome + '<br>' + eventoDisparado.dataHoraEventoLido"}],attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2)])}))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatório de Eventos Disparados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Eventos Disparados")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Evento")]),_vm._v(" "),_c('th',[_vm._v("Ponto")]),_vm._v(" "),_c('th',[_vm._v("Tratado")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Breq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalNovoCompromisso)?_c('div',{staticClass:"modal fade show",attrs:{"id":"modalBaixa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"false","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Data e Hora inicio:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.dataHoraInicio),expression:"model.dataHoraInicio"}],staticClass:"data form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.dataHoraInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "dataHoraInicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Data e Hora final:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.dataHoraFinal),expression:"model.dataHoraFinal"}],staticClass:"data form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.dataHoraFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "dataHoraFinal", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Titulo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.titulo),expression:"model.titulo"}],staticClass:"form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.titulo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "titulo", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Local:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.local),expression:"model.local"}],staticClass:"form-control",domProps:{"value":(_vm.model.local)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "local", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"form-control",domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Usuário:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.usuarioId),expression:"model.usuarioId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "usuarioId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('options',{attrs:{"items":"${usuarios}","itemValue":"id","itemLabel":"nome"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Exibir Como:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.exibirComo),expression:"model.exibirComo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "exibirComo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"O","label":"Ocupado"}}),_vm._v(" "),_c('option',{attrs:{"value":"A","label":"Ausente"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Visível Para:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.visivelPara),expression:"model.visivelPara"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "visivelPara", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"S","label":"Somente Usuário"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_vm._v("Cor:")]),_c('br'),_vm._v(" "),_c('div',{attrs:{"id":"colorPicker"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"track"}),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cor),expression:"model.cor"}],staticClass:"colorInput form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.model.cor)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cor", $event.target.value)}}})])])])]),_vm._v(" "),_vm._m(3)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"conteudo barra-ferramentas"},[_c('button',{staticClass:"btn btn-success",attrs:{"id":"novoCompromisso","type":"button"},on:{"click":function($event){_vm.showModalNovoCompromisso = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo Compromisso\n\t\t\t\t\t\t\t\t\t\t")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dadoss"}},[_c('br'),_vm._v(" "),_c('full-calendar',{attrs:{"events":_vm.fcEvents,"locale":"pt-br"}})],1)])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Novo Compromisso")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"color"},[_c('div',{staticClass:"colorInner"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"dropdown"},[_c('li')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('div',{staticClass:"col-md-2"},[_c('a',{staticClass:"btn btn-danger pull-left",attrs:{"id":"excluir","href":"#"}},[_vm._v("Excluir")])]),_vm._v(" "),_c('div',{staticClass:"col-md-10"},[_c('input',{staticClass:"btn btn-success",attrs:{"type":"submit","value":"Salvar"}}),_vm._v(" "),_vm._v("/agenda\" />\" class=\"btn btn-warning\">Fechar")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Agenda")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "C6nj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoCliente","to":"/convencoes"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n\t\t\t\t\t\t\t\t")])],1)])]),_vm._v("\n\n\t//\n\t@Column(name = \"inicio_fim_jornada_tolerancia\")\n\tprivate String inicioFimJornadaTolerancia;\n\t@Column(name = \"macro_fora_margem_horario_almoco\")\n\tprivate String macroForaMargemHorarioAlmoco;\n\n\t\t\t\t\t"),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-10 col-md-10"},[_c('label',[_vm._v("Nome:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"}],staticClass:"form-control",attrs:{"required":"required","autofocus":"autofocus"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-10 col-md-10"},[_c('label',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"form-control",attrs:{"required":"required","autofocus":"autofocus"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v("Data Inicio:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataInicio),callback:function ($$v) {_vm.$set(_vm.model, "dataInicio", $$v)},expression:"model.dataInicio"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataFinal),callback:function ($$v) {_vm.$set(_vm.model, "dataFinal", $$v)},expression:"model.dataFinal"}})],1)]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.clienteId),expression:"model.clienteId"}],attrs:{"type":"hidden","id":"clienteId"},domProps:{"value":(_vm.model.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"clienteNome","name":"clienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarCliente,"on-blur":_vm.verificarCliente},model:{value:(_vm.model.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.model, "clienteNomeFantasia", $$v)},expression:"model.clienteNomeFantasia"}})],1)])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Segunda a Quinta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSegundaQuinta", $$v)},expression:"model.inicioJornadaSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Fim Jornada Segunda a Quinta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSegundaQuinta", $$v)},expression:"model.fimJornadaSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSegundaQuinta", $$v)},expression:"model.margemInicioAlmocoSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSegundaQuinta", $$v)},expression:"model.margemFinalAlmocoSegundaQuinta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSegundaQuinta),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSegundaQuinta", $$v)},expression:"model.jornadaDuracaoSegundaQuinta"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Sexta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSexta),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSexta", $$v)},expression:"model.inicioJornadaSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Fim Jornada Sexta:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSexta),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSexta", $$v)},expression:"model.fimJornadaSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSexta),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSexta", $$v)},expression:"model.margemInicioAlmocoSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSexta),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSexta", $$v)},expression:"model.margemFinalAlmocoSexta"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSexta),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSexta", $$v)},expression:"model.jornadaDuracaoSexta"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Sábado:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaSabado),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaSabado", $$v)},expression:"model.inicioJornadaSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Final Jornada Sábado:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaSabado),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaSabado", $$v)},expression:"model.fimJornadaSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoSabado),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoSabado", $$v)},expression:"model.margemInicioAlmocoSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoSabado),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoSabado", $$v)},expression:"model.margemFinalAlmocoSabado"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoSabado),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoSabado", $$v)},expression:"model.jornadaDuracaoSabado"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Início Jornada Domingo:")]),_c('br'),_vm._v(" "),_c('input-hora-picker',{staticClass:"form-control pula hora",model:{value:(_vm.model.inicioJornadaDomingo),callback:function ($$v) {_vm.$set(_vm.model, "inicioJornadaDomingo", $$v)},expression:"model.inicioJornadaDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Final Jornada Domingo:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.fimJornadaDomingo),callback:function ($$v) {_vm.$set(_vm.model, "fimJornadaDomingo", $$v)},expression:"model.fimJornadaDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Inicio:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemInicioAlmocoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "margemInicioAlmocoDomingo", $$v)},expression:"model.margemInicioAlmocoDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Margem Almoço Final:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.margemFinalAlmocoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "margemFinalAlmocoDomingo", $$v)},expression:"model.margemFinalAlmocoDomingo"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Duração Jornada:")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",model:{value:(_vm.model.jornadaDuracaoDomingo),callback:function ($$v) {_vm.$set(_vm.model, "jornadaDuracaoDomingo", $$v)},expression:"model.jornadaDuracaoDomingo"}})],1)])],2)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Conceito")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CA9a":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"readonly":_vm.readonly,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "CDVM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{attrs:{"id":"veiculoPeriodo"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"lista-veiculos"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.veiculoId),expression:"filtros.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.filtros.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.clienteId),expression:"filtros.clienteId"}],staticClass:"form-control",attrs:{"id":"clienteId","type":"hidden"},domProps:{"value":(_vm.filtros.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('h4',{staticClass:"panel-title"},[_vm._v("Veículo:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscaVeiculo),expression:"buscaVeiculo"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","placeholder":"Filtrar veículo","type":"text"},domProps:{"value":(_vm.buscaVeiculo)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarVeiculos($event)},"input":function($event){if($event.target.composing){ return; }_vm.buscaVeiculo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.buscarVeiculos}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{attrs:{"id":"dados-analise-jornada-lista-veiculos"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.dadosGrid),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosGrid[i].clienteIdVeiculo != _vm.dadosGrid[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))]),_vm._v(" "),(grid.marcaEquipamento == 'OBD')?[_c('img',{attrs:{"src":"/static/images/obd.png"}})]:_vm._e()],2)])],2)})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"row row-margin"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data inicial:")]),_c('br'),_vm._v(" "),_c('input-data-format',{staticClass:"form-control pula data",attrs:{"id":'dataInicial'},nativeOn:{"blur":function($event){return _vm.setarDataInicial($event)}},model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Hora inicial: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",attrs:{"id":'horaInicial'},model:{value:(_vm.filtros.horaInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "horaInicial", $$v)},expression:"filtros.horaInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"id":"dataFinalLabel"}},[_vm._v("Data final:")]),_c('br'),_vm._v(" "),_c('input-data-format',{staticClass:"form-control pula data",attrs:{"id":'dataFinal'},nativeOn:{"blur":function($event){return _vm.setarDataFinal($event)}},model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"id":"horaFinalLabel"}},[_vm._v("Hora final: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",attrs:{"id":'horaFinal'},model:{value:(_vm.filtros.horaFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "horaFinal", $$v)},expression:"filtros.horaFinal"}})],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.motoristaId),expression:"filtros.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.filtros.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.filtros.motoristaNome),callback:function ($$v) {_vm.$set(_vm.filtros, "motoristaNome", $$v)},expression:"filtros.motoristaNome"}}),_vm._v(" "),_c('br')],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"opcoesRelatorio"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"1"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"1")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "1")}}}),_vm._v(" Viagem por Veículo")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"2"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"2")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "2")}}}),_vm._v(" Viagem por Motorista")]),_vm._v(" "),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarRelatorio}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Relatório\n                    ")])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Período:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('small',[_vm._v("*Os dados de rastreamento ficam armazenados por 90 dias.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Relatório")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Cy2f":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue__ = __webpack_require__("xMKZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce93194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasConvencao_vue__ = __webpack_require__("OTPw");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencao_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3ce93194_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasConvencao_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D+CC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
  extends: _vueChartjs.Pie,
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
};

/***/ }),

/***/ "D5vg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__ = __webpack_require__("4yen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63711587_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesEditar_vue__ = __webpack_require__("PTMa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_63711587_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "D7gQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "DNd/":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "DS/V":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMensagem: false,
      mensagemAlerta: ''
    };
  },
  mounted: function mounted() {
    this.buscarGrid();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    buscarVeiculos: function buscarVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/listarVeiculos?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculos = dadosCadastro;
        self.processando = false;
      });
    },
    gerarAnalise: function gerarAnalise() {
      var self = this;
      var veiculoId = self.selecionada;
      var dataHoraInicial = self.dataInicial + ' ' + self.horaInicial;
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-');
      var dataHoraFinal = (0, _moment2.default)(dataHoraInicial, 'DD/MM/YYYY HH:mm:ss');
      dataHoraFinal.add(3, 'days');
      dataHoraFinal = (0, _moment2.default)(dataHoraFinal).format('DD/MM/YYYY HH:mm:ss');
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-');
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção');
        return;
      }
      self.processando = true;

      this.$router.replace('/analiseJornadaView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal);
    },
    gerarAnaliseFrota: function gerarAnaliseFrota() {
      var self = this;
      var veiculoId = self.selecionada;
      var dataHoraInicial = self.dataInicial + ' 00:00:00';
      var dataHoraFinal = self.dataInicial + ' 23:59:59';
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };

      var url = '/api/verificarAnaliseJornadasMultiplas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);

        {
          var message = 'Deseja realmente gerar as Jornadas ?';
          var options = {
            html: false,
            loader: true,
            reverse: false,
            okText: 'Sim',
            cancelText: 'Não',
            animation: 'zoom',
            type: 'basic',
            verification: 'continue',
            clicksCount: 3 };
          self.$dialog.confirm(message, options).then(function (dialog) {
            self.processando = true;
            dialog.close();
            url = '/api/analiseJornadasMultiplasFrota?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
            _axios2.default.get(url, config).then(function (response) {
              console.log(response.data);
              dadosCadastro = response.data;
              self.dadosAnalise = dadosCadastro;
              self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
              self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
              self.processando = false;
              self.showModalMensagem = true;
              self.mensagemAlerta = 'Jornadas processadas.';
            });
          }).catch(function () {
            console.log('Clicked on cancel');
          });
        }
      });
    }
  }
};

/***/ }),

/***/ "Dg7K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue__ = __webpack_require__("tB6P");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73beb44c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuariosLista_vue__ = __webpack_require__("MYxH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_73beb44c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuariosLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "DlPF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__ = __webpack_require__("+uNH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f811b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__ = __webpack_require__("Za1C");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_56f811b0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeTempoForaHorarioTrabalhoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ED8O":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('PontoCadastro',{attrs:{"showModalPonto":_vm.showModalPonto,"latitude":_vm.pontoCadastroLat,"longitude":_vm.pontoCadastroLng},on:{"eventname":_vm.updateparent,"update:showModalPonto":function($event){_vm.showModalPonto=$event}}}),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":{'Inicio': 'dataHoraInicio', 'Fim': 'dataHoraFim', 'Tempo Total': 'horaTotal', 'Ponto Mais Próximo': 'pontoMaisProximo', 'Status': 'status', 'Km Rodados': 'kmRodados', 'Km Rodados Odômetro': 'kmRodadosOdometro', 
              'Velocidade Máxima': 'velocidadeMaxima', 'Velocidade Média': 'velocidadeMedia', 'Motorista': 'motorista'  },"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Tempo de Sensor Desligado : ' + _vm.dadosRelatorios.tempoParado  + '  Tempo de Sensor Acionado : ' + _vm.dadosRelatorios.tempoDeslocamento + '\n  Distância Total: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.kmRodados) + '\n  Distância com sensor Desligado: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosDesativado) + ' Km ' + '\n Distância com sensor Acionado: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosAcionado) + ' Km ' + ' \n Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima) + ' Km/h ',"worksheet":"My Worksheet","name":"RelatorioPosicoes.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarDesacionadosMapa()}}},[_vm._v("Posições com o sensor Desligado")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarAcionadosMapa()}}},[_vm._v("Posições com o sensor Acionado")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados), 'linhaAzulClaro': dados.status === 'SENSOR ACIONADO' },on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataHoraInicio))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataHoraFim))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.horaTotal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('strong',[_vm._v(_vm._s(dados.macro))])])]),_vm._v(" "),(dados.kmRodados === null)?[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.status)+" ")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidadeMetros(dados.kmRodadosOdometro))+" Km")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMaxima))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMedia))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])])]:[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.status)+" ")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidadeMetros(dados.kmRodadosOdometro))+" Km")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMaxima))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMedia))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])])]],2)}))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('div',{staticClass:"pull-left"},[_c('strong',[_vm._v("Tempo de Sensor Desligado:")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.tempoParado)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Tempo de Sensor Acionado:")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.tempoDeslocamento)+" "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Distância Total:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.kmRodados))+" Km "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Distância com sensor Desligado:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosDesativado))+" Km "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Distância com sensor Acionado:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.kmRodadosAcionado))+" Km "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Velocidade Média:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h "),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Velocidade Máxima:")]),_vm._v(" "+_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h "),_c('br')])]),_vm._v(" "),_c('div',{staticClass:"col-md-9"},[(_vm.dadosRelatorios.motoristas.length > 0)?[_c('div',{staticClass:"row"},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.motoristas),function(motoristas,i){return _c('tr',[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(motoristas.motoristaNome))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(motoristas.tempoTrabalhado))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(motoristas.kmRodados))+" Km")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(motoristas.velocidadeMaxima))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(motoristas.velocidadeMedia))+" Km/h")])])])}))])])]:_vm._e()],2)]),_vm._v(" "),_vm._m(5)]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Análise de Trabalho")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"120"}},[_vm._v("INICIO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("FIM")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("TEMPO TOTAL")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("STATUS")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("KM RODADOS")]),_vm._v(" "),_c('th',{attrs:{"width":"160"}},[_vm._v("VELOCIDADE MÁXIMA")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("VELOCIDADE MÉDIA")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("MOTORISTA")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Motoristas Encontrados")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Tempo Trabalhado")]),_vm._v(" "),_c('th',{attrs:{"width":"160"}},[_vm._v("Km Rodado")]),_vm._v(" "),_c('th',{attrs:{"width":"160"}},[_vm._v("Velocidade Máxima")]),_vm._v(" "),_c('th',{attrs:{"width":"160"}},[_vm._v("Velocidade Média")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{},[_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EHas":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      lugares: [],
      areas: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      selecionada: '0',
      selecionados: [],
      atualizarGrid: 0,
      atualizarGridInterval: '',
      dadosGrid: [],
      dadosGridAlertaRoubo: [],
      dadosVeiculos: [],
      pontosTipos: [],
      processando: false,
      place: null,
      visualizarPonto: false,
      visualizarArea: false,
      visualizarRota: false,
      showCardPonto: false,
      showCardArea: false,
      showCardRota: false,
      showVeiculosAlertaRoubo: true,
      openControleMapa: false,
      showModalConfirmarGravacao: false,
      mensagemConfirmarGravacao: '',
      mensagemConfirmarGravacaoQuantidade: '',
      ponto: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        clienteId: '0',
        pontoTipoId: '11'
      },
      area: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        tamanho: '50',
        clienteId: '0'
      },
      rota: {
        directionsService: null,
        directionsDisplay: null,
        rotaOrigem: '',
        rotaDestino: '',
        clienteId: '0',
        pontos: []
      }
    };
  },
  mounted: function mounted() {
    this.buscarGrid();
    this.buscarGridAlertaRoubo();
    this.buscarPontosTipos();
  },

  methods: {
    startInterval: function startInterval() {
      var self = this;
      console.log('set interval');
      if (self.atualizarGrid === 0 || self.atualizarGrid === '0') {
        clearInterval(self.atualizarGridInterval);
      } else {
        self.atualizarGridInterval = setInterval(function () {
          self.atualizarBuscarGrid();
        }, self.atualizarGrid);
      }
    },
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarGridAlertaRoubo: function buscarGridAlertaRoubo() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=true';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGridAlertaRoubo = dadosCadastro.dados;
        self.processando = false;
      });
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/grid?busca=' + self.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro.dados;
        self.processando = false;
        self.markers = [];
      });
    },
    buscarPontosTipos: function buscarPontosTipos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/pontosTipos/buscarPontosTipos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.pontosTipos = response.data;
      });
    },
    atualizarBuscarGrid: function atualizarBuscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/grid?busca=' + self.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro.dados;
        self.processando = false;
        self.markers = [];
        self.removerMarkers();
        self.adicionarMarkers();
      });
    },

    buscarVeiculos: function buscarVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/listarVeiculos?busca=' + this.busca;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculos = dadosCadastro;
        self.processando = false;
      });
    },
    adicionarMarker: function adicionarMarker(posicao) {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      var position = {
        lat: posicao.latitude,
        lng: posicao.longitude
      };
      var marker = { position: position, descricao: posicao.descricaoVeiculo, dataHora: posicao.dataHora, ignicao: posicao.ignicao, movimento: posicao.movimento, gprs: posicao.gprs, velocidade: posicao.velocidade, pontoMaisProximo: posicao.pontoMaisProximo };
      if (posicao.latitude !== 0) {
        if (self.selecionados.includes(posicao.idVeiculo)) {
          self.selecionados.splice(self.selecionados.indexOf(posicao.idVeiculo), 1);
          for (var i = 0; i < self.markers.length; i++) {
            if (self.markers[i].descricao === marker.descricao) {
              self.markers.splice(i, 1);
            }
          }
          if (self.markers.length === 1) {
            self.areas = [];
            if (self.showCardArea) {
              self.areas.push(self.markers[0]);
            }
          } else {
            self.areas = [];
          }
        } else {
          self.markers.push(marker);
          self.selecionados.push(posicao.idVeiculo);
          if (self.markers.length === 1) {
            self.areas = [];
            if (self.showCardArea) {
              self.areas.push(marker);
            }
          } else {
            self.areas = [];
          }
        }
        for (var _i = 0; _i < self.markers.length; _i++) {
          var myLatLng = new window.google.maps.LatLng({ lat: self.markers[_i].position.lat, lng: self.markers[_i].position.lng });
          bounds.extend(myLatLng);
        }
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }

        self.currentPlace = null;
      }
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();

      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.dadosGrid.length; i++) {
          if (self.dadosGrid[i].latitude !== 0) {
            var marker = {
              lat: self.dadosGrid[i].latitude,
              lng: self.dadosGrid[i].longitude
            };
            if (self.selecionados.includes(self.dadosGrid[i].idVeiculo)) {
              self.markers.push({ position: marker, descricao: self.dadosGrid[i].descricaoVeiculo, dataHora: self.dadosGrid[i].dataHora, ignicao: self.dadosGrid[i].ignicao, movimento: self.dadosGrid[i].movimento, gprs: self.dadosGrid[i].gprs, velocidade: self.dadosGrid[i].velocidade, pontoMaisProximo: self.dadosGrid[i].pontoMaisProximo });
              var myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
              bounds.extend(myLatLng);
            }
          }
        }
      } else {
        for (var _i2 = 0; _i2 < self.dadosGrid.length; _i2++) {
          if (self.dadosGrid[_i2].latitude !== 0) {
            var _marker = {
              lat: self.dadosGrid[_i2].latitude,
              lng: self.dadosGrid[_i2].longitude
            };
            self.markers.push({ position: _marker, descricao: self.dadosGrid[_i2].descricaoVeiculo, dataHora: self.dadosGrid[_i2].dataHora, ignicao: self.dadosGrid[_i2].ignicao, movimento: self.dadosGrid[_i2].movimento, gprs: self.dadosGrid[_i2].gprs, velocidade: self.dadosGrid[_i2].velocidade, pontoMaisProximo: self.dadosGrid[_i2].pontoMaisProximo });
            var _myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            bounds.extend(_myLatLng);
            self.selecionados.push(self.dadosGrid[_i2].idVeiculo);
          }
        }
      }
      for (var _i3 = 0; _i3 < self.lugares.length; _i3++) {
        self.markers.push({
          position: {
            lat: self.lugares[_i3].position.lat,
            lng: self.lugares[_i3].position.lng
          },
          descricao: self.lugares[_i3].descricao
        });
        var _myLatLng2 = new window.google.maps.LatLng({ lat: self.lugares[_i3].position.lat, lng: self.lugares[_i3].position.lng });
        bounds.extend(_myLatLng2);
      }
      self.$refs.map.fitBounds(bounds);
      if (self.$refs.map.$mapObject.zoom > 18) {
        self.$refs.map.$mapObject.setZoom(18);
      }

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
    },
    removerLugares: function removerLugares() {
      var self = this;
      self.lugares = [];
    },
    limparSelecionados: function limparSelecionados() {
      var self = this;
      self.selecionados = [];
    },
    setPlace: function setPlace(place) {
      this.place = place;
    },
    usePlace: function usePlace(place) {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      if (this.place) {
        this.lugares.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          },
          descricao: this.place.name
        });
        this.markers.push({
          position: {
            lat: this.place.geometry.location.lat(),
            lng: this.place.geometry.location.lng()
          },
          descricao: this.place.name
        });

        var myLatLng = new window.google.maps.LatLng({ lat: this.place.geometry.location.lat(), lng: this.place.geometry.location.lng() });
        bounds.extend(myLatLng);
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
        $(this.$el).find('#buscarLocal').val('');
        this.place = null;
      }
    },

    geolocate: function geolocate() {
      var _this = this;

      navigator.geolocation.getCurrentPosition(function (position) {
        _this.center = {
          lat: position.coords.latitude,
          lng: position.coords.longitude,
          infoText: 'Marker 1'
        };
      });
    },
    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + parseFloat(marker.velocidade).toFixed(2) + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    },
    setRotaOrigem: function setRotaOrigem(place) {
      console.log(place);
      this.rota.rotaOrigem = place.formatted_address;
    },
    setRotaDestino: function setRotaDestino(place) {
      this.rota.rotaDestino = place.formatted_address;
    },

    buscarRota: function buscarRota() {
      var self = this;
      if (self.rota.directionsDisplay === null) {
        self.rota.directionsService = new window.google.maps.DirectionsService();
        self.rota.directionsDisplay = new window.google.maps.DirectionsRenderer();
      } else {
        self.rota.directionsDisplay.setMap(null);
      }
      self.rota.directionsDisplay.setMap(self.$refs.map.$mapObject);
      var vm = this;
      vm.rota.directionsService.route({
        origin: self.rota.rotaOrigem,
        destination: self.rota.rotaDestino,
        travelMode: 'DRIVING',
        provideRouteAlternatives: true
      }, function (response, status) {
        if (status === 'OK') {
          vm.rota.directionsDisplay.setDirections(response);
          console.log(response);
        } else {
          if (status === 'ZERO_RESULTS') {
            self.$toastr('error', 'NÃO FOI POSSÍVEL ENCONTRAR UMA ROTAS.', 'Atenção');
          }
          console.log('Directions request failed due to ' + status);
        }
      });
    },
    mostrarCadastroPonto: function mostrarCadastroPonto() {
      var self = this;
      self.showCardPonto = true;
      self.showCardArea = false;
      self.showCardRota = false;
    },
    mostrarCadastroArea: function mostrarCadastroArea() {
      var self = this;
      self.showCardArea = true;
      self.showCardPonto = false;
      self.showCardRota = false;
      if (self.markers.length === 1) {
        self.areas = self.markers;
      } else {
        self.areas = [];
      }
    },
    mostrarCadastroRota: function mostrarCadastroRota() {
      var self = this;
      self.showCardRota = true;
      self.showCardPonto = false;
      self.showCardArea = false;
    },

    setarClientePonto: function setarClientePonto(cliente) {
      this.ponto.clienteId = cliente.id;
      this.ponto.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#pontoClienteNome').val(cliente.nomeFantasia);
    },
    verificarClientePonto: function verificarClientePonto() {
      if ($(this.$el).find('#pontoClienteId').val() === '0') {
        this.ponto.clienteId = 0;
        this.ponto.clienteNome = '';
        $(this.$el).find('#pontoClienteId').val(0);
        $(this.$el).find('#pontoClienteNome').val('');
      }
      if ($(this.$el).find('#pontoClienteNomePonto').val() === '') {
        this.ponto.clienteId = 0;
        this.ponto.clienteNome = '';
        $(this.$el).find('#pontoClienteId').val(0);
        $(this.$el).find('#pontoClienteNome').val('');
      }
    },
    gravarPonto: function gravarPonto() {
      var self = this;
      if (self.markers.length === 0) {
        this.$toastr('error', 'Adicione um ponto de referência ao mapa.', 'Atenção');
        return;
      }
      if (self.markers.length > 1) {
        this.$toastr('error', 'Adicione APENAS UM ponto de referência ao mapa.', 'Atenção');
        return;
      }
      if (self.ponto.descricao === '') {
        this.$toastr('error', 'Adicione a descrição do ponto.', 'Atenção');
        return;
      }
      self.ponto.latitude = self.markers[0].position.lat;
      self.ponto.longitude = self.markers[0].position.lng;
      self.processando = true;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/pontos/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.ponto), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Ponto gravado com sucesso!</h4><br/>';
          self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> pontos para cadastro</p>';
          self.showModalConfirmarGravacao = true;
          self.showCardPonto = false;
          self.showCardArea = false;
          self.showCardRota = false;
          self.ponto = { id: '0', latitude: '0', longitude: '0', descricao: '', clienteId: '0', pontoTipoId: '0' };
        }
      }).catch(function (error) {
        self.processando = false;
        console.log(error);
      });
    },
    gravarArea: function gravarArea() {
      var self = this;
      if (self.markers.length > 0) {}
    },
    gravarRota: function gravarRota() {
      var self = this;
      self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Rota gravada com sucesso!</h4><br/>';
      self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> rotas para cadastro</p>';
      self.showModalConfirmarGravacao = true;
      self.showCardPonto = false;
      self.showCardArea = false;
      self.showCardRota = false;
      self.rota = { directionsService: null, directionsDisplay: null, rotaOrigem: '', rotaDestino: '', clienteId: '0', pontos: [] };
    }
  }
};

/***/ }),

/***/ "EP7J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalExportarPontos)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalExportarPontos","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.exportarPontos.dataInicial),callback:function ($$v) {_vm.$set(_vm.exportarPontos, "dataInicial", $$v)},expression:"exportarPontos.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.exportarPontos.dataFinal),callback:function ($$v) {_vm.$set(_vm.exportarPontos, "dataFinal", $$v)},expression:"exportarPontos.dataFinal"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarExportarPontos}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalExportarPontos = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalNovaJornada)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Tipo Jornada:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.tipoJornada),expression:"jornada.tipoJornada"}],staticClass:"form-control",attrs:{"id":"modalItemTipoJornada","required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.jornada, "tipoJornada", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Jornada")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Falta")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Folga")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Folga Semanal")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Folga I.J.")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Feriado")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Atestado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Ferias")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("Compensado")])])])]),_vm._v(" "),(_vm.jornada.tipoJornada === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraFinal", $$v)},expression:"jornada.dataHoraFinal"}})],1)])]:(_vm.jornada.tipoJornada === '8')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraFinal", $$v)},expression:"jornada.dataHoraFinal"}})],1)])]:[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1)])],_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.motoristaId),expression:"jornada.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNovaJornadaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotoristaNovaJornada,"on-blur":_vm.verificarMotoristaNovaJornada},model:{value:(_vm.jornada.motoristaNome),callback:function ($$v) {_vm.$set(_vm.jornada, "motoristaNome", $$v)},expression:"jornada.motoristaNome"}})],1)]),_vm._v(" "),(_vm.jornada.tipoJornada === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.veiculoId),expression:"jornada.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('buscar-veiculo',{attrs:{"type":"search","id":"veiculoNovaJornadaDescricao","placeholder":"Selecione um veículo..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarVeiculoNovaJornada,"on-blur":_vm.verificarVeiculoNovaJornada},model:{value:(_vm.jornada.veiculoDescricao),callback:function ($$v) {_vm.$set(_vm.jornada, "veiculoDescricao", $$v)},expression:"jornada.veiculoDescricao"}})],1)])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarNovaJornada}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalNovaJornada = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalRelatorioSintetico)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Tipo Relatório:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.tipo),expression:"relatorio.tipo"}],staticClass:"form-control",attrs:{"required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorio, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Relatório Sintetico")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Relatório de Tempo de Alimentção")]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('option',{attrs:{"value":"3"}},[_vm._v("Relatório Sintetico TESTE")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataInicial", $$v)},expression:"relatorio.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataFinal", $$v)},expression:"relatorio.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v("Motoristas/Cargo")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.buscas),expression:"relatorio.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.relatorio.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarTodosMotoristasRelatorio()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "buscas", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscarTodosMotoristasRelatorio()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.selecionadoMotoristaTodos}},[_vm._v(" Selecionar Todos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.selecionadoMotoristaLimpar}},[_vm._v(" Limpar Seleção")])])]),_vm._v(" "),_c('div',{staticStyle:{"max-height":"calc(100vh - 444px)","overflow-y":"auto"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaMotoristas","width":"100%"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosMotoristas),function(motorista){return _c('tr',{class:{ 'selecionado': _vm.selecionadoMotorista(motorista) },on:{"click":function($event){_vm.selecionarMotoristaItem(motorista)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":motorista.id}}),_vm._v(" "),(_vm.selecionadoMotorista(motorista))?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(motorista.id))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(motorista.nome))])])])}))])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.motoristaId),expression:"relatorio.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.relatorio.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "motoristaId", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarRelatorioSinteticoMotoristas}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorioSintetico = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalNovaJornada = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Nova Jornada Manual\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.juntarJornada}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Juntar Jornadas\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.duplicarJornada}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Duplicar Jornada\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.abrirModalRelatorioSintetico}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatório Sintético\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.deletarMultiplas}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Deletar Jornadas\n                  ")]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.recalcularJornadas}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Recalcular Jornadas\n                    ")])]:_vm._e(),_vm._v(" "),_c('button',{staticClass:"btn btn-warning",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalExportarPontos = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Exportar Arq. Ponto\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],2)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Periodo:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-8"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"todos","selected":"selected"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"aprovadacom"}},[_vm._v("Aprovada com Documento")]),_vm._v(" "),_c('option',{attrs:{"value":"aprovadasem"}},[_vm._v("Aprovada")]),_vm._v(" "),_c('option',{attrs:{"value":"gerado"}},[_vm._v("Gerado pelo Sistema")]),_vm._v(" "),_c('option',{attrs:{"value":"editado"}},[_vm._v("Editado Manual")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-limpo"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(jornada){return _c('tr',{class:{ 'selecionado': _vm.selecionado(jornada) },on:{"click":function($event){_vm.selecionarItem(jornada, $event)},"dblclick":function($event){_vm.editar(jornada.id)}}},[_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(jornada.id))]),_vm._v(" "),_c('td',{attrs:{"width":"155"}},[_vm._v(_vm._s(jornada.dataHoraInicial)),_c('br'),_vm._v(_vm._s(jornada.dataHoraFinal))]),_vm._v(" "),_c('td',[(jornada.diaria === true)?[_c('strong',[_vm._v("DIÁRIA")])]:_vm._e(),_vm._v(" "),(jornada.folga === true)?[_c('strong',[_vm._v("FOLGA")])]:_vm._e(),_vm._v(" "),(jornada.folgaSemanal === true)?[_c('strong',[_vm._v("FOLGA SEMANAL")])]:_vm._e(),_vm._v(" "),(jornada.folgaIJ === true)?[_c('strong',[_vm._v("FOLGA I.J.")])]:_vm._e(),_vm._v(" "),(jornada.falta === true)?[_c('strong',[_vm._v("FALTA")])]:_vm._e(),_vm._v(" "),(jornada.feriado === true)?[_c('strong',[_vm._v("FERIADO")])]:_vm._e(),_vm._v(" "),(jornada.atestado === true)?[_c('strong',[_vm._v("ATESTADO")])]:_vm._e(),_vm._v(" "),(jornada.ferias === true)?[_c('strong',[_vm._v("FÉRIAS")])]:_vm._e(),_vm._v(" "),(jornada.compensado === true)?[_c('strong',[_vm._v("COMPENSADO")])]:_vm._e(),_vm._v(" "),(jornada.veiculoDescricao !== null)?[_c('strong',[_vm._v(_vm._s(jornada.veiculoDescricao))])]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(jornada.motoristaNome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(jornada.status))]),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[(jornada.ajudante1Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 1'),expression:"'Gerar Jornada Ajudante 1'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 1)}}})]:_vm._e(),_vm._v(" "),(jornada.ajudante2Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 2'),expression:"'Gerar Jornada Ajudante 2'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 2)}}})]:_vm._e(),_vm._v(" "),(jornada.ajudante3Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 3'),expression:"'Gerar Jornada Ajudante 3'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 3)}}})]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Imprimir'),expression:"'Imprimir'"}],attrs:{"src":"/static/images/imprimir.png"},on:{"click":function($event){_vm.imprimir(jornada.id)}}}),_vm._v(" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'GestaoJornadasEditar', params: { id: jornada.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(jornada.id)}}})],1)])}))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Exportar Arquivo de Pontos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Nova Jornada")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatório Sintético")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Cargo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Gestão de Jornadas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Cód")]),_vm._v(" "),_c('th',[_vm._v("Período")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Motorista")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "EhHL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "EiHW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-vendedor',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#vendedorNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#vendedorNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVendedoresAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "El0Z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("WgA/")));

/***/ }),

/***/ "ExJn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue__ = __webpack_require__("EHas");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6538db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoramento_vue__ = __webpack_require__("koM4");
function injectStyle (ssrContext) {
  __webpack_require__("o106")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Monitoramento_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2b6538db_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Monitoramento_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "F0rU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.descricaoVeiculo))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.clienteVeiculo))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F0rt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "F8FW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosVeiculo.buscas,
        pagina: this.$store.state.filtrosVeiculo.pagina,
        quantidade: this.$store.state.filtrosVeiculo.quantidade,
        status: this.$store.state.filtrosVeiculo.status,
        selecionada: this.$store.state.filtrosVeiculo.selecionada
      },
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.filtros.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.filtros.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_VEICULO', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/veiculos/editar/' + id);
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Veículo?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/veiculos/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo deletado com sucesso.', 'Atenção');
              url = '/api/veiculos?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "FBFl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue__ = __webpack_require__("RxM3");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f24e206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputQuantidade_vue__ = __webpack_require__("D7gQ");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputQuantidade_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5f24e206_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputQuantidade_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "FLhB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('sidebar'),_vm._v(" "),_c('main',{staticClass:"main"},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Fhei":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue__ = __webpack_require__("ohNw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9ce28c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarTransportador_vue__ = __webpack_require__("CA9a");
function injectStyle (ssrContext) {
  __webpack_require__("2s0f")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTransportador_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9b9ce28c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarTransportador_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Fptk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue__ = __webpack_require__("fPub");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289cd9ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontosLista_vue__ = __webpack_require__("4/sl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_289cd9ac_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontosLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "G5IE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue__ = __webpack_require__("pQzR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea0260e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosEditar_vue__ = __webpack_require__("l9zi");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5ea0260e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "G909":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue__ = __webpack_require__("N4Y6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b21aaeae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesView_vue__ = __webpack_require__("cNYX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b21aaeae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "GB0m":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  name: 'AuthLayout'
};

/***/ }),

/***/ "GY//":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hOwk")));

/***/ }),

/***/ "GecJ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue__ = __webpack_require__("IetH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88dc78ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabela_vue__ = __webpack_require__("Vkzg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabela_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_88dc78ae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabela_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Geto":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalDuracaoDesativarBateria)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"lancarFinanceiroModal","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Duração")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.duracaoDesativarBateria),expression:"duracaoDesativarBateria"}],staticClass:"form-control",attrs:{"id":"lancarFinanceiroTipoLancamento","type":"text"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.duracaoDesativarBateria=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("1 Dia")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("3 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("1 Semana")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('smal',[_vm._v("* após o período selecionado o evento será ativado automaticamente.")])],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"confirmarLancarFinanceiro","type":"button"},on:{"click":function($event){_vm.confirmarAtivarAlertaBateria()}}},[_vm._v("Confirmar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalDuracaoDesativarBateria = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoVeiculo","to":"/veiculos"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab1"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Placa:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.placa),expression:"model.placa"}],staticClass:"pula form-control placa",attrs:{"readonly":"readonly\n                          "},domProps:{"value":(_vm.model.placa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "placa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8 col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"pula form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Data Cadastro:")]),_c('br'),_vm._v(" "),(_vm.model.id === 0)?[_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataCadastroRastreamento),callback:function ($$v) {_vm.$set(_vm.model, "dataCadastroRastreamento", $$v)},expression:"model.dataCadastroRastreamento"}})]:[_c('input-data-picker',{staticClass:"pula data form-control",attrs:{"readonly":"readonly"},model:{value:(_vm.model.dataCadastroRastreamento),callback:function ($$v) {_vm.$set(_vm.model, "dataCadastroRastreamento", $$v)},expression:"model.dataCadastroRastreamento"}})]],2)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Dados do Veículo:")]),_c('br'),_vm._v("\n                          "+_vm._s(_vm.model.marca)+"/"),_c('strong',[_vm._v(_vm._s(_vm.model.modelo))]),_vm._v(" - "+_vm._s(_vm.model.anoFabricacao)+"/"+_vm._s(_vm.model.anoModelo)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Km Atual:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.kmAtual),expression:"model.kmAtual"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.kmAtual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "kmAtual", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Senha Identificação:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.senhaIdentificacao),expression:"model.senhaIdentificacao"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.senhaIdentificacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "senhaIdentificacao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Macro:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.macroAutomatica),expression:"model.macroAutomatica"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "macroAutomatica", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"","label":""}}),_vm._v(" "),_c('option',{attrs:{"value":"03","label":"03 - Carga e Descarga"}}),_vm._v(" "),_c('option',{attrs:{"value":"34","label":"34 - Diaria"}})])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                          Aplicativo\n                        ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta Roubo:")]),_c('br'),_vm._v(" "),(_vm.model.alertaRoubo)?_c('div',[_vm._m(4),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaRoubo('Deseja realmente desativar o Alerta de Roubo desse Veículo?')}}},[_vm._v("DESATIVAR")])]):_c('div',[_vm._m(5),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaRoubo('<strong>Atenção</strong><br><br>Ao colocar o veículo em estado de alerta, todos os clientes poderão visualiza-lo. Não informe um falso alerta de roubo, passível de penalidades!<br><br><br><br><strong>Deseja realmente ativar o Alerta de Roubo desse Veículo</strong>?')}}},[_vm._v("ATIVAR")])])]),_vm._v(" "),(_vm.model.possuiBloqueioBau)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Bloqueio Baú:")]),_c('br'),_vm._v(" "),(_vm.model.estaBloqueioBau)?_c('div',[_vm._m(6),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block"},[_vm._v("DESBLOQUEAR")])]):_c('div',[_vm._m(7),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block"},[_vm._v("BLOQUEAR")])])])]:_vm._e(),_vm._v(" "),(_vm.model.possuiBloqueioVeiculo)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Bloqueio Veículo:")]),_c('br'),_vm._v(" "),(_vm.model.estaBloqueioVeiculo)?_c('div',[_vm._m(8),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.bloquearVeiculo('Deseja realmente desbloquear esse Veículo?')}}},[_vm._v("DESBLOQUEAR")])]):_c('div',[_vm._m(9),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.bloquearVeiculo('Deseja realmente bloquear esse Veículo?')}}},[_vm._v("BLOQUEAR")])])])]:_vm._e(),_vm._v(" "),(_vm.model.possuiEventoIgnicao)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta Ignição:")]),_c('br'),_vm._v(" "),(_vm.model.estaEventoIgnicao)?_c('div',[_vm._m(10),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaIgnicao('Deseja realmente desativar o Alerta de Ignição desse Veículo?')}}},[_vm._v("DESATIVAR")])]):_c('div',[_vm._m(11),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaIgnicao('Deseja realmente ativar o Alerta de Ignição desse Veículo?')}}},[_vm._v("ATIVAR")])])])]:_vm._e(),_vm._v(" "),(_vm.model.possuiEventoArea)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta Área:")]),_c('br'),_vm._v(" "),(_vm.model.estaEventoArea)?_c('div',[_vm._m(12),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaArea('Deseja realmente desativar o Alerta de Área desse Veículo?')}}},[_vm._v("DESATIVAR")])]):_c('div',[_vm._m(13),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaArea('Deseja realmente ativar o Alerta de Área desse Veículo?')}}},[_vm._v("ATIVAR")])]),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Distância:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.eventoAreaDistancia),expression:"model.eventoAreaDistancia"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.eventoAreaDistancia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "eventoAreaDistancia", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.eventoAreaLatitude),expression:"model.eventoAreaLatitude"}],staticClass:"pula form-control ",attrs:{"type":"hidden"},domProps:{"value":(_vm.model.eventoAreaLatitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "eventoAreaLatitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.eventoAreaLongitude),expression:"model.eventoAreaLongitude"}],staticClass:"pula form-control ",attrs:{"type":"hidden"},domProps:{"value":(_vm.model.eventoAreaLongitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "eventoAreaLongitude", $event.target.value)}}})])]:_vm._e(),_vm._v(" "),(_vm.model.possuiEventoBateria)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta Bateria:")]),_c('br'),_vm._v(" "),(_vm.model.estaEventoBateria)?_c('div',[_vm._m(14),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaBateria('Deseja realmente desativar o Alerta de Bateria desse Veículo?')}}},[_vm._v("DESATIVAR")])]):_c('div',[_vm._m(15),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaBateria('Deseja realmente ativar o Alerta de Bateria desse Veículo?')}}},[_vm._v("ATIVAR")])])])]:_vm._e(),_vm._v(" "),(_vm.model.possuiEventoVelocidade)?[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Alerta Velocidade:")]),_c('br'),_vm._v(" "),(_vm.model.estaEventoVelocidade)?_c('div',[_vm._m(16),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaVelocidade('Deseja realmente desativar o Alerta de Velocidade desse Veículo?')}}},[_vm._v("DESATIVAR")])]):_c('div',[_vm._m(17),_vm._v(" "),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-danger btn-block",on:{"click":function($event){_vm.ativarAlertaVelocidade('Deseja realmente ativar o Alerta de Velocidade desse Veículo?')}}},[_vm._v("ATIVAR")])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',{staticClass:"control-label"},[_vm._v("Velocidade Máxima:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.velocidadeMaxima),expression:"model.velocidadeMaxima"}],staticClass:"pula form-control ",domProps:{"value":(_vm.model.velocidadeMaxima)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "velocidadeMaxima", $event.target.value)}}})])]:_vm._e()],2)])])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Tempo duração Desativar Bateria")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tab1","data-toggle":"tab"}},[_vm._v("Geral")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("BLOQUEADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESBLOQUEADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("BLOQUEADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESBLOQUEADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("ATIVADO")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("DESATIVADO")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "GpAW":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue__ = __webpack_require__("dWEF");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587447f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreasLista_vue__ = __webpack_require__("L2bj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_587447f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreasLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HP1X":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      atualizarGrid: 0,
      atualizarGridInterval: '',
      selecionada: '0',
      dadosTabela: [],
      dadosTabelaAlertaRoubo: [],
      processando: true,
      showModalDadosVeiculo: false,
      dadosVeiculo: [],
      dadosVeiculoContatoCliente: [],
      dadosVeiculoContatoClientePaga: []
    };
  },

  created: function created() {
    this.buscarGrid();
    this.buscarGridAlertaRoubo();
  },
  methods: {
    startInterval: function startInterval() {
      var self = this;
      console.log('set interval');
      if (self.atualizarGrid === 0 || self.atualizarGrid === '0') {
        clearInterval(self.atualizarGridInterval);
      } else {
        self.atualizarGridInterval = setInterval(function () {
          self.buscarGrid();
        }, self.atualizarGrid);
      }
    },
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    setMixPanel: function setMixPanel() {
      var data = this.$auth.user();
      this.$ma.setUserProperties({ userId: data.uid, UserId: data.uid, name: data.name, Name: data.name, Email: '', Company: 'Spark' });
      this.$ma.setAlias(data.name);
      this.$ma.setUsername(data.name);
    },
    buscarDadosEmpresa: function buscarDadosEmpresa() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/verificarCadastroEmpresa';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        if (response.data === false) {
          self.$router.replace('/empresa');
        }
      });
    },
    buscarGridAlertaRoubo: function buscarGridAlertaRoubo() {
      var self = this;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=true';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabelaAlertaRoubo = dadosCadastro.dados;
      });
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/grid?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos + '&alertaRoubo=false';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.processando = false;
      });
    },
    mostrarDadosVeiculo: function mostrarDadosVeiculo(veiculo) {
      var self = this;
      self.dadosVeiculo = [];
      self.processando = true;
      self.showModalDadosVeiculo = true;
      self.buscarGridDadosVeiculo(veiculo);
    },
    buscarGridDadosVeiculo: function buscarGridDadosVeiculo(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gridDadosVeiculo?veiculo=' + veiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculo = dadosCadastro;
        self.processando = false;
      });
    },
    buscarGridDadosVeiculoContatoCliente: function buscarGridDadosVeiculoContatoCliente(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clienteId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculoContatoCliente = dadosCadastro;
        self.processando = false;
      });
    },
    buscarGridDadosVeiculoContatoClientePaga: function buscarGridDadosVeiculoContatoClientePaga(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clientePagaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculoContatoClientePaga = dadosCadastro;
        self.processando = false;
      });
    },
    buscarVendasProdutosMaisVendidosPeriodo: function buscarVendasProdutosMaisVendidosPeriodo() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.vendasProdutosMaisVendidosPeriodoDados = response.data;
      });
    },
    buscarRealizadoReceberPeriodo: function buscarRealizadoReceberPeriodo() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/financeiroReceberPeriodo?periodo=' + this.financeiroPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento;
      _axios2.default.get(url, config).then(function (response) {
        var receber = [];
        var recebido = [];
        for (var i = 0; i < response.data.length; i++) {
          receber = response.data[i].valorTotal;
          recebido = response.data[i].valorTotalPago;
        }
        self.realizadoReceber = {
          labels: ['Receber', 'Recebido'],
          datasets: [{
            label: 'Receber',
            backgroundColor: ['#FF9800', '#42A5F5'],
            data: [receber, recebido]
          }]
        };
      });
    },
    buscarRealizadoPagarPeriodo: function buscarRealizadoPagarPeriodo() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/financeiroPagarPeriodo?periodo=' + this.financeiroPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento;
      _axios2.default.get(url, config).then(function (response) {
        var pagar = [];
        var pago = [];
        for (var i = 0; i < response.data.length; i++) {
          pagar = response.data[i].valorTotal;
          pago = response.data[i].valorTotalPago;
        }
        self.realizadoPagar = {
          labels: ['Pagar', 'Pago'],
          datasets: [{
            label: 'pagar',
            backgroundColor: ['#F4511E', '#42A5F5'],
            data: [pagar, pago]
          }]
        };
      });
    }
  }
};

/***/ }),

/***/ "HUt/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__ = __webpack_require__("fcFS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("PKAF")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_input_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "HX5m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{name: 'ConvencoesEditar', params: { id: 0 }}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_vm._m(1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscas),expression:"buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.buscas=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantidade),expression:"quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.quantidade=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaConvencoes","width":"100%"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(convecao){return _c('tr',{class:{ 'selecionado': _vm.selecionado(convecao) },on:{"click":function($event){_vm.selecionarItem(convecao)},"dblclick":function($event){_vm.editar(convecao.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":convecao.id}}),_vm._v(" "),(convecao.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(convecao.id))]),_vm._v(" "),_c('td',[_vm._v("\n                      "+_vm._s(convecao.nome)+"\n                    ")]),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'ConvencoesEditar', params: { id: convecao.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(convecao.id)}}})],1)])}))])])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.pagina,"fn":_vm.paginacao}})],1)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Convenções")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HYkd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue__ = __webpack_require__("gVe6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b723e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasConvencaoView_vue__ = __webpack_require__("U90E");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasConvencaoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_6e9b723e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasConvencaoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "IYJS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.showModalConfirmarGravacao)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('span',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.mensagemConfirmarGravacao)}}),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.mensagemConfirmarGravacaoQuantidade)}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"text-danger",attrs:{"href":"#"},on:{"click":function($event){_vm.showModalConfirmarGravacao = false}}},[_c('strong',[_vm._v("Fechar")])])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalPonto)?_c('div',{staticClass:"modal fade fadeIn show ",attrs:{"tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-md"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v("Pontos")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","right":"8px","font-size":"20px"},on:{"click":function($event){_vm.closeModal()}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.descricao),expression:"ponto.descricao"}],staticClass:"form-control",attrs:{"placeholder":"Descrição do ponto","type":"text"},domProps:{"value":(_vm.ponto.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ponto, "descricao", $event.target.value)}}})]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.clienteId),expression:"ponto.clienteId"}],attrs:{"type":"hidden","id":"pontoClienteId"},domProps:{"value":(_vm.ponto.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ponto, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"pontoClienteNome","name":"pontoClienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarClientePonto,"on-blur":_vm.verificarClientePonto},model:{value:(_vm.ponto.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.ponto, "clienteNomeFantasia", $$v)},expression:"ponto.clienteNomeFantasia"}})],1)]:_vm._e(),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Tipo do Ponto")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.pontoTipoId),expression:"ponto.pontoTipoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ponto, "pontoTipoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pontosTipos),function(pontoTipo){return _c('option',{attrs:{"selected":""},domProps:{"value":pontoTipo.id}},[_vm._v(_vm._s(pontoTipo.descricao))])}))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.gravarPonto();}}},[(_vm.processando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gravar Ponto")])]),_vm._v(" "),_c('hr')],2)])])])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-checkmark"},[_c('div',{staticClass:"check-icon"},[_c('span',{staticClass:"icon-line line-tip"}),_vm._v(" "),_c('span',{staticClass:"icon-line line-long"}),_vm._v(" "),_c('div',{staticClass:"icon-circle"}),_vm._v(" "),_c('div',{staticClass:"icon-fix"})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "IetH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        dataInicial: this.$store.state.filtrosGestaoJornada.dataInicial === '' ? this.primeiroDiaMes('') : this.$store.state.filtrosGestaoJornada.dataInicial,
        dataFinal: this.$store.state.filtrosGestaoJornada.dataFinal === '' ? this.ultimoDiaMes('') : this.$store.state.filtrosGestaoJornada.dataFinal,
        buscas: this.$store.state.filtrosGestaoJornada.buscas,
        exibir: this.$store.state.filtrosGestaoJornada.exibir,
        ordem: this.$store.state.filtrosGestaoJornada.ordem
      },
      jornada: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        veiculoId: '0',
        veiculoDescricao: '',
        tipoJornada: '1'
      },
      relatorio: {
        tipo: '1',
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        buscas: ''
      },
      dadosTabela: [],
      selecionadas: [],
      motoristas: [],
      motoristasSelecionados: [],
      dadosMotoristas: [],
      selecionadasMotoristas: [],
      selecionada: '',
      processando: false,
      botaoProcessando: false,
      showModalNovaJornada: false,
      showModalRelatorioSintetico: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item;
      if (event.ctrlKey || event.metaKey) {
        this.selecionadas.push(item);
      } else {
        this.selecionadas = [];
        this.selecionadas.push(item);
      }
    },
    selecionado: function selecionado(item) {
      for (var i = 0; i < this.selecionadas.length; i++) {
        if (this.selecionadas[i].id === item.id) {
          return true;
        }
      }
      return false;
    },
    buscarTodosMotoristasRelatorio: function buscarTodosMotoristasRelatorio() {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/buscarMotoristasAtivos?busca=' + self.relatorio.buscas;
      _axios2.default.get(url, config).then(function (response) {
        self.dadosMotoristas = response.data.slice();
        self.selecionadasMotoristas = response.data.slice();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    selecionarMotoristaItem: function selecionarMotoristaItem(item, event) {
      this.selecionadaMotorista = item;
      if (this.selecionadoMotorista(item)) {
        this.removerMotorista(item);
      } else {
        this.selecionadasMotoristas.push(item);
      }
    },
    selecionadoMotorista: function selecionadoMotorista(item) {
      for (var i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          return true;
        }
      }
      return false;
    },
    removerMotorista: function removerMotorista(item) {
      for (var i = 0; i < this.selecionadasMotoristas.length; i++) {
        if (this.selecionadasMotoristas[i].id === item.id) {
          console.log('Remove ' + item);
          this.selecionadasMotoristas.splice(i, 1);
        }
      }
    },
    selecionadoMotoristaTodos: function selecionadoMotoristaTodos() {
      this.selecionadasMotoristas = this.dadosMotoristas.slice();
    },
    selecionadoMotoristaLimpar: function selecionadoMotoristaLimpar() {
      this.selecionadasMotoristas = [];
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar() {
      var self = this;
      this.$store.commit('SET_FILTROS_GESTAO_JORNADA', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      self.processando = true;
      var url = '/api/v2/gestaoJornadas/listarJornadaMacros?buscas=' + this.filtros.buscas + '&dataHoraInicial=' + this.filtros.dataInicial + '&dataHoraFinal=' + this.filtros.dataFinal + '&exibir=' + this.filtros.exibir + '&ordem=' + this.filtros.ordem;
      _axios2.default.get(url, config).then(function (response) {
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro;
        self.processando = false;
      });
    },
    gravarAnalise: function gravarAnalise() {
      var _this = this;

      var self = this;
      self.processando = true;
      var promises = [];

      var message = 'Deseja realmente gerar essas Jornadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this.$store.state.token }
        };
        for (var i = 0; i < _this.dadosTabela.length; i++) {
          promises.push(_axios2.default.get('/api/v2/gestaoJornadas/gerarJornadaMacrosGravar?jornadaMacroId=' + self.dadosTabela[i].id + '&dataHoraInicial=' + self.dadosTabela[i].dataInicial + '&dataHoraFinal=' + self.dadosTabela[i].dataFinalReal, config).then(function (response) {}));
        }
        _promise2.default.all(promises).then(function () {
          return self.$toastr('success', 'Jornadas geradas com sucesso.', 'Atenção');
        }, self.buscar(), dialog.close());
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    juntarJornada: function juntarJornada(id) {
      var _this2 = this;

      var self = this;
      if (self.selecionadas.length !== 2) {
        self.$toastr('error', 'Selecione duas Jornadas para Combinar.', 'Atenção');
        return;
      }
      var message = 'Deseja realmente combinar essas Jornadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this2.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/juntarJornada?jornadaUmId=' + self.selecionadas[0].id + '&jornadaDoisId=' + self.selecionadas[1].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas combinadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao combinar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    abrirModalRelatorioSintetico: function abrirModalRelatorioSintetico() {
      this.buscarTodosMotoristasRelatorio();
      this.showModalRelatorioSintetico = true;
    },
    duplicarJornada: function duplicarJornada(id) {
      var _this3 = this;

      var self = this;
      if (self.selecionadas.length === 0) {
        return;
      }
      if (self.selecionadas.length > 1) {
        return;
      }
      var message = 'Deseja realmente duplicar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this3.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/duplicar?id=' + self.selecionadas[0].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornada duplicada com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao duplicar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    deletarMultiplas: function deletarMultiplas(id) {
      var _this4 = this;

      var self = this;
      var message = 'Deseja realmente deletar todas as Jornada listadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this4.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/deletarMultiplas?buscas=' + _this4.filtros.buscas + '&dataInicial=' + _this4.filtros.dataInicial + '&dataFinal=' + _this4.filtros.dataFinal + '&status=' + _this4.filtros.status;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas deletadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao deletar as Jornadas', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    recalcularJornadas: function recalcularJornadas(id) {
      var _this5 = this;

      var self = this;
      var message = 'Deseja realmente recalcular todas as Jornada listadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this5.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/recalcularJornadas?buscas=' + _this5.filtros.buscas + '&dataInicial=' + _this5.filtros.dataInicial + '&dataFinal=' + _this5.filtros.dataFinal + '&status=' + _this5.filtros.status;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas recalculadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao recalcular as Jornadas', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.relatorio.motoristaId = motorista.id;
      this.relatorio.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    setarMotoristaNovaJornada: function setarMotoristaNovaJornada(motorista) {
      this.jornada.motoristaId = motorista.id;
      this.jornada.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNovaJornadaNome').val(motorista.nome);
    },
    verificarMotoristaNovaJornada: function verificarMotoristaNovaJornada() {
      if ($(this.$el).find('#motoristaNovaJornadaId').val() === '0') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
      if ($(this.$el).find('#motoristaNovaJornadaNome').val() === '') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
    },
    buscarTodosMotoristas: function buscarTodosMotoristas() {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/buscarMotoristasAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        self.motoristas = response;
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    setarVeiculoNovaJornada: function setarVeiculoNovaJornada(veiculo) {
      this.jornada.veiculoId = veiculo.idVeiculo;
      this.jornada.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoNovaJornadaDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculoNovaJornada: function verificarVeiculoNovaJornada() {
      if ($(this.$el).find('#veiculoNovaJornadaId').val() === '0') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
      if ($(this.$el).find('#veiculoNovaJornadaDescricao').val() === '') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
    },
    imprimir: function imprimir(id) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarRelatorioSintetico: function gerarRelatorioSintetico(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '';
      if (this.relatorio.tipo === 1 || this.relatorio.tipo === '1') {
        url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      } else {
        url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      }
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarRelatorioSinteticoMotoristas: function gerarRelatorioSinteticoMotoristas() {
      var _this6 = this;

      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };

      var _loop = function _loop(i) {
        url = '';

        if (_this6.relatorio.tipo === 1 || _this6.relatorio.tipo === '1') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + _this6.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this6.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        } else if (_this6.relatorio.tipo === 2 || _this6.relatorio.tipo === '2') {
          url = '/api/gestaoJornadas/relatorioTempoAlimentacao?dataHoraInicio=' + _this6.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this6.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        } else if (_this6.relatorio.tipo === 3 || _this6.relatorio.tipo === '3') {
          url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?teste=1&dataHoraInicio=' + _this6.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + _this6.relatorio.dataFinal + ' 23:59:59&motoristaId=' + self.selecionadasMotoristas[i].id;
        }
        _axios2.default.get(url, config).then(function (response) {
          var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf;name=document.pdf;' }));
          var link = document.createElement('a');
          link.href = url;
          link.setAttribute('filename', 'file.pdf');
          if (self.relatorio.tipo === 1 || self.relatorio.tipo === '1') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          } else if (self.relatorio.tipo === 3 || self.relatorio.tipo === '3') {
            link.setAttribute('download', 'JornadaSintetico_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          } else {
            link.setAttribute('download', 'RelatorioTempoAlimentacao_' + self.relatorio.dataInicial.replace('/', '') + '_' + self.relatorio.dataFinal.replace('/', '') + '_' + self.selecionadasMotoristas[i].nome.replace(/\s+/g, ''));
          }
          link.setAttribute('target', '_blank');
          document.getElementById('imprimirLinks').appendChild(link);
          link.click();
          self.processando = false;
          self.botaoProcessando = false;
        }).catch(function (error) {
          console.log(error);
          self.processando = false;
          self.botaoProcessando = false;
        });
      };

      for (var i = 0; i < self.selecionadasMotoristas.length; i++) {
        var url;

        _loop(i);
      }
    },
    gerarNovaJornada: function gerarNovaJornada(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/v2/gestaoJornadas/criarJornadaMacros?dataHoraInicial=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId;
      _axios2.default.post(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.showModalNovaJornada = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarJornadaAjudante: function gerarJornadaAjudante(jornada, ajudante) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/gravarJornadaAjudante?jornada=' + jornada + '&ajudante=' + ajudante;
      _axios2.default.get(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    deletar: function deletar(id) {
      var _this7 = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this7.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/gestaoJornadas/deletar?id=' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção');
              self.buscar();
              dialog.close();
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "IjQE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue__ = __webpack_require__("OnCj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b041c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConvencoesLista_vue__ = __webpack_require__("HX5m");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_16b041c6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConvencoesLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "ItD1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__ = __webpack_require__("r9Uq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3710f310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__ = __webpack_require__("q55J");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3710f310_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAcionamentoDeEntradaSinteticoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "J6W3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__ = __webpack_require__("m2EB");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ff31f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__ = __webpack_require__("pQpl");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_sidebar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_25ff31f0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_sidebar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JCpY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__ = __webpack_require__("aPSQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("rrPM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_modal_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JDVb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__ = __webpack_require__("kJiG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("nHb0")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_form_file_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "JHMb":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.idName},on:{"click":_vm.generate}},[_vm._t("default",[_vm._v("\n\t\tDownload "+_vm._s(_vm.name)+"\n\t")])],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "JSRt":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue__ = __webpack_require__("5TR5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39fe13fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarFornecedor_vue__ = __webpack_require__("ndIY");
function injectStyle (ssrContext) {
  __webpack_require__("h1uO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFornecedor_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_39fe13fe_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarFornecedor_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Jjzc":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "JpoZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var obdIgnicao = this.$route.params.obdIgnicao;
      var obdRpm = this.$route.params.obdRpm;
      var obdTemperatura = this.$route.params.obdTemperatura;
      var obdErro = this.$route.params.obdErro;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoesObdTrip?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes + '&obdIgnicao=' + obdIgnicao + '&obdRpm=' + obdRpm + '&obdTemperatura=' + obdTemperatura + '&obdErro=' + obdErro;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    },
    visualizarMapa: function visualizarMapa() {
      var self = this;
      self.showModalMapa = true;
      self.adicionarMarkers();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          console.log(self.selecionados[i].latitude);
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      }

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "JtrI":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "KnvL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('header',{staticClass:"app-header navbar"},[(_vm.showModalInteracoes)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalRelatoriosVenda","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',[_vm._v("Data Lançamento:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"data-hora form-control",model:{value:(_vm.interacao.dataLancamento),callback:function ($$v) {_vm.$set(_vm.interacao, "dataLancamento", $$v)},expression:"interacao.dataLancamento"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-9 col-md-9"},[_c('label',[_vm._v("Tipo de Interação:")]),_vm._v(" "),_c('select',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.interacao.motivoInteracaoId),expression:"interacao.motivoInteracaoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.interacao, "motivoInteracaoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.motivosInteracoes),function(motivoInteracao){return _c('option',{domProps:{"value":motivoInteracao.id}},[_vm._v(_vm._s(motivoInteracao.nome))])}))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Titular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.titularId),expression:"interacao.titularId"}],attrs:{"type":"hidden","name":"titularInteracoesId"},domProps:{"value":(_vm.interacao.titularId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "titularId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.titularTipo),expression:"interacao.titularTipo"}],attrs:{"type":"hidden","name":"titularInteracoesTipo"},domProps:{"value":(_vm.interacao.titularTipo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "titularTipo", $event.target.value)}}}),_vm._v(" "),_c('buscar-titular',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"titularInteracoes","placeholder":"Nome do Titular","classes":{ input: 'pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarTitularInteracoes,"on-blur":_vm.verificarTitularInteracoes},model:{value:(_vm.interacao.titular),callback:function ($$v) {_vm.$set(_vm.interacao, "titular", $$v)},expression:"interacao.titular"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.interacao.descricao),expression:"interacao.descricao"}],staticClass:"pula form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.interacao.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "descricao", $event.target.value)}}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"id":"imprimirVendaModal","type":"button"},on:{"click":_vm.gravarInteracao}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gravar\n          ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalInteracoes = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('button',{staticClass:"navbar-toggler mobile-sidebar-toggler d-lg-none",attrs:{"type":"button"},on:{"click":_vm.esconderMenu}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('button',{staticClass:"sidebar-minimizer d-md-down-none navbar-toggler",attrs:{"type":"button"},on:{"click":_vm.esconderMenu}},[_c('span',{staticClass:"navbar-toggler-icon"})]),_vm._v(" "),_c('a',{staticClass:"navbar-brand",attrs:{"href":"#"}},[_c('img',{attrs:{"height":"40","src":'/static/images/logo.png'}})]),_vm._v(" "),_c('div',{staticClass:"navbar-dados-empresa"},[_c('span',[_c('strong',[_vm._v(_vm._s(_vm.model.nomeFantasia))])]),_c('br'),_vm._v(" "),(_vm.model.nomeFantasia !== _vm.model.nome)?[_c('span',[_vm._v(_vm._s(_vm.model.nome)+"    ")])]:_vm._e(),_vm._v(" "),_c('span',[_vm._v(_vm._s(_vm.model.documento))])],2),_vm._v(" "),_c('ul',{staticClass:"nav navbar-nav ml-auto"},[_c('li',{staticClass:"nav-item dropdown"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"dropdown-menu dropdown-menu-right"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"divider"}),_vm._v(" "),_c('a',{staticClass:"dropdown-item",attrs:{"href":"#"},on:{"click":function($event){_vm.logout()}}},[_c('i',{staticClass:"fa fa-lock"}),_vm._v(" Sair ")])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Lançar Interação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link nav-link",attrs:{"data-toggle":"dropdown","href":"#","role":"button","aria-haspopup":"true","aria-expanded":"false"}},[_c('img',{staticClass:"img-avatar",attrs:{"src":"/static/images/avatar.png","alt":"Menu de Usuário"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dropdown-header text-center"},[_c('strong',[_vm._v("Configuração")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item",attrs:{"href":"javascript:void(Tawk_API.toggle())"}},[_c('i',{staticClass:"fa fa-question-circle-o"}),_vm._v(" Suporte")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-user"}),_vm._v(" Perfil")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"dropdown-item",attrs:{"href":"#"}},[_c('i',{staticClass:"fa fa-wrench"}),_vm._v(" Configurações")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L2bj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"id":"btnNovoVeiculo","to":"/veiculos/novo"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_vm._m(1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(veiculo){return _c('tr',{class:{ 'selecionado': _vm.selecionado(veiculo) },on:{"click":function($event){_vm.selecionarItem(veiculo)},"dblclick":function($event){_vm.editar(veiculo.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":veiculo.id}}),_vm._v(" "),(veiculo.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(veiculo.id))]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.clienteNome))])]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.descricao))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(veiculo.placa))])]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.modelo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(veiculo.marca))])]),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'VeiculosEditar', params: { id: veiculo.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(veiculo.id)}}})],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Veiculos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Cliente")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Marca")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "L6Ed":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-quantidade-10',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: '',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: '.',
      affixesStay: true,
      precision: 10
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "LcEY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue__ = __webpack_require__("oVZj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245082f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCnpj_vue__ = __webpack_require__("ZOVF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCnpj_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_245082f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCnpj_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "LcV4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"value":"0"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Liod":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "LmXX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var obdIgnicao = this.$route.params.obdIgnicao;
      var obdRpm = this.$route.params.obdRpm;
      var obdTemperatura = this.$route.params.obdTemperatura;
      var obdErro = this.$route.params.obdErro;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoesObd?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes + '&obdIgnicao=' + obdIgnicao + '&obdRpm=' + obdRpm + '&obdTemperatura=' + obdTemperatura + '&obdErro=' + obdErro;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    },
    visualizarMapa: function visualizarMapa() {
      var self = this;
      self.showModalMapa = true;
      self.adicionarMarkers();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          console.log(self.selecionados[i].latitude);
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      }

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "M1g5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-hora-picker-ss',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('99:99');
    $(this.$el).timepicker({
      dateFormat: '',
      timeFormat: 'HH:mm',
      closeText: 'Fechar',
      prevText: '&#x3c;Anterior',
      nextText: 'Pr&oacute;ximo&#x3e;',
      currentText: 'Agora',
      monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      weekHeader: 'Sm',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
      onSelect: function onSelect(date) {
        vmm.$emit('input', date);
      }
    });
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  methods: {
    setValue: function setValue(date) {
      $(this.$el).val(date);
    }
  },
  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99:99');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9792a6e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("vH6h");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9792a6e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MI0s":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-data-picker',
  props: {
    value: {
      validator: function validator(val) {
        return val === null || val instanceof Date || typeof val === 'string';
      }
    },
    format: {
      default: 'dd/mm/yy'
    },
    onBlur: Function
  },
  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  methods: {
    setValue: function setValue(date) {
      $(this.$el).val(date);
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).datepicker({
      closeText: 'Fechar',
      prevText: '&#x3c;Anterior',
      nextText: 'Pr&oacute;ximo&#x3e;',
      currentText: 'Hoje',
      monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      weekHeader: 'Sm',
      dateFormat: 'dd/mm/yy',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
      onSelect: function onSelect(date) {
        vmm.$emit('input', date);
      }
    });
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  }
};
module.exports = vm;

/***/ }),

/***/ "MN2m":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue__ = __webpack_require__("AmAx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f996c090_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreasEditar_vue__ = __webpack_require__("+hW6");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AreasEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f996c090_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AreasEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "MYxH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"id":"btnNovoUsuario","to":"/usuarios/novo"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")])],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.status),expression:"status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.status=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscas),expression:"buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.buscas=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.quantidade),expression:"quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.quantidade=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaUsuarios","width":"100%"}},[_vm._m(1),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(usuario){return _c('tr',{class:{ 'selecionado': _vm.selecionado(usuario) },on:{"click":function($event){_vm.selecionarItem(usuario)},"dblclick":function($event){_vm.editar(usuario.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":usuario.id}}),_vm._v(" "),(usuario.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(usuario.id))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(usuario.nome))])]),_vm._v(" "),_c('td',{attrs:{"width":"250"}},[_c('strong',[_vm._v(_vm._s(usuario.login))])]),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'UsuariosEditar', params: { id: usuario.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"}})],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Usuário")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Login")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ma4z":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue__ = __webpack_require__("uRTQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184188e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarListaMotorista_vue__ = __webpack_require__("iLRu");
function injectStyle (ssrContext) {
  __webpack_require__("/Muj")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarListaMotorista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0184188e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarListaMotorista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "N1PV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"value":"0"}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "N4Y6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _PontoCadastro = __webpack_require__("OPWj");

var _PontoCadastro2 = _interopRequireDefault(_PontoCadastro);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    PontoCadastro: _PontoCadastro2.default
  },
  data: function data() {
    var _this = this;

    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      fieldsDadosRelatorios: {
        'Data': 'data',
        'Hora': 'hora',
        'Ponto Mais Próximo': 'pontoMaisProximo',
        'Velocidade': {
          field: 'velocidade',
          callback: function callback(value) {
            return _this.formatarVelocidadeMetros(value);
          }
        },
        'Deslocamento': {
          field: 'deslocamento',
          callback: function callback(value) {
            return _this.formatarVelocidadeMetros(value);
          }
        },
        'Ignição': 'ignicao',
        'GPS': 'gps',
        'GPRS': 'gprs',
        'Movimento': 'movimento',
        'Volt': {
          field: 'tensao',
          callback: function callback(value) {
            return _this.formatarVelocidadeMetros(value);
          }
        },
        'Motivo Transmissão': 'motivoTransmissao'
      },
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      showModalPonto: false,
      pontoCadastroLat: 0,
      pontoCadastroLng: 0,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },
  created: function created() {
    window.cadastrarPonto = this.cadastrarPonto;
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this2;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },
    cadastrarPonto: function cadastrarPonto(lat, lng) {
      this.pontoCadastroLat = lat;
      this.pontoCadastroLng = lng;
      this.showModalPonto = true;
    },
    updateparent: function updateparent() {
      this.showModalPonto = false;
    },
    generateReport: function generateReport() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/relatorios/relatorioDePosicoesPdf?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes + '&zoomMapa=8';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      });
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>' + '<br>Ponto: <span onClick="cadastrarPonto(' + marker.position.lat + ',' + marker.position.lng + ')" style="cursor: hand;cursor: pointer;" ><strong>Cadastrar ponto</strong></span>';
      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "NBAS":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "NHnr":
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(__dirname) {

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vueRouter = __webpack_require__("/ocq");

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _vueResource = __webpack_require__("8+8L");

var _vueResource2 = _interopRequireDefault(_vueResource);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vueAuth = __webpack_require__("MLZB");

var _vueAuth2 = _interopRequireDefault(_vueAuth);

var _vuejsDialog = __webpack_require__("7VfX");

var _vuejsDialog2 = _interopRequireDefault(_vuejsDialog);

var _bootstrapVue = __webpack_require__("e6fC");

var _bootstrapVue2 = _interopRequireDefault(_bootstrapVue);

var _App = __webpack_require__("M93x");

var _App2 = _interopRequireDefault(_App);

var _store = __webpack_require__("YtJ0");

var _store2 = _interopRequireDefault(_store);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

var _veeValidate = __webpack_require__("sUu7");

var _veeValidate2 = _interopRequireDefault(_veeValidate);

var _vueToastr = __webpack_require__("zfY3");

var _vueToastr2 = _interopRequireDefault(_vueToastr);

__webpack_require__("DNd/");

var _vueSidebarMenu = __webpack_require__("yXZZ");

var _vueSidebarMenu2 = _interopRequireDefault(_vueSidebarMenu);

__webpack_require__("JtrI");

var _Index = __webpack_require__("7uFO");

var _Index2 = _interopRequireDefault(_Index);

var _Monitoramento = __webpack_require__("ExJn");

var _Monitoramento2 = _interopRequireDefault(_Monitoramento);

var _Grid = __webpack_require__("oUvO");

var _Grid2 = _interopRequireDefault(_Grid);

var _Dashboard = __webpack_require__("YAPR");

var _Dashboard2 = _interopRequireDefault(_Dashboard);

var _Relatorios = __webpack_require__("wteZ");

var _Relatorios2 = _interopRequireDefault(_Relatorios);

var _RelatoriosTelemetria = __webpack_require__("6kCs");

var _RelatoriosTelemetria2 = _interopRequireDefault(_RelatoriosTelemetria);

var _AnaliseJornadas = __webpack_require__("5vBt");

var _AnaliseJornadas2 = _interopRequireDefault(_AnaliseJornadas);

var _AnaliseJornadasView = __webpack_require__("sUt0");

var _AnaliseJornadasView2 = _interopRequireDefault(_AnaliseJornadasView);

var _GestaoJornadasLista = __webpack_require__("7z+T");

var _GestaoJornadasLista2 = _interopRequireDefault(_GestaoJornadasLista);

var _GestaoJornadasNovo = __webpack_require__("QwTq");

var _GestaoJornadasNovo2 = _interopRequireDefault(_GestaoJornadasNovo);

var _GestaoJornadasEditar = __webpack_require__("biBf");

var _GestaoJornadasEditar2 = _interopRequireDefault(_GestaoJornadasEditar);

var _AnaliseJornadaTabela = __webpack_require__("GecJ");

var _AnaliseJornadaTabela2 = _interopRequireDefault(_AnaliseJornadaTabela);

var _AnaliseJornadaTabelaEditar = __webpack_require__("A2U7");

var _AnaliseJornadaTabelaEditar2 = _interopRequireDefault(_AnaliseJornadaTabelaEditar);

var _AnaliseJornadaTabelaVisualizar = __webpack_require__("aVqU");

var _AnaliseJornadaTabelaVisualizar2 = _interopRequireDefault(_AnaliseJornadaTabelaVisualizar);

var _AnaliseJornadasConvencao = __webpack_require__("Cy2f");

var _AnaliseJornadasConvencao2 = _interopRequireDefault(_AnaliseJornadasConvencao);

var _AnaliseJornadasConvencaoView = __webpack_require__("HYkd");

var _AnaliseJornadasConvencaoView2 = _interopRequireDefault(_AnaliseJornadasConvencaoView);

var _GestaoJornadasConvencaoLista = __webpack_require__("eGyS");

var _GestaoJornadasConvencaoLista2 = _interopRequireDefault(_GestaoJornadasConvencaoLista);

var _GestaoJornadasConvencaoNovo = __webpack_require__("15F0");

var _GestaoJornadasConvencaoNovo2 = _interopRequireDefault(_GestaoJornadasConvencaoNovo);

var _GestaoJornadasConvencaoEditar = __webpack_require__("90Hy");

var _GestaoJornadasConvencaoEditar2 = _interopRequireDefault(_GestaoJornadasConvencaoEditar);

var _Agenda = __webpack_require__("slZv");

var _Agenda2 = _interopRequireDefault(_Agenda);

var _Login = __webpack_require__("kvsw");

var _Login2 = _interopRequireDefault(_Login);

var _Logout = __webpack_require__("ATiK");

var _Logout2 = _interopRequireDefault(_Logout);

var _ClientesLista = __webpack_require__("rrxP");

var _ClientesLista2 = _interopRequireDefault(_ClientesLista);

var _ClientesEditar = __webpack_require__("D5vg");

var _ClientesEditar2 = _interopRequireDefault(_ClientesEditar);

var _MotoristasLista = __webpack_require__("nzKj");

var _MotoristasLista2 = _interopRequireDefault(_MotoristasLista);

var _MotoristasEditar = __webpack_require__("pnzP");

var _MotoristasEditar2 = _interopRequireDefault(_MotoristasEditar);

var _VeiculosLista = __webpack_require__("SvWc");

var _VeiculosLista2 = _interopRequireDefault(_VeiculosLista);

var _VeiculosEditar = __webpack_require__("g5vT");

var _VeiculosEditar2 = _interopRequireDefault(_VeiculosEditar);

var _AreasLista = __webpack_require__("GpAW");

var _AreasLista2 = _interopRequireDefault(_AreasLista);

var _AreasEditar = __webpack_require__("MN2m");

var _AreasEditar2 = _interopRequireDefault(_AreasEditar);

var _PontosLista = __webpack_require__("Fptk");

var _PontosLista2 = _interopRequireDefault(_PontosLista);

var _PontosEditar = __webpack_require__("m1Is");

var _PontosEditar2 = _interopRequireDefault(_PontosEditar);

var _ConvencoesLista = __webpack_require__("IjQE");

var _ConvencoesLista2 = _interopRequireDefault(_ConvencoesLista);

var _ConvencoesEditar = __webpack_require__("QxhN");

var _ConvencoesEditar2 = _interopRequireDefault(_ConvencoesEditar);

var _EventosLista = __webpack_require__("1WfN");

var _EventosLista2 = _interopRequireDefault(_EventosLista);

var _EventosEditar = __webpack_require__("G5IE");

var _EventosEditar2 = _interopRequireDefault(_EventosEditar);

var _EventosDisparadosLista = __webpack_require__("s49b");

var _EventosDisparadosLista2 = _interopRequireDefault(_EventosDisparadosLista);

var _UsuariosLista = __webpack_require__("Dg7K");

var _UsuariosLista2 = _interopRequireDefault(_UsuariosLista);

var _UsuariosEditar = __webpack_require__("WZka");

var _UsuariosEditar2 = _interopRequireDefault(_UsuariosEditar);

var _RelatorioDePosicoesView = __webpack_require__("G909");

var _RelatorioDePosicoesView2 = _interopRequireDefault(_RelatorioDePosicoesView);

var _RelatorioDePosicoesNovoView = __webpack_require__("qvRI");

var _RelatorioDePosicoesNovoView2 = _interopRequireDefault(_RelatorioDePosicoesNovoView);

var _RelatorioDePosicoesObdView = __webpack_require__("2m9g");

var _RelatorioDePosicoesObdView2 = _interopRequireDefault(_RelatorioDePosicoesObdView);

var _RelatorioDePosicoesObdTripView = __webpack_require__("1TUT");

var _RelatorioDePosicoesObdTripView2 = _interopRequireDefault(_RelatorioDePosicoesObdTripView);

var _RelatorioDeAnaliseTrabalhoProducaoView = __webpack_require__("2QPb");

var _RelatorioDeAnaliseTrabalhoProducaoView2 = _interopRequireDefault(_RelatorioDeAnaliseTrabalhoProducaoView);

var _RelatorioDeAnaliseDeCondutaView = __webpack_require__("PAsa");

var _RelatorioDeAnaliseDeCondutaView2 = _interopRequireDefault(_RelatorioDeAnaliseDeCondutaView);

var _RelatorioDeAnaliseTrabalhoProducaoSinteticoView = __webpack_require__("QrIj");

var _RelatorioDeAnaliseTrabalhoProducaoSinteticoView2 = _interopRequireDefault(_RelatorioDeAnaliseTrabalhoProducaoSinteticoView);

var _RelatorioDeAcionamentoDeEntradaView = __webpack_require__("8ZWN");

var _RelatorioDeAcionamentoDeEntradaView2 = _interopRequireDefault(_RelatorioDeAcionamentoDeEntradaView);

var _RelatorioDeAcionamentoDeEntradaSinteticoView = __webpack_require__("ItD1");

var _RelatorioDeAcionamentoDeEntradaSinteticoView2 = _interopRequireDefault(_RelatorioDeAcionamentoDeEntradaSinteticoView);

var _RelatorioDeTempoForaHorarioTrabalhoView = __webpack_require__("DlPF");

var _RelatorioDeTempoForaHorarioTrabalhoView2 = _interopRequireDefault(_RelatorioDeTempoForaHorarioTrabalhoView);

var _RelatorioDeKmRodadoVeiculoView = __webpack_require__("ahZu");

var _RelatorioDeKmRodadoVeiculoView2 = _interopRequireDefault(_RelatorioDeKmRodadoVeiculoView);

var _RelatorioDeKmRodadoFrotaView = __webpack_require__("YFZs");

var _RelatorioDeKmRodadoFrotaView2 = _interopRequireDefault(_RelatorioDeKmRodadoFrotaView);

var _RelatorioTelemetriaViagemGeralView = __webpack_require__("UidA");

var _RelatorioTelemetriaViagemGeralView2 = _interopRequireDefault(_RelatorioTelemetriaViagemGeralView);

var _RelatorioTelemetriaViagemPorVeiculoView = __webpack_require__("zixC");

var _RelatorioTelemetriaViagemPorVeiculoView2 = _interopRequireDefault(_RelatorioTelemetriaViagemPorVeiculoView);

var _RelatorioTelemetriaViagemPorMotoristaView = __webpack_require__("ng/p");

var _RelatorioTelemetriaViagemPorMotoristaView2 = _interopRequireDefault(_RelatorioTelemetriaViagemPorMotoristaView);

var _NotFoundView = __webpack_require__("seUh");

var _NotFoundView2 = _interopRequireDefault(_NotFoundView);

var _sparkComponentsPlugin = __webpack_require__("VJjC");

var _sparkComponentsPlugin2 = _interopRequireDefault(_sparkComponentsPlugin);

var _vTooltip = __webpack_require__("VN6J");

var _vTooltip2 = _interopRequireDefault(_vTooltip);

var _vue2GoogleMaps = __webpack_require__("sA6N");

var VueGoogleMaps = _interopRequireWildcard(_vue2GoogleMaps);

var _vue2Datepicker = __webpack_require__("trBP");

var _vue2Datepicker2 = _interopRequireDefault(_vue2Datepicker);

__webpack_require__("1QwG");

var _vueJsonExcel = __webpack_require__("fXhN");

var _vueJsonExcel2 = _interopRequireDefault(_vueJsonExcel);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_sparkComponentsPlugin2.default);
_vue2.default.use(_vueResource2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuejsDialog2.default);
_vue2.default.use(_bootstrapVue2.default);
_vue2.default.use(_veeValidate2.default);
_vue2.default.use(_vTooltip2.default);
_vue2.default.use(_vueToastr2.default, {
  defaultPosition: 'toast-top-right',
  defaultType: 'info',
  defaultTimeout: 2000
});
_vue2.default.use(_vueSidebarMenu2.default);
_vue2.default.use(_vue2Datepicker2.default);
_vue2.default.component('downloadExcel', _vueJsonExcel2.default);

_vue2.default.axios = _axios2.default;

var router = new _vueRouter2.default({
  hashbang: false,
  linkActiveClass: 'active',
  mode: 'history',
  base: __dirname,
  routes: [{ path: '/login', name: 'Login', component: _Login2.default, meta: { auth: false } }, { path: '/logout', name: 'Logout', component: _Logout2.default, meta: { auth: false } }, {
    path: '/',
    name: 'Index',
    component: _Index2.default,
    meta: { auth: true },
    children: [{ path: 'grid', alias: '', name: 'account', component: _Grid2.default, meta: { auth: true, analytics: 'account' } }, { path: 'grid', alias: '', name: 'Grid', component: _Grid2.default, meta: { auth: true, analytics: 'Grid' } }, { path: '/dashboard', name: 'Dashboard', component: _Dashboard2.default, meta: { auth: true, analytics: 'Dashboard' } }, { path: '/monitoramento', name: 'Monitoramento', component: _Monitoramento2.default, meta: { auth: true, analytics: 'Monitoramento' } }, { path: '/relatorios', name: 'Relatorios', component: _Relatorios2.default, meta: { auth: true, analytics: 'Relatorios' } }, { path: '/relatoriosTelemetria', name: 'RelatoriosTelemetria', component: _RelatoriosTelemetria2.default, meta: { auth: true, analytics: 'RelatoriosTelemetria' } }, { path: '/agenda', name: 'Agenda', component: _Agenda2.default, meta: { auth: true, analytics: 'Agenda' } }, { path: '/clientes', name: 'ClientesLista', component: _ClientesLista2.default, meta: { auth: true, analytics: 'ClientesLista' } }, { path: '/clientes/editar/:id', name: 'ClientesEditar', component: _ClientesEditar2.default, meta: { auth: true, analytics: 'ClientesEditar' } }, { path: '/motoristas', name: 'MotoristasLista', component: _MotoristasLista2.default, meta: { auth: true } }, { path: '/motoristas/editar/:id', name: 'MotoristasEditar', component: _MotoristasEditar2.default, meta: { auth: true } }, { path: '/veiculos', name: 'VeiculosLista', component: _VeiculosLista2.default, meta: { auth: true } }, { path: '/veiculos/editar/:id', name: 'VeiculosEditar', component: _VeiculosEditar2.default, meta: { auth: true } }, { path: '/usuarios', name: 'UsuariosLista', component: _UsuariosLista2.default, meta: { auth: true } }, { path: '/usuarios/editar/:id', name: 'UsuariosEditar', component: _UsuariosEditar2.default, meta: { auth: true } }, { path: '/analiseJornada', name: 'AnaliseJornadas', component: _AnaliseJornadas2.default, meta: { auth: true } }, { path: '/analiseJornadaView/:veiculo/:dataInicial/:dataFinal', name: 'AnaliseJornadasView', component: _AnaliseJornadasView2.default, meta: { auth: true } }, { path: '/gestaoJornada', name: 'GestaoJornadasLista', component: _GestaoJornadasLista2.default, meta: { auth: true } }, { path: '/gestaoJornada/novo', name: 'GestaoJornadasNovo', component: _GestaoJornadasNovo2.default, meta: { auth: true } }, { path: '/gestaoJornada/editar/:id', name: 'GestaoJornadasEditar', component: _GestaoJornadasEditar2.default, meta: { auth: true } }, { path: '/analiseJornadaTabela', name: 'AnaliseJornadasTabela', component: _AnaliseJornadaTabela2.default, meta: { auth: true } }, { path: '/analiseJornadaTabelaEditar', name: 'AnaliseJornadasTabelaEditar', component: _AnaliseJornadaTabelaEditar2.default, meta: { auth: true } }, { path: '/analiseJornadasTabelaVisualizar', name: 'AnaliseJornadasTabelaVisualizar', component: _AnaliseJornadaTabelaVisualizar2.default, meta: { auth: true } }, { path: '/analiseJornadaConvencao', name: 'AnaliseJornadasConvencao', component: _AnaliseJornadasConvencao2.default, meta: { auth: true } }, { path: '/analiseJornadaConvencaoView/:veiculo/:dataInicial/:dataFinal', name: 'AnaliseJornadasConvencaoView', component: _AnaliseJornadasConvencaoView2.default, meta: { auth: true } }, { path: '/gestaoJornadaConvencao', name: 'GestaoJornadasConvencaoLista', component: _GestaoJornadasConvencaoLista2.default, meta: { auth: true } }, { path: '/gestaoJornadaConvencao/novo', name: 'GestaoJornadasConvencaoNovo', component: _GestaoJornadasConvencaoNovo2.default, meta: { auth: true } }, { path: '/gestaoJornadaConvencao/editar/:id', name: 'GestaoJornadasConvencaoEditar', component: _GestaoJornadasConvencaoEditar2.default, meta: { auth: true } }, { path: '/eventos', name: 'EventosLista', component: _EventosLista2.default, meta: { auth: true } }, { path: '/eventos/editar/:id', name: 'EventosEditar', component: _EventosEditar2.default, meta: { auth: true } }, { path: '/eventosDisparados', name: 'EventosDisparadosLista', component: _EventosDisparadosLista2.default, meta: { auth: true } }, { path: '/areas', name: 'AreasLista', component: _AreasLista2.default, meta: { auth: true } }, { path: '/areas/editar/:id', name: 'AreasEditar', component: _AreasEditar2.default, meta: { auth: true } }, { path: '/pontos', name: 'PontosLista', component: _PontosLista2.default, meta: { auth: true } }, { path: '/pontos/editar/:id', name: 'PontosEditar', component: _PontosEditar2.default, meta: { auth: true } }, { path: '/convencoes', name: 'ConvencoesLista', component: _ConvencoesLista2.default, meta: { auth: true } }, { path: '/convencoes/editar/:id', name: 'ConvencoesEditar', component: _ConvencoesEditar2.default, meta: { auth: true } }, { path: '/relatorioDePosicoesView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes', name: 'RelatorioDePosicoesView', component: _RelatorioDePosicoesView2.default, meta: { auth: true } }, { path: '/relatorioDePosicoesNovoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes', name: 'RelatorioDePosicoesNovoView', component: _RelatorioDePosicoesNovoView2.default, meta: { auth: true } }, { path: '/relatorioDePosicoesObdView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes/:obdIgnicao/:obdRpm/:obdTemperatura/:obdErro', name: 'RelatorioDePosicoesObdView', component: _RelatorioDePosicoesObdView2.default, meta: { auth: true } }, { path: '/relatorioDePosicoesObdTripView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:agruparPosicoes/:obdIgnicao/:obdRpm/:obdTemperatura/:obdErro', name: 'RelatorioDePosicoesObdTripView', component: _RelatorioDePosicoesObdTripView2.default, meta: { auth: true } }, { path: '/relatorioDeAnaliseTrabalhoProducaoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada/:entradaVelocidade', name: 'RelatorioDeAnaliseTrabalhoProducaoView', component: _RelatorioDeAnaliseTrabalhoProducaoView2.default, meta: { auth: true } }, { path: '/relatorioDeAnaliseTrabalhoProducaoSinteticoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada/:entradaVelocidade', name: 'RelatorioDeAnaliseTrabalhoProducaoSinteticoView', component: _RelatorioDeAnaliseTrabalhoProducaoSinteticoView2.default, meta: { auth: true } }, { path: '/relatorioDeAnaliseDeCondutaView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade', name: 'RelatorioDeAnaliseDeCondutaView', component: _RelatorioDeAnaliseDeCondutaView2.default, meta: { auth: true } }, { path: '/relatorioDeAcionamentoDeEntradaView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidadeMinima/:filtroVelocidadeMaxima/:desprezarVelocidade/:entrada', name: 'RelatorioDeAcionamentoDeEntradaView', component: _RelatorioDeAcionamentoDeEntradaView2.default, meta: { auth: true } }, { path: '/relatorioDeAcionamentoDeEntradaSinteticoView/:veiculoId/:dataHoraInicial/:dataHoraFinal/:filtroVelocidade/:desprezarVelocidade/:entrada', name: 'RelatorioDeAcionamentoDeEntradaSinteticoView', component: _RelatorioDeAcionamentoDeEntradaSinteticoView2.default, meta: { auth: true } }, { path: '/relatorioDeTempoForaHorarioTrabalhoView/:clienteId/:dataHoraInicial', name: 'RelatorioDeTempoForaHorarioTrabalhoView', component: _RelatorioDeTempoForaHorarioTrabalhoView2.default, meta: { auth: true } }, { path: '/relatorioDeKmRodadoVeiculoView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioDeKmRodadoVeiculoView', component: _RelatorioDeKmRodadoVeiculoView2.default, meta: { auth: true } }, { path: '/relatorioDeKmRodadoFrotaView/:clienteId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioDeKmRodadoFrotaView', component: _RelatorioDeKmRodadoFrotaView2.default, meta: { auth: true } }, { path: '/relatorioTelemetriaViagemGeralView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemGeralView', component: _RelatorioTelemetriaViagemGeralView2.default, meta: { auth: true } }, { path: '/relatorioTelemetriaViagemPorVeiculoView/:veiculoId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemPorVeiculoView', component: _RelatorioTelemetriaViagemPorVeiculoView2.default, meta: { auth: true } }, { path: '/relatorioTelemetriaViagemPorMotoristaView/:motoristaId/:dataHoraInicial/:dataHoraFinal', name: 'RelatorioTelemetriaViagemPorMotoristaView', component: _RelatorioTelemetriaViagemPorMotoristaView2.default, meta: { auth: true } }]
  }, {
    path: '*',
    component: _NotFoundView2.default
  }]
});
_vue2.default.router = router;

_vue2.default.axios.defaults.baseURL = 'http://site.colge.com.br';

_vue2.default.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyBB8zpoVYyi09wzrxZONTbJn-AkxOto3JM',
    libraries: 'places' }
});

_vue2.default.use(_vueAuth2.default, {
  auth: __webpack_require__("2T3s"),
  http: __webpack_require__("E/+Z"),
  router: __webpack_require__("LFDJ"),
  rolesVar: 'roles',
  loginData: { url: '/login', method: 'POST', redirect: '/', fetchUser: true },
  fetchData: { url: '/loginData', method: 'GET', enabled: true },
  refreshData: { url: '/login', method: 'POST', enabled: false, interval: 0 },
  parseUserData: function parseUserData(data) {
    console.log('USER');
    console.log(data);
    return data.data;
  }
});
_vue2.default.use(__webpack_require__("m0IH"));
_vue2.default.http.interceptors.push(function (request, next) {
  next(function (res) {
    if (res.status === 401 && ['UnauthorizedAccess', 'InvliadToken'].indexOf(res.data.code) > -1) {
      _vue2.default.auth.logout({
        redirect: { name: 'Login' }
      });
    } else if (res.status === 500) {}
  });
});

_vue2.default.mixin({
  methods: {
    limparQuantidade: function limparQuantidade(value) {
      var val = '';
      if (isNaN(value)) {
        val = value.replace(',', '.');
        val = parseFloat((val / 1).toFixed(2));
      } else {
        val = parseFloat((value / 1).toFixed(2));
      }
      return val;
    },
    limparQuantidade10: function limparQuantidade10(value) {
      var val = '';
      if (isNaN(value)) {
        val = value.replace(',', '.');
        val = parseFloat((val / 1).toFixed(10));
      } else {
        val = parseFloat((value / 1).toFixed(10));
      }
      return val;
    },
    limparPercentual: function limparPercentual(value) {
      var val = '';
      if (isNaN(value)) {
        val = value.replace(',', '.');
        val = parseFloat((val / 1).toFixed(2));
      } else {
        val = parseFloat((value / 1).toFixed(2));
      }
      return val;
    },
    limparMonetario: function limparMonetario(value) {
      var val = '';
      if (isNaN(value)) {
        val = value.replace('R$ ', '').replace(',', '.');
        val = parseFloat((val / 1).toFixed(2));
      } else {
        val = parseFloat((value / 1).toFixed(2));
      }
      return val;
    },
    limparMonetario10: function limparMonetario10(value) {
      var val = '';
      if (isNaN(value)) {
        val = value.replace('R$ ', '').replace(',', '.');
        val = parseFloat((val / 1).toFixed(10));
      } else {
        val = parseFloat((value / 1).toFixed(10));
      }
      return val;
    },
    formatarMonetario: function formatarMonetario(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return 'R$ ' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatarPercentual: function formatarPercentual(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatarVelocidade: function formatarVelocidade(value) {
      var val = (value / 1).toFixed(2).replace('.', ',');
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    formatarVelocidadeMetros: function formatarVelocidadeMetros(value) {
      var val = (value / 1).toFixed(0).replace('.', ',');
      return '' + val.toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    },
    primeiroDiaMes: function primeiroDiaMes(mes) {
      if (mes === '') {
        var mes_ = (0, _moment2.default)().months() + 1 + '';
        if (mes_.length === 1) {
          mes_ = '0' + mes_;
        }
        return '01/' + mes_ + '/' + (0, _moment2.default)().year();
      }
    },
    ultimoDiaMes: function ultimoDiaMes(mes) {
      if (mes === '') {
        var mes_ = (0, _moment2.default)().months() + 1 + '';
        if (mes_.length === 1) {
          mes_ = '0' + mes_;
        }
        return (0, _moment2.default)().daysInMonth() + '/' + mes_ + '/' + (0, _moment2.default)().year();
      }
    },
    dataAtual: function dataAtual() {
      var dia_ = (0, _moment2.default)().date() + '';
      if (dia_.length === 1) {
        dia_ = '0' + dia_;
      }
      var mes_ = (0, _moment2.default)().months() + 1 + '';
      if (mes_.length === 1) {
        mes_ = '0' + mes_;
      }
      return dia_ + '/' + mes_ + '/' + (0, _moment2.default)().year();
    },
    dataOntem: function dataOntem() {
      var dataOntem = (0, _moment2.default)().subtract(1, 'days');
      var dia_ = dataOntem.date() + '';
      if (dia_.length === 1) {
        dia_ = '0' + dia_;
      }
      var mes_ = dataOntem.months() + 1 + '';
      if (mes_.length === 1) {
        mes_ = '0' + mes_;
      }
      return dia_ + '/' + mes_ + '/' + dataOntem.year();
    },
    dataHoraAtual: function dataHoraAtual() {
      var dia_ = (0, _moment2.default)().date() + '';
      if (dia_.length === 1) {
        dia_ = '0' + dia_;
      }
      var mes_ = (0, _moment2.default)().months() + 1 + '';
      if (mes_.length === 1) {
        mes_ = '0' + mes_;
      }
      return dia_ + '/' + mes_ + '/' + (0, _moment2.default)().year() + ' ' + (0, _moment2.default)().hours() + ':' + (0, _moment2.default)().minutes() + ':' + (0, _moment2.default)().seconds();
    },
    dataAtualAdicionar: function dataAtualAdicionar(data, tipo, quantidade) {
      var novaData = (0, _moment2.default)(data, 'DD/MM/YYYY');
      if (tipo === 'D') {
        novaData = novaData.add(quantidade, 'days');
      } else {
        novaData = novaData.add(quantidade, 'M');
      }
      var dia_ = novaData.date() + '';
      if (dia_.length === 1) {
        dia_ = '0' + dia_;
      }
      var mes_ = novaData.months() + 1 + '';
      if (mes_.length === 1) {
        mes_ = '0' + mes_;
      }
      return dia_ + '/' + mes_ + '/' + novaData.year();
    },
    diasEntreDadas: function diasEntreDadas(dataInicial, dataFinal) {
      var dataInicial_ = (0, _moment2.default)(dataInicial, 'DD/MM/YYYY');
      var dataFinal_ = (0, _moment2.default)(dataFinal, 'DD/MM/YYYY');
      var duration = _moment2.default.duration(dataFinal_.diff(dataInicial_));
      var days = duration.asDays();
      if (isNaN(days)) {
        days = 0;
      }
      return days;
    },
    dataMenor: function dataMenor(dataUm, dataDois) {
      var dataUm_ = (0, _moment2.default)(dataUm, 'DD/MM/YYYY');
      var dataDois_ = (0, _moment2.default)(dataDois, 'DD/MM/YYYY');
      return dataUm_.isBefore(dataDois_);
    },
    gerarCodigoBarras: function gerarCodigoBarras(numero) {
      var factor = 3;
      var sum = 0;
      for (var index = 0; numero.length < 12; index++) {
        numero = '0' + numero;
      }
      for (index = numero.length; index > 0; --index) {
        sum = sum + numero.substring(index - 1, index) * factor;
        factor = 4 - factor;
      }
      var cc = (1000 - sum) % 10;
      var digito = cc;
      return numero + '' + digito;
    },
    consultarOperadora: function consultarOperadora(numero) {
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/consutarOperadora?celular=' + numero;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        return response.data;
      });
    }
  }
});
new _vue2.default({
  el: '#app',
  router: router,
  template: '<App/>',
  components: {
    App: _App2.default
  },
  store: _store2.default
});
/* WEBPACK VAR INJECTION */}.call(exports, "/"))

/***/ }),

/***/ "NuQ6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{ref:"flyaway"},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "NyJI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "O/JI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
  extends: _vueChartjs.Line,
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
};

/***/ }),

/***/ "OPWj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue__ = __webpack_require__("vd8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82483244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontoCadastro_vue__ = __webpack_require__("IYJS");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontoCadastro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_82483244_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontoCadastro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "OQxC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_vm._v("Not Found")])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OSPL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OTPw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('div',{attrs:{"id":"veiculoPeriodo"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"lista-veiculos"}},[_c('h3',{staticClass:"panel-title"},[_vm._v("Veículo:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.veiculoId),expression:"veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.veiculoId=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.clienteId),expression:"clienteId"}],staticClass:"form-control",attrs:{"id":"clienteId","type":"hidden"},domProps:{"value":(_vm.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.clienteId=$event.target.value}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscaVeiculo),expression:"buscaVeiculo"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","placeholder":"Filtrar veículo","type":"text"},domProps:{"value":(_vm.buscaVeiculo)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarGrid($event)},"input":function($event){if($event.target.composing){ return; }_vm.buscaVeiculo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-lock",on:{"click":_vm.buscarGrid}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{attrs:{"id":"dados-analise-jornada-lista-veiculos"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.dadosGrid),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosGrid[i].clienteIdVeiculo != _vm.dadosGrid[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))])])])],2)})],2)])])]),_vm._v(" "),_c('br')])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"opcoesRelatorio"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataInicial),callback:function ($$v) {_vm.dataInicial=$$v},expression:"dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Hora inicial: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker',{staticClass:"form-control pula hora",model:{value:(_vm.horaInicial),callback:function ($$v) {_vm.horaInicial=$$v},expression:"horaInicial"}})],1)]),_vm._v(" "),_vm._m(4),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Análise\n                      ")])]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.$auth.check('P116'))?[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-danger btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarAnaliseFrota}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Análise Frota\n                        ")])])]:_vm._e()],2)])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h3',{staticClass:"panel-title"},[_vm._v("Análise")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Período:")]),_c('br')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('small',[_vm._v("*Os dados de rastreamento ficam armazenados por 90 dias.")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "OnCj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      buscas: '',
      pagina: 1,
      quantidade: 15,
      status: 'A',
      selecionada: '0',
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    };
  },

  created: function created() {
    this.buscar(1);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar(pagina) {
      this.pagina = pagina;
      var self = this;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadasConvencoes?buscas=' + this.buscas + '&pagina=' + this.pagina + '&quantidade=' + this.quantidade + '&status=' + this.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/jornadasConvencoes/editar/' + id);
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Convencão?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/jornadasConvencoes/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Convencão deletado com sucesso.', 'Atenção');
              url = '/api/jornadasConvencoes?buscas=' + self.buscas + '&pagina=' + self.pagina + '&quantidade=' + self.quantidade + '&status=' + self.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Convencão está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "OzEO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue__ = __webpack_require__("aWnz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17766aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataFormat_vue__ = __webpack_require__("ZQqV");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataFormat_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_17766aae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataFormat_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "P/cy":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoesNovo?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var self = this;
      self.showModalMapa = true;
      self.adicionarMarkers();
    },
    adicionarMarkers: function adicionarMarkers() {
      var _this = this;

      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            bounds = new window.google.maps.LatLngBounds();
            bounds.extend(myLatLng);
          }
        }
      }
      this.$refs.map.$mapCreated.then(function () {
        console.log(bounds);
        _this.$refs.map.$mapObject.fitBounds(bounds);
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "PAsa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue__ = __webpack_require__("p698");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b064222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseDeCondutaView_vue__ = __webpack_require__("UOsF");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseDeCondutaView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4b064222_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseDeCondutaView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "PKAF":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PTMa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalProdutosRelacionados)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalRelatoriosVenda","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(1),_vm._v(" "),_c('tbody',[_c('tr',[_c('td',[_vm._v("\n                            Blusa Preta com Pedras\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"50px"}},[_vm._v("\n                            99%\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"100px"}},[_c('div',{staticClass:"progress progress-sm mt-2 mb-3"},[_c('div',{staticClass:"progress-bar bg-success",style:('width: 99%'),attrs:{"aria-valuenow":99,"aria-valuemin":"0","aria-valuemax":"99"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                            Blusa Preta Regata\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"50px"}},[_vm._v("\n                            99%\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"100px"}},[_c('div',{staticClass:"progress progress-sm mt-2 mb-3"},[_c('div',{staticClass:"progress-bar bg-success",style:('width: 99%'),attrs:{"aria-valuenow":99,"aria-valuemin":"0","aria-valuemax":"99"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                            Batom Matte Fashion\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"50px"}},[_vm._v("\n                            99%\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"100px"}},[_c('div',{staticClass:"progress progress-sm mt-2 mb-3"},[_c('div',{staticClass:"progress-bar bg-success",style:('width: 99%'),attrs:{"aria-valuenow":99,"aria-valuemin":"0","aria-valuemax":"99"}})])])]),_vm._v(" "),_c('tr',[_c('td',[_vm._v("\n                            Blusa Azul Escuro\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"50px"}},[_vm._v("\n                            50%\n                          ")]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"100px"}},[_c('div',{staticClass:"progress progress-sm mt-2 mb-3"},[_c('div',{staticClass:"progress-bar bg-warning",style:('width: 50%'),attrs:{"aria-valuenow":50,"aria-valuemin":"0","aria-valuemax":"50"}})])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalProdutosRelacionados = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoCliente","to":"/clientes"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(3),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.buscarEnderecos}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabEnderecosAdicionais","data-toggle":"tab"}},[_vm._v("Endereços")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.buscarContatos}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabContatosAdicionais","data-toggle":"tab"}},[_vm._v("Contatos")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":function($event){_vm.buscarHistoricoFinanceiro(), _vm.buscarHistoricoCheque(), _vm.buscarClienteCreditoFinanceiro()}}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabHistoricoFinanceiro","data-toggle":"tab"}},[_vm._v("Histórico Financeiro")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.buscarHistoricoVendas}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabHistoricoVendas","data-toggle":"tab"}},[_vm._v("Histórico Vendas")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.buscarHistoricoInteracoes}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabHistoricoInteracoes","data-toggle":"tab"}},[_vm._v("Histórico de Interações")])]),_vm._v(" "),_c('li',{staticClass:"nav-item",on:{"click":_vm.buscarPerfilCliente}},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabPerfilCliente","data-toggle":"tab"}},[_vm._v("Perfil do Cliente")])]),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tabGeral"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Ativo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ativo),expression:"model.ativo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Tipo Cliente:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoCliente),expression:"model.tipoCliente"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tipoCliente", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"J","label":"Jurídico"}},[_vm._v("Jurídico")]),_vm._v(" "),_c('option',{attrs:{"value":"F","label":"Físico"}},[_vm._v("Físico")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Data Aniversário:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataAniversario),callback:function ($$v) {_vm.$set(_vm.model, "dataAniversario", $$v)},expression:"model.dataAniversario"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Conceito:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.conceitoId),expression:"model.conceitoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "conceitoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.conceitos),function(conceito){return _c('option',{domProps:{"value":conceito.id}},[_vm._v(_vm._s(conceito.nome))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Regime Tributário:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.regimeTributario),expression:"model.regimeTributario"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "regimeTributario", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","label":"0 - Pessoa Física"}},[_vm._v("0 - Pessoa Fisica")]),_vm._v(" "),_c('option',{attrs:{"value":"1","label":"1 - Simples Nacional"}},[_vm._v("1 - Simples Nacional")]),_vm._v(" "),_c('option',{attrs:{"value":"2","label":"2 - Simples Nacional, excesso sublimite de receita bruta"}},[_vm._v("2 - Simples Nacional, excesso sublimite de receita bruta")]),_vm._v(" "),_c('option',{attrs:{"value":"3","label":"3 - Regime Normal"}},[_vm._v("3 - Regime Normal")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Tipo Consumidor:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.tipoConsumidor),expression:"model.tipoConsumidor"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "tipoConsumidor", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","label":"0 - Normal"}},[_vm._v("0 - Normal")]),_vm._v(" "),_c('option',{attrs:{"value":"1","label":"1 - Consumidor final"}},[_vm._v("1 - Consumidor final")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome Fantasia:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.nomeFantasia),expression:"model.nomeFantasia"}],class:{'input pula form-control': true, 'is-danger': _vm.errors.has('nomeFantasia') },attrs:{"name":"nomeFantasia","data-vv-delay":"500","required":"required","autofocus":"autofocus"},domProps:{"value":(_vm.model.nomeFantasia)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nomeFantasia", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Razao Social:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label",attrs:{"id":"label-documento"}},[_vm._v("Documento:")]),_c('br'),_vm._v(" "),(_vm.model.tipoCliente == 'F')?_c('input-cpf',{staticClass:"pula form-control",model:{value:(_vm.model.documento),callback:function ($$v) {_vm.$set(_vm.model, "documento", $$v)},expression:"model.documento"}}):_vm._e(),_vm._v(" "),(_vm.model.tipoCliente == 'J')?_c('input-cnpj',{staticClass:"pula form-control",model:{value:(_vm.model.documento),callback:function ($$v) {_vm.$set(_vm.model, "documento", $$v)},expression:"model.documento"}}):_vm._e()],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("RG:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.rg),expression:"model.rg"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.rg)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "rg", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Inscrição Estadual:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.inscricaoEstadual),expression:"model.inscricaoEstadual"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.inscricaoEstadual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "inscricaoEstadual", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isentoInscricaoEstadual),expression:"isentoInscricaoEstadual"}],attrs:{"id":"isentoInscricaoEstadual","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isentoInscricaoEstadual)?_vm._i(_vm.isentoInscricaoEstadual,null)>-1:(_vm.isentoInscricaoEstadual)},on:{"click":function($event){_vm.setIsentoInscricaoEstadual()},"change":function($event){var $$a=_vm.isentoInscricaoEstadual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isentoInscricaoEstadual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isentoInscricaoEstadual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isentoInscricaoEstadual=$$c}}}}),_vm._v(" ISENTO")])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Inscrição Mun.:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.inscricaoMunicipal),expression:"model.inscricaoMunicipal"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.inscricaoMunicipal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "inscricaoMunicipal", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.isentoInscricaoMunicipal),expression:"isentoInscricaoMunicipal"}],attrs:{"id":"isentoInscricaoMunicipal","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.isentoInscricaoMunicipal)?_vm._i(_vm.isentoInscricaoMunicipal,null)>-1:(_vm.isentoInscricaoMunicipal)},on:{"click":function($event){_vm.setIsentoInscricaoMunicipal()},"change":function($event){var $$a=_vm.isentoInscricaoMunicipal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.isentoInscricaoMunicipal=$$a.concat([$$v]))}else{$$i>-1&&(_vm.isentoInscricaoMunicipal=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.isentoInscricaoMunicipal=$$c}}}}),_vm._v(" ISENTO")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-10 col-md-10"},[_c('label',{staticClass:"control-label"},[_vm._v("Endereço:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.endereco),expression:"model.endereco"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.endereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "endereco", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Número:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.numero),expression:"model.numero"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "numero", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-8 col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Complemento:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.complemento),expression:"model.complemento"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "complemento", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',{staticClass:"control-label"},[_vm._v("Bairro:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bairro),expression:"model.bairro"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "bairro", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',{staticClass:"control-label"},[_vm._v("Cidade:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.cidadeId),expression:"model.cidadeId"}],attrs:{"type":"hidden","id":"cidadeId"},domProps:{"value":(_vm.model.cidadeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "cidadeId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cidade',{attrs:{"type":"search","id":"cidadeNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarCidade,"on-blur":_vm.verificarCidade},model:{value:(_vm.model.cidadeNome),callback:function ($$v) {_vm.$set(_vm.model, "cidadeNome", $$v)},expression:"model.cidadeNome"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("CEP:")]),_c('br'),_vm._v(" "),_c('input-cep',{staticClass:"pula form-control",attrs:{"id":"cidadeCep"},model:{value:(_vm.model.cep),callback:function ($$v) {_vm.$set(_vm.model, "cep", $$v)},expression:"model.cep"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Estado:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.estado),expression:"model.estado"}],staticClass:"pula form-control",attrs:{"id":"cidadeEstado"},domProps:{"value":(_vm.model.estado)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "estado", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Contato:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.contato),expression:"model.contato"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.contato)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "contato", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Telefone:")]),_c('br'),_vm._v(" "),_c('input-telefone',{staticClass:"pula form-control",model:{value:(_vm.model.telefone),callback:function ($$v) {_vm.$set(_vm.model, "telefone", $$v)},expression:"model.telefone"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Celular:")]),_c('br'),_vm._v(" "),_c('input-telefone',{staticClass:"pula form-control",model:{value:(_vm.model.celular),callback:function ($$v) {_vm.$set(_vm.model, "celular", $$v)},expression:"model.celular"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-1 col-md-1"},[_c('label',{staticClass:"control-label"},[_vm._v("WhatsApp:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.whatsapp),expression:"model.whatsapp"}],staticClass:"pula",attrs:{"id":"whatsapp","name":"whatsapp","type":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.whatsapp)?_vm._i(_vm.model.whatsapp,null)>-1:(_vm.model.whatsapp)},on:{"change":function($event){var $$a=_vm.model.whatsapp,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model, "whatsapp", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model, "whatsapp", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model, "whatsapp", $$c)}}}}),_vm._v(" "),_vm._m(5)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Operadora:")]),_c('br'),_vm._v(" "),_c('a',{staticClass:"btn",attrs:{"href":"#","id":"consultaOperadora"},on:{"click":function($event){_vm.buscarOperadora(_vm.model.celular)}}},[_c('img',{attrs:{"src":"/static/images/buscar.png"}})]),_vm._v(" "),_c('img',{attrs:{"id":"logoCelularOperadora","src":'/static/images/'+_vm.model.celularOperadora+'.png'}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.celularOperadora),expression:"model.celularOperadora"}],staticClass:"pula form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.model.celularOperadora)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "celularOperadora", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("E-mail:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.email),expression:"model.email"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "email", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Vendedor:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.vendedorId),expression:"model.vendedorId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "vendedorId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","label":""}}),_vm._v(" "),_vm._l((_vm.vendedores),function(vendedor){return _c('option',{attrs:{"selected":""},domProps:{"value":vendedor}},[_vm._v(_vm._s(vendedor.nome))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Forma de Pagamento:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.formaPagamentoPadrao),expression:"model.formaPagamentoPadrao"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "formaPagamentoPadrao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","label":""}}),_vm._v(" "),_vm._l((_vm.formasPagamentos),function(formaPagamento){return _c('option',{attrs:{"selected":""},domProps:{"value":formaPagamento.id}},[_vm._v(_vm._s(formaPagamento.nome))])})],2)]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',{staticClass:"control-label"},[_vm._v("Tabela de Preço:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.produtoTabelaPrecoPadrao),expression:"model.produtoTabelaPrecoPadrao"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "produtoTabelaPrecoPadrao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0","label":""}}),_vm._v(" "),_vm._l((_vm.tabelasPrecos),function(tabelaPreco){return _c('option',{attrs:{"selected":""},domProps:{"value":tabelaPreco.id}},[_vm._v(_vm._s(tabelaPreco.nome))])})],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Site:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.site),expression:"model.site"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.site)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "site", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Inscrição Suf.:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.inscricaoSuframa),expression:"model.inscricaoSuframa"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.inscricaoSuframa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "inscricaoSuframa", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("IE ST:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.inscricaoEstadualSubTributario),expression:"model.inscricaoEstadualSubTributario"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.inscricaoEstadualSubTributario)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "inscricaoEstadualSubTributario", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Observação:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.observacao),expression:"model.observacao"}],staticClass:"pula form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.model.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "observacao", $event.target.value)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabEnderecosAdicionais"}},[_c('div',{staticClass:"dados_form"},[_c('button',{staticClass:"btn btn-info pull-right",attrs:{"id":"adicionarEndereco","type":"button"},on:{"click":_vm.adicionarEndereco}},[_vm._v("Adicionar Endereco")]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"enderecosAdicionais","width":"100%"}},[_vm._m(6),_vm._v(" "),_c('tbody',_vm._l((_vm.model.enderecos),function(endereco,i){return _c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.id),expression:"endereco.id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(endereco.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "id", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.endereco),expression:"endereco.endereco"}],staticClass:"form-control pula",domProps:{"value":(endereco.endereco)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "endereco", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.numero),expression:"endereco.numero"}],staticClass:"form-control pula",domProps:{"value":(endereco.numero)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "numero", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.complemento),expression:"endereco.complemento"}],staticClass:"form-control pula",domProps:{"value":(endereco.complemento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "complemento", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.bairro),expression:"endereco.bairro"}],staticClass:"form-control pula",domProps:{"value":(endereco.bairro)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "bairro", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(endereco.cidadeId),expression:"endereco.cidadeId"}],attrs:{"type":"hidden","id":'enderecosCidadeId_'+i},domProps:{"value":(endereco.cidadeId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(endereco, "cidadeId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cidade',{attrs:{"id":'enderecosCidadeNome_'+i,"classes":{ input: 'form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarCidadeEndereco},model:{value:(endereco.cidadeNome),callback:function ($$v) {_vm.$set(endereco, "cidadeNome", $$v)},expression:"endereco.cidadeNome"}})],1),_vm._v(" "),_c('td',[_c('input-cep',{staticClass:"form-control cep pula",attrs:{"id":"transportadorEnderecosCep_${loop.index}"},model:{value:(endereco.cep),callback:function ($$v) {_vm.$set(endereco, "cep", $$v)},expression:"endereco.cep"}})],1),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":"/static/images/remover.png"},on:{"click":function($event){_vm.removerEndereco(i)}}})])])}))])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabContatosAdicionais"}},[_c('div',{staticClass:"dados_form"},[_c('button',{staticClass:"btn btn-info pull-right",attrs:{"id":"adicionarContato","type":"button"},on:{"click":_vm.adicionarContato}},[_vm._v("Adicionar Contato")]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"contatosAdicionais","width":"100%"}},[_vm._m(7),_vm._v(" "),_c('tbody',_vm._l((_vm.model.contatos),function(contato,i){return _c('tr',[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(contato.id),expression:"contato.id"}],staticClass:"form-control",attrs:{"type":"hidden"},domProps:{"value":(contato.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contato, "id", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(contato.nome),expression:"contato.nome"}],staticClass:"form-control pula",domProps:{"value":(contato.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contato, "nome", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('input-telefone',{staticClass:"form-control pula",model:{value:(contato.telefone),callback:function ($$v) {_vm.$set(contato, "telefone", $$v)},expression:"contato.telefone"}})],1),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(contato.email),expression:"contato.email"}],staticClass:"form-control pula",domProps:{"value":(contato.email)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(contato, "email", $event.target.value)}}})]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":"/static/images/remover.png"},on:{"click":function($event){_vm.removerContato(i)}}})])])}))])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabHistoricoFinanceiro"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Controla Financeiro:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.controlaFinanceiro),expression:"model.controlaFinanceiro"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "controlaFinanceiro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Crédito do Cliente:")]),_c('br'),_vm._v(" "),_c('input-monetario',{staticClass:"pula monetario form-control",model:{value:(_vm.model.creditoFinanceiroMovimento),callback:function ($$v) {_vm.$set(_vm.model, "creditoFinanceiroMovimento", $$v)},expression:"model.creditoFinanceiroMovimento"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Crédito compras:")]),_c('br'),_vm._v(" "),_c('input-monetario',{staticClass:"pula monetario form-control",model:{value:(_vm.model.limiteCredito),callback:function ($$v) {_vm.$set(_vm.model, "limiteCredito", $$v)},expression:"model.limiteCredito"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Crédito utilizado:")]),_c('br'),_vm._v(" "),_c('input-monetario',{staticClass:"pula monetario form-control",attrs:{"readonly":"readonly"},model:{value:(_vm.model.limiteCreditoUtilizado),callback:function ($$v) {_vm.$set(_vm.model, "limiteCreditoUtilizado", $$v)},expression:"model.limiteCreditoUtilizado"}})],1),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Pontos Fidelidade:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pontosFidelidade),expression:"model.pontosFidelidade"}],staticClass:"pula form-control",attrs:{"readonly":"readonly"},domProps:{"value":(_vm.model.pontosFidelidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "pontosFidelidade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2"},[_c('label',[_vm._v("Bloqueado no SPC:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.bloqueadoSpc),expression:"model.bloqueadoSpc"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "bloqueadoSpc", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"tabelaHistoricoFinanceiro"}},[_c('div',{staticClass:"form-inline"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 text-right"},[_vm._v("\n                                Exibir: \n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirFinanceiro),expression:"exibirFinanceiro"}],staticClass:"pula form-control custom",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.exibirFinanceiro=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarHistoricoFinanceiro()}]}},[_c('option',{attrs:{"value":"30","label":"30 Dias"}},[_vm._v("30 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"60","label":"60 Dias"}},[_vm._v("60 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"90","label":"90 Dias"}},[_vm._v("90 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"120","label":"120 Dias"}},[_vm._v("120 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"0","label":"Tudo"}},[_vm._v("Tudo")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-hover",attrs:{"width":"100%"}},[_c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',[_vm._v("Data Lançamento")]),_vm._v(" "),_c('th',[_vm._v("Data Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Data Pagamento")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Valor Pago")]),_vm._v(" "),_c('tH')],1),_vm._v(" "),_c('tbody',_vm._l((_vm.historicoFinanceiro),function(financeiro){return _c('tr',{class:{ 'selecionado': _vm.selecionadoFinanceiro(financeiro) },on:{"click":function($event){_vm.selecionarFinanceiroItem(financeiro, $event)}}},[_c('td',[_vm._v(_vm._s(financeiro.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(financeiro.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(financeiro.dataLancamento))]),_vm._v(" "),_c('td',[((financeiro.dataBaixa === null || financeiro.dataBaixa === '') && _vm.dataMenor(financeiro.dataVencimento, _vm.dataAtual()))?[_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(financeiro.dataVencimento))])]),_vm._v("\n                                      "+_vm._s(_vm.diasEntreDadas(financeiro.dataVencimento, _vm.dataAtual()))+" dias\n                                    ")]:[_vm._v("\n                                      "+_vm._s(financeiro.dataVencimento)+"\n                                    ")]],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(financeiro.dataBaixa))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatarMonetario(financeiro.valor)))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatarMonetario(financeiro.valorPago)))]),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Visualizar Financeiro'),expression:"'Visualizar Financeiro'"}],attrs:{"src":"/static/images/visualizar.png"},on:{"click":function($event){_vm.visualizarFinanceiro(financeiro)}}}),_vm._v(" "),(financeiro.tipoMovimento === 'C' && financeiro.dataBaixa === null)?[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'ContasReceberEditar', params: { id: financeiro.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])]:_vm._e(),_vm._v(" "),(financeiro.tipoMovimento === 'D' && financeiro.dataBaixa === null)?[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'ContasPagarEditar', params: { id: financeiro.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])]:_vm._e()],2)])})),_vm._v(" "),_c('tfoot',[_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('td'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.formatarMonetario(_vm.valorTotalPagarFinanceiro(this.historicoFinanceiro))))]),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.formatarMonetario(_vm.valorTotalPagoFinanceiro(this.historicoFinanceiro))))]),_vm._v(" "),_c('td')])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"tabelaClienteCreditoFinanceiro"}},[_c('div',{staticClass:"form-inline"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 text-right"},[_vm._v("\n                                Exibir: \n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirFinanceiroCredito),expression:"exibirFinanceiroCredito"}],staticClass:"pula form-control custom",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.exibirFinanceiroCredito=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarHistoricoCredito()}]}},[_c('option',{attrs:{"value":"30","label":"30 Dias"}},[_vm._v("30 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"60","label":"60 Dias"}},[_vm._v("60 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"90","label":"90 Dias"}},[_vm._v("90 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"120","label":"120 Dias"}},[_vm._v("120 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"0","label":"Tudo"}},[_vm._v("Tudo")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(10),_vm._v(" "),_c('tbody',_vm._l((_vm.clienteCreditoFinanceiro),function(financeiro){return _c('tr',[_c('td',[_vm._v(_vm._s(financeiro.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(financeiro.data))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(financeiro.historico))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(_vm.formatarMonetario(financeiro.valor)))]),_vm._v(" "),_c('td',[(financeiro.devolucaoId !== 'null')?[_c('router-link',{attrs:{"to":{name: 'DevolucoesVisualizar', params: { id: financeiro.devolucaoId }}}},[_c('img',{attrs:{"src":"/static/images/visualizar.png"}})])]:_vm._e()],2)])})),_vm._v(" "),_c('tfoot',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.formatarMonetario(_vm.valorTotalCredito(this.clienteCreditoFinanceiro))))]),_vm._v(" "),_c('th')])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"tabelaHistoricoCheques"}},[_c('div',{staticClass:"form-inline"},[_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 text-right"},[_vm._v("\n                                Exibir: \n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirFinanceiroCheques),expression:"exibirFinanceiroCheques"}],staticClass:"pula form-control custom",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.exibirFinanceiroCheques=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarHistoricoCheque()}]}},[_c('option',{attrs:{"value":"30","label":"30 Dias"}},[_vm._v("30 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"60","label":"60 Dias"}},[_vm._v("60 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"90","label":"90 Dias"}},[_vm._v("90 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"120","label":"120 Dias"}},[_vm._v("120 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"0","label":"Tudo"}},[_vm._v("Tudo")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(12),_vm._v(" "),_c('tbody',_vm._l((_vm.historicoCheques),function(cheque){return _c('tr',[_c('td',{attrs:{"width":"60"}},[_vm._v(_vm._s(cheque.id))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(cheque.dataLancamento))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(cheque.dataEmissao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(cheque.emitente))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(cheque.dataVencimento))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(cheque.dataBaixa))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(cheque.status))]),_vm._v(" "),_c('td',{attrs:{"width":"110"}},[_vm._v(_vm._s(_vm.formatarMonetario(cheque.valor)))]),_vm._v(" "),_vm._m(13,true)])})),_vm._v(" "),_c('tfoot',[_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v(_vm._s(_vm.formatarMonetario(_vm.valorTotalCheque(this.historicoCheques))))]),_vm._v(" "),_c('th')])])])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabHistoricoVendas"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"tabelaHistoricoFinanceiro"}},[_c('div',{staticClass:"form-inline"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 text-right"},[_vm._v("\n                                Exibir: \n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirFinanceiro),expression:"exibirFinanceiro"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.exibirFinanceiro=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"30","label":"30 Dias"}},[_vm._v("30 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"60","label":"60 Dias"}},[_vm._v("60 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"90","label":"90 Dias"}},[_vm._v("90 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"120","label":"120 Dias"}},[_vm._v("120 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"0","label":"Tudo"}},[_vm._v("Tudo")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"tabelaHistoricoVendasProdutos","width":"100%"}},[_vm._m(15),_vm._v(" "),_c('tbody',_vm._l((_vm.vendasProdutos),function(venda){return _c('tr',[_c('td',[_vm._v(_vm._s(venda.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.dataVenda))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.formaPagamentoNome))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.formatarMonetario(venda.valorTotalVenda)))])]),_vm._v(" "),_c('td',[_c('img',{attrs:{"src":"/static/images/imprimir.png"},on:{"click":function($event){_vm.imprimirVendaProduto(venda.id)}}})])])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"tabelaHistoricoFinanceiro"}},[_c('div',{staticClass:"form-inline"},[_vm._m(16),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4 text-right"},[_vm._v("\n                                Exibir: \n                                "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.exibirFinanceiro),expression:"exibirFinanceiro"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.exibirFinanceiro=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"30","label":"30 Dias"}},[_vm._v("30 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"60","label":"60 Dias"}},[_vm._v("60 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"90","label":"90 Dias"}},[_vm._v("90 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"120","label":"120 Dias"}},[_vm._v("120 Dias")]),_vm._v(" "),_c('option',{attrs:{"value":"0","label":"Tudo"}},[_vm._v("Tudo")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"tabelaHistoricoVendasServicos","width":"100%"}},[_vm._m(17),_vm._v(" "),_c('tbody',_vm._l((_vm.vendasServicos),function(venda){return _c('tr',[_c('td',[_vm._v(_vm._s(venda.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.dataVenda))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(_vm.formatarMonetario(venda.valorTotalVenda)))])]),_vm._v(" "),_c('td',[_vm._v(_vm._s(venda.formaPagamentoNome))]),_vm._v(" "),_vm._m(18,true)])}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabHistoricoInteracoes"}},[_c('div',{staticClass:"dados_form"},[_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(19),_vm._v(" "),_c('tbody',_vm._l((_vm.interacoes),function(interacao){return _c('tr',[_c('td',[_vm._v(_vm._s(interacao.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.motivoInteracaoNome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.dataLancamento))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.descricao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.usuarioNome))])])}))])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabPerfilCliente"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('h4',[_vm._v("Gráfico de Vendas")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendasPeriodo),expression:"vendasPeriodo"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vendasPeriodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarPerfilCliente()}]}},[_c('option',{attrs:{"value":"12"}},[_vm._v("12 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Mês")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendasPeriodoAgrupamento),expression:"vendasPeriodoAgrupamento"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vendasPeriodoAgrupamento=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarPerfilCliente()}]}},[_c('option',{attrs:{"value":"S"}},[_vm._v("Semanal")]),_vm._v(" "),_c('option',{attrs:{"value":"M"}},[_vm._v("Mensal")])])])]),_vm._v(" "),_c('line-chart',{attrs:{"chart-data":_vm.perfilClienteGraficoVendas,"height":150}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 col-sm-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"}),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendasProdutosMaisVendidosPeriodo),expression:"vendasProdutosMaisVendidosPeriodo"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vendasProdutosMaisVendidosPeriodo=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarPerfilCliente()}]}},[_c('option',{attrs:{"value":"12"}},[_vm._v("12 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("6 Meses")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("1 Mês")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.vendasProdutosMaisVendidosPeriodoAgrupamento),expression:"vendasProdutosMaisVendidosPeriodoAgrupamento"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.vendasProdutosMaisVendidosPeriodoAgrupamento=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},function($event){_vm.buscarPerfilCliente()}]}},[_c('option',{attrs:{"value":"V"}},[_vm._v("Valor")]),_vm._v(" "),_c('option',{attrs:{"value":"Q"}},[_vm._v("Quantidade")])])])]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(20),_vm._v(" "),_c('tbody',_vm._l((_vm.vendasProdutosMaisVendidosPeriodoDados),function(produtoVendido,i){return _c('tr',[_c('td',[_c('div',[_vm._v(_vm._s(produtoVendido.produtoNome)+"\n                                    "),_c('span',{staticClass:"font-weight-bold float-right"},[_vm._v("("+_vm._s(produtoVendido.percentual)+"%)")])]),_vm._v(" "),_c('div',{staticClass:"progress progress-sm mt-2 mb-3"},[(i === 0)?_c('div',{staticClass:"progress-bar bg-info",style:('width: ' + produtoVendido.percentual + '%'),attrs:{"aria-valuenow":produtoVendido.percentual,"aria-valuemin":"0","aria-valuemax":"100"}}):_vm._e(),_vm._v(" "),(i === 1)?_c('div',{staticClass:"progress-bar bg-success",style:('width: ' + produtoVendido.percentual + '%'),attrs:{"aria-valuenow":produtoVendido.percentual,"aria-valuemin":"0","aria-valuemax":"100"}}):_vm._e(),_vm._v(" "),(i === 2)?_c('div',{staticClass:"progress-bar bg-warning",style:('width: ' + produtoVendido.percentual + '%'),attrs:{"aria-valuenow":produtoVendido.percentual,"aria-valuemin":"0","aria-valuemax":"100"}}):_vm._e(),_vm._v(" "),(i === 3)?_c('div',{staticClass:"progress-bar bg-danger",style:('width: ' + produtoVendido.percentual + '%'),attrs:{"aria-valuenow":produtoVendido.percentual,"aria-valuemin":"0","aria-valuemax":"100"}}):_vm._e(),_vm._v(" "),(i === 4)?_c('div',{staticClass:"progress-bar bg-info",style:('width: ' + produtoVendido.percentual + '%'),attrs:{"aria-valuenow":produtoVendido.percentual,"aria-valuemin":"0","aria-valuemax":"100"}}):_vm._e()])]),_vm._v(" "),_c('td',{staticClass:"text-center",attrs:{"width":"100px"}},[_vm._v("\n                                  "+_vm._s(produtoVendido.quantidade)+"\n                                ")]),_vm._v(" "),_c('td',{attrs:{"width":"150px"}},[_vm._v("\n                                  "+_vm._s(_vm.formatarMonetario(produtoVendido.valorTotal))+"\n                                ")])])}))])])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabECommerce"}},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Ativo no e-Commerce:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ecommerceAtivo),expression:"model.ecommerceAtivo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "ecommerceAtivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('label',[_vm._v("Código no e-Commerce:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ecommerceId),expression:"model.ecommerceId"}],staticClass:"pula monetario form-control",domProps:{"value":(_vm.model.ecommerceId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ecommerceId", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Email e-Commerce:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ecommerceEmail),expression:"model.ecommerceEmail"}],staticClass:"pula monetario form-control",domProps:{"value":(_vm.model.ecommerceEmail)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "ecommerceEmail", $event.target.value)}}})])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Produtos Relacionados")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("Percentual")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Cliente")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tabGeral","data-toggle":"tab"}},[_vm._v("Geral")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabECommerce","data-toggle":"tab"}},[_vm._v("e-Commerce")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"btn",attrs:{"id":"abrirWhatsApp","href":"#"}},[_c('img',{attrs:{"src":"/static/images/whatsapp.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Endereço")]),_vm._v(" "),_c('th',[_vm._v("Número")]),_vm._v(" "),_c('th',[_vm._v("Complemento")]),_vm._v(" "),_c('th',[_vm._v("Bairro")]),_vm._v(" "),_c('th',[_vm._v("Cidade")]),_vm._v(" "),_c('th',[_vm._v("Cep")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("Email")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 col-md-8"},[_c('h5',[_vm._v("Histórico Financeiro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 col-md-8"},[_c('h5',[_vm._v("Créditos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Histórico")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 col-md-8"},[_c('h5',[_vm._v("Cheques")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Lancamento")]),_vm._v(" "),_c('th',[_vm._v("Emissão")]),_vm._v(" "),_c('th',[_vm._v("Emitente")]),_vm._v(" "),_c('th',[_vm._v("Vencimento")]),_vm._v(" "),_c('th',[_vm._v("Pagamento")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{attrs:{"width":"60"}},[_c('div',{staticClass:"pull-right"},[_c('a',{attrs:{"href":"/financeiroMovimentos/editar?id=${clienteCheque.id}","data-toggle":"tooltip","data-placement":"top","title":"Visualizar Lan�amento"}},[_c('span',{staticClass:"glyphicon glyphicon-export"})])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 col-md-8"},[_c('h5',[_vm._v("Histórico de Vendas de Produtos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-8 col-md-8"},[_c('h5',[_vm._v("Histórico de Vendas de Serviços")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Data")]),_vm._v(" "),_c('th',[_vm._v("Valor")]),_vm._v(" "),_c('th',[_vm._v("Forma de Pagamento")]),_vm._v(" "),_c('th')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',[_c('img',{attrs:{"src":"/static/images/deletar.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',{attrs:{"width":"60"}},[_vm._v("Código")]),_vm._v(" "),_c('th',{attrs:{"width":"240"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Lançamento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Usuário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Produto")]),_vm._v(" "),_c('th',[_vm._v("Quantidade")]),_vm._v(" "),_c('th',[_vm._v("Valor Total")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "PXE4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "PpwH":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      context: 'login context',
      loaded: false,
      data: {
        body: {
          username: '',
          password: ''
        },
        rememberMe: false,
        fetchUser: true
      },
      error: null
    };
  },
  ready: function ready() {
    var _this = this;

    setTimeout(function () {
      _this.loaded = true;
    }, 500);
  },
  mounted: function mounted() {
    console.log(this.$auth.redirect());
  },

  methods: {
    login: function login() {
      var _this2 = this;

      var redirect = this.$auth.redirect();
      this.$auth.login({
        body: this.data.body,
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: { name: redirect ? redirect.from.name : 'account' },
        fetchUser: this.data.fetchUser
      }).then(function () {
        console.log('success ' + _this2.context);
        var token = _this2.$auth.token();
        console.log('login success ' + token);
        _this2.$store.commit('SET_AUTH_TOKEN', token);
      }, function (res) {
        console.log('error ' + _this2.context);
        _this2.error = res.data;
      });
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    },
    unimpersonate: function unimpersonate() {
      this.$auth.unimpersonate({
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    }
  }
};

/***/ }),

/***/ "QO3c":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _vueFullcalendar = __webpack_require__("xzgZ");

var _vueFullcalendar2 = _interopRequireDefault(_vueFullcalendar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      dadosTabela: [],
      model: {
        id: '',
        dataHoraInicio: '',
        dataHoraFinal: '',
        titulo: '',
        local: '',
        descricao: '',
        usuarioId: '',
        exibirComo: '',
        visivelPara: '',
        cor: ''
      },
      fcEvents: [],
      showModalNovoCompromisso: false
    };
  },

  created: function created() {
    this.buscar();
  },
  components: {
    fullCalendar: _vueFullcalendar2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/bancos?buscas=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/bancos/editar/' + id);
    },
    deletar: function deletar(id) {
      var message = 'Are you sure?';
      var options = {
        html: false,
        loader: false,
        reverse: false,
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function () {
        console.log('Clicked on proceed');
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "QYRB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navbar = __webpack_require__("kNln");

var _navbar2 = _interopRequireDefault(_navbar);

var _sidebar = __webpack_require__("J6W3");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'layout',
  components: {
    Navbar: _navbar2.default,
    Sidebar: _sidebar2.default
  },
  computed: {
    classObject: function classObject() {
      return {
        'sidebar-hidden': !this.toggleWithoutAnimation && !this.sidebarOpened,
        'sidebar-hidden sidebar-hidden_without-animation': this.toggleWithoutAnimation && !this.sidebarOpened
      };
    }
  }
};

/***/ }),

/***/ "QgcD":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-codigoncm',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      console.log('setValue');
      $(this.$el).find('#' + this.id).val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.ncm);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#codigoNcmCodigo').val(clean.ncm);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarCodigosNcmsAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    console.log(this.id);
    console.log(this.value);
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "QrIj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__ = __webpack_require__("/nOG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c16170d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__ = __webpack_require__("3kV7");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c16170d0_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeAnaliseTrabalhoProducaoSinteticoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "QwTq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue__ = __webpack_require__("Trcb");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a113c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasNovo_vue__ = __webpack_require__("W6Aj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasNovo_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e2a113c4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasNovo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Qx6j":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    }
  }
};

/***/ }),

/***/ "QxhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue__ = __webpack_require__("4De/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aecb8834_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConvencoesEditar_vue__ = __webpack_require__("C6nj");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ConvencoesEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_aecb8834_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ConvencoesEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "RkKk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "RxM3":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-quantidade',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: '',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: '.',
      affixesStay: true
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "S4sO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SCsL":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "SJXc":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _PieChart = __webpack_require__("D+CC");

var _PieChart2 = _interopRequireDefault(_PieChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default,
    PieChart: _PieChart2.default
  },
  data: function data() {
    return {
      filtros: {
        motoristaId: '0',
        motoristaNome: '',
        clienteId: this.$store.state.filtrosRelatorios.clienteId,
        veiculoId: this.$store.state.filtrosRelatorios.veiculoId,
        veiculoMarcaEquipamento: '',
        veiculoDescricao: this.$store.state.filtrosRelatorios.veiculoDescricao,
        dataInicial: this.$store.state.filtrosRelatorios.dataInicial === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataInicial,
        horaInicial: this.$store.state.filtrosRelatorios.horaInicial,
        dataFinal: this.$store.state.filtrosRelatorios.dataFinal === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataFinal,
        horaFinal: this.$store.state.filtrosRelatorios.horaFinal,
        relatorio: this.$store.state.filtrosRelatorios.relatorio,
        buscaVeiculo: this.$store.state.filtrosRelatorios.buscaVeiculo,
        selecionada: this.$store.state.filtrosRelatorios.selecionada,
        filtroVelocidade: this.$store.state.filtrosRelatorios.filtroVelocidade,
        filtroVelocidadeMinima: this.$store.state.filtrosRelatorios.filtroVelocidadeMinima,
        filtroVelocidadeMaxima: this.$store.state.filtrosRelatorios.filtroVelocidadeMaxima,
        desprezarVelocidade: '5',
        agruparPosicoes: this.$store.state.filtrosRelatorios.agruparPosicoes,
        entrada: this.$store.state.filtrosRelatorios.entrada,
        entradaVelocidade: this.$store.state.filtrosRelatorios.entradaVelocidade,
        obdIgnicao: this.$store.state.filtrosRelatorios.obdIgnicao,
        obdRpm: this.$store.state.filtrosRelatorios.obdRpm,
        obdTemperatura: this.$store.state.filtrosRelatorios.obdTemperatura,
        obdErro: this.$store.state.filtrosRelatorios.obdErro,
        agrupar: this.$store.state.filtrosRelatorios.agrupar,
        formato: 'visualizacao'
      },
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      buscaVeiculo: '',
      processando: false
    };
  },
  mounted: function mounted() {
    this.buscarVeiculos();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
      this.filtros.veiculoId = item.idVeiculo;
      this.filtros.veiculoMarcaEquipamento = item.marcaEquipamento;
    },
    selecionado: function selecionado(item) {
      return this.filtros.veiculoId === item.idVeiculo;
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    buscarVeiculos: function buscarVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/buscarVeiculosTelemetriaAtivos?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    setarDataInicial: function setarDataInicial(e) {
      console.log('set inicial');
      console.log(e);
      console.log(e.target);

      this.filtros.dataInicial = $(this.$el).find('#dataInicial').val();
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val();
      this.filtros.dataFinal = this.filtros.dataInicial;
      console.log($(this.$el).find('#dataFinal').val($(this.$el).find('#dataInicial').val()));
    },
    setarDataFinal: function setarDataFinal() {
      console.log('set final');
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val();
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.filtros.veiculoId = 0;
        this.filtros.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.filtros.veiculoId = 0;
        this.filtros.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    setarMotorista: function setarMotorista(motorista) {
      this.filtros.motoristaId = motorista.id;
      this.filtros.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.filtros.motoristaId = 0;
        this.filtros.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.filtros.motoristaId = 0;
        this.filtros.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },

    gerarRelatorio: function gerarRelatorio() {
      var self = this;
      var veiculoId = self.filtros.veiculoId;
      var motoristaId = self.filtros.motoristaId;
      var dataHoraInicial = self.filtros.dataInicial + ' ' + self.filtros.horaInicial + ':00';
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-');
      var dataHoraFinal = self.filtros.dataFinal + ' ' + self.filtros.horaFinal + ':59';
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-');
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção');
        return;
      }
      if (this.diasEntreDadas(this.filtros.dataInicial, this.filtros.dataFinal) < 0) {
        self.$toastr('error', 'Verifique o Período do relatório.', 'Atenção');
        return;
      }
      if (self.filtros.relatorio === '0' || self.filtros.relatorio === '1') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 2) {
          self.$toastr('error', 'O Período não pode ser superior a 2 dias.', 'Atenção');
          return;
        }
      }
      if (self.filtros.relatorio === '2') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 0) {
          self.$toastr('error', 'A analise deve ser do mesmo dia.', 'Atenção');
          return;
        }
      }
      if (self.filtros.relatorio === '3') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 16) {
          self.$toastr('error', 'O Período não pode ser superior a 16 dias.', 'Atenção');
          return;
        }
      }
      self.$store.commit('SET_FILTROS_RELATORIOS', self.filtros);

      if (self.filtros.relatorio === 0 || self.filtros.relatorio === '0') {
        self.$router.replace('/relatorioTelemetriaViagemGeralView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal);
      } else if (self.filtros.relatorio === 1 || self.filtros.relatorio === '1') {
        self.$router.replace('/relatorioTelemetriaViagemPorVeiculoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal);
      } else if (self.filtros.relatorio === 2 || self.filtros.relatorio === '2') {
        self.$router.replace('/relatorioTelemetriaViagemPorMotoristaView/' + motoristaId + '/' + dataHoraInicial + '/' + dataHoraFinal);
      }
    }
  }
};

/***/ }),

/***/ "SMuX":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-telefone-celular',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('(99) 99999-9999');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('(99) 99999-9999');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "SvWc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue__ = __webpack_require__("F8FW");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bda143e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VeiculosLista_vue__ = __webpack_require__("rfTd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_bda143e4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VeiculosLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "T4AT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"readonly":_vm.readonly,"errors":_vm.errors,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "TBGY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue__ = __webpack_require__("MI0s");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417fc1d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataPicker_vue__ = __webpack_require__("V8gd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_417fc1d6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "TCzx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "TiHD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotorista)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motoristaId),expression:"motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motoristaId=$event.target.value}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.motoristaNome),callback:function ($$v) {_vm.motoristaNome=$$v},expression:"motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotorista}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotorista = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotivo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{staticClass:"pula form-control",attrs:{"id":"modalItemId","type":"hidden","required":"required"}}),_vm._v(" "),(_vm.selecionada === '' || _vm.selecionada === '0')?[_vm._m(3),_c('br')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mudarMotivoId),expression:"mudarMotivoId"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mudarMotivoId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"03"}},[_vm._v("03 - Espera")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04 - Alimentacao")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05 - Descanso Direcao")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06 - Abastecimento")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07 - Fiscalizacao")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08 - Manutencao em Jornada")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09 - Contato")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 - \"Socorro\"")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11 - Transito")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("34 - Diaria")])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotivo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotivo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{staticClass:"pula form-control",attrs:{"id":"modalItemIdManual","type":"hidden","required":"required","value":"551058"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Inicio:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraInicioControleManual),expression:"dividirTempo.dataHoraInicioControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.dividirTempo.dataHoraInicioControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraInicioControleManual", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraInicio),expression:"dividirTempo.dataHoraInicio"}],staticClass:"pula dataHora form-control",attrs:{"required":"required","readonly":"readonly"},domProps:{"value":(_vm.dividirTempo.dataHoraInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraInicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraFinalControleManual),expression:"dividirTempo.dataHoraFinalControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.dividirTempo.dataHoraFinalControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraFinalControleManual", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraFinal),expression:"dividirTempo.dataHoraFinal"}],staticClass:"pula dataHora form-control",attrs:{"required":"required"},domProps:{"value":(_vm.dividirTempo.dataHoraFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraFinal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Duração:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraDuracao),expression:"dividirTempo.dataHoraDuracao"}],staticClass:"pula form-control",attrs:{"readonly":"readonly"},domProps:{"value":(_vm.dividirTempo.dataHoraDuracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraDuracao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Status:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.statusVeiculo),expression:"dividirTempo.statusVeiculo"}],staticClass:"pula form-control",attrs:{"required":"required","disabled":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dividirTempo, "statusVeiculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"VEICULO PARADO"}},[_vm._v("VEICULO PARADO")]),_vm._v(" "),_c('option',{attrs:{"value":"VEICULO EM MOVIMENTO"}},[_vm._v("VEICULO EM MOVIMENTO")]),_vm._v(" "),_c('option',{attrs:{"value":"EM DIARIA"}},[_vm._v("EM DIARIA")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.motivo),expression:"dividirTempo.motivo"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dividirTempo, "motivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"03"}},[_vm._v("03 - Espera")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04 - Alimentacao")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05 - Descanso Direcao")]),_vm._v(" "),_c('option',{attrs:{"value":"06"}},[_vm._v("06 - Abastecimento")]),_vm._v(" "),_c('option',{attrs:{"value":"07"}},[_vm._v("07 - Fiscalizacao")]),_vm._v(" "),_c('option',{attrs:{"value":"08"}},[_vm._v("08 - Manutencao em Jornada")]),_vm._v(" "),_c('option',{attrs:{"value":"09"}},[_vm._v("09 - Contato")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 - \"Socorro\"")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11 - Transito")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("34 - Diaria")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observação:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.observacao),expression:"dividirTempo.observacao"}],staticClass:"pula form-control",domProps:{"value":(_vm.dividirTempo.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "observacao", $event.target.value)}}})])]),_vm._v(" "),_c('input',{attrs:{"id":"modalItemAutomaticoManual","type":"hidden","value":"false"}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gravarDividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":12,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Mudar Motivo"},on:{"click":_vm.mudarMotivoModal}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/gestaoJornada"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Data: ")]),_vm._v("De: "+_vm._s(_vm.jornada.dataHoraInicial)+" até "+_vm._s(_vm.jornada.dataHoraFinal)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.jornada.veiculoDescricao)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(" "+_vm._s(_vm.jornada.motoristaNome)),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('span',{on:{"click":function($event){_vm.showModalMudarMotorista = true}}},[_vm._v("Mudar motorista")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(6),_vm._v(" "),_vm._l((_vm.jornadaItens),function(grid,i){return _c('tbody',[_c('tr',{class:{ 'selecionado': _vm.selecionado(grid), 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') },on:{"click":function($event){_vm.selecionarItem(grid, $event)}}},[_c('td',{attrs:{"width":"140"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',{attrs:{"width":"85"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',{attrs:{"width":"200"}},[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))])]),_vm._v(" "),_c('td',{attrs:{"width":"205"}},[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',{attrs:{"width":"150"}},[_c('small',[_vm._v(_vm._s(grid.observacao))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(grid.statusVeiculo === 'VEICULO PARADO')?[(grid.latitude !== '' && grid.latitude !== '0.0;')?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Ver Mapa'),expression:"'Ver Mapa'"}],attrs:{"href":"#"},on:{"click":function($event){_vm.visualizarMapa(grid)}}},[_c('img',{attrs:{"src":"/static/images/ponto.png"}})])]:_vm._e()]:_vm._e(),_vm._v(" "),(grid.statusVeiculo === 'VEICULO PARADO' || grid.statusVeiculo === 'EM DIARIA')?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"href":"#"},on:{"click":function($event){_vm.showDividirTempo(grid.id)}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])]:_vm._e()],2)])])})],2),_vm._v(" "),_vm._m(7),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(8),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoJornada)+" ")]),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDiaria)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAbastecimento)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoManutencao)+" ")]),_c('br')]),_vm._v(" "),_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoCargaDescarga)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoFiscalizacao)+" ")]),_c('br')]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDescansoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAlimentacao)+" ")]),_c('br')]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAdicionalNoturno)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna2)+" ")]),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraTrabalhada)+" ")]),_c('br')]),_vm._v(" "),_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraIndenizada)+" ")]),_c('br')]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraDescanso)+" ")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motivo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalMudarMotivoMensagem"}},[_vm._v("Não foi selecionado um lançamento"),_c('br'),_vm._v(" Serão trocados todos os lançamentos sem Motivos.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dividir Tempo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 text-center"}),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-center"},[_c('br'),_c('h5',[_c('strong',[_vm._v("TOTAIS")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-center"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Tempo em Jornada: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Direção: "),_c('br'),_vm._v("\n              Diária: "),_c('br'),_vm._v("\n              Abastecimento: "),_c('br'),_vm._v("\n              Manutenção: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Carga e Descarga: "),_c('br'),_vm._v("\n              Fiscalização: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Descanso de Direção: "),_c('br'),_vm._v("\n              Alimentação: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Adicional Noturno: "),_c('br'),_vm._v("\n              Hora Extra Normal 1:"),_c('br'),_vm._v("\n              Hora Extra Normal 2: "),_c('br'),_vm._v("\n              Hora Extra Noturna 1:"),_c('br'),_vm._v("\n              Hora Extra Noturna 2: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Trabalhando: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Indenizada: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Descanso: "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ToLT":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      inicioJornadaManual: false,
      finalJornadaManual: false,
      dataHoraInicialJornadaManual: '',
      dataHoraFinalJornadaManual: '',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosAnalise: [],
      dadosAnaliseMacros: [],
      dadosAnaliseProblemas: '',
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.gerarAnalise();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    gerarAnalise: function gerarAnalise() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/analiseJornadas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
      });
    },
    gravarAnalise: function gravarAnalise() {
      var self = this;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      if (self.inicioJornadaManual === true) {
        if (self.dataHoraInicialJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Inicial da Jornada', 'Atenção');
          return;
        }
      }
      if (self.finalJornadaManual === true) {
        if (self.dataHoraFinalJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Final da Jornada', 'Atenção');
          return;
        }
      }
      self.processando = true;
      var url = '/api/analiseJornadasGravar?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      if (self.inicioJornadaManual === true) {
        url = url + '&dataHoraInicialJornada=' + self.dataHoraInicialJornadaManual;
      }
      if (self.finalJornadaManual === true) {
        url = url + '&dataHoraFinalJornada=' + self.dataHoraFinalJornadaManual;
      }
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
        self.$router.replace('/gestaoJornada');
      });
    }
  }
};

/***/ }),

/***/ "Trcb":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalDividirTempo: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: ''
    };
  },

  created: function created() {
    this.buscar();
    this.buscarItens();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornada = dados;
      });
    },
    buscarItens: function buscarItens() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornadaItens = dados;
      });
    },
    mudarMotorista: function mudarMotorista() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotorista = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.motoristaId = motorista.id;
      this.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    showDividirTempo: function showDividirTempo(jornadaId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/buscarJornadaItem&id=' + jornadaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        self.showModalDividirTempo = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    gravarDividirTempo: function gravarDividirTempo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + this.$route.params.id + '&dataHoraInicio=' + self.divisao.dataHoraInicio + '&dataHoraFinal=' + self.divisao.dataHoraFinal + '&dataHoraDuracao=' + self.divisao.dataHoraDuracao + '&motivo=' + self.divisao.motivo + '&observacao=' + self.divisao.observacao + '&status=' + self.divisao.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    salvar: function salvar() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.jornada), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.$router.replace('/gestaoJornada');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ "U90E":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Periodo: ")]),_vm._v(" De: "+_vm._s(_vm.dadosAnalise.dataInicial)+" até "+_vm._s(_vm.dadosAnalise.dataFinal)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosAnalise.veiculo)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosAnalise.empresa)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.kmRodados).toFixed(2))+" Km \n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMedia).toFixed(2))+" Km/h\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMaxima).toFixed(2))+" Km/h \n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.inicioJornadaManual),expression:"inicioJornadaManual"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.inicioJornadaManual)?_vm._i(_vm.inicioJornadaManual,null)>-1:(_vm.inicioJornadaManual)},on:{"change":function($event){var $$a=_vm.inicioJornadaManual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.inicioJornadaManual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.inicioJornadaManual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.inicioJornadaManual=$$c}}}}),_vm._v(" Informar inicio de Jornada Manual")]),_vm._v(" "),(_vm.inicioJornadaManual)?[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data hora Inicial Jornada: ")]),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataHoraInicialJornadaManual),callback:function ($$v) {_vm.dataHoraInicialJornadaManual=$$v},expression:"dataHoraInicialJornadaManual"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.finalJornadaManual),expression:"finalJornadaManual"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.finalJornadaManual)?_vm._i(_vm.finalJornadaManual,null)>-1:(_vm.finalJornadaManual)},on:{"change":function($event){var $$a=_vm.finalJornadaManual,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.finalJornadaManual=$$a.concat([$$v]))}else{$$i>-1&&(_vm.finalJornadaManual=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.finalJornadaManual=$$c}}}}),_vm._v(" Informar final de Jornada Manual")]),_vm._v(" "),(_vm.finalJornadaManual)?[_c('br'),_vm._v(" "),_c('strong',[_vm._v("Data hora Final Jornada: ")]),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"form-control pula data",model:{value:(_vm.dataHoraFinalJornadaManual),callback:function ($$v) {_vm.dataHoraFinalJornadaManual=$$v},expression:"dataHoraFinalJornadaManual"}})]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(_vm._s(_vm.dadosAnalise.motorista)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('div',[_c('strong',[_vm._v("Problemas encontrados na Análise")]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.dadosAnaliseProblemas)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"pull-right"},[_c('button',{staticClass:"btn btn-success ",attrs:{"id":"gravarAnalise","type":"button"},on:{"click":_vm.gravarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-save",attrs:{"aria-hidden":"true"}}),_vm._v(" Gravar Análise\n                ")])])])])]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(1),_vm._v(" "),_vm._l((_vm.dadosAnaliseMacros),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(grid.dataHoraInicio))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grid.macro))])])])})],2),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dadosAnalise.dados),function(grid,i){return _c('tbody',[(i > 0 && _vm.dadosAnalise.dados[i].data !== _vm.dadosAnalise.dados[i-1].data)?[_vm._m(3,true)]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }},[_c('td',{attrs:{"width":"140"}},[_c('small',[_vm._v(_vm._s(grid.data)+" "+_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.data)+" "+_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',{attrs:{"width":"85"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.observacao))])])])],2)})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("MACRO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"background-color":"#FF0400","height":"20px"}},[_c('td',{attrs:{"colspan":"6"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "U9P9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatoriosTelemetria"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_vm._m(3),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.length > 0)?[_c('div',{attrs:{"id":"relatorioTelemetriaViagemGeral"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"table-layout":"fixed"},attrs:{"id":"tableRelatorioTelemetriaViagemGeral"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeInicio),expression:"dados.latitudeInicio"}],attrs:{"id":'latitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeInicio),expression:"dados.longitudeInicio"}],attrs:{"id":'longitudeI_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeInicio", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitudeFim),expression:"dados.latitudeFim"}],attrs:{"id":'latitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.latitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitudeFim", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitudeFim),expression:"dados.longitudeFim"}],attrs:{"id":'longitudeF_'+i,"type":"hidden"},domProps:{"value":(dados.longitudeFim)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitudeFim", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.veiculoDescricao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataInicial))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataFinal))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemDistancia))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.viagemTempo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoParado))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoParadoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoMovimento))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoMovimentoPercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tempoExcessoVelocidade))]),_vm._v(" "),_c('small',{staticClass:"text-danger"},[_vm._v(_vm._s(dados.tempoExcessoVelocidadePercentual)+" %")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMaxima))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.velocidadeMedia))])]),_vm._v(" "),_c('td',[(dados.motoristaNome !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motoristaNome))])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade'),expression:"'Excesso de Velocidade'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidade))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso Velocidade na Chuva'),expression:"'Excesso Velocidade na Chuva'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeChuva))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Excesso de Velocidade dentro de cerca'),expression:"'Excesso de Velocidade dentro de cerca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaExcessoVelocidadeCerca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Aceleração Brusca'),expression:"'Aceleração Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaAceleracaoBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Freada Brusca'),expression:"'Freada Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaFreadaBrusca))]),_vm._v(" / ")]),_vm._v(" "),_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Mudança Faixa Brusca'),expression:"'Mudança Faixa Brusca'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMudancaFaixaBrusca))])])]),_vm._v(" "),_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Total de Transgressões'),expression:"'Total de Transgressões'"}]},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaTotalTransgressoes))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaMediaPorKm))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.alertaClassificacao))])])])}))])])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Telemetria - Viagem por Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v("Fenix Sat Ltda\n              ")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"250"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Periodo")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Distância")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Tempo")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. Parado")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Movimento\t")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("T. em Excesso")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Max")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Vel Média")]),_vm._v(" "),_c('th',{attrs:{"width":"200"}},[_vm._v("Motorista")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Transgressões")]),_vm._v(" "),_c('th',{attrs:{"width":"80"}},[_vm._v("Total")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Média por km")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("Classificação")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "UOsF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "URKx":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-data-picker-2',
  props: {
    id: String,
    value: {
      validator: function validator(val) {
        return val === null || val instanceof Date || typeof val === 'string';
      }
    },
    format: {
      default: 'dd/mm/yy'
    }
  },
  watch: {
    value: function value(_value) {
      console.log('#' + this.id);

      this.setValue(_value);
    },
    openDate: function openDate() {
      this.setPageDate();
    },
    initialView: function initialView() {
      this.setInitialView();
    }
  },
  methods: {
    setValue: function setValue(date) {
      console.log('set value');

      $(this.$el).find('#' + this.id).val(date);
    },

    setarData: function setarData() {}
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).datepicker({
      closeText: 'Fechar',
      prevText: '&#x3c;Anterior',
      nextText: 'Pr&oacute;ximo&#x3e;',
      currentText: 'Hoje',
      monthNames: ['Janeiro', 'Fevereiro', 'Mar&ccedil;o', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro'],
      monthNamesShort: ['Jan', 'Fev', 'Mar', 'Abr', 'Mai', 'Jun', 'Jul', 'Ago', 'Set', 'Out', 'Nov', 'Dez'],
      dayNames: ['Domingo', 'Segunda-feira', 'Ter&ccedil;a-feira', 'Quarta-feira', 'Quinta-feira', 'Sexta-feira', 'Sabado'],
      dayNamesShort: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      dayNamesMin: ['Dom', 'Seg', 'Ter', 'Qua', 'Qui', 'Sex', 'Sab'],
      weekHeader: 'Sm',
      dateFormat: 'dd/mm/yy',
      firstDay: 0,
      isRTL: false,
      showMonthAfterYear: false,
      yearSuffix: '',
      onSelect: function onSelect(date) {
        vmm.$emit('input', date);
      }
    });
    $(this.$el).val(this.value);

    $(this.$el).on('change', function () {
      console.log('mount');
      vmm.$emit('input', this.value);
    });
  }
};
module.exports = vm;

/***/ }),

/***/ "UTg/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  'SET_AUTH_TOKEN': function SET_AUTH_TOKEN(state, token) {
    state.token = token;
  },
  'SET_SISTEMA': function SET_SISTEMA(state, _collapsed) {
    state.sistema.collapsed = _collapsed;
  },
  'SET_FILTROS_GESTAO_JORNADA': function SET_FILTROS_GESTAO_JORNADA(state, _filtros) {
    state.filtrosGestaoJornada.dataInicial = _filtros.dataInicial;
    state.filtrosGestaoJornada.dataFinal = _filtros.dataFinal;
    state.filtrosGestaoJornada.buscas = _filtros.buscas;
    state.filtrosGestaoJornada.status = _filtros.status;
    state.filtrosGestaoJornada.exibir = _filtros.exibir;
    state.filtrosGestaoJornada.ordem = _filtros.ordem;
  },
  'SET_FILTROS_RELATORIOS': function SET_FILTROS_RELATORIOS(state, _filtros) {
    state.filtrosRelatorios.clienteId = _filtros.clienteId;
    state.filtrosRelatorios.veiculoId = _filtros.veiculoId;
    state.filtrosRelatorios.veiculoDescricao = _filtros.veiculoDescricao;
    state.filtrosRelatorios.dataInicial = _filtros.dataInicial;
    state.filtrosRelatorios.horaInicial = _filtros.horaInicial;
    state.filtrosRelatorios.dataFinal = _filtros.dataFinal;
    state.filtrosRelatorios.horaFinal = _filtros.horaFinal;
    state.filtrosRelatorios.relatorio = _filtros.relatorio;
    state.filtrosRelatorios.buscaVeiculo = _filtros.buscaVeiculo;
    state.filtrosRelatorios.selecionada = _filtros.selecionada;
    state.filtrosRelatorios.filtroVelocidade = _filtros.filtroVelocidade;
    state.filtrosRelatorios.filtroVelocidadeMinima = _filtros.filtroVelocidadeMinima;
    state.filtrosRelatorios.filtroVelocidadeMaxima = _filtros.filtroVelocidadeMaxima;
    state.filtrosRelatorios.desprezarVelocidade = _filtros.desprezarVelocidade;
    state.filtrosRelatorios.agruparPosicoes = _filtros.agruparPosicoes;
    state.filtrosRelatorios.entrada = _filtros.entrada;
    state.filtrosRelatorios.entradaVelocidade = _filtros.entradaVelocidade;
    state.filtrosRelatorios.obdIgnicao = _filtros.obdIgnicao;
    state.filtrosRelatorios.obdRpm = _filtros.obdRpm;
    state.filtrosRelatorios.obdTemperatura = _filtros.obdTemperatura;
    state.filtrosRelatorios.obdErro = _filtros.obdErro;
    state.filtrosRelatorios.agrupar = _filtros.agrupar;
    state.filtrosRelatorios.formato = _filtros.formato;
  },
  'SET_FILTROS_CLIENTE': function SET_FILTROS_CLIENTE(state, _filtros) {
    state.filtrosCliente.buscas = _filtros.buscas;
    state.filtrosCliente.pagina = _filtros.pagina;
    state.filtrosCliente.quantidade = _filtros.quantidade;
    state.filtrosCliente.status = _filtros.status;
    state.filtrosCliente.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_FORNECEDOR': function SET_FILTROS_FORNECEDOR(state, _filtros) {
    state.filtrosFornecedor.buscas = _filtros.buscas;
    state.filtrosFornecedor.pagina = _filtros.pagina;
    state.filtrosFornecedor.quantidade = _filtros.quantidade;
    state.filtrosFornecedor.status = _filtros.status;
    state.filtrosFornecedor.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_TRANSPORTADOR': function SET_FILTROS_TRANSPORTADOR(state, _filtros) {
    state.filtrosTransportador.buscas = _filtros.buscas;
    state.filtrosTransportador.pagina = _filtros.pagina;
    state.filtrosTransportador.quantidade = _filtros.quantidade;
    state.filtrosTransportador.status = _filtros.status;
    state.filtrosTransportador.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_VEICULO': function SET_FILTROS_VEICULO(state, _filtros) {
    state.filtrosVeiculo.buscas = _filtros.buscas;
    state.filtrosVeiculo.pagina = _filtros.pagina;
    state.filtrosVeiculo.quantidade = _filtros.quantidade;
    state.filtrosVeiculo.status = _filtros.status;
    state.filtrosVeiculo.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_VENDEDOR': function SET_FILTROS_VENDEDOR(state, _filtros) {
    state.filtrosVendedor.buscas = _filtros.buscas;
    state.filtrosVendedor.pagina = _filtros.pagina;
    state.filtrosVendedor.quantidade = _filtros.quantidade;
    state.filtrosVendedor.status = _filtros.status;
    state.filtrosVendedor.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_PRODUTO': function SET_FILTROS_PRODUTO(state, _filtros) {
    state.filtrosProduto.buscas = _filtros.buscas;
    state.filtrosProduto.pagina = _filtros.pagina;
    state.filtrosProduto.quantidade = _filtros.quantidade;
    state.filtrosProduto.status = _filtros.status;
    state.filtrosProduto.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_SERVICO': function SET_FILTROS_SERVICO(state, _filtros) {
    state.filtrosServico.buscas = _filtros.buscas;
    state.filtrosServico.pagina = _filtros.pagina;
    state.filtrosServico.quantidade = _filtros.quantidade;
    state.filtrosServico.status = _filtros.status;
    state.filtrosServico.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_DEPOSITO_MOVIMENTO': function SET_FILTROS_DEPOSITO_MOVIMENTO(state, _filtros) {
    state.filtrosDepositoMovimento.dataInicial = _filtros.dataInicial;
    state.filtrosDepositoMovimento.dataFinal = _filtros.dataFinal;
    state.filtrosDepositoMovimento.produtoId = _filtros.produtoId;
    state.filtrosDepositoMovimento.produtoNome = _filtros.produtoNome;
    state.filtrosDepositoMovimento.tipo = _filtros.tipo;
    state.filtrosDepositoMovimento.depositoId = _filtros.depositoId;
  },
  'SET_FILTROS_DEPOSITO_BALANCO': function SET_FILTROS_DEPOSITO_BALANCO(state, _filtros) {
    state.filtrosDepositoBalanco.dataInicial = _filtros.dataInicial;
    state.filtrosDepositoBalanco.dataFinal = _filtros.dataFinal;
    state.filtrosDepositoBalanco.produtoId = _filtros.produtoId;
    state.filtrosDepositoBalanco.produtoNome = _filtros.produtoNome;
    state.filtrosDepositoBalanco.tipo = _filtros.tipo;
    state.filtrosDepositoBalanco.depositoId = _filtros.depositoId;
  },
  'SET_FILTROS_FINANCEIRO': function SET_FILTROS_FINANCEIRO(state, _filtros) {
    state.filtrosFinanceiro.dataInicial = _filtros.dataInicial;
    state.filtrosFinanceiro.dataFinal = _filtros.dataFinal;
    state.filtrosFinanceiro.busca = _filtros.busca;
    state.filtrosFinanceiro.titularId = _filtros.titularId;
    state.filtrosFinanceiro.titularTipo = _filtros.titularTipo;
    state.filtrosFinanceiro.titularNome = _filtros.titularNome;
    state.filtrosFinanceiro.titular = _filtros.titular;
    state.filtrosFinanceiro.exibir = _filtros.exibir;
    state.filtrosFinanceiro.ordenarPor = _filtros.ordenarPor;
  },
  'SET_FILTROS_BANCO': function SET_FILTROS_BANCO(state, _filtros) {
    state.filtrosBanco.buscas = _filtros.buscas;
    state.filtrosBanco.pagina = _filtros.pagina;
    state.filtrosBanco.quantidade = _filtros.quantidade;
    state.filtrosBanco.status = _filtros.status;
    state.filtrosBanco.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_BANCO_MOVIMENTO': function SET_FILTROS_BANCO_MOVIMENTO(state, _filtros) {
    state.filtrosBancoMovimento.dataInicial = _filtros.dataInicial;
    state.filtrosBancoMovimento.dataFinal = _filtros.dataFinal;
    state.filtrosBancoMovimento.busca = _filtros.busca;
    state.filtrosBancoMovimento.bancoId = _filtros.bancoId;
    state.filtrosBancoMovimento.exibir = _filtros.exibir;
    state.filtrosBancoMovimento.ordenarPor = _filtros.ordenarPor;
  },
  'SET_FILTROS_BANCO_BOLETO': function SET_FILTROS_BANCO_BOLETO(state, _filtros) {
    state.filtrosBancoBoleto.dataInicial = _filtros.dataInicial;
    state.filtrosBancoBoleto.dataFinal = _filtros.dataFinal;
    state.filtrosBancoBoleto.busca = _filtros.busca;
    state.filtrosBancoBoleto.bancoId = _filtros.bancoId;
    state.filtrosBancoBoleto.exibir = _filtros.exibir;
    state.filtrosBancoBoleto.ordenarPor = _filtros.ordenarPor;
  },
  'SET_FILTROS_CHEQUE': function SET_FILTROS_CHEQUE(state, _filtros) {
    state.filtrosCheque.dataInicial = _filtros.dataInicial;
    state.filtrosCheque.dataFinal = _filtros.dataFinal;
    state.filtrosCheque.busca = _filtros.busca;
    state.filtrosCheque.titularId = _filtros.titularId;
    state.filtrosCheque.titularTipo = _filtros.titularTipo;
    state.filtrosCheque.titularNome = _filtros.titularNome;
    state.filtrosCheque.titular = _filtros.titular;
    state.filtrosCheque.status = _filtros.status;
    state.filtrosCheque.ordenarPor = _filtros.ordenarPor;
  },
  'SET_FILTROS_COMPRA': function SET_FILTROS_COMPRA(state, _filtros) {
    state.filtrosCompra.dataInicial = _filtros.dataInicial;
    state.filtrosCompra.dataFinal = _filtros.dataFinal;
    state.filtrosCompra.fornecedorId = _filtros.fornecedorId;
    state.filtrosCompra.fornecedorNome = _filtros.fornecedorNome;
    state.filtrosCompra.numero = _filtros.numero;
    state.filtrosCompra.status = _filtros.status;
    state.filtrosCompra.selecionada = _filtros.selecionada;
    state.filtrosCompra.selecionadaCompra = _filtros.selecionadaCompra;
  },
  'SET_FILTROS_COMPRA_COTACAO': function SET_FILTROS_COMPRA_COTACAO(state, _filtros) {
    state.filtrosCompraCotacao.dataInicial = _filtros.dataInicial;
    state.filtrosCompraCotacao.dataFinal = _filtros.dataFinal;
    state.filtrosCompraCotacao.fornecedorId = _filtros.fornecedorId;
    state.filtrosCompraCotacao.fornecedorNome = _filtros.fornecedorNome;
    state.filtrosCompraCotacao.numero = _filtros.numero;
    state.filtrosCompraCotacao.status = _filtros.status;
    state.filtrosCompraCotacao.selecionada = _filtros.selecionada;
    state.filtrosCompraCotacao.selecionadaCompra = _filtros.selecionadaCompra;
  },
  'SET_FILTROS_VENDA': function SET_FILTROS_VENDA(state, _filtros) {
    state.filtrosVenda.dataInicial = _filtros.dataInicial;
    state.filtrosVenda.dataFinal = _filtros.dataFinal;
    state.filtrosVenda.clienteId = _filtros.clienteId;
    state.filtrosVenda.clienteNome = _filtros.clienteNome;
    state.filtrosVenda.numero = _filtros.numero;
    state.filtrosVenda.status = _filtros.status;
  },
  'SET_FILTROS_DEVOLUCAO': function SET_FILTROS_DEVOLUCAO(state, _filtros) {
    state.filtrosDevolucao.dataInicial = _filtros.dataInicial;
    state.filtrosDevolucao.dataFinal = _filtros.dataFinal;
    state.filtrosDevolucao.clienteId = _filtros.clienteId;
    state.filtrosDevolucao.clienteNome = _filtros.clienteNome;
    state.filtrosDevolucao.numero = _filtros.numero;
    state.filtrosDevolucao.status = _filtros.status;
  },
  'SET_FILTROS_VENDA_SERVICO': function SET_FILTROS_VENDA_SERVICO(state, _filtros) {
    state.filtrosVendaServico.dataInicial = _filtros.dataInicial;
    state.filtrosVendaServico.dataFinal = _filtros.dataFinal;
    state.filtrosVendaServico.clienteId = _filtros.clienteId;
    state.filtrosVendaServico.clienteNome = _filtros.clienteNome;
    state.filtrosVendaServico.numero = _filtros.numero;
    state.filtrosVendaServico.status = _filtros.status;
  },
  'SET_FILTROS_VENDA_COMODATO': function SET_FILTROS_VENDA_COMODATO(state, _filtros) {
    state.filtrosVendaComodato.dataInicial = _filtros.dataInicial;
    state.filtrosVendaComodato.dataFinal = _filtros.dataFinal;
    state.filtrosVendaComodato.clienteId = _filtros.clienteId;
    state.filtrosVendaComodato.clienteNome = _filtros.clienteNome;
    state.filtrosVendaComodato.numero = _filtros.numero;
    state.filtrosVendaComodato.status = _filtros.status;
  },
  'SET_FILTROS_NOTA_FISCAL': function SET_FILTROS_NOTA_FISCAL(state, _filtros) {
    state.filtrosNotaFiscal.dataInicial = _filtros.dataInicial;
    state.filtrosNotaFiscal.dataFinal = _filtros.dataFinal;
    state.filtrosNotaFiscal.clienteId = _filtros.clienteId;
    state.filtrosNotaFiscal.clienteNome = _filtros.clienteNome;
    state.filtrosNotaFiscal.numero = _filtros.numero;
    state.filtrosNotaFiscal.status = _filtros.status;
  },
  'SET_FILTROS_FORMA_PAGAMENTO': function SET_FILTROS_FORMA_PAGAMENTO(state, _filtros) {
    state.filtrosFormaPagamento.buscas = _filtros.buscas;
    state.filtrosFormaPagamento.pagina = _filtros.pagina;
    state.filtrosFormaPagamento.quantidade = _filtros.quantidade;
    state.filtrosFormaPagamento.status = _filtros.status;
    state.filtrosFormaPagamento.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_CODIGO_NCM': function SET_FILTROS_CODIGO_NCM(state, _filtros) {
    state.filtrosCodigoNcm.buscas = _filtros.buscas;
    state.filtrosCodigoNcm.pagina = _filtros.pagina;
    state.filtrosCodigoNcm.quantidade = _filtros.quantidade;
    state.filtrosCodigoNcm.status = _filtros.status;
    state.filtrosCodigoNcm.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_CIDADE': function SET_FILTROS_CIDADE(state, _filtros) {
    state.filtrosCidade.buscas = _filtros.buscas;
    state.filtrosCidade.pagina = _filtros.pagina;
    state.filtrosCidade.quantidade = _filtros.quantidade;
    state.filtrosCidade.status = _filtros.status;
    state.filtrosCidade.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_MOTORISTA': function SET_FILTROS_MOTORISTA(state, _filtros) {
    state.filtrosMotorista.buscas = _filtros.buscas;
    state.filtrosMotorista.pagina = _filtros.pagina;
    state.filtrosMotorista.quantidade = _filtros.quantidade;
    state.filtrosMotorista.status = _filtros.status;
    state.filtrosMotorista.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_EVENTO': function SET_FILTROS_EVENTO(state, _filtros) {
    state.filtrosEvento.buscas = _filtros.buscas;
    state.filtrosEvento.pagina = _filtros.pagina;
    state.filtrosEvento.quantidade = _filtros.quantidade;
    state.filtrosEvento.status = _filtros.status;
    state.filtrosEvento.selecionada = _filtros.selecionada;
  },
  'SET_FILTROS_EVENTO_DISPARADO': function SET_FILTROS_EVENTO_DISPARADO(state, _filtros) {
    state.filtrosEventoDisparado.dataInicial = _filtros.dataInicial;
    state.filtrosEventoDisparado.dataFinal = _filtros.dataFinal;
    state.filtrosEventoDisparado.buscas = _filtros.buscas;
    state.filtrosEventoDisparado.eventoId = _filtros.eventoId;
    state.filtrosEventoDisparado.status = _filtros.status;
  }
};

/***/ }),

/***/ "UeKE":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-titular',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,
    readonly: Boolean,
    errors: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#titular').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#titular').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarTitularesAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "UidA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue__ = __webpack_require__("ZIYP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff216692_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemGeralView_vue__ = __webpack_require__("+9oD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemGeralView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_ff216692_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemGeralView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "V3kN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default
  },
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: true,
        clienteId: '0',
        clienteNomeFantasia: '',
        motorista: true,
        tipoJornadaAjudante: 'T',
        nome: '',
        documento: '',
        rg: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '0',
        cidadeNome: '',
        cep: '',
        estado: '',
        telefone: '',
        celular: '',
        celularOperadora: '',
        email: '',
        cnh: '',
        tipoCnh: '',
        primeiraCnh: '',
        vencimentoCnh: '',
        codigoEmpresa: '',
        codigoRastreador: '',
        login: '',
        senha: '',
        numeroPis: '',
        cargo: '',
        jornada: '',
        dataNascimento: '',
        dataCadastro: '',
        empresaCnpj: '',
        empresaNome: '',
        empresaEndereco: '',
        observacao: '',
        jornadaHorarioControlado: false,
        inicioJornadaSegundaQuinta: '00:00:00',
        margemInicioAlmocoSegundaQuinta: '00:00:00',
        margemFinalAlmocoSegundaQuinta: '00:00:00',

        fimJornadaSegundaQuinta: '00:00:00',
        inicioJornadaSexta: '00:00:00',
        margemInicioAlmocoSexta: '00:00:00',
        margemFinalAlmocoSexta: '00:00:00',

        fimJornadaSexta: '00:00:00',
        inicioJornadaSabado: '00:00:00',
        margemInicioAlmocoSabado: '00:00:00',
        margemFinalAlmocoSabado: '00:00:00',

        fimJornadaSabado: '00:00:00',
        inicioJornadaDomingo: '00:00:00',
        margemInicioAlmocoDomingo: '00:00:00',
        margemFinalAlmocoDomingo: '00:00:00',
        fimJornadaDomingo: '00:00:00',

        jornadaDuracaoSegundaQuinta: '00:00:00',
        jornadaDuracaoSexta: '00:00:00',
        jornadaDuracaoSabado: '00:00:00',
        jornadaDuracaoDomingo: '00:00:00',

        inicioFimJornadaTolerancia: '00:00:00',
        macroForaMargemHorarioAlmoco: '',
        tipoControleJornada: '',
        codigoCadastroEmpresa: ''
      },
      isentoInscricaoEstadual: false,
      isentoInscricaoMunicipal: false,
      conceitos: [],
      formasPagamentos: [],
      tabelasPrecos: [],
      vendedores: [],
      motoristaCreditoFinanceiro: [],
      historicoFinanceiro: [],
      historicoCheques: [],
      vendasProdutos: [],
      vendasServicos: [],
      interacoes: [],
      perfilClienteGraficoVendas: null,
      vendasPeriodo: '12',
      vendasPeriodoAgrupamento: 'S',
      vendasProdutosMaisVendidosPeriodo: '12',
      vendasProdutosMaisVendidosPeriodoAgrupamento: 'V',
      vendasPeriodoLabels: [],
      vendasPeriodoDados: [],
      vendasProdutosMaisVendidosPeriodoDados: [],
      exibirFinanceiro: 30,
      exibirFinanceiroCredito: 30,
      exibirFinanceiroCheques: 30,
      showModalProdutosRelacionados: false,
      selecionadosFinanceiros: [],
      selecionadosCreditos: [],
      selecionadosCheques: []
    };
  },

  created: function created() {
    this.buscar();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token, 'connection': 'keep-alive' }
      };
      var url = '/api/motoristas/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        console.log(response.data.nomeFantasia);
        var dados = response.data;
        self.model.id = dados.id;
        if (dados.cliente !== null) {
          self.model.clienteId = dados.cliente.id;
          self.model.clienteNomeFantasia = dados.cliente.nomeFantasia;
        }
        self.model.ativo = dados.ativo;
        self.model.tipoJornadaAjudante = dados.tipoJornadaAjudante;
        self.model.nome = dados.nome;
        self.model.documento = dados.documento;
        self.model.rg = dados.rg;
        self.model.endereco = dados.endereco;
        self.model.numero = dados.numero;
        self.model.complemento = dados.complemento;
        self.model.bairro = dados.bairro;
        if (dados.cidade !== null) {
          self.model.cidadeId = dados.cidade.id;
          self.model.cidadeNome = dados.cidade.cidade;
        }
        self.model.cep = dados.cep;
        self.model.estado = dados.estado;
        self.model.contato = dados.contato;
        self.model.telefone = dados.telefone;
        self.model.celular = dados.celular;
        self.model.whatsapp = dados.whatsapp;
        self.model.celularOperadora = dados.celularOperadora;
        self.model.email = dados.email;
        self.model.cnh = dados.cnh;
        self.model.primeiraCnh = dados.primeiraCnh;
        self.model.tipoCnh = dados.tipoCnh;
        self.model.vencimentoCnh = dados.vencimentoCnh;
        self.model.codigoEmpresa = dados.codigoEmpresa;
        self.model.codigoRastreador = dados.codigoRastreador;
        self.model.login = dados.login;
        self.model.senha = dados.senha;
        self.model.numeroPis = dados.numeroPis;
        self.model.cargo = dados.cargo;
        self.model.jornada = dados.jornada;
        self.model.dataNascimento = dados.dataNascimento;
        self.model.dataCadastro = dados.dataCadastro;
        self.model.empresaCnpj = dados.empresaCnpj;
        self.model.empresaNome = dados.empresaNome;
        self.model.empresaEndereco = dados.empresaEndereco;
        self.model.observacao = dados.observacao;

        self.model.jornadaHorarioControlado = dados.jornadaHorarioControlado;
        self.model.inicioJornadaSegundaQuinta = dados.inicioJornadaSegundaQuinta;
        self.model.margemInicioAlmocoSegundaQuinta = dados.margemInicioAlmocoSegundaQuinta;
        self.model.margemFinalAlmocoSegundaQuinta = dados.margemFinalAlmocoSegundaQuinta;
        self.model.fimJornadaSegundaQuinta = dados.fimJornadaSegundaQuinta;
        self.model.inicioJornadaSexta = dados.inicioJornadaSexta;
        self.model.margemInicioAlmocoSexta = dados.margemInicioAlmocoSexta;
        self.model.margemFinalAlmocoSexta = dados.margemFinalAlmocoSexta;
        self.model.fimJornadaSexta = dados.fimJornadaSexta;
        self.model.inicioJornadaSabado = dados.inicioJornadaSabado;
        self.model.margemInicioAlmocoSabado = dados.margemInicioAlmocoSabado;
        self.model.margemFinalAlmocoSabado = dados.margemFinalAlmocoSabado;
        self.model.fimJornadaSabado = dados.fimJornadaSabado;
        self.model.inicioJornadaDomingo = dados.inicioJornadaDomingo;
        self.model.margemInicioAlmocoDomingo = dados.margemInicioAlmocoDomingo;
        self.model.margemFinalAlmocoDomingo = dados.margemFinalAlmocoDomingo;
        self.model.fimJornadaDomingo = dados.fimJornadaDomingo;
        self.model.inicioFimJornadaTolerancia = dados.inicioFimJornadaTolerancia;
        self.model.macroForaMargemHorarioAlmoco = dados.macroForaMargemHorarioAlmoco;
        self.model.tipoControleJornada = dados.tipoControleJornada;
        self.model.codigoCadastroEmpresa = dados.codigoCadastroEmpresa;
        self.model.jornadaDuracaoSegundaQuinta = dados.jornadaDuracaoSegundaQuinta;
        self.model.jornadaDuracaoSexta = dados.jornadaDuracaoSexta;
        self.model.jornadaDuracaoSabado = dados.jornadaDuracaoSabado;
        self.model.jornadaDuracaoDomingo = dados.jornadaDuracaoDomingo;
      });
    },
    buscarConceitos: function buscarConceitos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarConceitos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.conceitos = dados;
      });
    },
    buscarFormasPagamentos: function buscarFormasPagamentos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarFormasPagamentos?busca=&tipo=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.formasPagamentos = dados;
      });
    },
    buscarTabelasPrecos: function buscarTabelasPrecos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarProdutosTabelasPrecos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.tabelasPrecos = dados;
      });
    },
    buscarVendedores: function buscarVendedores() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarVendedores?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.vendedores = dados;
      });
    },
    buscarEnderecos: function buscarEnderecos() {
      var self = this;
      if (self.model.enderecos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesEnderecos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.model.enderecos = dados;
        });
      }
    },
    buscarContatos: function buscarContatos() {
      var self = this;
      if (self.model.contatos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesContatos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.model.contatos = dados;
        });
      }
    },
    buscarHistoricoCredito: function buscarHistoricoCredito() {
      var self = this;
      if (self.motoristaCreditoFinanceiro.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/buscarClientesCreditos?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCredito;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.motoristaCreditoFinanceiro = dados;
        });
      }
    },
    selecionarCreditoItem: function selecionarCreditoItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCreditos.includes(item)) {
          var p = this.selecionadosCreditos.indexOf(item);
          this.selecionadosCreditos.splice(p, 1);
        } else {
          this.selecionadosCreditos.push(item);
        }
      } else {
        this.selecionadosCreditos = [];
        this.selecionadosCreditos.push(item);
      }
    },
    selecionadoCredito: function selecionadoCredito(item) {
      return this.selecionadosCreditos.includes(item);
    },
    buscarHistoricoFinanceiro: function buscarHistoricoFinanceiro() {
      var self = this;

      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/motoristaHistoricoFinanceiro?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiro;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.historicoFinanceiro = dados;
      });
    },
    selecionarFinanceiroItem: function selecionarFinanceiroItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosFinanceiros.includes(item)) {
          var p = this.selecionadosFinanceiros.indexOf(item);
          this.selecionadosFinanceiros.splice(p, 1);
        } else {
          this.selecionadosFinanceiros.push(item);
        }
      } else {
        this.selecionadosFinanceiros = [];
        this.selecionadosFinanceiros.push(item);
      }
    },
    selecionadoFinanceiro: function selecionadoFinanceiro(item) {
      return this.selecionadosFinanceiros.includes(item);
    },
    buscarHistoricoCheque: function buscarHistoricoCheque() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/motoristaHistoricoCheque?id=' + this.$route.params.id + '&periodo=' + self.exibirFinanceiroCheques;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.historicoCheques = dados;
      });
    },
    selecionarChequeItem: function selecionarChequeItem(item, event) {
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionadosCheques.includes(item)) {
          var p = this.selecionadosCheques.indexOf(item);
          this.selecionadosCheques.splice(p, 1);
        } else {
          this.selecionadosCheques.push(item);
        }
      } else {
        this.selecionadosCheques = [];
        this.selecionadosCheques.push(item);
      }
    },
    selecionadoCheque: function selecionadoCheque(item) {
      return this.selecionadosCheques.includes(item);
    },
    valorTotalPagarFinanceiro: function valorTotalPagarFinanceiro(financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor;
          }
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valor;
          }
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalPagoFinanceiro: function valorTotalPagoFinanceiro(financeiroMovimento) {
      if (this.selecionadosFinanceiros.length > 1) {
        return this.selecionadosFinanceiros.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago;
          }
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          if (financeiroMovimento.tipoMovimento === 'C') {
            valorTotalPagar = valorTotalPagar + financeiroMovimento.valorPago;
          }
          if (financeiroMovimento.tipoMovimento === 'D') {
            valorTotalPagar = valorTotalPagar - financeiroMovimento.valorPago;
          }
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalCredito: function valorTotalCredito(financeiroMovimento) {
      if (this.selecionadosCreditos.length > 1) {
        return this.selecionadosCreditos.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      }
    },
    valorTotalCheque: function valorTotalCheque(financeiroMovimento) {
      if (this.selecionadosCheques.length > 1) {
        return this.selecionadosCheques.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      } else {
        return financeiroMovimento.reduce(function (valorTotalPagar, financeiroMovimento) {
          valorTotalPagar = valorTotalPagar + financeiroMovimento.valor;
          return valorTotalPagar;
        }, 0);
      }
    },
    buscarHistoricoVendas: function buscarHistoricoVendas() {
      var self = this;
      if (self.vendasProdutos.length === 0) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
        };
        var url = '/api/motoristasHistoricoVendasProdutos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.vendasProdutos = dados;
        });
      }
      if (self.vendasServicos.length === 0) {
        url = '/api/motoristasHistoricoVendasServicos/' + this.$route.params.id;
        _axios2.default.get(url, config).then(function (response) {
          console.log(response.data);
          var dados = response.data;
          self.vendasServicos = dados;
        });
      }
    },
    buscarHistoricoInteracoes: function buscarHistoricoInteracoes() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/motoristasHistoricoInteracoes/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.interacoes = dados;
      });
    },
    buscarOperadora: function buscarOperadora(numero) {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/consutarOperadora?celular=' + numero;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.model.celularOperadora = response.data;
      });
    },
    setIsentoInscricaoEstadual: function setIsentoInscricaoEstadual() {
      if (this.isentoInscricaoEstadual === false) {
        this.model.inscricaoEstadual = 'ISENTO';
      } else {
        this.model.inscricaoEstadual = '';
      }
    },
    setIsentoInscricaoMunicipal: function setIsentoInscricaoMunicipal() {
      if (this.isentoInscricaoMunicipal === false) {
        this.model.inscricaoMunicipal = 'ISENTO';
      } else {
        this.model.inscricaoMunicipal = '';
      }
    },
    setarCliente: function setarCliente(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarCliente: function verificarCliente() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    setarCidade: function setarCidade(cidade) {
      this.model.cidadeId = cidade.id;
      this.model.cidadeNome = cidade.cidade;
      this.model.cep = cidade.cep;
      this.model.estado = cidade.estado;
      $(this.$el).find('#cidadeNome').val(cidade.cidade);
      $(this.$el).find('#cidadeCep').val(cidade.cep);
      $(this.$el).find('#cidadeEstado').val(cidade.estado);
    },
    verificarCidade: function verificarCidade() {
      if ($(this.$el).find('#cidadeId').val() === '0') {
        this.model.cidadeId = 0;
        this.model.cidadeNome = '';
        this.model.cep = '';
        this.model.estado = '';
        $(this.$el).find('#cidadeId').val(0);
        $(this.$el).find('#cidadeNome').val('');
        $(this.$el).find('#cidadeCep').val('');
        $(this.$el).find('#cidadeEstado').val('');
      }
      if ($(this.$el).find('#cidadeNome').val() === '') {
        this.model.cidadeId = 0;
        this.model.cidadeNome = '';
        this.model.cep = '';
        this.model.estado = '';
        $(this.$el).find('#cidadeId').val(0);
        $(this.$el).find('#cidadeNome').val('');
        $(this.$el).find('#cidadeCep').val('');
        $(this.$el).find('#cidadeEstado').val('');
      }
    },
    setarCidadeEndereco: function setarCidadeEndereco(cidade, i) {
      console.log('Item: ' + i);
      this.model.enderecos[i].cidadeId = cidade.id;
      this.model.enderecos[i].cidadeNome = cidade.cidade;
      this.model.enderecos[i].cep = cidade.cep;
      this.model.enderecos[i].estado = cidade.estado;
      $(this.$el).find('#enderecosCidadeNome_' + i).val(cidade.cidade);
      $(this.$el).find('#enderecosCidadeCep_' + i).val(cidade.cep);
      $(this.$el).find('#enderecosCidadeEstado_' + i).val(cidade.estado);
    },
    adicionarEndereco: function adicionarEndereco() {
      var self = this;
      self.model.enderecos.push({
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        pontoReferencia: '',
        cidadeId: '0',
        cidade: '',
        cep: '',
        tipoEnderecoId: '0'
      });
    },
    removerEndereco: function removerEndereco(i) {
      var self = this;
      self.model.enderecos.splice(i, 1);
    },
    adicionarContato: function adicionarContato() {
      var self = this;
      self.model.contatos.push({
        nome: '',
        telefone: '',
        email: ''
      });
    },
    removerContato: function removerContato(i) {
      var self = this;
      self.model.contatos.splice(i, 1);
    },
    buscarPerfilCliente: function buscarPerfilCliente() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/vendasPeriodo?periodo=' + this.vendasPeriodo + '&agrupamento=' + this.vendasPeriodoAgrupamento + '&motoristaId=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var periodos = [];
        for (var i = 0; i < response.data.length; i++) {
          periodos.push(response.data[i].periodo + '/' + response.data[i].ano);
        }
        var valores = [];
        for (var _i = 0; _i < response.data.length; _i++) {
          valores.push(response.data[_i].valorTotalVenda);
        }
        self.perfilClienteGraficoVendas = {
          labels: periodos,
          datasets: [{
            label: 'Vendas',
            backgroundColor: '#79c447',
            data: valores
          }]
        };
      });
      url = '/api/dashboard/vendasProdutosMaisVendidosPeriodo?periodo=' + this.vendasProdutosMaisVendidosPeriodo + '&agrupamento=' + this.vendasProdutosMaisVendidosPeriodoAgrupamento + '&motoristaId=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.vendasProdutosMaisVendidosPeriodoDados = response.data;
      });
    },
    imprimirVendaProduto: function imprimirVendaProduto(vendaProdutoId) {
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/vendas/imprimirVenda?id=' + vendaProdutoId + '&exibirCliente=1&exibirMarca=1&exibirPreco=1&exibirPrecoPadrao=0&exibirPromissoria=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
      });
    },
    visualizarFinanceiro: function visualizarFinanceiro(movimento) {
      window.open('/financeiroMovimentoVisualizar/' + movimento.id, '_blank');
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/motoristas/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Motorista gravado com sucesso.', 'Atenção');
              self.$router.replace('/motoristas');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "V8gd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VAVw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue__ = __webpack_require__("vlR9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2d311da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTelefone_vue__ = __webpack_require__("bUvH");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputTelefone_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b2d311da_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputTelefone_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "VJjC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _SparkBotaoBaixaFinanceiro = __webpack_require__("WC6J");

var _SparkBotaoBaixaFinanceiro2 = _interopRequireDefault(_SparkBotaoBaixaFinanceiro);

var _SparkBuscarCidade = __webpack_require__("0L0x");

var _SparkBuscarCidade2 = _interopRequireDefault(_SparkBuscarCidade);

var _SparkBuscarCliente = __webpack_require__("ftCg");

var _SparkBuscarCliente2 = _interopRequireDefault(_SparkBuscarCliente);

var _SparkBuscarFinanceiro = __webpack_require__("cO9X");

var _SparkBuscarFinanceiro2 = _interopRequireDefault(_SparkBuscarFinanceiro);

var _SparkBuscarFornecedor = __webpack_require__("JSRt");

var _SparkBuscarFornecedor2 = _interopRequireDefault(_SparkBuscarFornecedor);

var _SparkBuscarProduto = __webpack_require__("bUu9");

var _SparkBuscarProduto2 = _interopRequireDefault(_SparkBuscarProduto);

var _SparkBuscarServico = __webpack_require__("cL2t");

var _SparkBuscarServico2 = _interopRequireDefault(_SparkBuscarServico);

var _SparkBuscarTransportador = __webpack_require__("Fhei");

var _SparkBuscarTransportador2 = _interopRequireDefault(_SparkBuscarTransportador);

var _SparkBuscarVeiculo = __webpack_require__("2Sb2");

var _SparkBuscarVeiculo2 = _interopRequireDefault(_SparkBuscarVeiculo);

var _SparkBuscarVendedor = __webpack_require__("6gxo");

var _SparkBuscarVendedor2 = _interopRequireDefault(_SparkBuscarVendedor);

var _SparkBuscarCodigoNcm = __webpack_require__("AQx4");

var _SparkBuscarCodigoNcm2 = _interopRequireDefault(_SparkBuscarCodigoNcm);

var _SparkBuscarCodigoNcmTabela = __webpack_require__("+1Ym");

var _SparkBuscarCodigoNcmTabela2 = _interopRequireDefault(_SparkBuscarCodigoNcmTabela);

var _SparkBuscarTitular = __webpack_require__("vJtg");

var _SparkBuscarTitular2 = _interopRequireDefault(_SparkBuscarTitular);

var _SparkBuscarMotorista = __webpack_require__("3CUm");

var _SparkBuscarMotorista2 = _interopRequireDefault(_SparkBuscarMotorista);

var _SparkBuscarListaMotorista = __webpack_require__("Ma4z");

var _SparkBuscarListaMotorista2 = _interopRequireDefault(_SparkBuscarListaMotorista);

var _SparkInputCep = __webpack_require__("sLWx");

var _SparkInputCep2 = _interopRequireDefault(_SparkInputCep);

var _SparkInputCnpj = __webpack_require__("LcEY");

var _SparkInputCnpj2 = _interopRequireDefault(_SparkInputCnpj);

var _SparkInputCpf = __webpack_require__("+/eX");

var _SparkInputCpf2 = _interopRequireDefault(_SparkInputCpf);

var _SparkInputDataHoraPicker = __webpack_require__("tls5");

var _SparkInputDataHoraPicker2 = _interopRequireDefault(_SparkInputDataHoraPicker);

var _SparkInputDataPicker = __webpack_require__("TBGY");

var _SparkInputDataPicker2 = _interopRequireDefault(_SparkInputDataPicker);

var _SparkInputDataPicker3 = __webpack_require__("X80I");

var _SparkInputDataPicker4 = _interopRequireDefault(_SparkInputDataPicker3);

var _SparkInputDataFormat = __webpack_require__("OzEO");

var _SparkInputDataFormat2 = _interopRequireDefault(_SparkInputDataFormat);

var _SparkInputHoraPicker = __webpack_require__("387/");

var _SparkInputHoraPicker2 = _interopRequireDefault(_SparkInputHoraPicker);

var _SparkInputHoraPickerSS = __webpack_require__("dYEB");

var _SparkInputHoraPickerSS2 = _interopRequireDefault(_SparkInputHoraPickerSS);

var _SparkInputMonetario = __webpack_require__("7UY5");

var _SparkInputMonetario2 = _interopRequireDefault(_SparkInputMonetario);

var _SparkInputMonetario3 = __webpack_require__("zQeX");

var _SparkInputMonetario4 = _interopRequireDefault(_SparkInputMonetario3);

var _SparkInputPlaca = __webpack_require__("YmZh");

var _SparkInputPlaca2 = _interopRequireDefault(_SparkInputPlaca);

var _SparkInputPeso = __webpack_require__("w1sO");

var _SparkInputPeso2 = _interopRequireDefault(_SparkInputPeso);

var _SparkInputPercentual = __webpack_require__("6rdH");

var _SparkInputPercentual2 = _interopRequireDefault(_SparkInputPercentual);

var _SparkInputQuantidade = __webpack_require__("FBFl");

var _SparkInputQuantidade2 = _interopRequireDefault(_SparkInputQuantidade);

var _SparkInputQuantidade3 = __webpack_require__("4+kY");

var _SparkInputQuantidade4 = _interopRequireDefault(_SparkInputQuantidade3);

var _SparkInputTelefone = __webpack_require__("VAVw");

var _SparkInputTelefone2 = _interopRequireDefault(_SparkInputTelefone);

var _SparkInputTelefoneCelular = __webpack_require__("/NIs");

var _SparkInputTelefoneCelular2 = _interopRequireDefault(_SparkInputTelefoneCelular);

var _SparkInputTexto = __webpack_require__("0Ln6");

var _SparkInputTexto2 = _interopRequireDefault(_SparkInputTexto);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var SparkComponentsPlugin = {
  install: function install(Vue, options) {
    Vue.component(_SparkBotaoBaixaFinanceiro2.default.name, _SparkBotaoBaixaFinanceiro2.default);

    Vue.component(_SparkBuscarCidade2.default.name, _SparkBuscarCidade2.default);
    Vue.component(_SparkBuscarCliente2.default.name, _SparkBuscarCliente2.default);
    Vue.component(_SparkBuscarFinanceiro2.default.name, _SparkBuscarFinanceiro2.default);
    Vue.component(_SparkBuscarFornecedor2.default.name, _SparkBuscarFornecedor2.default);
    Vue.component(_SparkBuscarProduto2.default.name, _SparkBuscarProduto2.default);
    Vue.component(_SparkBuscarServico2.default.name, _SparkBuscarServico2.default);
    Vue.component(_SparkBuscarTransportador2.default.name, _SparkBuscarTransportador2.default);
    Vue.component(_SparkBuscarVeiculo2.default.name, _SparkBuscarVeiculo2.default);
    Vue.component(_SparkBuscarVendedor2.default.name, _SparkBuscarVendedor2.default);
    Vue.component(_SparkBuscarCodigoNcm2.default.name, _SparkBuscarCodigoNcm2.default);
    Vue.component(_SparkBuscarCodigoNcmTabela2.default.name, _SparkBuscarCodigoNcmTabela2.default);
    Vue.component(_SparkBuscarTitular2.default.name, _SparkBuscarTitular2.default);
    Vue.component(_SparkBuscarMotorista2.default.name, _SparkBuscarMotorista2.default);
    Vue.component(_SparkBuscarListaMotorista2.default.name, _SparkBuscarListaMotorista2.default);
    Vue.component(_SparkInputCep2.default.name, _SparkInputCep2.default);
    Vue.component(_SparkInputCnpj2.default.name, _SparkInputCnpj2.default);
    Vue.component(_SparkInputCpf2.default.name, _SparkInputCpf2.default);
    Vue.component(_SparkInputDataHoraPicker2.default.name, _SparkInputDataHoraPicker2.default);
    Vue.component(_SparkInputDataPicker2.default.name, _SparkInputDataPicker2.default);
    Vue.component(_SparkInputDataPicker4.default.name, _SparkInputDataPicker4.default);
    Vue.component(_SparkInputDataFormat2.default.name, _SparkInputDataFormat2.default);
    Vue.component(_SparkInputHoraPicker2.default.name, _SparkInputHoraPicker2.default);
    Vue.component(_SparkInputHoraPickerSS2.default.name, _SparkInputHoraPickerSS2.default);
    Vue.component(_SparkInputMonetario2.default.name, _SparkInputMonetario2.default);
    Vue.component(_SparkInputMonetario4.default.name, _SparkInputMonetario4.default);
    Vue.component(_SparkInputPlaca2.default.name, _SparkInputPlaca2.default);
    Vue.component(_SparkInputPeso2.default.name, _SparkInputPeso2.default);
    Vue.component(_SparkInputPercentual2.default.name, _SparkInputPercentual2.default);
    Vue.component(_SparkInputQuantidade2.default.name, _SparkInputQuantidade2.default);
    Vue.component(_SparkInputQuantidade4.default.name, _SparkInputQuantidade4.default);
    Vue.component(_SparkInputTelefone2.default.name, _SparkInputTelefone2.default);
    Vue.component(_SparkInputTelefoneCelular2.default.name, _SparkInputTelefoneCelular2.default);
    Vue.component(_SparkInputTexto2.default.name, _SparkInputTexto2.default);
  }
};

exports.default = SparkComponentsPlugin;

/***/ }),

/***/ "VUMS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-cidade',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      console.log('LOG: ' + this.id);
      $(this.$el).find('#' + this.id).val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.cidade);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        var novoId = this.id.split('_')[1];
        this.onSelect(clean, novoId);
        $(this.$el).find('#' + this.id).val(clean.cidade);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarCidadesAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "VWha":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-cep',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('99999-999');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99999-999');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "VYFL":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 58px)","height":"calc(100vh - 158px)"},attrs:{"center":_vm.center,"zoom":12}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMapa = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":{'Data': 'data', 'Hora': 'hora',  'Ponto Mais Próximo': 'pontoMaisProximo',
              'Velocidade': 'velocidade', 'Deslocamento': 'deslocamento', 'Ignição': 'ignicao', 'GPS': 'gps', 'GPRS': 'gprs', 'Movimento': 'movimento', 'Volt': 'tensao', 'Motivo Transmissão': 'motivoTransmissao'  },"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Distância Percorrida: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida) + 'Km' + '\n  Odômetro do GPS: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro) + ' Km ' + '\n  Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima) + ' Km/h ',"footer":_vm.dadosRelatorios.data,"worksheet":"My Worksheet","name":"filename.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.obd_TEMPERATURA))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.obd_ROTACAO))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("TEMP")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("RPM")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VjHd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"animated fadeIn"},[(_vm.showModalDadosVeiculo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"tabbable"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(2),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tab2","data-toggle":"tab"},on:{"click":function($event){_vm.buscarGridDadosVeiculoContatoCliente(), _vm.buscarGridDadosVeiculoContatoClientePaga()}}},[_vm._v("Contatos")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tab2","data-toggle":"tab"},on:{"click":function($event){_vm.buscarGridCliente()}}},[_vm._v("Ações")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(3),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoDataCadastro)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(4),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoMarca)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(5),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoModelo)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(6),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoDataInstalacao)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(7),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoSerial)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(8),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoMarca)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(9),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoModelo)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(10),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoOperadora)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(11),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.equipamentoNumero)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(12),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoObservação01)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(13),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoObservação02)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(14),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.veiculoSenha)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(15),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clienteNome)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(16),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clienteTelefone)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_vm._m(17),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clienteEmail)+"\n                          ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(18),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clientePagaNome)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(19),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clientePagaTelefone)+"\n                          ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_vm._m(20),_c('br'),_vm._v("\n                            "+_vm._s(_vm.dadosVeiculo.clientePagaEmail)+"\n                          ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab2"}},[_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"contatosAdicionais","width":"100%"}},[_vm._m(21),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosVeiculoContatoCliente),function(contato,i){return _c('tr',[_c('td',[_vm._v(_vm._s(contato.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.email))])])}))]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"contatosAdicionais","width":"100%"}},[_vm._m(22),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosVeiculoContatoClientePaga),function(contato,i){return _c('tr',[_c('td',[_vm._v(_vm._s(contato.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.email))])])}))])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab3"}})])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDadosVeiculo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{},[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col-md-8 col-lg-8 form-group"},[_c('label',[_vm._v("Busca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarGrid(), _vm.buscarGridAlertaRoubo()},"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1 col-lg-1 velocidade no-gutter"},[_c('label',[_vm._v("Velocidade")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.velocidade),expression:"velocidade"}],staticClass:"form-control",attrs:{"id":"velocidade","name":"velocidade","type":"text"},domProps:{"value":(_vm.velocidade)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarGrid(), _vm.buscarGridAlertaRoubo()},"input":function($event){if($event.target.composing){ return; }_vm.velocidade=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2 col-lg-2 atualizacao no-gutter"},[_c('label',[_vm._v(" ")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.atualizarGrid),expression:"atualizarGrid"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.atualizarGrid=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.startInterval]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Não Atualiza")]),_vm._v(" "),_c('option',{attrs:{"value":"300000"}},[_vm._v("5 Minutos")]),_vm._v(" "),_c('option',{attrs:{"value":"180000"}},[_vm._v("3 Minutos")]),_vm._v(" "),_c('option',{attrs:{"value":"60000"}},[_vm._v("1 Minuto")])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1 col-lg-1 atualizacao no-gutter"},[_c('label',[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.buscarGrid(), _vm.buscarGridAlertaRoubo()}}},[_vm._v("Buscar")])])])])]),_vm._v(" "),(_vm.dadosTabelaAlertaRoubo.length > 0)?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',[_c('h4',{staticClass:"text-danger"},[_vm._v("VEÍCULOS EM ALERTA DE ROUBO")]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(23),_vm._v(" "),_vm._l((_vm.dadosTabelaAlertaRoubo),function(grid,i){return _c('tbody',[_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(grid.dataHora))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(grid.descricaoVeiculo))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(grid.pontoMaisProximo))])])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(grid.velocidade)))])])]),_vm._v(" "),_c('td',[(grid.ignicaoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(grid.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(grid.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(grid.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(grid.movimentoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(grid.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(grid.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(grid.tensao)))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(grid.tensao)))])]],2)])])})],2),_vm._v(" "),_c('br')])])])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-grid"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(24),_vm._v(" "),_vm._l((_vm.dadosTabela),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosTabela[i].clienteIdVeiculo != _vm.dadosTabela[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.dataHora))])]),_vm._v(" "),_c('td',[(grid.vencidos > 0)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Possui débitos vencidos'),expression:"'Possui débitos vencidos'"}],attrs:{"src":"/static/images/dinheiro.png"}})]:_vm._e(),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('small',{staticClass:"text-muted"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.mostrarDadosVeiculo(grid.idVeiculo)}}},[_vm._v(" "+_vm._s(grid.descricaoVeiculo))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.pontoMaisProximo))])]),_vm._v(" "),_c('td',[(grid.alertaVelocidade === 'true')?[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(grid.velocidade)))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(grid.velocidade)))])]],2),_vm._v(" "),_c('td',[(grid.possuiIgnicao)?[(grid.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]:[_c('img',{attrs:{"src":"/static/images/disable.png"}})]],2),_vm._v(" "),_c('td',[(grid.possuiGps)?[(grid.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]:[_c('img',{attrs:{"src":"/static/images/disable.png"}})]],2),_vm._v(" "),_c('td',[(grid.possuiGprs)?[(grid.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]:[_c('img',{attrs:{"src":"/static/images/disable.png"}})]],2),_vm._v(" "),_c('td',[(grid.possuiMovimento)?[(grid.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]:[_c('img',{attrs:{"src":"/static/images/disable.png"}})]],2),_vm._v(" "),_c('td',[(grid.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(grid.tensao)))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(grid.tensao)))])]],2)])],2)})],2)])])])],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dados do Veículo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tab1","data-toggle":"tab"}},[_vm._v("Veículo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Data da Cadastro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Marca")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Modelo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Data da instalação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Serial")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Marca")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Modelo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Operadora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Numero do Chip")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Observação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Observação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Senha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Cliente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Telefone")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Cliente Paga")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Telefone")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Data e Hora")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"}},[_vm._v("Descrição do Veículo")]),_vm._v(" "),_c('th',[_vm._v("Ponto mais próximo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"60px"}},[_vm._v("Km/h")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20px"}},[_vm._v("IGN")]),_vm._v(" "),_c('th',{staticStyle:{"width":"21px"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24px"}},[_vm._v("GSM")]),_vm._v(" "),_c('th',{staticStyle:{"width":"26px"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{staticStyle:{"width":"31px"}},[_vm._v("Tensão")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Data e Hora")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"}},[_vm._v("Descrição do Veículo")]),_vm._v(" "),_c('th',[_vm._v("Ponto mais próximo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"60px"}},[_vm._v("Km/h")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20px"}},[_vm._v("IGN")]),_vm._v(" "),_c('th',{staticStyle:{"width":"21px"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24px"}},[_vm._v("GSM")]),_vm._v(" "),_c('th',{staticStyle:{"width":"26px"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{staticStyle:{"width":"31px"}},[_vm._v("Tensão")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Vkzg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalNovaJornada)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraFinal", $$v)},expression:"jornada.dataHoraFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.motoristaId),expression:"jornada.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNovaJornadaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotoristaNovaJornada,"on-blur":_vm.verificarMotoristaNovaJornada},model:{value:(_vm.jornada.motoristaNome),callback:function ($$v) {_vm.$set(_vm.jornada, "motoristaNome", $$v)},expression:"jornada.motoristaNome"}})],1)]),_vm._v(" "),(_vm.jornada.tipoJornada === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.veiculoId),expression:"jornada.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('buscar-veiculo',{attrs:{"type":"search","id":"veiculoNovaJornadaDescricao","placeholder":"Selecione um veículo..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarVeiculoNovaJornada,"on-blur":_vm.verificarVeiculoNovaJornada},model:{value:(_vm.jornada.veiculoDescricao),callback:function ($$v) {_vm.$set(_vm.jornada, "veiculoDescricao", $$v)},expression:"jornada.veiculoDescricao"}})],1)])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarNovaJornada}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalNovaJornada = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalRelatorioSintetico)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Tipo Relatório:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.tipo),expression:"relatorio.tipo"}],staticClass:"form-control",attrs:{"required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorio, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Relatório Sintetico")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("Relatório de Tempo de Alimentção")]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('option',{attrs:{"value":"3"}},[_vm._v("Relatório Sintetico TESTE")])]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataInicial", $$v)},expression:"relatorio.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataFinal", $$v)},expression:"relatorio.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v("Motoristas/Cargo")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.buscas),expression:"relatorio.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.relatorio.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarTodosMotoristasRelatorio()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "buscas", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_c('label',[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscarTodosMotoristasRelatorio()}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.selecionadoMotoristaTodos}},[_vm._v(" Selecionar Todos")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.selecionadoMotoristaLimpar}},[_vm._v(" Limpar Seleção")])])]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaMotoristas","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosMotoristas),function(motorista){return _c('tr',{class:{ 'selecionado': _vm.selecionadoMotorista(motorista) },on:{"click":function($event){_vm.selecionarMotoristaItem(motorista)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":motorista.id}}),_vm._v(" "),(_vm.selecionadoMotorista(motorista))?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(motorista.id))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(motorista.nome))])])])}))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.motoristaId),expression:"relatorio.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.relatorio.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "motoristaId", $event.target.value)}}})])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarRelatorioSinteticoMotoristas}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorioSintetico = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalNovaJornada = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Nova Jornada Manual\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.gravarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Gerar Todas Jornadas\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Periodo:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-7 col-md-7"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.exibir),expression:"filtros.exibir"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "exibir", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"T","selected":"selected"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"G"}},[_vm._v("Gerados")]),_vm._v(" "),_c('option',{attrs:{"value":"NG"}},[_vm._v("Não Gerados")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Ordem:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.ordem),expression:"filtros.ordem"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "ordem", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"motorista","selected":"selected"}},[_vm._v("Motorista")]),_vm._v(" "),_c('option',{attrs:{"value":"veiculo"}},[_vm._v("Veículo")]),_vm._v(" "),_c('option',{attrs:{"value":"data"}},[_vm._v("Data")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-limpo"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(5),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(jornada){return _c('tr',{class:{ 'selecionado': _vm.selecionado(jornada) },on:{"click":function($event){_vm.selecionarItem(jornada, $event)},"dblclick":function($event){_vm.editar(jornada.id)}}},[_c('td',{attrs:{"width":"155"}},[_vm._v(_vm._s(jornada.dataInicial))]),_vm._v(" "),_c('td',{attrs:{"width":"155"}},[(jornada.dataFinalReal === null)?[_c('strong',[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(jornada.dataFinal))])])]:[_vm._v("\n                        "+_vm._s(jornada.dataFinal)+"\n                      ")]],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(jornada.motoristaNome))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(jornada.veiculoDescricao))])]),_vm._v(" "),_c('td',[(jornada.gerado)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Visualizar'),expression:"'Visualizar'"}],attrs:{"to":{name: 'AnaliseJornadasTabelaEditar', params: { dataInicial: jornada.dataInicial, dataFinal: jornada.dataFinal, motoristaId: jornada.motoristaId }}}},[_c('img',{attrs:{"src":"/static/images/visualizar.png"}})]),_vm._v(" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Visualizar com Movimento'),expression:"'Visualizar com Movimento'"}],attrs:{"to":{name: 'AnaliseJornadasTabelaVisualizar', params: { dataInicial: jornada.dataInicial, dataFinal: jornada.dataFinal, jornadaMacroId: jornada.id }}}},[_c('img',{attrs:{"src":"/static/images/visualizar.png"}})])],1)])}))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Nova Jornada")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatório Sintético")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th'),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Cargo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Gestão de Jornadas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Início")]),_vm._v(" "),_c('th',[_vm._v("Fim")]),_vm._v(" "),_c('th',[_vm._v("Motorista")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Gerado")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "W6Aj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotorista)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motoristaId),expression:"motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motoristaId=$event.target.value}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.motoristaNome),callback:function ($$v) {_vm.motoristaNome=$$v},expression:"motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotorista}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotorista = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.dividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.dividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Recalcular e Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/gestaoJornada"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Data: ")]),_vm._v("De: "+_vm._s(_vm.jornada.dataHoraInicial)+" até "+_vm._s(_vm.jornada.dataHoraFinal)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.jornada.veiculoDescricao)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(" "+_vm._s(_vm.jornada.motoristaNome)),_c('br'),_vm._v(" "),_c('span',{on:{"click":function($event){_vm.showModalMudarMotorista = true}}},[_vm._v("Mudar motorista")])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(7),_vm._v(" "),_vm._l((_vm.jornadaItens),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_c('small',[_vm._v(_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.observacao))])]),_vm._v(" "),_c('td',[(grid.statusVeiculo === 'VEICULO PARADO')?[_vm._m(8,true)]:_vm._e()],2)])])})],2),_vm._v(" "),_vm._m(9),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAbastecimento)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAdicionalNoturno)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAlimentacao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoCargaDescarga)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDescansoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoFiscalizacao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraIndenizada)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoJornada)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoManutencao)+" ")]),_c('br')])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dividir Tempo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motivo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{attrs:{"onclick":"dividirJornada(500209)","href":"#"}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9 text-center"}),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-center"},[_c('strong',[_vm._v("TOTAIS")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-11 text-right"},[_vm._v("\n              Tempo em Abastecimento: "),_c('br'),_vm._v("\n              Tempo em Adicional Noturno: "),_c('br'),_vm._v("\n              Tempo em Alimentação: "),_c('br'),_vm._v("\n              Tempo em Carga e Descarga: "),_c('br'),_vm._v("\n              Tempo em Descanso de Dirção: "),_c('br'),_vm._v("\n              Tempo em Direção: "),_c('br'),_vm._v("\n              Tempo em Fiscalização: "),_c('br'),_vm._v("\n              Tempo em Hora Extra Normal 1:"),_c('br'),_vm._v("\n              Tempo em Hora Extra Normal 2: "),_c('br'),_vm._v("\n              Tempo em Hora Extra Noturna 1:"),_c('br'),_vm._v("\n              Tempo em Hora Extra Noturna 2: "),_c('br'),_vm._v("\n              Tempo em Hora Indenizada: "),_c('br'),_vm._v("\n              Tempo em Jornada: "),_c('br'),_vm._v("\n              Tempo em Manutenção: "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "WC6J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue__ = __webpack_require__("pO7K");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138ba334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBotaoBaixaFinanceiro_vue__ = __webpack_require__("bwi3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBotaoBaixaFinanceiro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_138ba334_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBotaoBaixaFinanceiro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "WZka":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue__ = __webpack_require__("XKcN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc6ccc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuariosEditar_vue__ = __webpack_require__("qza3");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_UsuariosEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7dc6ccc5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_UsuariosEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "Wlh7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatoriosTelemetria/viagemPorVeiculo?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "X/gF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-street-view-pano-container"},[_c('div',{ref:"vue-street-view-pano",staticClass:"vue-street-view-pano"}),_vm._v(" "),_vm._t("default")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "X7DP":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "X80I":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue__ = __webpack_require__("URKx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29480670_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataPicker2_vue__ = __webpack_require__("fMAI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataPicker2_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_29480670_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataPicker2_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "XKcN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: true,
        nome: '',
        login: '',
        modificaSenha: false,
        senha: '',
        empresa: '0',
        departamento: '0',
        role: 'ROLE_ADMIN',
        dataCadastro: this.dataHoraAtual(),
        dataHoraUltimoAcesso: this.dataHoraAtual(),
        permissoes: {
          acessar: false,
          menuCadastros: '',
          menuEstoque: '',
          menuFinanceiro: '',
          menuBancos: '',
          menuCheques: '',
          menuCompras: '',
          menuVendas: '',
          menuFiscal: '',
          configuracaoFiscalEditar: '',
          menuSistema: '',
          sintegra: '',
          sped: '',
          clientesCadastrar: '',
          clientesEditar: '',
          clientesExcluir: '',
          clientesVisualizar: '',
          clientesRelatorios: '',
          fornecedoresCadastrar: '',
          fornecedoresEditar: '',
          fornecedoresExcluir: '',
          fornecedoresVisualizar: '',
          fornecedoresRelatorios: '',
          transportadoresCadastrar: '',
          transportadoresEditar: '',
          transportadoresExcluir: '',
          transportadoresVisualizar: '',
          transportadoresRelatorios: '',
          veiculosCadastrar: '',
          veiculosEditar: '',
          veiculosExcluir: '',
          veiculosVisualizar: '',
          veiculosRelatorios: '',
          vendedoresCadastrar: '',
          vendedoresEditar: '',
          vendedoresExcluir: '',
          vendedoresVisualizar: '',
          vendedoresRelatorios: '',
          produtosCadastrar: '',
          produtosEditar: '',
          produtosExcluir: '',
          produtosVisualizar: '',
          produtosRelatorios: '',
          servicosCadastrar: '',
          servicosEditar: '',
          servicosExcluir: '',
          servicosVisualizar: '',
          servicosRelatorios: '',
          depositosCadastrar: '',
          depositosEditar: '',
          depositosExcluir: '',
          depositosVisualizar: '',
          depositosRelatorios: '',
          movimentacaoEstoqueCadastrar: '',
          movimentacaoEstoqueEditar: '',
          movimentacaoEstoqueExcluir: '',
          movimentacaoEstoqueVisualizar: '',
          movimentacaoEstoqueRelatorios: '',
          balancoEstoqueCadastrar: '',
          balancoEstoqueEditar: '',
          balancoEstoqueExcluir: '',
          balancoEstoqueVisualizar: '',
          balancoEstoqueRelatorios: '',
          fluxoCaixaCadastrar: '',
          fluxoCaixaEditar: '',
          fluxoCaixaExcluir: '',
          fluxoCaixaVisualizar: '',
          fluxoCaixaRelatorios: '',
          contasPagarCadastrar: '',
          contasPagarEditar: '',
          contasPagarExcluir: '',
          contasPagarVisualizar: '',
          contasPagarRelatorios: '',
          contasReceberCadastrar: '',
          contasReceberEditar: '',
          contasReceberExcluir: '',
          contasReceberVisualizar: '',
          contasReceberRelatorios: '',
          bancosCadastrar: '',
          bancosEditar: '',
          bancosExcluir: '',
          bancosVisualizar: '',
          bancosRelatorios: '',
          movimentacaoBancariaCadastrar: '',
          movimentacaoBancariaEditar: '',
          movimentacaoBancariaExcluir: '',
          movimentacaoBancariaVisualizar: '',
          movimentacaoBancariaRelatorios: '',
          movimentacaoBoletosCadastrar: '',
          movimentacaoBoletosEditar: '',
          movimentacaoBoletosExcluir: '',
          movimentacaoBoletosVisualizar: '',
          movimentacaoBoletosRelatorios: '',
          chequesEmitidosCadastrar: '',
          chequesEmitidosEditar: '',
          chequesEmitidosExcluir: '',
          chequesEmitidosVisualizar: '',
          chequesEmitidosRelatorios: '',
          chequesRepasseCadastrar: '',
          chequesRepasseEditar: '',
          chequesRepasseExcluir: '',
          chequesRepasseVisualizar: '',
          chequesRepasseRelatorios: '',
          statusChequeCadastrar: '',
          statusChequeEditar: '',
          statusChequeExcluir: '',
          statusChequeVisualizar: '',
          statusChequeRelatorios: '',
          comprasCadastrar: '',
          comprasEditar: '',
          comprasConfirmar: '',
          comprasCancelar: '',
          comprasVisualizar: '',
          comprasRelatorios: '',
          analiseCompraCadastrar: '',
          analiseCompraEditar: '',
          analiseCompraConfirmar: '',
          analiseCompraCancelar: '',
          analiseCompraVisualizar: '',
          analiseCompraRelatorios: '',
          cotacaoCompraCadastrar: '',
          cotacaoCompraEditar: '',
          cotacaoCompraConfirmar: '',
          cotacaoCompraCancelar: '',
          cotacaoCompraVisualizar: '',
          cotacaoCompraRelatorios: '',
          vendasProdutosCadastrar: '',
          vendasProdutosEditar: '',
          vendasProdutosConfirmar: '',
          vendasProdutosCancelar: '',
          vendasProdutosVisualizar: '',
          vendasProdutosRelatorios: '',
          devolucaoProdutosCadastrar: '',
          devolucaoProdutosEditar: '',
          devolucaoProdutosConfirmar: '',
          devolucaoProdutosCancelar: '',
          devolucaoProdutosVisualizar: '',
          devolucaoProdutosRelatorios: '',
          vendasServicosCadastrar: '',
          vendasServicosEditar: '',
          vendasServicosConfirmar: '',
          vendasServicosCancelar: '',
          vendasServicosVisualizar: '',
          vendasServicosRelatorios: '',
          vendasProdutosPdvCadastrar: '',
          vendasProdutosPdvEditar: '',
          vendasProdutosPdvConfirmar: '',
          vendasProdutosPdvCancelar: '',
          vendasProdutosPdvVisualizar: '',
          vendasProdutosPdvRelatorios: '',
          configuracaoVendasEditar: '',
          configuracaoVendasMobileEditar: '',
          nfeCadastrar: '',
          nfeEditar: '',
          nfeEnviar: '',
          nfeCancelar: '',
          nfeEventos: '',
          nfeVisualizar: '',
          nfeRelatorios: '',
          nfceCadastrar: '',
          nfceEditar: '',
          nfceEnviar: '',
          nfceCancelar: '',
          nfceEventos: '',
          nfceVisualizar: '',
          nfceRelatorios: '',
          nfseCadastrar: '',
          nfseEditar: '',
          nfseEnviar: '',
          nfseCancelar: '',
          nfseEventos: '',
          nfseVisualizar: '',
          nfseRelatorios: '',
          mdfeCadastrar: '',
          mdfeEditar: '',
          mdfeEnviar: '',
          mdfeCancelar: '',
          mdfeEventos: '',
          mdfeVisualizar: '',
          mdfeRelatorios: '',
          cteCadastrar: '',
          cteEditar: '',
          cteEnviar: '',
          cteCancelar: '',
          cteEventos: '',
          cteVisualizar: '',
          cteRelatorios: '',
          guiaTrafegoCadastrar: '',
          guiaTrafegoEditar: '',
          guiaTrafegoEnviar: '',
          guiaTrafegoCancelar: '',
          guiaTrafegoEventos: '',
          guiaTrafegoVisualizar: '',
          guiaTrafegoRelatorios: '',
          mensagensNfeCadastrar: '',
          mensagensNfeEditar: '',
          mensagensNfeExcluir: '',
          mensagensNfeVisualizar: '',
          mensagensNfeRelatorios: '',
          mensagensNfceCadastrar: '',
          mensagensNfceEditar: '',
          mensagensNfceExcluir: '',
          mensagensNfceVisualizar: '',
          mensagensNfceRelatorios: '',
          mensagensNfseCadastrar: '',
          mensagensNfseEditar: '',
          mensagensNfseExcluir: '',
          mensagensNfseVisualizar: '',
          mensagensNfseRelatorios: '',
          mensagensMdfeCadastrar: '',
          mensagensMdfeEditar: '',
          mensagensMdfeExcluir: '',
          mensagensMdfeVisualizar: '',
          mensagensMdfeRelatorios: '',
          mensagensCteCadastrar: '',
          mensagensCteEditar: '',
          mensagensCteExcluir: '',
          mensagensCteVisualizar: '',
          mensagensCteRelatorios: '',
          formasPagamentoCadastrar: '',
          formasPagamentoEditar: '',
          formasPagamentoExcluir: '',
          formasPagamentoVisualizar: '',
          formasPagamentoRelatorios: '',
          codigosNcmsCadastrar: '',
          codigosNcmsEditar: '',
          codigosNcmsExcluir: '',
          codigosNcmsVisualizar: '',
          codigosNcmsRelatorios: '',
          cidadesCadastrar: '',
          cidadesEditar: '',
          cidadesExcluir: '',
          cidadesVisualizar: '',
          cidadesRelatorios: '',
          centrosCustosCadastrar: '',
          centrosCustosEditar: '',
          centrosCustosExcluir: '',
          centrosCustosVisualizar: '',
          centrosCustosRelatorios: '',
          conceitosCadastrar: '',
          conceitosEditar: '',
          conceitosExcluir: '',
          conceitosVisualizar: '',
          conceitosRelatorios: '',
          contasCaixaCadastrar: '',
          contasCaixaEditar: '',
          contasCaixaExcluir: '',
          contasCaixaVisualizar: '',
          contasCaixaRelatorios: '',
          codigoCfopCadastrar: '',
          codigoCfopEditar: '',
          codigoCfopExcluir: '',
          codigoCfopVisualizar: '',
          codigoCfopRelatorios: '',
          codigoCfopRegrasCadastrar: '',
          codigoCfopRegrasEditar: '',
          codigoCfopRegrasExcluir: '',
          codigoCfopRegrasVisualizar: '',
          codigoCfopRegrasRelatorios: '',
          planosContasCadastrar: '',
          planosContasEditar: '',
          planosContasExcluir: '',
          planosContasVisualizar: '',
          planosContasRelatorios: '',
          produtosMarcasCadastrar: '',
          produtosMarcasEditar: '',
          produtosMarcasExcluir: '',
          produtosMarcasVisualizar: '',
          produtosMarcasRelatorios: '',
          produtosGruposCadastrar: '',
          produtosGruposEditar: '',
          produtosGruposExcluir: '',
          produtosGruposVisualizar: '',
          produtosGruposRelatorios: '',
          produtosSubGruposCadastrar: '',
          produtosSubGruposEditar: '',
          produtosSubGruposExcluir: '',
          produtosSubGruposVisualizar: '',
          produtosSubGruposRelatorios: '',
          produtosCoresCadastrar: '',
          produtosCoresEditar: '',
          produtosCoresExcluir: '',
          produtosCoresVisualizar: '',
          produtosCoresRelatorios: '',
          produtosTamanhosCadastrar: '',
          produtosTamanhosEditar: '',
          produtosTamanhosExcluir: '',
          produtosTamanhosVisualizar: '',
          produtosTamanhosRelatorios: '',
          produtosUnidadesCadastrar: '',
          produtosUnidadesEditar: '',
          produtosUnidadesExcluir: '',
          produtosUnidadesVisualizar: '',
          produtosUnidadesRelatorios: '',
          produtosDepartamentosCadastrar: '',
          produtosDepartamentosEditar: '',
          produtosDepartamentosExcluir: '',
          produtosDepartamentosVisualizar: '',
          produtosDepartamentosRelatorios: '',
          produtosTabelasPrecosCadastrar: '',
          produtosTabelasPrecosEditar: '',
          produtosTabelasPrecosExcluir: '',
          produtosTabelasPrecosVisualizar: '',
          produtosTabelasPrecosRelatorios: '',
          unidadesNegocioCadastrar: '',
          unidadesNegocioEditar: '',
          unidadesNegocioExcluir: '',
          unidadesNegocioVisualizar: '',
          unidadesNegocioRelatorios: '',
          tiposContatosCadastrar: '',
          tiposContatosEditar: '',
          tiposContatosExcluir: '',
          tiposContatosVisualizar: '',
          tiposContatosRelatorios: '',
          tiposEnderecosCadastrar: '',
          tiposEnderecosEditar: '',
          tiposEnderecosExcluir: '',
          tiposEnderecosVisualizar: '',
          tiposEnderecosRelatorios: '',
          tiposInteracoesCadastrar: '',
          tiposInteracoesEditar: '',
          tiposInteracoesExcluir: '',
          tiposInteracoesVisualizar: '',
          tiposInteracoesRelatorios: '',
          motivosCancelamentoCadastrar: '',
          motivosCancelamentoEditar: '',
          motivosCancelamentoExcluir: '',
          motivosCancelamentoVisualizar: '',
          motivosCancelamentoRelatorios: '',
          motivosDevolucaoCadastrar: '',
          motivosDevolucaoEditar: '',
          motivosDevolucaoExcluir: '',
          motivosDevolucaoVisualizar: '',
          motivosDevolucaoRelatorios: '',
          motivosInteracoesCadastrar: '',
          motivosInteracoesEditar: '',
          motivosInteracoesExcluir: '',
          motivosInteracoesVisualizar: '',
          motivosInteracoesRelatorios: '',
          usuarioCadastrar: '',
          usuarioEditar: '',
          usuarioExcluir: '',
          usuarioVisualizar: '',
          usuarioRelatorios: '',
          empresaCadastrar: '',
          empresaEditar: '',
          empresaExcluir: '',
          empresaVisualizar: '',
          empresaRelatorios: '',
          parametroBloquearPrecoVenda: '',
          parametroBloquearPrecoPedido: ''
        }
      }
    };
  },

  created: function created() {
    this.buscar();
    this.buscarPermissoes();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/usuarios/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;
        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.nome = dados.nome;
        self.model.login = dados.login;
        self.model.senha = dados.senha;
        self.model.role = 'ROLE_ADMIN';
        self.model.departamento = dados.departamento;
        self.model.empresa = dados.empresa;
        self.model.dataCadastro = '01/01/2018';
        self.model.dataHoraUltimoAcesso = '01/01/2018 12:00:00';
      });
    },
    buscarPermissoes: function buscarPermissoes() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/usuarios/permissoes/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;
        self.model.permissoes.acessar = dados.includes('ROLE_ACESSAR');
        self.model.permissoes.menuCadastros = dados.includes('ROLE_MENU_CADASTROS');
        self.model.permissoes.menuEstoque = dados.includes('ROLE_MENU_ESTOQUE');
        self.model.permissoes.menuFinanceiro = dados.includes('ROLE_MENU_FINANCEIRO');
        self.model.permissoes.menuBancos = dados.includes('ROLE_MENU_BANCOS');
        self.model.permissoes.menuCheques = dados.includes('ROLE_MENU_CHEQUES');
        self.model.permissoes.menuCompras = dados.includes('ROLE_MENU_COMPRAS');
        self.model.permissoes.menuVendas = dados.includes('ROLE_MENU_VENDAS');
        self.model.permissoes.menuFiscal = dados.includes('ROLE_MENU_FISCAL');
        self.model.permissoes.configuracaoFiscalEditar = dados.includes('ROLE_CONFIGURACAO_FISCAL_EDITAR');
        self.model.permissoes.menuSistema = dados.includes('ROLE_MENU_SISTEMA');
        self.model.permissoes.sintegra = dados.includes('ROLE_SINTEGRA');
        self.model.permissoes.sped = dados.includes('ROLE_SPED');

        self.model.permissoes.clientesCadastrar = dados.includes('ROLE_CLIENTES_CADASTRAR');
        self.model.permissoes.clientesEditar = dados.includes('ROLE_CLIENTES_EDITAR');
        self.model.permissoes.clientesExcluir = dados.includes('ROLE_CLIENTES_EXCLUIR');
        self.model.permissoes.clientesVisualizar = dados.includes('ROLE_CLIENTES_VISUALIZAR');
        self.model.permissoes.clientesRelatorios = dados.includes('ROLE_CLIENTES_RELATORIOS');
        self.model.permissoes.fornecedoresCadastrar = dados.includes('ROLE_FORNECEDORES_CADASTRAR');
        self.model.permissoes.fornecedoresEditar = dados.includes('ROLE_FORNECEDORES_EDITAR');
        self.model.permissoes.fornecedoresExcluir = dados.includes('ROLE_FORNECEDORES_EXCLUIR');
        self.model.permissoes.fornecedoresVisualizar = dados.includes('ROLE_FORNECEDORES_VISUALIZAR');
        self.model.permissoes.fornecedoresRelatorios = dados.includes('ROLE_FORNECEDORES_RELATORIOS');
        self.model.permissoes.transportadoresCadastrar = dados.includes('ROLE_TRANSPORTADORES_CADASTRAR');
        self.model.permissoes.transportadoresEditar = dados.includes('ROLE_TRANSPORTADORES_EDITAR');
        self.model.permissoes.transportadoresExcluir = dados.includes('ROLE_TRANSPORTADORES_EXCLUIR');
        self.model.permissoes.transportadoresVisualizar = dados.includes('ROLE_TRANSPORTADORES_VISUALIZAR');
        self.model.permissoes.transportadoresRelatorios = dados.includes('ROLE_TRANSPORTADORES_RELATORIOS');
        self.model.permissoes.veiculosCadastrar = dados.includes('ROLE_VEICULOS_CADASTRAR');
        self.model.permissoes.veiculosEditar = dados.includes('ROLE_VEICULOS_EDITAR');
        self.model.permissoes.veiculosExcluir = dados.includes('ROLE_VEICULOS_EXCLUIR');
        self.model.permissoes.veiculosVisualizar = dados.includes('ROLE_VEICULOS_VISUALIZAR');
        self.model.permissoes.veiculosRelatorios = dados.includes('ROLE_VEICULOS_RELATORIOS');
        self.model.permissoes.vendedoresCadastrar = dados.includes('ROLE_VENDEDORES_CADASTRAR');
        self.model.permissoes.vendedoresEditar = dados.includes('ROLE_VENDEDORES_EDITAR');
        self.model.permissoes.vendedoresExcluir = dados.includes('ROLE_VENDEDORES_EXCLUIR');
        self.model.permissoes.vendedoresVisualizar = dados.includes('ROLE_VENDEDORES_VISUALIZAR');
        self.model.permissoes.vendedoresRelatorios = dados.includes('ROLE_VENDEDORES_RELATORIOS');
        self.model.permissoes.produtosCadastrar = dados.includes('ROLE_PRODUTOS_CADASTRAR');
        self.model.permissoes.produtosEditar = dados.includes('ROLE_PRODUTOS_EDITAR');
        self.model.permissoes.produtosExcluir = dados.includes('ROLE_PRODUTOS_EXCLUIR');
        self.model.permissoes.produtosVisualizar = dados.includes('ROLE_PRODUTOS_VISUALIZAR');
        self.model.permissoes.produtosRelatorios = dados.includes('ROLE_PRODUTOS_RELATORIOS');
        self.model.permissoes.servicosCadastrar = dados.includes('ROLE_SERVICOS_CADASTRAR');
        self.model.permissoes.servicosEditar = dados.includes('ROLE_SERVICOS_EDITAR');
        self.model.permissoes.servicosExcluir = dados.includes('ROLE_SERVICOS_EXCLUIR');
        self.model.permissoes.servicosVisualizar = dados.includes('ROLE_SERVICOS_VISUALIZAR');
        self.model.permissoes.servicosRelatorios = dados.includes('ROLE_SERVICOS_RELATORIOS');
        self.model.permissoes.depositosCadastrar = dados.includes('ROLE_DEPOSITOS_CADASTRAR');
        self.model.permissoes.depositosEditar = dados.includes('ROLE_DEPOSITOS_EDITAR');
        self.model.permissoes.depositosExcluir = dados.includes('ROLE_DEPOSITOS_EXCLUIR');
        self.model.permissoes.depositosVisualizar = dados.includes('ROLE_DEPOSITOS_VISUALIZAR');
        self.model.permissoes.depositosRelatorios = dados.includes('ROLE_DEPOSITOS_RELATORIOS');
        self.model.permissoes.movimentacaoEstoqueCadastrar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_CADASTRAR');
        self.model.permissoes.movimentacaoEstoqueEditar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_EDITAR');
        self.model.permissoes.movimentacaoEstoqueExcluir = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_EXCLUIR');
        self.model.permissoes.movimentacaoEstoqueVisualizar = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_VISUALIZAR');
        self.model.permissoes.movimentacaoEstoqueRelatorios = dados.includes('ROLE_MOVIMENTACAO_ESTOQUE_RELATORIOS');
        self.model.permissoes.balancoEstoqueCadastrar = dados.includes('ROLE_BALANCO_ESTOQUE_CADASTRAR');
        self.model.permissoes.balancoEstoqueEditar = dados.includes('ROLE_BALANCO_ESTOQUE_EDITAR');
        self.model.permissoes.balancoEstoqueExcluir = dados.includes('ROLE_BALANCO_ESTOQUE_EXCLUIR');
        self.model.permissoes.balancoEstoqueVisualizar = dados.includes('ROLE_BALANCO_ESTOQUE_VISUALIZAR');
        self.model.permissoes.balancoEstoqueRelatorios = dados.includes('ROLE_BALANCO_ESTOQUE_RELATORIOS');
        self.model.permissoes.fluxoCaixaCadastrar = dados.includes('ROLE_FLUXO_CAIXA_CADASTRAR');
        self.model.permissoes.fluxoCaixaEditar = dados.includes('ROLE_FLUXO_CAIXA_EDITAR');
        self.model.permissoes.fluxoCaixaExcluir = dados.includes('ROLE_FLUXO_CAIXA_EXCLUIR');
        self.model.permissoes.fluxoCaixaVisualizar = dados.includes('ROLE_FLUXO_CAIXA_VISUALIZAR');
        self.model.permissoes.fluxoCaixaRelatorios = dados.includes('ROLE_FLUXO_CAIXA_RELATORIOS');
        self.model.permissoes.contasPagarCadastrar = dados.includes('ROLE_CONTAS_PAGAR_CADASTRAR');
        self.model.permissoes.contasPagarEditar = dados.includes('ROLE_CONTAS_PAGAR_EDITAR');
        self.model.permissoes.contasPagarExcluir = dados.includes('ROLE_CONTAS_PAGAR_EXCLUIR');
        self.model.permissoes.contasPagarVisualizar = dados.includes('ROLE_CONTAS_PAGAR_VISUALIZAR');
        self.model.permissoes.contasPagarRelatorios = dados.includes('ROLE_CONTAS_PAGAR_RELATORIOS');
        self.model.permissoes.contasReceberCadastrar = dados.includes('ROLE_CONTAS_RECEBER_CADASTRAR');
        self.model.permissoes.contasReceberEditar = dados.includes('ROLE_CONTAS_RECEBER_EDITAR');
        self.model.permissoes.contasReceberExcluir = dados.includes('ROLE_CONTAS_RECEBER_EXCLUIR');
        self.model.permissoes.contasReceberVisualizar = dados.includes('ROLE_CONTAS_RECEBER_VISUALIZAR');
        self.model.permissoes.contasReceberRelatorios = dados.includes('ROLE_CONTAS_RECEBER_RELATORIOS');
        self.model.permissoes.bancosCadastrar = dados.includes('ROLE_BANCOS_CADASTRAR');
        self.model.permissoes.bancosEditar = dados.includes('ROLE_BANCOS_EDITAR');
        self.model.permissoes.bancosExcluir = dados.includes('ROLE_BANCOS_EXCLUIR');
        self.model.permissoes.bancosVisualizar = dados.includes('ROLE_BANCOS_VISUALIZAR');
        self.model.permissoes.bancosRelatorios = dados.includes('ROLE_BANCOS_RELATORIOS');
        self.model.permissoes.movimentacaoBancariaCadastrar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_CADASTRAR');
        self.model.permissoes.movimentacaoBancariaEditar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_EDITAR');
        self.model.permissoes.movimentacaoBancariaExcluir = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_EXCLUIR');
        self.model.permissoes.movimentacaoBancariaVisualizar = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_VISUALIZAR');
        self.model.permissoes.movimentacaoBancariaRelatorios = dados.includes('ROLE_MOVIMENTACAO_BANCARIA_RELATORIOS');
        self.model.permissoes.movimentacaoBoletosCadastrar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_CADASTRAR');
        self.model.permissoes.movimentacaoBoletosEditar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_EDITAR');
        self.model.permissoes.movimentacaoBoletosExcluir = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_EXCLUIR');
        self.model.permissoes.movimentacaoBoletosVisualizar = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_VISUALIZAR');
        self.model.permissoes.movimentacaoBoletosRelatorios = dados.includes('ROLE_MOVIMENTACAO_BOLETOS_RELATORIOS');

        self.model.permissoes.chequesEmitidosCadastrar = dados.includes('ROLE_CHEQUES_EMITIDOS_CADASTRAR');
        self.model.permissoes.chequesEmitidosEditar = dados.includes('ROLE_CHEQUES_EMITIDOS_EDITAR');
        self.model.permissoes.chequesEmitidosExcluir = dados.includes('ROLE_CHEQUES_EMITIDOS_EXCLUIR');
        self.model.permissoes.chequesEmitidosVisualizar = dados.includes('ROLE_CHEQUES_EMITIDOS_VISUALIZAR');
        self.model.permissoes.chequesEmitidosRelatorios = dados.includes('ROLE_CHEQUES_EMITIDOS_RELATORIOS');
        self.model.permissoes.chequesRepasseCadastrar = dados.includes('ROLE_CHEQUES_REPASSE_CADASTRAR');
        self.model.permissoes.chequesRepasseEditar = dados.includes('ROLE_CHEQUES_REPASSE_EDITAR');
        self.model.permissoes.chequesRepasseExcluir = dados.includes('ROLE_CHEQUES_REPASSE_EXCLUIR');
        self.model.permissoes.chequesRepasseVisualizar = dados.includes('ROLE_CHEQUES_REPASSE_VISUALIZAR');
        self.model.permissoes.chequesRepasseRelatorios = dados.includes('ROLE_CHEQUES_REPASSE_RELATORIOS');
        self.model.permissoes.statusChequeCadastrar = dados.includes('ROLE_STATUS_CHEQUE_CADASTRAR');
        self.model.permissoes.statusChequeEditar = dados.includes('ROLE_STATUS_CHEQUE_EDITAR');
        self.model.permissoes.statusChequeExcluir = dados.includes('ROLE_STATUS_CHEQUE_EXCLUIR');
        self.model.permissoes.statusChequeVisualizar = dados.includes('ROLE_STATUS_CHEQUE_VISUALIZAR');
        self.model.permissoes.statusChequeRelatorios = dados.includes('ROLE_STATUS_CHEQUE_RELATORIOS');
        self.model.permissoes.comprasCadastrar = dados.includes('ROLE_COMPRAS_CADASTRAR');
        self.model.permissoes.comprasEditar = dados.includes('ROLE_COMPRAS_EDITAR');
        self.model.permissoes.comprasConfirmar = dados.includes('ROLE_COMPRAS_CONFIRMAR');
        self.model.permissoes.comprasCancelar = dados.includes('ROLE_COMPRAS_CANCELAR');
        self.model.permissoes.comprasVisualizar = dados.includes('ROLE_COMPRAS_VISUALIZAR');
        self.model.permissoes.comprasRelatorios = dados.includes('ROLE_COMPRAS_RELATORIOS');
        self.model.permissoes.analiseCompraCadastrar = dados.includes('ROLE_ANALISE_COMPRA_CADASTRAR');
        self.model.permissoes.analiseCompraEditar = dados.includes('ROLE_ANALISE_COMPRA_EDITAR');
        self.model.permissoes.analiseCompraConfirmar = dados.includes('ROLE_ANALISE_COMPRA_CONFIRMAR');
        self.model.permissoes.analiseCompraCancelar = dados.includes('ROLE_ANALISE_COMPRA_CANCELAR');
        self.model.permissoes.analiseCompraVisualizar = dados.includes('ROLE_ANALISE_COMPRA_VISUALIZAR');
        self.model.permissoes.analiseCompraRelatorios = dados.includes('ROLE_ANALISE_COMPRA_RELATORIOS');
        self.model.permissoes.cotacaoCompraCadastrar = dados.includes('ROLE_COTACAO_COMPRA_CADASTRAR');
        self.model.permissoes.cotacaoCompraEditar = dados.includes('ROLE_COTACAO_COMPRA_EDITAR');
        self.model.permissoes.cotacaoCompraConfirmar = dados.includes('ROLE_COTACAO_COMPRA_CONFIRMAR');
        self.model.permissoes.cotacaoCompraCancelar = dados.includes('ROLE_COTACAO_COMPRA_CANCELAR');
        self.model.permissoes.cotacaoCompraVisualizar = dados.includes('ROLE_COTACAO_COMPRA_VISUALIZAR');
        self.model.permissoes.cotacaoCompraRelatorios = dados.includes('ROLE_COTACAO_COMPRA_RELATORIOS');
        self.model.permissoes.vendasProdutosCadastrar = dados.includes('ROLE_VENDAS_PRODUTOS_CADASTRAR');
        self.model.permissoes.vendasProdutosEditar = dados.includes('ROLE_VENDAS_PRODUTOS_EDITAR');
        self.model.permissoes.vendasProdutosConfirmar = dados.includes('ROLE_VENDAS_PRODUTOS_CONFIRMAR');
        self.model.permissoes.vendasProdutosCancelar = dados.includes('ROLE_VENDAS_PRODUTOS_CANCELAR');
        self.model.permissoes.vendasProdutosVisualizar = dados.includes('ROLE_VENDAS_PRODUTOS_VISUALIZAR');
        self.model.permissoes.vendasProdutosRelatorios = dados.includes('ROLE_VENDAS_PRODUTOS_RELATORIOS');
        self.model.permissoes.devolucaoProdutosCadastrar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CADASTRAR');
        self.model.permissoes.devolucaoProdutosEditar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_EDITAR');
        self.model.permissoes.devolucaoProdutosConfirmar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CONFIRMAR');
        self.model.permissoes.devolucaoProdutosCancelar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_CANCELAR');
        self.model.permissoes.devolucaoProdutosVisualizar = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_VISUALIZAR');
        self.model.permissoes.devolucaoProdutosRelatorios = dados.includes('ROLE_DEVOLUCAO_PRODUTOS_RELATORIOS');
        self.model.permissoes.vendasServicosCadastrar = dados.includes('ROLE_VENDAS_SERVICOS_CADASTRAR');
        self.model.permissoes.vendasServicosEditar = dados.includes('ROLE_VENDAS_SERVICOS_EDITAR');
        self.model.permissoes.vendasServicosConfirmar = dados.includes('ROLE_VENDAS_SERVICOS_CONFIRMAR');
        self.model.permissoes.vendasServicosCancelar = dados.includes('ROLE_VENDAS_SERVICOS_CANCELAR');
        self.model.permissoes.vendasServicosVisualizar = dados.includes('ROLE_VENDAS_SERVICOS_VISUALIZAR');
        self.model.permissoes.vendasServicosRelatorios = dados.includes('ROLE_VENDAS_SERVICOS_RELATORIOS');
        self.model.permissoes.vendasProdutosPdvCadastrar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CADASTRAR');
        self.model.permissoes.vendasProdutosPdvEditar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_EDITAR');
        self.model.permissoes.vendasProdutosPdvConfirmar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CONFIRMAR');
        self.model.permissoes.vendasProdutosPdvCancelar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_CANCELAR');
        self.model.permissoes.vendasProdutosPdvVisualizar = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_VISUALIZAR');
        self.model.permissoes.vendasProdutosPdvRelatorios = dados.includes('ROLE_VENDAS_PRODUTOS_PDV_RELATORIOS');
        self.model.permissoes.configuracaoVendasEditar = dados.includes('ROLE_CONFIGURACAO_VENDAS_EDITAR');
        self.model.permissoes.configuracaoVendasMobileEditar = dados.includes('ROLE_CONFIGURACAO_VENDAS_MOBILE_EDITAR');
        self.model.permissoes.nfeCadastrar = dados.includes('ROLE_NFE_CADASTRAR');
        self.model.permissoes.nfeEditar = dados.includes('ROLE_NFE_EDITAR');
        self.model.permissoes.nfeEnviar = dados.includes('ROLE_NFE_ENVIAR');
        self.model.permissoes.nfeCancelar = dados.includes('ROLE_NFE_CANCELAR');
        self.model.permissoes.nfeEventos = dados.includes('ROLE_NFE_EVENTOS');
        self.model.permissoes.nfeVisualizar = dados.includes('ROLE_NFE_VISUALIZAR');
        self.model.permissoes.nfeRelatorios = dados.includes('ROLE_NFE_RELATORIOS');
        self.model.permissoes.nfceCadastrar = dados.includes('ROLE_NFCE_CADASTRAR');
        self.model.permissoes.nfceEditar = dados.includes('ROLE_NFCE_EDITAR');
        self.model.permissoes.nfceEnviar = dados.includes('ROLE_NFCE_ENVIAR');
        self.model.permissoes.nfceCancelar = dados.includes('ROLE_NFCE_CANCELAR');
        self.model.permissoes.nfceEventos = dados.includes('ROLE_NFCE_EVENTOS');
        self.model.permissoes.nfceVisualizar = dados.includes('ROLE_NFCE_VISUALIZAR');
        self.model.permissoes.nfceRelatorios = dados.includes('ROLE_NFCE_RELATORIOS');
        self.model.permissoes.nfseCadastrar = dados.includes('ROLE_NFSE_CADASTRAR');
        self.model.permissoes.nfseEditar = dados.includes('ROLE_NFSE_EDITAR');
        self.model.permissoes.nfseEnviar = dados.includes('ROLE_NFSE_ENVIAR');
        self.model.permissoes.nfseCancelar = dados.includes('ROLE_NFSE_CANCELAR');
        self.model.permissoes.nfseEventos = dados.includes('ROLE_NFSE_EVENTOS');
        self.model.permissoes.nfseVisualizar = dados.includes('ROLE_NFSE_VISUALIZAR');
        self.model.permissoes.nfseRelatorios = dados.includes('ROLE_NFSE_RELATORIOS');
        self.model.permissoes.mdfeCadastrar = dados.includes('ROLE_MDFE_CADASTRAR');
        self.model.permissoes.mdfeEditar = dados.includes('ROLE_MDFE_EDITAR');
        self.model.permissoes.mdfeEnviar = dados.includes('ROLE_MDFE_ENVIAR');
        self.model.permissoes.mdfeCancelar = dados.includes('ROLE_MDFE_CANCELAR');
        self.model.permissoes.mdfeEventos = dados.includes('ROLE_MDFE_EVENTOS');
        self.model.permissoes.mdfeVisualizar = dados.includes('ROLE_MDFE_VISUALIZAR');
        self.model.permissoes.mdfeRelatorios = dados.includes('ROLE_MDFE_RELATORIOS');
        self.model.permissoes.cteCadastrar = dados.includes('ROLE_CTE_CADASTRAR');
        self.model.permissoes.cteEditar = dados.includes('ROLE_CTE_EDITAR');
        self.model.permissoes.cteEnviar = dados.includes('ROLE_CTE_ENVIAR');
        self.model.permissoes.cteCancelar = dados.includes('ROLE_CTE_CANCELAR');
        self.model.permissoes.cteEventos = dados.includes('ROLE_CTE_EVENTOS');
        self.model.permissoes.cteVisualizar = dados.includes('ROLE_CTE_VISUALIZAR');
        self.model.permissoes.cteRelatorios = dados.includes('ROLE_CTE_RELATORIOS');
        self.model.permissoes.guiaTrafegoCadastrar = dados.includes('ROLE_GUIA_TRAFEGO_CADASTRAR');
        self.model.permissoes.guiaTrafegoEditar = dados.includes('ROLE_GUIA_TRAFEGO_EDITAR');
        self.model.permissoes.guiaTrafegoEnviar = dados.includes('ROLE_GUIA_TRAFEGO_ENVIAR');
        self.model.permissoes.guiaTrafegoCancelar = dados.includes('ROLE_GUIA_TRAFEGO_CANCELAR');
        self.model.permissoes.guiaTrafegoEventos = dados.includes('ROLE_GUIA_TRAFEGO_EVENTOS');
        self.model.permissoes.guiaTrafegoVisualizar = dados.includes('ROLE_GUIA_TRAFEGO_VISUALIZAR');
        self.model.permissoes.guiaTrafegoRelatorios = dados.includes('ROLE_GUIA_TRAFEGO_RELATORIOS');
        self.model.permissoes.mensagensNfeCadastrar = dados.includes('ROLE_MENSAGENS_NFE_CADASTRAR');
        self.model.permissoes.mensagensNfeEditar = dados.includes('ROLE_MENSAGENS_NFE_EDITAR');
        self.model.permissoes.mensagensNfeExcluir = dados.includes('ROLE_MENSAGENS_NFE_EXCLUIR');
        self.model.permissoes.mensagensNfeVisualizar = dados.includes('ROLE_MENSAGENS_NFE_VISUALIZAR');
        self.model.permissoes.mensagensNfeRelatorios = dados.includes('ROLE_MENSAGENS_NFE_RELATORIOS');
        self.model.permissoes.mensagensNfceCadastrar = dados.includes('ROLE_MENSAGENS_NFCE_CADASTRAR');
        self.model.permissoes.mensagensNfceEditar = dados.includes('ROLE_MENSAGENS_NFCE_EDITAR');
        self.model.permissoes.mensagensNfceExcluir = dados.includes('ROLE_MENSAGENS_NFCE_EXCLUIR');
        self.model.permissoes.mensagensNfceVisualizar = dados.includes('ROLE_MENSAGENS_NFCE_VISUALIZAR');
        self.model.permissoes.mensagensNfceRelatorios = dados.includes('ROLE_MENSAGENS_NFCE_RELATORIOS');
        self.model.permissoes.mensagensNfseCadastrar = dados.includes('ROLE_MENSAGENS_NFSE_CADASTRAR');
        self.model.permissoes.mensagensNfseEditar = dados.includes('ROLE_MENSAGENS_NFSE_EDITAR');
        self.model.permissoes.mensagensNfseExcluir = dados.includes('ROLE_MENSAGENS_NFSE_EXCLUIR');
        self.model.permissoes.mensagensNfseVisualizar = dados.includes('ROLE_MENSAGENS_NFSE_VISUALIZAR');
        self.model.permissoes.mensagensNfseRelatorios = dados.includes('ROLE_MENSAGENS_NFSE_RELATORIOS');
        self.model.permissoes.mensagensMdfeCadastrar = dados.includes('ROLE_MENSAGENS_MDFE_CADASTRAR');
        self.model.permissoes.mensagensMdfeEditar = dados.includes('ROLE_MENSAGENS_MDFE_EDITAR');
        self.model.permissoes.mensagensMdfeExcluir = dados.includes('ROLE_MENSAGENS_MDFE_EXCLUIR');
        self.model.permissoes.mensagensMdfeVisualizar = dados.includes('ROLE_MENSAGENS_MDFE_VISUALIZAR');
        self.model.permissoes.mensagensMdfeRelatorios = dados.includes('ROLE_MENSAGENS_MDFE_RELATORIOS');
        self.model.permissoes.mensagensCteCadastrar = dados.includes('ROLE_MENSAGENS_CTE_CADASTRAR');
        self.model.permissoes.mensagensCteEditar = dados.includes('ROLE_MENSAGENS_CTE_EDITAR');
        self.model.permissoes.mensagensCteExcluir = dados.includes('ROLE_MENSAGENS_CTE_EXCLUIR');
        self.model.permissoes.mensagensCteVisualizar = dados.includes('ROLE_MENSAGENS_CTE_VISUALIZAR');
        self.model.permissoes.mensagensCteRelatorios = dados.includes('ROLE_MENSAGENS_CTE_RELATORIOS');
        self.model.permissoes.formasPagamentoCadastrar = dados.includes('ROLE_FORMAS_PAGAMENTO_CADASTRAR');
        self.model.permissoes.formasPagamentoEditar = dados.includes('ROLE_FORMAS_PAGAMENTO_EDITAR');
        self.model.permissoes.formasPagamentoExcluir = dados.includes('ROLE_FORMAS_PAGAMENTO_EXCLUIR');
        self.model.permissoes.formasPagamentoVisualizar = dados.includes('ROLE_FORMAS_PAGAMENTO_VISUALIZAR');
        self.model.permissoes.formasPagamentoRelatorios = dados.includes('ROLE_FORMAS_PAGAMENTO_RELATORIOS');
        self.model.permissoes.codigosNcmsCadastrar = dados.includes('ROLE_CODIGOS_NCMS_CADASTRAR');
        self.model.permissoes.codigosNcmsEditar = dados.includes('ROLE_CODIGOS_NCMS_EDITAR');
        self.model.permissoes.codigosNcmsExcluir = dados.includes('ROLE_CODIGOS_NCMS_EXCLUIR');
        self.model.permissoes.codigosNcmsVisualizar = dados.includes('ROLE_CODIGOS_NCMS_VISUALIZAR');
        self.model.permissoes.codigosNcmsRelatorios = dados.includes('ROLE_CODIGOS_NCMS_RELATORIOS');
        self.model.permissoes.cidadesCadastrar = dados.includes('ROLE_CIDADES_CADASTRAR');
        self.model.permissoes.cidadesEditar = dados.includes('ROLE_CIDADES_EDITAR');
        self.model.permissoes.cidadesExcluir = dados.includes('ROLE_CIDADES_EXCLUIR');
        self.model.permissoes.cidadesVisualizar = dados.includes('ROLE_CIDADES_VISUALIZAR');
        self.model.permissoes.cidadesRelatorios = dados.includes('ROLE_CIDADES_RELATORIOS');
        self.model.permissoes.centrosCustosCadastrar = dados.includes('ROLE_CENTROS_CUSTOS_CADASTRAR');
        self.model.permissoes.centrosCustosEditar = dados.includes('ROLE_CENTROS_CUSTOS_EDITAR');
        self.model.permissoes.centrosCustosExcluir = dados.includes('ROLE_CENTROS_CUSTOS_EXCLUIR');
        self.model.permissoes.centrosCustosVisualizar = dados.includes('ROLE_CENTROS_CUSTOS_VISUALIZAR');
        self.model.permissoes.centrosCustosRelatorios = dados.includes('ROLE_CENTROS_CUSTOS_RELATORIOS');
        self.model.permissoes.conceitosCadastrar = dados.includes('ROLE_CONCEITOS_CADASTRAR');
        self.model.permissoes.conceitosEditar = dados.includes('ROLE_CONCEITOS_EDITAR');
        self.model.permissoes.conceitosExcluir = dados.includes('ROLE_CONCEITOS_EXCLUIR');
        self.model.permissoes.conceitosVisualizar = dados.includes('ROLE_CONCEITOS_VISUALIZAR');
        self.model.permissoes.conceitosRelatorios = dados.includes('ROLE_CONCEITOS_RELATORIOS');
        self.model.permissoes.contasCaixaCadastrar = dados.includes('ROLE_CONTAS_CAIXA_CADASTRAR');
        self.model.permissoes.contasCaixaEditar = dados.includes('ROLE_CONTAS_CAIXA_EDITAR');
        self.model.permissoes.contasCaixaExcluir = dados.includes('ROLE_CONTAS_CAIXA_EXCLUIR');
        self.model.permissoes.contasCaixaVisualizar = dados.includes('ROLE_CONTAS_CAIXA_VISUALIZAR');
        self.model.permissoes.contasCaixaRelatorios = dados.includes('ROLE_CONTAS_CAIXA_RELATORIOS');
        self.model.permissoes.codigoCfopCadastrar = dados.includes('ROLE_CODIGO_CFOP_CADASTRAR');
        self.model.permissoes.codigoCfopEditar = dados.includes('ROLE_CODIGO_CFOP_EDITAR');
        self.model.permissoes.codigoCfopExcluir = dados.includes('ROLE_CODIGO_CFOP_EXCLUIR');
        self.model.permissoes.codigoCfopVisualizar = dados.includes('ROLE_CODIGO_CFOP_VISUALIZAR');
        self.model.permissoes.codigoCfopRelatorios = dados.includes('ROLE_CODIGO_CFOP_RELATORIOS');
        self.model.permissoes.codigoCfopRegrasCadastrar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_CADASTRAR');
        self.model.permissoes.codigoCfopRegrasEditar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_EDITAR');
        self.model.permissoes.codigoCfopRegrasExcluir = dados.includes('ROLE_CODIGO_CFOP_REGRAS_EXCLUIR');
        self.model.permissoes.codigoCfopRegrasVisualizar = dados.includes('ROLE_CODIGO_CFOP_REGRAS_VISUALIZAR');
        self.model.permissoes.codigoCfopRegrasRelatorios = dados.includes('ROLE_CODIGO_CFOP_REGRAS_RELATORIOS');
        self.model.permissoes.planosContasCadastrar = dados.includes('ROLE_PLANOS_CONTAS_CADASTRAR');
        self.model.permissoes.planosContasEditar = dados.includes('ROLE_PLANOS_CONTAS_EDITAR');
        self.model.permissoes.planosContasExcluir = dados.includes('ROLE_PLANOS_CONTAS_EXCLUIR');
        self.model.permissoes.planosContasVisualizar = dados.includes('ROLE_PLANOS_CONTAS_VISUALIZAR');
        self.model.permissoes.planosContasRelatorios = dados.includes('ROLE_PLANOS_CONTAS_RELATORIOS');
        self.model.permissoes.produtosMarcasCadastrar = dados.includes('ROLE_PRODUTOS_MARCAS_CADASTRAR');
        self.model.permissoes.produtosMarcasEditar = dados.includes('ROLE_PRODUTOS_MARCAS_EDITAR');
        self.model.permissoes.produtosMarcasExcluir = dados.includes('ROLE_PRODUTOS_MARCAS_EXCLUIR');
        self.model.permissoes.produtosMarcasVisualizar = dados.includes('ROLE_PRODUTOS_MARCAS_VISUALIZAR');
        self.model.permissoes.produtosMarcasRelatorios = dados.includes('ROLE_PRODUTOS_MARCAS_RELATORIOS');
        self.model.permissoes.produtosGruposCadastrar = dados.includes('ROLE_PRODUTOS_GRUPOS_CADASTRAR');
        self.model.permissoes.produtosGruposEditar = dados.includes('ROLE_PRODUTOS_GRUPOS_EDITAR');
        self.model.permissoes.produtosGruposExcluir = dados.includes('ROLE_PRODUTOS_GRUPOS_EXCLUIR');
        self.model.permissoes.produtosGruposVisualizar = dados.includes('ROLE_PRODUTOS_GRUPOS_VISUALIZAR');
        self.model.permissoes.produtosGruposRelatorios = dados.includes('ROLE_PRODUTOS_GRUPOS_RELATORIOS');
        self.model.permissoes.produtosSubGruposCadastrar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_CADASTRAR');
        self.model.permissoes.produtosSubGruposEditar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_EDITAR');
        self.model.permissoes.produtosSubGruposExcluir = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_EXCLUIR');
        self.model.permissoes.produtosSubGruposVisualizar = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_VISUALIZAR');
        self.model.permissoes.produtosSubGruposRelatorios = dados.includes('ROLE_PRODUTOS_SUB_GRUPOS_RELATORIOS');
        self.model.permissoes.produtosCoresCadastrar = dados.includes('ROLE_PRODUTOS_CORES_CADASTRAR');
        self.model.permissoes.produtosCoresEditar = dados.includes('ROLE_PRODUTOS_CORES_EDITAR');
        self.model.permissoes.produtosCoresExcluir = dados.includes('ROLE_PRODUTOS_CORES_EXCLUIR');
        self.model.permissoes.produtosCoresVisualizar = dados.includes('ROLE_PRODUTOS_CORES_VISUALIZAR');
        self.model.permissoes.produtosCoresRelatorios = dados.includes('ROLE_PRODUTOS_CORES_RELATORIOS');
        self.model.permissoes.produtosTamanhosCadastrar = dados.includes('ROLE_PRODUTOS_TAMANHOS_CADASTRAR');
        self.model.permissoes.produtosTamanhosEditar = dados.includes('ROLE_PRODUTOS_TAMANHOS_EDITAR');
        self.model.permissoes.produtosTamanhosExcluir = dados.includes('ROLE_PRODUTOS_TAMANHOS_EXCLUIR');
        self.model.permissoes.produtosTamanhosVisualizar = dados.includes('ROLE_PRODUTOS_TAMANHOS_VISUALIZAR');
        self.model.permissoes.produtosTamanhosRelatorios = dados.includes('ROLE_PRODUTOS_TAMANHOS_RELATORIOS');
        self.model.permissoes.produtosUnidadesCadastrar = dados.includes('ROLE_PRODUTOS_UNIDADES_CADASTRAR');
        self.model.permissoes.produtosUnidadesEditar = dados.includes('ROLE_PRODUTOS_UNIDADES_EDITAR');
        self.model.permissoes.produtosUnidadesExcluir = dados.includes('ROLE_PRODUTOS_UNIDADES_EXCLUIR');
        self.model.permissoes.produtosUnidadesVisualizar = dados.includes('ROLE_PRODUTOS_UNIDADES_VISUALIZAR');
        self.model.permissoes.produtosUnidadesRelatorios = dados.includes('ROLE_PRODUTOS_UNIDADES_RELATORIOS');
        self.model.permissoes.produtosDepartamentosCadastrar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_CADASTRAR');
        self.model.permissoes.produtosDepartamentosEditar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_EDITAR');
        self.model.permissoes.produtosDepartamentosExcluir = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_EXCLUIR');
        self.model.permissoes.produtosDepartamentosVisualizar = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_VISUALIZAR');
        self.model.permissoes.produtosDepartamentosRelatorios = dados.includes('ROLE_PRODUTOS_DEPARTAMENTOS_RELATORIOS');
        self.model.permissoes.produtosTabelasPrecosCadastrar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_CADASTRAR');
        self.model.permissoes.produtosTabelasPrecosEditar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_EDITAR');
        self.model.permissoes.produtosTabelasPrecosExcluir = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_EXCLUIR');
        self.model.permissoes.produtosTabelasPrecosVisualizar = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_VISUALIZAR');
        self.model.permissoes.produtosTabelasPrecosRelatorios = dados.includes('ROLE_PRODUTOS_TABELAS_PRECOS_RELATORIOS');
        self.model.permissoes.unidadesNegocioCadastrar = dados.includes('ROLE_UNIDADES_NEGOCIO_CADASTRAR');
        self.model.permissoes.unidadesNegocioEditar = dados.includes('ROLE_UNIDADES_NEGOCIO_EDITAR');
        self.model.permissoes.unidadesNegocioExcluir = dados.includes('ROLE_UNIDADES_NEGOCIO_EXCLUIR');
        self.model.permissoes.unidadesNegocioVisualizar = dados.includes('ROLE_UNIDADES_NEGOCIO_VISUALIZAR');
        self.model.permissoes.unidadesNegocioRelatorios = dados.includes('ROLE_UNIDADES_NEGOCIO_RELATORIOS');
        self.model.permissoes.tiposContatosCadastrar = dados.includes('ROLE_TIPOS_CONTATOS_CADASTRAR');
        self.model.permissoes.tiposContatosEditar = dados.includes('ROLE_TIPOS_CONTATOS_EDITAR');
        self.model.permissoes.tiposContatosExcluir = dados.includes('ROLE_TIPOS_CONTATOS_EXCLUIR');
        self.model.permissoes.tiposContatosVisualizar = dados.includes('OLE_TIPOS_CONTATOS_VISUALIZAR');
        self.model.permissoes.tiposContatosRelatorios = dados.includes('OLE_TIPOS_CONTATOS_RELATORIOS');
        self.model.permissoes.tiposEnderecosCadastrar = dados.includes('OLE_TIPOS_ENDERECOS_CADASTRAR');
        self.model.permissoes.tiposEnderecosEditar = dados.includes('ROLE_TIPOS_ENDERECOS_EDITAR');
        self.model.permissoes.tiposEnderecosExcluir = dados.includes('ROLE_TIPOS_ENDERECOS_EXCLUIR');
        self.model.permissoes.tiposEnderecosVisualizar = dados.includes('OLE_TIPOS_ENDERECOS_VISUALIZAR');
        self.model.permissoes.tiposEnderecosRelatorios = dados.includes('OLE_TIPOS_ENDERECOS_RELATORIOS');
        self.model.permissoes.tiposInteracoesCadastrar = dados.includes('OLE_TIPOS_INTERACOES_CADASTRAR');
        self.model.permissoes.tiposInteracoesEditar = dados.includes('ROLE_TIPOS_INTERACOES_EDITAR');
        self.model.permissoes.tiposInteracoesExcluir = dados.includes('ROLE_TIPOS_INTERACOES_EXCLUIR');
        self.model.permissoes.tiposInteracoesVisualizar = dados.includes('ROLE_TIPOS_INTERACOES_VISUALIZAR');
        self.model.permissoes.tiposInteracoesRelatorios = dados.includes('ROLE_TIPOS_INTERACOES_RELATORIOS');
        self.model.permissoes.motivosCancelamentoCadastrar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_CADASTRAR');
        self.model.permissoes.motivosCancelamentoEditar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_EDITAR');
        self.model.permissoes.motivosCancelamentoExcluir = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_EXCLUIR');
        self.model.permissoes.motivosCancelamentoVisualizar = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_VISUALIZAR');
        self.model.permissoes.motivosCancelamentoRelatorios = dados.includes('ROLE_MOTIVOS_CANCELAMENTO_RELATORIOS');
        self.model.permissoes.motivosDevolucaoCadastrar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_CADASTRAR');
        self.model.permissoes.motivosDevolucaoEditar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_EDITAR');
        self.model.permissoes.motivosDevolucaoExcluir = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_EXCLUIR');
        self.model.permissoes.motivosDevolucaoVisualizar = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_VISUALIZAR');
        self.model.permissoes.motivosDevolucaoRelatorios = dados.includes('ROLE_MOTIVOS_DEVOLUCAO_RELATORIOS');
        self.model.permissoes.motivosInteracoesCadastrar = dados.includes('ROLE_MOTIVOS_INTERACOES_CADASTRAR');
        self.model.permissoes.motivosInteracoesEditar = dados.includes('ROLE_MOTIVOS_INTERACOES_EDITAR');
        self.model.permissoes.motivosInteracoesExcluir = dados.includes('ROLE_MOTIVOS_INTERACOES_EXCLUIR');
        self.model.permissoes.motivosInteracoesVisualizar = dados.includes('ROLE_MOTIVOS_INTERACOES_VISUALIZAR');
        self.model.permissoes.motivosInteracoesRelatorios = dados.includes('ROLE_MOTIVOS_INTERACOES_RELATORIOS');
        self.model.permissoes.usuarioCadastrar = dados.includes('ROLE_USUARIO_CADASTRAR');
        self.model.permissoes.usuarioEditar = dados.includes('ROLE_USUARIO_EDITAR');
        self.model.permissoes.usuarioExcluir = dados.includes('ROLE_USUARIO_EXCLUIR');
        self.model.permissoes.usuarioVisualizar = dados.includes('ROLE_USUARIO_VISUALIZAR');
        self.model.permissoes.usuarioRelatorios = dados.includes('ROLE_USUARIO_RELATORIOS');
        self.model.permissoes.empresaCadastrar = dados.includes('ROLE_EMPRESA_CADASTRAR');
        self.model.permissoes.empresaEditar = dados.includes('ROLE_EMPRESA_EDITAR');
        self.model.permissoes.empresaExcluir = dados.includes('ROLE_EMPRESA_EXCLUIR');
        self.model.permissoes.empresaVisualizar = dados.includes('ROLE_EMPRESA_VISUALIZAR');
        self.model.permissoes.empresaRelatorios = dados.includes('ROLE_EMPRESA_RELATORIOS');
      });
    },
    modificarSenha: function modificarSenha() {
      console.log('modifica');
      this.model.modificaSenha = true;
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/usuarios/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Usuário gravado com sucesso.', 'Atenção');
              self.$router.replace('/usuarios');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "Y5Fq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('navbar'),_vm._v(" "),_c('div',{staticClass:"app-body"},[_c('sidebar-menu',{attrs:{"menu":_vm.menu,"collapsed":this.$store.state.sistema.collapsed,"theme":_vm.selectedTheme,"showOneChild":false,"width":_vm.width,"widthCollapsed":_vm.widthCollapsed},on:{"collapse":_vm.onCollapse}}),_vm._v(" "),_c('div',{class:[{'collapsed' : this.$store.state.sistema.collapsed }],attrs:{"id":"main"}},[_c('div',{staticClass:"container-fluid"},[_c('router-view')],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "YAPR":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__ = __webpack_require__("sEs6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2c3bd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__ = __webpack_require__("vGaq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dashboard_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5c2c3bd6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dashboard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YFZs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue__ = __webpack_require__("hIFP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc99996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeKmRodadoFrotaView_vue__ = __webpack_require__("sDeo");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoFrotaView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7cc99996_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeKmRodadoFrotaView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YI6p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__ = __webpack_require__("jIen");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__ = __webpack_require__("4Teq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */

/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_placeInputImpl_js___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_13bfbbee_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_placeInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YmZh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue__ = __webpack_require__("Z+0/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d6f419_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPlaca_vue__ = __webpack_require__("p3ZX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPlaca_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_34d6f419_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPlaca_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "YtJ0":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vue = __webpack_require__("7+uW");

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__("NYxO");

var _vuex2 = _interopRequireDefault(_vuex);

var _state = __webpack_require__("yalW");

var _state2 = _interopRequireDefault(_state);

var _mutations = __webpack_require__("UTg/");

var _mutations2 = _interopRequireDefault(_mutations);

var _vuexPersistedstate = __webpack_require__("424j");

var _vuexPersistedstate2 = _interopRequireDefault(_vuexPersistedstate);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

exports.default = new _vuex2.default.Store({
  state: _state2.default,
  mutations: _mutations2.default,
  plugins: [(0, _vuexPersistedstate2.default)()]
});

/***/ }),

/***/ "Yyib":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Z+0/":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-placa',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "ZFBM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoVeiculo","to":"/pontos"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab1"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Código:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.codigo),expression:"model.codigo"}],staticClass:"pula form-control placa",domProps:{"value":(_vm.model.codigo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "codigo", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-8 col-md-8"},[_c('label',{staticClass:"control-label"},[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"pula form-control",attrs:{"required":"required"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Tipo Ponto:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.pontoTipoId),expression:"model.pontoTipoId"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "pontoTipoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}}),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}})])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.clienteId),expression:"model.clienteId"}],attrs:{"type":"hidden","id":"clienteId"},domProps:{"value":(_vm.model.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"clienteNome","name":"clienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarCliente,"on-blur":_vm.verificarCliente},model:{value:(_vm.model.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.model, "clienteNomeFantasia", $$v)},expression:"model.clienteNomeFantasia"}})],1)])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Ponto")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tab1","data-toggle":"tab"}},[_vm._v("Geral")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZIYP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatoriosTelemetria/viagemGeral?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "ZIfE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZOVF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ZQqV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Za1C":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "a5Lw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _PontoCadastro = __webpack_require__("OPWj");

var _PontoCadastro2 = _interopRequireDefault(_PontoCadastro);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    PontoCadastro: _PontoCadastro2.default
  },
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      selecionados: [],
      dadosRelatorios: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      showModalPonto: false,
      pontoCadastroLat: 0,
      pontoCadastroLng: 0,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },
  created: function created() {
    window.cadastrarPonto = this.cadastrarPonto;
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item);
      this.selecionada = item.dataHoraInicio;
      this.selecionados = item;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.dataHoraInicio;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var entrada = this.$route.params.entrada;
      var entradaVelocidade = this.$route.params.entradaVelocidade;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDeAnaliseTrabalhoProducao?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&entrada=' + entrada + '&entradaVelocidade=' + entradaVelocidade;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      var latitudes = self.selecionados.latitude.split(';');
      var longitudes = self.selecionados.longitude.split(';');
      for (var i = 0; i < latitudes.length; i++) {
        console.log(latitudes[i]);
        console.log(latitudes[i] !== '0' && latitudes[i] !== '');
        if (latitudes[i] !== '0' && latitudes[i] !== '') {
          var marker = {};
          if (latitudes[i] !== '0') {
            marker = {
              lat: parseFloat(latitudes[i]),
              lng: parseFloat(longitudes[i])
            };
          }
          self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHoraInicio: self.selecionados.dataHoraInicio, dataHoraFim: self.selecionados.dataHoraFim, horaTotal: self.selecionados.horaTotal, velocidade: self.selecionados.velocidade, pontoMaisProximo: self.selecionados.pontoMaisProximo, macro: self.selecionados.macro });

          self.path.push({
            lat: marker.lat,
            lng: marker.lng
          });

          self.center = marker;
          myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
          if (bounds === null) {
            bounds = new window.google.maps.LatLngBounds();
          }
          bounds.extend(myLatLng);
        }
      }

      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    visualizarDesacionadosMapa: function visualizarDesacionadosMapa() {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2() {
        var self;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                self = _this2;

                self.removerMarkers();
                self.showModalMapa = true;
                _context2.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarDesacionadosMarkers();

              case 6:
              case 'end':
                return _context2.stop();
            }
          }
        }, _callee2, _this2);
      }))();
    },
    adicionarDesacionadosMarkers: function adicionarDesacionadosMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;

      for (var z = 0; z < self.dadosRelatorios.dados.length; z++) {
        if (self.dadosRelatorios.dados[z].kmRodados === null) {
          var latitudes = self.dadosRelatorios.dados[z].latitude.split(';');
          var longitudes = self.dadosRelatorios.dados[z].longitude.split(';');
          for (var i = 0; i < latitudes.length; i++) {
            if (latitudes[i] !== '' && latitudes[i] !== '0' && latitudes[i] !== '0.0') {
              var marker = {};
              marker = {
                lat: parseFloat(latitudes[i]),
                lng: parseFloat(longitudes[i])
              };
              self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHoraInicio: self.dadosRelatorios.dados[z].dataHoraInicio, dataHoraFim: self.dadosRelatorios.dados[z].dataHoraFim, horaTotal: self.dadosRelatorios.dados[z].horaTotal, velocidade: self.dadosRelatorios.dados[z].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[z].pontoMaisProximo, macro: self.dadosRelatorios.dados[z].macro });

              self.path.push({
                lat: marker.lat,
                lng: marker.lng
              });

              self.center = marker;
              myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
              if (bounds === null) {
                bounds = new window.google.maps.LatLngBounds();
              }
              bounds.extend(myLatLng);
            }
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });
      self.currentPlace = null;
    },
    visualizarAcionadosMapa: function visualizarAcionadosMapa() {
      var _this3 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee3() {
        var self;
        return _regenerator2.default.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                self = _this3;

                self.removerMarkers();
                self.showModalMapa = true;
                _context3.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarAcionadosMarkers();

              case 6:
              case 'end':
                return _context3.stop();
            }
          }
        }, _callee3, _this3);
      }))();
    },
    adicionarAcionadosMarkers: function adicionarAcionadosMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;

      for (var z = 0; z < self.dadosRelatorios.dados.length; z++) {
        if (self.dadosRelatorios.dados[z].kmRodados !== null) {
          var latitudes = self.dadosRelatorios.dados[z].latitude.split(';');
          var longitudes = self.dadosRelatorios.dados[z].longitude.split(';');
          for (var i = 0; i < latitudes.length; i++) {
            if (latitudes[i] !== '' && latitudes[i] !== '0' && latitudes[i] !== '0.0') {
              var marker = {};
              marker = {
                lat: parseFloat(latitudes[i]),
                lng: parseFloat(longitudes[i])
              };
              self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHoraInicio: self.dadosRelatorios.dados[z].dataHoraInicio, dataHoraFim: self.dadosRelatorios.dados[z].dataHoraFim, horaTotal: self.dadosRelatorios.dados[z].horaTotal, velocidade: self.dadosRelatorios.dados[z].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[z].pontoMaisProximo, macro: self.dadosRelatorios.dados[z].macro });

              self.path.push({
                lat: marker.lat,
                lng: marker.lng
              });

              self.center = marker;
              myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
              if (bounds === null) {
                bounds = new window.google.maps.LatLngBounds();
              }
              bounds.extend(myLatLng);
            }
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });
      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);
    },
    cadastrarPonto: function cadastrarPonto(lat, lng) {
      this.pontoCadastroLat = lat;
      this.pontoCadastroLng = lng;
      this.showModalPonto = true;
    },
    updateparent: function updateparent() {
      this.showModalPonto = false;
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      console.log(marker);
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Data Hora Inicio:</strong> ' + marker.dataHoraInicio + '<br>' + '<strong>Data Hora Fim:</strong> ' + marker.dataHoraFim + '<br>' + '<strong>Tempo Total:</strong> ' + marker.horaTotal + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br><strong>Macros:</strong><br>' + marker.macro + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>' + '<br>Ponto: <a onClick="cadastrarPonto(' + marker.position.lat + ',' + marker.position.lng + ')" style="cursor: hand;cursor: pointer;" ><strong>Cadastrar ponto</strong></a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "aGmC":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var motoristaId = this.$route.params.motoristaId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatoriosTelemetria/viagemPorMotorista?motoristaId=' + motoristaId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "aPSQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _modal = __webpack_require__("rKsW");

var _modal2 = _interopRequireDefault(_modal);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _modal2.default;

/***/ }),

/***/ "aVqU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue__ = __webpack_require__("0mNe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4137262a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabelaVisualizar_vue__ = __webpack_require__("ywe9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadaTabelaVisualizar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4137262a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadaTabelaVisualizar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "aWnz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-data-format',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  mounted: function mounted() {
    $(this.$el).mask('99/99/9999');
    $(this.$el).val(this.value);
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99/99/9999');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');

      $(this.$el).find('#' + this.id).val(_value);
    }
  },
  methods: {
    setValue: function setValue(date) {
      $(this.$el).val(date);
    },
    setDataFinal: function setDataFinal() {
      $(this.$el).find('#dataFinal').val(this.value);
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "ahZu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue__ = __webpack_require__("TCzx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2865dd37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeKmRodadoVeiculoView_vue__ = __webpack_require__("yukh");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDeKmRodadoVeiculoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2865dd37_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDeKmRodadoVeiculoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bICA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalRelatorios)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalRelatoriosVenda","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Tipo do Relatório:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorios.tipo),expression:"relatorios.tipo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorios, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1","label":"Relação de Motoristas"}},[_vm._v("Relação de Motoristas")]),_vm._v(" "),_c('option',{attrs:{"value":"2","label":"Aniversariantes"}},[_vm._v("Aniversariantes")]),_vm._v(" "),_c('option',{attrs:{"value":"3","label":"Ranking de Motoristas"}},[_vm._v("Ranking de Motoristas")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Inicial:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataInicial", $$v)},expression:"relatorios.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Final:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataFinal", $$v)},expression:"relatorios.dataFinal"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"id":"imprimirVendaModal","type":"button"},on:{"click":_vm.imprimirRelatorios}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Imprimir\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorios = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"to":{name: 'MotoristasEditar', params: { id: 0 }}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"},on:{"click":_vm.relatoriosModal}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaMotoristas","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(motorista){return _c('tr',{class:{ 'selecionado': _vm.selecionado(motorista) },on:{"click":function($event){_vm.selecionarItem(motorista)},"dblclick":function($event){_vm.editar(motorista.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":motorista.id}}),_vm._v(" "),(motorista.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(motorista.id))]),_vm._v(" "),_c('td',{attrs:{"width":"350"}},[_c('strong',[_vm._v(_vm._s(motorista.nome))]),_vm._v(" "),(motorista.documento != null && motorista.documento != '')?[_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(motorista.documento))])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(motorista.clienteNomeFantasia))]),_vm._v(" "),(motorista.clienteNome != null && motorista.clienteNome != '')?[_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(motorista.clienteNome))])]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'MotoristasEditar', params: { id: motorista.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatórios de Motoristas")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Opções:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Motoristas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Empresa")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bUu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue__ = __webpack_require__("AiPH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cb8dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarProduto_vue__ = __webpack_require__("n5OU");
function injectStyle (ssrContext) {
  __webpack_require__("q0df")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarProduto_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f3cb8dae_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarProduto_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bUvH":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bYtI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vueChartjs = __webpack_require__("UlOv");

var reactiveProp = _vueChartjs.mixins.reactiveProp;
exports.default = {
  extends: _vueChartjs.Bar,
  mixins: [reactiveProp],
  props: ['options'],
  mounted: function mounted() {
    this.renderChart(this.chartData, this.options);
  }
};

/***/ }),

/***/ "biBf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue__ = __webpack_require__("r1zz");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8fbbe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasEditar_vue__ = __webpack_require__("lCdO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0b8fbbe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "bwi3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{staticClass:"modal fade",attrs:{"id":"modalBaixa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Vencimento:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"form-control pula data",attrs:{"id":"baixarVencimento"}})],1),_vm._v(" "),_vm._m(2),_vm._v(" "),_vm._m(3),_vm._v(" "),_vm._m(4)]),_vm._v(" "),_vm._m(5),_vm._v(" "),_c('br'),_vm._v(" "),_c('br'),_vm._v(" "),_vm._m(6),_vm._v(" "),_vm._m(7),_vm._v(" "),_vm._m(8)]),_vm._v(" "),_vm._m(9)])]),_vm._v(" "),_vm._m(10)])])]),_vm._v(" "),_c('input',{staticClass:"btn"})])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('button',{staticClass:"close",attrs:{"type":"button","data-dismiss":"modal","aria-label":"Close"}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('h4',{staticClass:"modal-title"},[_vm._v("Baixar Movimento Financeiro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('label',{staticClass:"label-filtros"},[_vm._v("C�d.")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"baixarId"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-11 col-md-11"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Titular")]),_vm._v(" "),_c('input',{staticClass:"form-control",attrs:{"id":"baixarTitular"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Valor:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarValor"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Multa:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarMulta"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Juros:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarJuros"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Pagamento:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula data",attrs:{"id":"baixarDataPagamento"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-3 col-md-3"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Valor Pago:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarValorPago"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Usar Credito?")]),_vm._v(" "),_c('select',{staticClass:"form-control custom",attrs:{"id":"baixarUsarCreditoTitular"}},[_c('option',{attrs:{"value":"nao"}},[_vm._v("N�o")]),_vm._v(" "),_c('option',{attrs:{"value":"sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Credito Disponivel:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarCreditoTitularDisponivel"}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Credito Utilizado:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarCreditoTitularUtilizado"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Lan�ar diferen�a de pagamento como:")]),_vm._v(" "),_c('select',{staticClass:"form-control custom",attrs:{"id":"baixarDiferencaPagamento"}},[_c('option',{attrs:{"value":"desconto"}},[_vm._v("Desconto")]),_vm._v(" "),_c('option',{attrs:{"value":"parcela"}},[_vm._v("Parcela")]),_vm._v(" "),_c('option',{attrs:{"value":"credito"}},[_vm._v("Cr�dito")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros",attrs:{"id":"labelBaixarValorDesconto"}},[_vm._v("Desconto:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula monetario",attrs:{"id":"baixarValorDesconto"}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Novo Vencimento:")]),_vm._v(" "),_c('input',{staticClass:"form-control pula data",attrs:{"id":"baixarNovaDataVencimento"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-6 col-md-6"},[_vm._v("\n  \t\t\t\t\t\tEfetuar baixa utilizando:\n  \t\t\t\t\t\t"),_c('select',{staticClass:"form-control custom",attrs:{"id":"baixarTipoPagamento"}},[_c('option',{attrs:{"value":"dinheiro"}},[_vm._v("Dinherio")]),_vm._v(" "),_c('option',{attrs:{"value":"cheque"}},[_vm._v("Cheque")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('label',{attrs:{"id":"labelAdicionarCheque"}},[_vm._v("Pagamento com Cheques")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4"},[_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"id":"utilizarCheque","type":"button"}},[_vm._v("Utilizar Cheque")])]),_vm._v(" "),_c('div',{staticClass:"col-sm-4 col-md-4"},[_c('button',{staticClass:"btn btn-primary pull-right",attrs:{"id":"adicionarCheque","type":"button"}},[_vm._v("Adicionar Cheque")])])]),_vm._v(" "),_c('table',{attrs:{"id":"tabelaCheques","width":"100%"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-primary",attrs:{"id":"gravarBaixa","type":"button"}},[_vm._v("Gravar Pagamento")]),_vm._v(" "),_c('button',{staticClass:"btn btn-default",attrs:{"type":"button","data-dismiss":"modal"}},[_vm._v("Fechar")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "bz7+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "c6lI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalRelatorios)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalRelatoriosVenda","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Tipo do Relatório:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorios.tipo),expression:"relatorios.tipo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorios, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1","label":"Relação de Clientes"}},[_vm._v("Relação de Clientes")]),_vm._v(" "),_c('option',{attrs:{"value":"2","label":"Aniversariantes"}},[_vm._v("Aniversariantes")]),_vm._v(" "),_c('option',{attrs:{"value":"3","label":"Ranking de Clientes"}},[_vm._v("Ranking de Clientes")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Inicial:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataInicial", $$v)},expression:"relatorios.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Final:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataFinal", $$v)},expression:"relatorios.dataFinal"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"id":"imprimirVendaModal","type":"button"},on:{"click":_vm.imprimirRelatorios}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Imprimir\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorios = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"id":"btnNovoCliente","to":"/clientes/novo"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"},on:{"click":_vm.relatoriosModal}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaClientes","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(cliente){return _c('tr',{class:{ 'selecionado': _vm.selecionado(cliente) },on:{"click":function($event){_vm.selecionarItem(cliente)},"dblclick":function($event){_vm.editar(cliente.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":cliente.id}}),_vm._v(" "),(cliente.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(cliente.id))]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(cliente.nomeFantasia))]),_vm._v(" "),(cliente.nomeFantasia != cliente.nome && cliente.nome != '')?[_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(cliente.nome))])]:_vm._e(),_vm._v(" "),(cliente.documento != null && cliente.documento != '')?[_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(cliente.documento))])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(cliente.endereco))]),_vm._v(" "),(cliente.numero != null && cliente.numero != '')?[_c('small',{staticClass:"text-muted"},[_vm._v("  ,  "+_vm._s(cliente.numero))])]:_vm._e(),_vm._v(" "),(cliente.cidadeNome != null && cliente.cidadeNome != '')?[_c('small',{staticClass:"text-muted"},[_vm._v("  ,  "+_vm._s(cliente.cidadeNome)+", "+_vm._s(cliente.cidadeEstado))])]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'ClientesEditar', params: { id: cliente.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(cliente.id)}}})],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatórios de Clientes")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Opções:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Clientes")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Endereço")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cCPU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cL2t":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue__ = __webpack_require__("i+Bj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a93ad828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarServico_vue__ = __webpack_require__("bz7+");
function injectStyle (ssrContext) {
  __webpack_require__("7Blq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarServico_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a93ad828_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarServico_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cNYX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('PontoCadastro',{attrs:{"showModalPonto":_vm.showModalPonto,"latitude":_vm.pontoCadastroLat,"longitude":_vm.pontoCadastroLng},on:{"eventname":_vm.updateparent,"update:showModalPonto":function($event){_vm.showModalPonto=$event}}}),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}}),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.generateReport()}}},[_vm._v("Download PDF")]),_vm._v(" "),_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":_vm.fieldsDadosRelatorios,"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Distância Percorrida: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida) + 'Km' + '\n  Odômetro do GPS: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro) + ' Km ' + '\n  Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima) + ' Km/h ',"footer":_vm.dadosRelatorios.data,"worksheet":"My Worksheet","name":"filename.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Odômetro do GPS: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[(dados.alertaVelocidade === 'true')?[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicaoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.gpsDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.gprsDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.movimentoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(dados.tensao))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))]),_vm._v(" "),(dados.motorista !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])]:_vm._e()],2)])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "cO9X":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue__ = __webpack_require__("/pYe");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43040c00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarFinanceiro_vue__ = __webpack_require__("1+km");
function injectStyle (ssrContext) {
  __webpack_require__("wH/M")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarFinanceiro_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43040c00_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarFinanceiro_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "cm6r":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: false,
        codigo: '',
        descricao: '',
        clienteId: '0',
        clienteNome: '',
        clienteNomeFantasia: '',
        pontoTipoId: '0',
        pontoTipoDescricao: '',
        latitude: '0',
        longitude: '0'
      },
      pontosTipos: []
    };
  },

  created: function created() {
    this.buscar();
    this.buscarPontosTipos();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/pontos/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        var dados = response.data;
        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.codigo = dados.codigo;
        self.model.descricao = dados.descricao;
        self.model.clienteId = dados.clienteId;
        self.model.clienteNome = dados.clienteNome;
        self.model.clienteNomeFantasia = dados.clienteNomeFantasia;
        self.model.pontoTipoId = dados.pontoTipoId;
        self.model.pontoTipoDescricao = dados.pontoTipoDescricao;
        self.model.latitude = dados.latitude;
        self.model.longitude = dados.longitude;
      });
    },
    buscarPontosTipos: function buscarPontosTipos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/pontosTipos/buscarPontosTiposAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.pontosTipos = dados;
      });
    },
    setarCliente: function setarCliente(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarCliente: function verificarCliente() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/pontos/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Ponto gravado com sucesso.', 'Atenção');
              self.$router.replace('/pontos');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "dWEF":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosVeiculo.buscas,
        pagina: this.$store.state.filtrosVeiculo.pagina,
        quantidade: this.$store.state.filtrosVeiculo.quantidade,
        status: this.$store.state.filtrosVeiculo.status,
        selecionada: this.$store.state.filtrosVeiculo.selecionada
      },
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.filtros.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.filtros.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_VEICULO', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/veiculos/editar/' + id);
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Veículo?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/veiculos/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo deletado com sucesso.', 'Atenção');
              url = '/api/veiculos?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "dYEB":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue__ = __webpack_require__("M1g5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4566d58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputHoraPickerSS_vue__ = __webpack_require__("F0rt");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputHoraPickerSS_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b4566d58_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputHoraPickerSS_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eGyS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue__ = __webpack_require__("m2dh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1e5207_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoLista_vue__ = __webpack_require__("rZ8Y");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GestaoJornadasConvencaoLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c1e5207_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GestaoJornadasConvencaoLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "eof4":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  data: function data() {
    return {
      context: 'login context',
      loaded: false,
      data: {
        body: {
          username: 'developer',
          password: 'teste123'
        },
        rememberMe: false,
        fetchUser: true
      },
      error: null
    };
  },
  ready: function ready() {
    var _this = this;

    setTimeout(function () {
      _this.loaded = true;
    }, 500);

    if (this.$auth.token()) {
      this.$auth.refresh();
    }
  },
  mounted: function mounted() {
    console.log(this.$auth.redirect());
  },

  methods: {
    login: function login() {
      var _this2 = this;

      var redirect = this.$auth.redirect();
      this.$auth.login({
        body: this.data.body,
        data: this.data.body,
        rememberMe: this.data.rememberMe,
        redirect: { name: redirect ? redirect.from.name : 'account' },
        fetchUser: this.data.fetchUser
      }).then(function () {
        console.log('success ' + _this2.context);
      }, function (res) {
        console.log('error ' + _this2.context);
        _this2.error = res.data;
      });
    },
    logout: function logout() {
      this.$auth.logout({
        makeRequest: true,
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    },
    unimpersonate: function unimpersonate() {
      this.$auth.unimpersonate({
        success: function success() {
          console.log('success ' + this.context);
        },
        error: function error() {
          console.log('error ' + this.context);
        }
      });
    }
  }
};

/***/ }),

/***/ "fMAI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"id":_vm.id,"on-change":_vm.setarData}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fPub":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosVeiculo.buscas,
        pagina: this.$store.state.filtrosVeiculo.pagina,
        quantidade: this.$store.state.filtrosVeiculo.quantidade,
        status: this.$store.state.filtrosVeiculo.status,
        selecionada: this.$store.state.filtrosVeiculo.selecionada
      },
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.filtros.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.filtros.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_VEICULO', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/pontos?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/pontos/editar/' + id);
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Veículo?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/pontos/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Veículo deletado com sucesso.', 'Atenção');
              url = '/api/pontos?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Veículo está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "fQ06":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section',{staticStyle:{"min-height":"637px"},attrs:{"id":"main-content"}},[_c('div',[_c('h1',[_vm._v("LOGOUT")]),_vm._v(" "),_c('form',{on:{"submit":function($event){$event.preventDefault();_vm.login()}}},[_c('table',[_c('tr',[_c('td',[_vm._v("Username:")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.username),expression:"data.body.username"}],domProps:{"value":(_vm.data.body.username)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "username", $event.target.value)}}})])]),_c('tr',[_c('td',[_vm._v("Password:")]),_vm._v(" "),_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.body.password),expression:"data.body.password"}],attrs:{"type":"password"},domProps:{"value":(_vm.data.body.password)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.data.body, "password", $event.target.value)}}})])]),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.rememberMe),expression:"data.rememberMe"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.data.rememberMe)?_vm._i(_vm.data.rememberMe,null)>-1:(_vm.data.rememberMe)},on:{"change":function($event){var $$a=_vm.data.rememberMe,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.data, "rememberMe", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.data, "rememberMe", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.data, "rememberMe", $$c)}}}}),_vm._v(" Remember Me")])])]),_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.data.fetchUser),expression:"data.fetchUser"}],attrs:{"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.data.fetchUser)?_vm._i(_vm.data.fetchUser,null)>-1:(_vm.data.fetchUser)},on:{"change":function($event){var $$a=_vm.data.fetchUser,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.data, "fetchUser", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.data, "fetchUser", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.data, "fetchUser", $$c)}}}}),_vm._v(" Fetch User (test)")])])]),_vm._m(0)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.error),expression:"error"}],staticStyle:{"color":"red","word-wrap":"break-word"}})])]),_vm._v(" "),_c('div',[(_vm.$auth.ready() && _vm.loaded)?_c('div',[_c('div',{staticStyle:{"text-align":"center"}},[_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'default'}),expression:"{name: 'default'}"}]},[_vm._v("home")]),_vm._v(" •\n\n              "),_c('span',[_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'async'}),expression:"{name: 'async'}"}]},[_vm._v("async")]),_vm._v(" •\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(!_vm.$auth.check()),expression:"!$auth.check()"}]},[_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'login'}),expression:"{name: 'login'}"}]},[_vm._v("login")]),_vm._v(" •\n                  "),_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'register'}),expression:"{name: 'register'}"}]},[_vm._v("register")]),_vm._v(" •\n                  "),_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'oauth1'}),expression:"{name: 'oauth1'}"}]},[_vm._v("oauth1")]),_vm._v(" •\n                  "),_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'oauth2'}),expression:"{name: 'oauth2'}"}]},[_vm._v("oauth2")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check('admin')),expression:"$auth.check('admin')"}]},[_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'admin'}),expression:"{name: 'admin'}"}]},[_vm._v("admin")]),_vm._v(" •\n                  "),_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'users'}),expression:"{name: 'users'}"}]},[_vm._v("users")]),_vm._v(" •\n              ")]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.check()),expression:"$auth.check()"}]},[_c('a',{directives:[{name:"link",rawName:"v-link",value:({name: 'account'}),expression:"{name: 'account'}"}]},[_vm._v("account")]),_vm._v(" •\n                  "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.logout()}}},[_vm._v("logout")])]),_vm._v(" "),_c('span',{directives:[{name:"show",rawName:"v-show",value:(_vm.$auth.impersonating()),expression:"$auth.impersonating()"}]},[_vm._v("\n                  •\n                  "),_c('a',{attrs:{"href":"javascript:void(0);"},on:{"click":function($event){_vm.unimpersonate()}}},[_vm._v("(logout "+_vm._s(_vm.$auth.user().username)+")")])])]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticStyle:{"max-width":"400px","margin":"0 auto 50px auto"}},[_c('router-view')],1),_vm._v(" "),_c('hr'),_vm._v(" "),_vm._m(1)]):_vm._e(),_vm._v(" "),(!_vm.$auth.ready() || !_vm.loaded)?_c('div',[_c('div',{staticStyle:{"text-align":"center","padding-top":"50px"}},[_vm._v("\n              Loading site...\n          ")])]):_vm._e()])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('button',{attrs:{"type":"submit"}},[_vm._v("Login")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"text-align":"center","font-size":"12px"}},[_vm._v("\n              Websanova "),_c('a',{attrs:{"href":"https://github.com/websanova/laravel-api-demo"}},[_vm._v("demo server")]),_vm._v(" available on GitHub\n          ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fUAX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "fXhN":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__ = __webpack_require__("uZUK");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56fa764e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__ = __webpack_require__("JHMb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_JsonExcel_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_56fa764e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_JsonExcel_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "fcFS":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formInput = __webpack_require__("qRo1");

var _formInput2 = _interopRequireDefault(_formInput);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formInput2.default;

/***/ }),

/***/ "ftCg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue__ = __webpack_require__("uZDI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ceec9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCliente_vue__ = __webpack_require__("j8A5");
function injectStyle (ssrContext) {
  __webpack_require__("ys1d")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarCliente_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_57ceec9b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarCliente_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "g5vT":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue__ = __webpack_require__("9Trd");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b91a447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VeiculosEditar_vue__ = __webpack_require__("Geto");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_VeiculosEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_1b91a447_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_VeiculosEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "gVe6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      inicioJornadaManual: false,
      finalJornadaManual: false,
      dataHoraInicialJornadaManual: '',
      dataHoraFinalJornadaManual: '',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosAnalise: [],
      dadosAnaliseMacros: [],
      dadosAnaliseProblemas: '',
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.gerarAnalise();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    gerarAnalise: function gerarAnalise() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/analiseJornadas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
      });
    },
    gravarAnalise: function gravarAnalise() {
      var self = this;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataFinal.replace(/-/g, '/');
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      if (self.inicioJornadaManual === true) {
        if (self.dataHoraInicialJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Inicial da Jornada', 'Atenção');
          return;
        }
      }
      if (self.finalJornadaManual === true) {
        if (self.dataHoraFinalJornadaManual === '') {
          self.$toastr('error', 'Preencha a Data Final da Jornada', 'Atenção');
          return;
        }
      }
      self.processando = true;
      var url = '/api/analiseJornadasGravar?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      if (self.inicioJornadaManual === true) {
        url = url + '&dataHoraInicialJornada=' + self.dataHoraInicialJornadaManual;
      }
      if (self.finalJornadaManual === true) {
        url = url + '&dataHoraFinalJornada=' + self.dataHoraFinalJornadaManual;
      }
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosAnalise = dadosCadastro;
        self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
        self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
        self.processando = false;
        self.$router.replace('/gestaoJornada');
      });
    }
  }
};

/***/ }),

/***/ "gkTP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("8ebl")));

/***/ }),

/***/ "h1uO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "h5eE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.ncm))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.descricao))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hIFP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: {
        data: '',
        veiculo: '',
        empresa: '',
        distanciaPercorrida: '0',
        velocidadeMedia: '0',
        velocidadeMaxima: '0'
      },
      selecionados: [],
      processando: true,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
      this.selecionados = this.selecionados.sort(function (a, b) {
        return b.id - a.id;
      });
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculoId;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
        self.markers = [];
        self.path = [];
        self.removerMarkers();
      });
    },
    visualizarMapa: function visualizarMapa() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 2000);
                });

              case 5:
                self.adicionarMarkers();

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },
    adicionarMarkers: function adicionarMarkers() {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      if (self.selecionados.length > 0) {
        for (var i = 0; i < self.selecionados.length; i++) {
          if (self.selecionados[i].latitude !== 0) {
            var marker = {};
            if (self.selecionados[i].latitude !== '0') {
              marker = {
                lat: self.selecionados[i].latitude,
                lng: self.selecionados[i].longitude
              };
            }
            self.markers.push({ position: marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.selecionados[i].hora, ignicao: self.selecionados[i].ignicao, velocidade: self.selecionados[i].velocidade, pontoMaisProximo: self.selecionados[i].pontoMaisProximo });
            self.path.push({
              lat: self.selecionados[i].latitude,
              lng: self.selecionados[i].longitude
            });

            self.center = marker;
            myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      } else {
        for (var _i = 0; _i < self.dadosRelatorios.dados.length; _i++) {
          console.log(self.dadosRelatorios.dados[_i].latitude);
          if (self.dadosRelatorios.dados[_i].latitude !== 0) {
            var _marker = {};
            if (self.dadosRelatorios.dados[_i].latitude !== '0') {
              _marker = {
                lat: self.dadosRelatorios.dados[_i].latitude,
                lng: self.dadosRelatorios.dados[_i].longitude
              };
            }
            self.markers.push({ position: _marker, descricao: self.dadosRelatorios.veiculo, dataHora: self.dadosRelatorios.dados[_i].hora, ignicao: self.dadosRelatorios.dados[_i].ignicao, velocidade: self.dadosRelatorios.dados[_i].velocidade, pontoMaisProximo: self.dadosRelatorios.dados[_i].pontoMaisProximo });
            self.path.push({
              lat: self.dadosRelatorios.dados[_i].latitude,
              lng: self.dadosRelatorios.dados[_i].longitude
            });

            self.center = _marker;
            myLatLng = new window.google.maps.LatLng({ lat: _marker.lat, lng: _marker.lng });
            if (bounds === null) {
              bounds = new window.google.maps.LatLngBounds();
            }
            bounds.extend(myLatLng);
          }
        }
      }
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });

      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '<strong>Veículo:</strong> ' + marker.descricao + '<br>' + '<strong>Hora:</strong> ' + marker.dataHora + '<br>' + '<strong>Velocidade:</strong> ' + marker.velocidade + ' Km/h<br>' + '<strong>Ignição:</strong> ' + (marker.ignicao === 0 ? 'Desligada' : 'Ligada') + '<br>' + '<strong>Ponto:</strong> ' + marker.pontoMaisProximo + '<br>' + 'Maps: <a href="https://www.google.com/maps/search/' + marker.position.lat + ',+' + marker.position.lng + '/@' + marker.position.lat + ',' + marker.position.lng + ',15z" target="_blank"> Ver no Google Maps</a>';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "hQ4h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
//
//
//
//
//

/* harmony default export */ __webpack_exports__["a"] = ((function (x) {
  return x.default || x;
})(__webpack_require__("hQTS")));

/***/ }),

/***/ "i+Bj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-servico',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#servicoNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#servicoNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarServicosAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "i6Kr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "iLRu":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"click":_vm.handleDoubleClick,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.clienteNomeFantasia))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.clienteNome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.rg))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "j8A5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"readonly":_vm.readonly,"errors":_vm.errors,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "jdWM":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _navbar = __webpack_require__("kNln");

var _navbar2 = _interopRequireDefault(_navbar);

var _sidebar = __webpack_require__("J6W3");

var _sidebar2 = _interopRequireDefault(_sidebar);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'layout',
  components: {
    Navbar: _navbar2.default,
    Sidebar: _sidebar2.default
  },
  data: function data() {
    return {
      menu: [],
      collapsed: false,
      themes: ['', 'white-theme'],
      selectedTheme: 'white-theme',
      width: '280px',
      widthCollapsed: '60px'
    };
  },

  created: function created() {
    this.criarMenu();
  },
  methods: {
    onCollapse: function onCollapse(collapsed) {
      console.log(collapsed);
      this.$store.commit('SET_SISTEMA', collapsed);
    },
    onItemClick: function onItemClick(event, item) {
      console.log('onItemClick');
    },
    criarMenu: function criarMenu() {
      var menu_ = [];
      if (this.$auth.check('P102')) {
        menu_.push({ href: '/grid', title: 'Grid', icon: 'icon-speedometer' });
      }
      if (this.$auth.check('P103')) {
        menu_.push({ href: '/dashboard', title: 'Dashboard', icon: 'icon-speedometer' });
      }
      if (this.$auth.check('P104')) {
        menu_.push({ href: '/monitoramento', title: 'Monitoramento', icon: 'icon-speedometer' });
      }
      if (this.$auth.check('P105')) {
        menu_.push({ href: '/relatorios', title: 'Relatórios', icon: 'icon-speedometer' });
      }
      if (this.$auth.check('P105')) {
        menu_.push({ href: '/relatoriosTelemetria', title: 'Relatórios Telemetria', icon: 'icon-speedometer' });
      }
      if (this.$auth.check('P107')) {
        menu_.push({ href: '/eventosDisparados', title: 'Eventos Disparados', icon: 'icon-speedometer' });
      }

      var menuChild = [];

      menuChild.push({ href: '/analiseJornada', title: 'Análise', icon: 'icon-note' });
      menuChild.push({ href: '/gestaoJornada', title: 'Gestão Jornada', icon: 'icon-note' });
      menuChild.push({ href: '/analiseJornadaTabela', title: 'Análise Tabela', icon: 'icon-note' });

      if (this.$auth.check('P106')) {
        menu_.push({ title: 'Jornada', icon: 'icon-note', child: menuChild });
      }

      if (this.$auth.check('P110')) {
        var menuChildJC = [];

        menuChildJC.push({ href: '/analiseJornadaConvencao', title: 'Análise Convenção', icon: 'icon-note' });
        menuChildJC.push({ href: '/gestaoJornadaConvencao', title: 'Gestão Jornada Convenção', icon: 'icon-note' });

        if (this.$auth.check('P106')) {
          menu_.push({ title: 'Jornada Convenção', icon: 'icon-note', child: menuChildJC });
        }
      }
      if (this.$auth.check('P118')) {
        var _menuChildJC = [];

        _menuChildJC.push({ href: '/analiseJornadaTabela', title: 'Análise Tabela', icon: 'icon-note' });

        if (this.$auth.check('P118')) {
          menu_.push({ title: 'Jornada Tabela', icon: 'icon-note', child: _menuChildJC });
        }
      }
      var menuChildC = [];
      if (this.$auth.check('P110')) {
        menuChildC.push({ href: '/convencoes', title: 'Convenções', icon: 'icon-note' });
      }
      if (this.$auth.check('P110')) {
        menuChildC.push({ href: '/eventos', title: 'Eventos', icon: 'icon-note' });
      }

      if (this.$auth.check('P113')) {
        menuChildC.push({ href: '/motoristas', title: 'Motoristas', icon: 'icon-note' });
      }
      if (this.$auth.check('P114')) {
        menuChildC.push({ href: '/veiculos', title: 'Veículos', icon: 'icon-note' });
      }
      if (this.$auth.check('P108')) {
        menu_.push({ title: 'Cadastros', icon: 'icon-note', child: menuChildC });
      }
      this.menu = menu_;
    }
  }
};

/***/ }),

/***/ "jlLR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosMotorista.buscas,
        pagina: this.$store.state.filtrosMotorista.pagina,
        quantidade: this.$store.state.filtrosMotorista.quantidade,
        status: this.$store.state.filtrosMotorista.status
      },
      relatorios: {
        tipo: 0,
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes('')
      },
      selecionada: '0',
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10,
      showModalRelatorios: false,
      isLoading: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosMotorista.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_MOTORISTA', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/motoristas?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/motoristas/editar/' + id);
    },
    relatoriosModal: function relatoriosModal() {
      this.showModalRelatorios = true;
    },
    imprimirRelatorios: function imprimirRelatorios() {
      var self = this;
      self.isLoading = true;

      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/motoristas/relatorio?tipo=' + self.relatorios.tipo + '&dataInicial=' + self.relatorios.dataInicial + '&dataFinal=' + self.relatorios.dataFinal;
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.isLoading = false;
      });
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Motorista?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/motoristas/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Motorista deletado com sucesso.', 'Atenção');
              url = '/api/motoristas?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Motorista está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "k/fU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.cidade))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("CEP: "+_vm._s(data.cep))]),_vm._v("  "),_c('small',[_vm._v("Estado: "+_vm._s(data.estado))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "k9zN":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalDividirTempo: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: ''
    };
  },

  created: function created() {
    this.buscar();
    this.buscarItens();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornada = dados;
      });
    },
    buscarItens: function buscarItens() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornadaItens = dados;
      });
    },
    mudarMotorista: function mudarMotorista() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotorista = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.motoristaId = motorista.id;
      this.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    showDividirTempo: function showDividirTempo(jornadaId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/buscarJornadaItem&id=' + jornadaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        self.showModalDividirTempo = true;
      }).catch(function (error) {
        console.log(error);
      });
    },
    gravarDividirTempo: function gravarDividirTempo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + this.$route.params.id + '&dataHoraInicio=' + self.divisao.dataHoraInicio + '&dataHoraFinal=' + self.divisao.dataHoraFinal + '&dataHoraDuracao=' + self.divisao.dataHoraDuracao + '&motivo=' + self.divisao.motivo + '&observacao=' + self.divisao.observacao + '&status=' + self.divisao.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    salvar: function salvar() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.jornada), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.$router.replace('/gestaoJornada');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ "kJiG":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _formFile = __webpack_require__("9NuQ");

var _formFile2 = _interopRequireDefault(_formFile);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _formFile2.default;

/***/ }),

/***/ "kNln":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__ = __webpack_require__("wOYj");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35618d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__ = __webpack_require__("KnvL");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_navbar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_35618d50_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_navbar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "kOYZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-monetario',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: 'R$ ',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: ',',
      affixesStay: true
    });
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  },
  destroyed: function destroyed() {
    $(this.$el).off().maskMoney('destroy');
  }
};
module.exports = vm;

/***/ }),

/***/ "kc16":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.ncm))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.descricao))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "koM4":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row linha-monitoramento"},[(_vm.showModalConfirmarGravacao)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('span',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.mensagemConfirmarGravacao)}}),_c('br'),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticClass:"text-center",domProps:{"innerHTML":_vm._s(_vm.mensagemConfirmarGravacaoQuantidade)}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('a',{staticClass:"text-danger",attrs:{"href":"#"},on:{"click":function($event){_vm.showModalConfirmarGravacao = false}}},[_c('strong',[_vm._v("Fechar")])])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-md-3 coluna-monitoramento-veiculos"},[_c('div',{attrs:{"id":"listaVeiculosMonitoramento"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 text-center"},[_c('div',{staticClass:"card card-monitoramento"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"btn-group btn-block"},[_c('button',{staticClass:"btn btn-danger btn-block",attrs:{"type":"button","data-toggle":"dropdown","aria-haspopup":"true","aria-expanded":"false"}},[_vm._v("\n                    Ferramentas de Cadastro\n                  ")]),_vm._v(" "),_c('div',{staticClass:"dropdown-menu"},[_c('a',{staticClass:"dropdown-item",on:{"click":function($event){_vm.mostrarCadastroPonto()}}},[_c('i',{staticClass:"fas fa-map-marker"}),_vm._v("Cadastro de Pontos")]),_vm._v(" "),_c('div',{staticClass:"dropdown-divider"})])])])]),_vm._v(" "),(_vm.showCardPonto)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v("Pontos")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","right":"8px","font-size":"20px"},on:{"click":function($event){_vm.showCardPonto = false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.descricao),expression:"ponto.descricao"}],staticClass:"form-control",attrs:{"placeholder":"Descrição do ponto","type":"text"},domProps:{"value":(_vm.ponto.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ponto, "descricao", $event.target.value)}}})]),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.clienteId),expression:"ponto.clienteId"}],attrs:{"type":"hidden","id":"pontoClienteId"},domProps:{"value":(_vm.ponto.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.ponto, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"pontoClienteNome","name":"pontoClienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarClientePonto,"on-blur":_vm.verificarClientePonto},model:{value:(_vm.ponto.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.ponto, "clienteNomeFantasia", $$v)},expression:"ponto.clienteNomeFantasia"}})],1)]:_vm._e(),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Tipo do Ponto")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.ponto.pontoTipoId),expression:"ponto.pontoTipoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.ponto, "pontoTipoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.pontosTipos),function(pontoTipo){return _c('option',{attrs:{"selected":""},domProps:{"value":pontoTipo.id}},[_vm._v(_vm._s(pontoTipo.descricao))])}))])]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.gravarPonto();}}},[(_vm.processando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gravar Ponto")])]),_vm._v(" "),_c('hr')],2)]):_vm._e(),_vm._v(" "),(_vm.showCardArea)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v("Áreas")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","right":"8px","font-size":"20px"},on:{"click":function($event){_vm.showCardArea = false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12 text-left"},[_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.area.descricao),expression:"area.descricao"}],staticClass:"form-control",attrs:{"placeholder":"Descrição do area","type":"text"},domProps:{"value":(_vm.area.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.area, "descricao", $event.target.value)}}}),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.area.tamanho),expression:"area.tamanho"}],staticClass:"form-control",attrs:{"placeholder":"Tamano em Metros","type":"text"},domProps:{"value":(_vm.area.tamanho)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.area, "tamanho", $event.target.value)}}}),_vm._v(" "),_c('label',[_vm._v("Tipo da área")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.area.tipo),expression:"area.tipo"}],staticClass:"form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.area, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Área geral")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("Vinculada a veículo")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.gravarArea();}}},[_vm._v("Gravar Área")])])])]):_vm._e(),_vm._v(" "),(_vm.showCardRota)?_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"row"},[_c('h4',[_vm._v("Rotas")]),_vm._v(" "),_c('span',{staticStyle:{"position":"absolute","right":"8px","font-size":"20px"},on:{"click":function($event){_vm.showCardRota = false}}},[_c('i',{staticClass:"fas fa-times"})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Origem:")]),_vm._v(" "),_c('gmap-autocomplete',{staticClass:"form-control",attrs:{"placeholder":"Origem"},on:{"place_changed":_vm.setRotaOrigem}}),_vm._v(" "),_c('label',[_vm._v("Destino:")]),_vm._v(" "),_c('gmap-autocomplete',{staticClass:"form-control",attrs:{"placeholder":"Origem"},on:{"place_changed":_vm.setRotaDestino}}),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.buscarRota();}}},[_vm._v("Buscar Rota")]),_vm._v(" "),_c('label',[_vm._v("Descrição")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.rota.descricao),expression:"rota.descricao"}],staticClass:"form-control",attrs:{"placeholder":"Descrição da rota","type":"text"},domProps:{"value":(_vm.rota.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.rota, "descricao", $event.target.value)}}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.gravarRota();}}},[_vm._v("Gravar Rota")])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.removerMarkers();_vm.removerLugares();_vm.limparSelecionados()}}},[_vm._v("Limpar Mapa")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.adicionarMarkers()}}},[_vm._v("Todos Mapa")])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.atualizarGrid),expression:"atualizarGrid"}],staticClass:"form-control",on:{"change":[function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.atualizarGrid=$event.target.multiple ? $$selectedVal : $$selectedVal[0]},_vm.startInterval]}},[_c('option',{attrs:{"value":"0"}},[_vm._v("Não Atualizar Mapa")]),_vm._v(" "),_c('option',{attrs:{"value":"300000"}},[_vm._v("5 Minutos")]),_vm._v(" "),_c('option',{attrs:{"value":"180000"}},[_vm._v("3 Minutos")]),_vm._v(" "),_c('option',{attrs:{"value":"60000"}},[_vm._v("1 Minuto")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","placeholder":"Filtrar veículo","type":"text"},domProps:{"value":(_vm.busca)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.limparSelecionados(),_vm.buscarGrid(),_vm.buscarGridAlertaRoubo()},"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":function($event){_vm.limparSelecionados(),_vm.buscarGrid(),_vm.buscarGridAlertaRoubo()}}},[_vm._v("Buscar")])])])])])]),_vm._v(" "),_c('div',{attrs:{"id":"dados-monitoramento-lista-veiculos"}},[(_vm.dadosGridAlertaRoubo.length > 0)?[_c('div',[_c('span',{staticStyle:{"color":"#ff5454 !important","font-weight":"bold","font-size":"22px"}},[_vm._v("ALERTA DE ROUBO")]),_c('span',{class:{ 'plus-cross-add plus-cross-rotate': !_vm.showVeiculosAlertaRoubo, 'plus-cross-add': _vm.showVeiculosAlertaRoubo },staticStyle:{"position":"relative","float":"right","right":"8px","font-size":"20px"},on:{"click":function($event){_vm.showVeiculosAlertaRoubo = !_vm.showVeiculosAlertaRoubo}}},[_c('i',{staticClass:"fas fa-times"})])]),_vm._v(" "),(_vm.showVeiculosAlertaRoubo)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dadosGridAlertaRoubo),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(grid.descricaoVeiculo))])])]),_vm._v(" "),(_vm.selecionados.includes(grid.idVeiculo))?[_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remover do Mapa'),expression:"'Remover do Mapa'"}],staticClass:"text-danger",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.adicionarMarker(grid, true)}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]:[_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Adicionar no Mapa'),expression:"'Adicionar no Mapa'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.adicionarMarker(grid, true)}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]],2)])})],2)]:_vm._e()]:_vm._e(),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.dadosGrid),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosGrid[i].clienteIdVeiculo != _vm.dadosGrid[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))])]),_vm._v(" "),(_vm.selecionados.includes(grid.idVeiculo))?[_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Remover do Mapa'),expression:"'Remover do Mapa'"}],staticClass:"text-danger",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.adicionarMarker(grid, true)}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]:[_c('td',[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Adicionar no Mapa'),expression:"'Adicionar no Mapa'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.adicionarMarker(grid, true)}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])])]],2)],2)})],2)],2)])]),_vm._v(" "),_c('div',{staticClass:"col-md-9 coluna-monitoramento"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-10"},[_c('gmap-autocomplete',{staticClass:"form-control",attrs:{"id":"buscarLocal","placeholder":"Buscar local.."},on:{"place_changed":_vm.setPlace}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.usePlace}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"100%  height: calc(100vh - 58px)"},attrs:{"center":_vm.center,"zoom":4}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position,"icon":{
          //path: 'M 16, 1.14, 21, 2.1, 25, 4.2, 28, 7.4, 30, 11.3, 30.6, 15.74, 25.85, 26.49, 21.02, 31.89, 15.92, 43.86, 10.92, 31.89, 5.9, 26.26, 1.4, 15.74, 2.1, 11.3, 4, 7.4, 7.1, 4.2, 11, 2.1, 16, 1.14 ',
          path: 'M 0, 0, -10, -10, -10, -35, 180, -35, 180, -10 10, -10, 0, 0',
          fillColor: 'white',
          fillOpacity: 1,
          scale: .9,
          strokeColor: 'gray',
          strokeWeight: 1,
          labelOrigin: {x: 80, y: -22}
        },"label":{
          color: 'black',
          strokeColor: 'black',
          strokeWeight: 8,
          fillColor: '#FFF',
          fontSize: '12px',
          text: m.descricao,
          labelOrigin: {x: 0, y: 60}
        }},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),_vm._l((_vm.areas),function(pin,index){return _c('gmap-circle',{key:index,attrs:{"center":pin.position,"radius":parseInt(_vm.area.tamanho),"visible":true,"options":{fillColor:'#ffa726', fillOpacity:0.5, strokeColor:'#ba791a',strokeWeight:3}}})})],2)],1)])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"success-checkmark"},[_c('div',{staticClass:"check-icon"},[_c('span',{staticClass:"icon-line line-tip"}),_vm._v(" "),_c('span',{staticClass:"icon-line line-long"}),_vm._v(" "),_c('div',{staticClass:"icon-circle"}),_vm._v(" "),_c('div',{staticClass:"icon-fix"})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_vm._v("Tamnho área "),_c('small',[_vm._v("   (em metros)")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}})])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "kvsw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__ = __webpack_require__("61q0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4691cfe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__ = __webpack_require__("6Ucv");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Login_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4691cfe3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Login_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "l9zi":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"dados-formulario-tab"}},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 pull-right"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoCliente","to":"/eventos"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n\t\t\t\t\t\t\t\t")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"tabbable"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tabGeral"}},[_c('div',{staticClass:"dados_form"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Cliente:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.clienteId),expression:"model.clienteId"}],attrs:{"type":"hidden","id":"clienteId"},domProps:{"value":(_vm.model.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('buscar-cliente',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],attrs:{"id":"clienteNome","name":"clienteNome","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"required":true,"errors":_vm.errors.has('clienteNome'),"on-select":_vm.setarCliente,"on-blur":_vm.verificarCliente},model:{value:(_vm.model.clienteNomeFantasia),callback:function ($$v) {_vm.$set(_vm.model, "clienteNomeFantasia", $$v)},expression:"model.clienteNomeFantasia"}})],1)])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Nome:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label",attrs:{"id":"label-documento"}},[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.descricao),expression:"model.descricao"}],staticClass:"pula form-control",attrs:{"rows":"3"},domProps:{"value":(_vm.model.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "descricao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Ativo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ativo),expression:"model.ativo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Data Hora Inicio:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataHoraInicio),callback:function ($$v) {_vm.$set(_vm.model, "dataHoraInicio", $$v)},expression:"model.dataHoraInicio"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',{staticClass:"control-label"},[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"pula data form-control",model:{value:(_vm.model.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.model, "dataHoraFinal", $$v)},expression:"model.dataHoraFinal"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Monitorado Pela Central:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.monitoradoPelaCentral),expression:"model.monitoradoPelaCentral"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "monitoradoPelaCentral", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_c('label',[_vm._v("Todos Veiculos:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.todosVeiculos),expression:"model.todosVeiculos"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "todosVeiculos", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])])])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Motorista")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ul',{staticClass:"nav nav-tabs"},[_c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tabGeral","data-toggle":"tab"}},[_vm._v("Geral")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lCdO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotorista)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.motoristaId),expression:"motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.motoristaId=$event.target.value}}}),_vm._v(" "),_c('buscar-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.motoristaNome),callback:function ($$v) {_vm.motoristaNome=$$v},expression:"motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotorista}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotorista = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalMudarMotivo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{staticClass:"pula form-control",attrs:{"id":"modalItemId","type":"hidden","required":"required"}}),_vm._v(" "),(_vm.selecionada === '' || _vm.selecionada === '0')?[_vm._m(3),_c('br')]:_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.mudarMotivoId),expression:"mudarMotivoId"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.mudarMotivoId=$event.target.multiple ? $$selectedVal : $$selectedVal[0]}}},[_c('option',{attrs:{"value":"03"}},[_vm._v("03 - Espera")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04 - Alimentacao")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05 - Descanso Direcao")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11 - Transito")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("34 - Em Atividade")])])])])],2),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.mudarMotivo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMudarMotivo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalDividirTempo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(4),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{staticClass:"pula form-control",attrs:{"id":"modalItemIdManual","type":"hidden","required":"required","value":"551058"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Inicio:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraInicioControleManual),expression:"dividirTempo.dataHoraInicioControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.dividirTempo.dataHoraInicioControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraInicioControleManual", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraInicio),expression:"dividirTempo.dataHoraInicio"}],staticClass:"pula dataHora form-control",attrs:{"required":"required","readonly":"readonly"},domProps:{"value":(_vm.dividirTempo.dataHoraInicio)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraInicio", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraFinalControleManual),expression:"dividirTempo.dataHoraFinalControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.dividirTempo.dataHoraFinalControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraFinalControleManual", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraFinal),expression:"dividirTempo.dataHoraFinal"}],staticClass:"pula dataHora form-control",attrs:{"required":"required"},domProps:{"value":(_vm.dividirTempo.dataHoraFinal)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraFinal", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Duração:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.dataHoraDuracao),expression:"dividirTempo.dataHoraDuracao"}],staticClass:"pula form-control",attrs:{"readonly":"readonly"},domProps:{"value":(_vm.dividirTempo.dataHoraDuracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "dataHoraDuracao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Status:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.statusVeiculo),expression:"dividirTempo.statusVeiculo"}],staticClass:"pula form-control",attrs:{"required":"required","disabled":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dividirTempo, "statusVeiculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"VEICULO PARADO"}},[_vm._v("VEICULO PARADO")]),_vm._v(" "),_c('option',{attrs:{"value":"VEICULO EM MOVIMENTO"}},[_vm._v("VEICULO EM MOVIMENTO")]),_vm._v(" "),_c('option',{attrs:{"value":"EM ATIVIDADE"}},[_vm._v("EM ATIVIDADE")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.motivo),expression:"dividirTempo.motivo"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.dividirTempo, "motivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"03"}},[_vm._v("03 - Espera")]),_vm._v(" "),_c('option',{attrs:{"value":"04"}},[_vm._v("04 - Alimentacao")]),_vm._v(" "),_c('option',{attrs:{"value":"05"}},[_vm._v("05 - Descanso Direcao")]),_vm._v(" "),_c('option',{attrs:{"value":"11"}},[_vm._v("11 - Transito")]),_vm._v(" "),_c('option',{attrs:{"value":"34"}},[_vm._v("34 - Em Atividade")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',{staticClass:"control-label"},[_vm._v("Observação:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.dividirTempo.observacao),expression:"dividirTempo.observacao"}],staticClass:"pula form-control",domProps:{"value":(_vm.dividirTempo.observacao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.dividirTempo, "observacao", $event.target.value)}}})])]),_vm._v(" "),_c('input',{attrs:{"id":"modalItemAutomaticoManual","type":"hidden","value":"false"}})]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gravarDividirTempo}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDividirTempo = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalAdicionarDiaria)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(5),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('input',{staticClass:"pula form-control",attrs:{"id":"modalItemIdManual","type":"hidden","required":"required","value":"551058"}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Inicio:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adicionarDiaria.dataHoraInicioControleManual),expression:"adicionarDiaria.dataHoraInicioControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.adicionarDiaria.dataHoraInicioControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adicionarDiaria, "dataHoraInicioControleManual", $event.target.value)}}}),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"pula dataHora form-control",attrs:{"required":"required","readonly":"readonly"},model:{value:(_vm.adicionarDiaria.dataHoraInicio),callback:function ($$v) {_vm.$set(_vm.adicionarDiaria, "dataHoraInicio", $$v)},expression:"adicionarDiaria.dataHoraInicio"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adicionarDiaria.dataHoraFinalControleManual),expression:"adicionarDiaria.dataHoraFinalControleManual"}],staticClass:"pula dataHora form-control",attrs:{"type":"hidden"},domProps:{"value":(_vm.adicionarDiaria.dataHoraFinalControleManual)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adicionarDiaria, "dataHoraFinalControleManual", $event.target.value)}}}),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"pula dataHora form-control",attrs:{"required":"required","readonly":"readonly"},model:{value:(_vm.adicionarDiaria.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.adicionarDiaria, "dataHoraFinal", $$v)},expression:"adicionarDiaria.dataHoraFinal"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Duração:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.adicionarDiaria.dataHoraDuracao),expression:"adicionarDiaria.dataHoraDuracao"}],staticClass:"pula form-control",attrs:{"readonly":"readonly"},domProps:{"value":(_vm.adicionarDiaria.dataHoraDuracao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.adicionarDiaria, "dataHoraDuracao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Status:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.adicionarDiaria.statusVeiculo),expression:"adicionarDiaria.statusVeiculo"}],staticClass:"pula form-control",attrs:{"required":"required","disabled":"true"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.adicionarDiaria, "statusVeiculo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"VEICULO PARADO"}},[_vm._v("VEICULO PARADO")]),_vm._v(" "),_c('option',{attrs:{"value":"VEICULO EM MOVIMENTO"}},[_vm._v("VEICULO EM MOVIMENTO")]),_vm._v(" "),_c('option',{attrs:{"value":"EM ATIVIDADE"}},[_vm._v("EM ATIVIDADE")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.adicionarDiaria.motivo),expression:"adicionarDiaria.motivo"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.adicionarDiaria, "motivo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{domProps:{"value":'34'}},[_vm._v("34 - Em Atividade")])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gravarAdicionarDiaria}},[_vm._v("Gravar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalAdicionarDiaria = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":12,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_vm._m(6),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('input',{staticClass:"btn btn-primary",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Mudar Motivo"},on:{"click":_vm.mudarMotivoModal}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/gestaoJornada"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n              ")])],1)]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Data: ")]),_vm._v("De: "+_vm._s(_vm.jornada.dataHoraInicial)+" até "+_vm._s(_vm.jornada.dataHoraFinal)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.jornada.veiculoDescricao)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(" "+_vm._s(_vm.jornada.motoristaNome)),_c('br'),_vm._v(" "),_c('a',{attrs:{"href":"#"}},[_c('span',{on:{"click":function($event){_vm.showModalMudarMotorista = true}}},[_vm._v("Mudar motorista")])])])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(7),_vm._v(" "),_vm._l((_vm.jornadaItens),function(grid,i){return _c('tbody',[_c('tr',{class:{ 'selecionado': _vm.selecionado(grid), 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') },on:{"click":function($event){_vm.selecionarItem(grid, $event)}}},[_c('td',{attrs:{"width":"140"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraInicio)),_c('br'),_vm._v(_vm._s(grid.dataHoraFinal))])]),_vm._v(" "),_c('td',{attrs:{"width":"85"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))]),_vm._v(" "),(grid.statusVeiculo === 'VEICULO EM MOVIMENTO')?[_c('small',[_vm._v(" - "+_vm._s(_vm.formatarVelocidadeMetros(grid.kmRodados))+" metros ")])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',{attrs:{"width":"150"}},[_c('small',[_vm._v(_vm._s(grid.observacao))])]),_vm._v(" "),_c('td',{staticClass:"text-right"},[(grid.statusVeiculo === 'VEICULO PARADO' || grid.statusVeiculo === 'EM DIARIA')?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Adicionar Macro'),expression:"'Adicionar Macro'"}],attrs:{"href":"#"},on:{"click":function($event){_vm.showAdicionarDiaria(grid.id)}}},[_c('img',{attrs:{"src":"/static/images/adicionar.png"}})])]:_vm._e(),_vm._v(" "),(grid.statusVeiculo === 'VEICULO PARADO')?[(grid.latitude !== '' && grid.latitude !== '0.0;')?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Ver Mapa'),expression:"'Ver Mapa'"}],attrs:{"href":"#"},on:{"click":function($event){_vm.visualizarMapa(grid)}}},[_c('img',{attrs:{"src":"/static/images/ponto.png"}})])]:_vm._e()]:_vm._e(),_vm._v(" "),(grid.statusVeiculo === 'VEICULO PARADO' || grid.statusVeiculo === 'EM DIARIA')?[_c('a',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"href":"#"},on:{"click":function($event){_vm.showDividirTempo(grid.id)}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])]:_vm._e()],2)])])})],2),_vm._v(" "),_vm._m(8),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(9),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoJornada)+" ")]),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(10),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDiaria)+" ")]),_c('br')]),_vm._v(" "),_vm._m(11),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoEmEspera)+" ")]),_c('br')]),_vm._v(" "),_vm._m(12),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoDescansoDirecao)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAlimentacao)+" ")]),_c('br')]),_vm._v(" "),_vm._m(13),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoAdicionalNoturno)+" ")]),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal1)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna1)+" ")]),_c('br'),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNormal2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtraNoturna2)+" ")]),_c('br'),_vm._v(" "),_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraExtras)+" ")]),_c('br')])]),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(14),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraTrabalhada)+" ")]),_c('br')]),_vm._v(" "),_vm._m(15),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraIndenizada)+" ")]),_c('br')]),_vm._v(" "),_vm._m(16),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('strong',[_vm._v(" "+_vm._s(_vm.jornada.tempoHoraDescanso)+" ")]),_c('br')]),_vm._v(" "),_c('div',{staticClass:"col-md-3 text-right"})])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motorista")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Mudar Motivo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"modalMudarMotivoMensagem"}},[_vm._v("Não foi selecionado um lançamento"),_c('br'),_vm._v(" Serão trocados todos os lançamentos sem Motivos.")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dividir Tempo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Adicionar Diária")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Jornada")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")]),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4 text-center"}),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-center"},[_c('br'),_c('h5',[_c('strong',[_vm._v("TOTAIS")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-4 text-center"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Tempo em Jornada: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Direção: "),_c('br'),_vm._v("\n              Em Atividade: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Em Espera: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Descanso de Direção: "),_c('br'),_vm._v("\n              Alimentação: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Adicional Noturno: "),_c('br'),_c('br'),_vm._v("\n              H. E. 1° Estágio Diurno:"),_c('br'),_vm._v("\n              H. E. 1° Estágio Noturno:"),_c('br'),_c('br'),_vm._v("\n              H. E. 2° Estágio Diurno:"),_c('br'),_vm._v("\n              H. E. 2° Estágio Noturno:"),_c('br'),_vm._v("\n              Total de Hora Extra:"),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Trabalhando: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Indenizada: "),_c('br')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-2 text-right"},[_vm._v("\n              Total Descanso: "),_c('br')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "lQJf":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-monetario-10',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: 'R$ ',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: ',',
      affixesStay: true,
      precision: 10
    });
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  },
  destroyed: function destroyed() {
    $(this.$el).off().maskMoney('destroy');
  }
};
module.exports = vm;

/***/ }),

/***/ "m1Is":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue__ = __webpack_require__("cm6r");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8b2e86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontosEditar_vue__ = __webpack_require__("ZFBM");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_PontosEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d8b2e86_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_PontosEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "m2EB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  ready: function ready() {},
  beforeDestroy: function beforeDestroy() {}
};

/***/ }),

/***/ "m2dh":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        dataInicial: this.$store.state.filtrosGestaoJornada.dataInicial === '' ? this.primeiroDiaMes('') : this.$store.state.filtrosGestaoJornada.dataInicial,
        dataFinal: this.$store.state.filtrosGestaoJornada.dataFinal === '' ? this.ultimoDiaMes('') : this.$store.state.filtrosGestaoJornada.dataFinal,
        buscas: this.$store.state.filtrosGestaoJornada.buscas,
        status: this.$store.state.filtrosGestaoJornada.status
      },
      jornada: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: '',
        veiculoId: '0',
        veiculoDescricao: '',
        tipoJornada: '1'
      },
      relatorio: {
        tipo: '1',
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        motoristaId: '0',
        motoristaNome: ''
      },
      dadosTabela: [],
      selecionadas: [],
      selecionada: '',
      processando: false,
      botaoProcessando: false,
      showModalNovaJornada: false,
      showModalRelatorioSintetico: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosVeiculo.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
    this.buscar();
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item;
      if (event.ctrlKey || event.metaKey) {
        this.selecionadas.push(item);
      } else {
        this.selecionadas = [];
        this.selecionadas.push(item);
      }
    },
    selecionado: function selecionado(item) {
      for (var i = 0; i < this.selecionadas.length; i++) {
        if (this.selecionadas[i].id === item.id) {
          return true;
        }
      }
      return false;
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar() {
      var self = this;
      this.$store.commit('SET_FILTROS_GESTAO_JORNADA', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.processando = false;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/gestaoJornada/editar/' + id);
    },
    juntarJornada: function juntarJornada(id) {
      var _this = this;

      var self = this;
      if (self.selecionadas.length !== 2) {
        self.$toastr('error', 'Selecione duas Jornadas para Combinar.', 'Atenção');
        return;
      }
      var message = 'Deseja realmente combinar essas Jornadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/juntarJornada?jornadaUmId=' + self.selecionadas[0].id + '&jornadaDoisId=' + self.selecionadas[1].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas combinadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao combinar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    duplicarJornada: function duplicarJornada(id) {
      var _this2 = this;

      var self = this;
      if (self.selecionadas.length === 0) {
        return;
      }
      if (self.selecionadas.length > 1) {
        return;
      }
      var message = 'Deseja realmente duplicar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this2.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/duplicar?id=' + self.selecionadas[0].id;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornada duplicada com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao duplicar a Jornada', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    deletarMultiplas: function deletarMultiplas(id) {
      var _this3 = this;

      var self = this;
      var message = 'Deseja realmente deletar todas as Jornada listadas?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        var config = {
          headers: { 'Authorization': 'Bearer ' + _this3.$store.state.token }
        };
        self.processando = true;
        var url = '/api/gestaoJornadas/deletarMultiplas?buscas=' + _this3.filtros.buscas + '&dataInicial=' + _this3.filtros.dataInicial + '&dataFinal=' + _this3.filtros.dataFinal + '&status=' + _this3.filtros.status;
        _axios2.default.get(url, config).then(function (response) {
          self.processando = false;
          if (response.data === 'OK') {
            self.$toastr('success', 'Jornadas deletadas com sucesso.', 'Atenção');
            self.buscar();
            dialog.close();
          } else {
            self.$toastr('error', 'Erro ao deletar as Jornadas', 'Atenção');
            dialog.close();
          }
        });
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.relatorio.motoristaId = motorista.id;
      this.relatorio.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.relatorio.motoristaId = 0;
        this.relatorio.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    setarMotoristaNovaJornada: function setarMotoristaNovaJornada(motorista) {
      this.jornada.motoristaId = motorista.id;
      this.jornada.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNovaJornadaNome').val(motorista.nome);
    },
    verificarMotoristaNovaJornada: function verificarMotoristaNovaJornada() {
      if ($(this.$el).find('#motoristaNovaJornadaId').val() === '0') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
      if ($(this.$el).find('#motoristaNovaJornadaNome').val() === '') {
        this.jornada.motoristaId = 0;
        this.jornada.motoristaNome = '';
        $(this.$el).find('#motoristaNovaJornadaId').val(0);
        $(this.$el).find('#motoristaNovaJornadaNome').val('');
      }
    },
    setarVeiculoNovaJornada: function setarVeiculoNovaJornada(veiculo) {
      this.jornada.veiculoId = veiculo.idVeiculo;
      this.jornada.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoNovaJornadaDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculoNovaJornada: function verificarVeiculoNovaJornada() {
      if ($(this.$el).find('#veiculoNovaJornadaId').val() === '0') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
      if ($(this.$el).find('#veiculoNovaJornadaDescricao').val() === '') {
        this.jornada.veiculoId = 0;
        this.jornada.veiculoDescricao = '';
        $(this.$el).find('#veiculoNovaJornadaId').val(0);
        $(this.$el).find('#veiculoNovaJornadaDescricao').val('');
      }
    },
    imprimir: function imprimir(id) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarRelatorioSintetico: function gerarRelatorioSintetico(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '';
      if (this.relatorio.tipo === 1 || this.relatorio.tipo === '1') {
        url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      } else {
        url = '/api/gestaoJornadas/imprimirJornadaSinteticaHorario?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      }
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
        self.botaoProcessando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarNovaJornada: function gerarNovaJornada(e) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/novo?dataHoraInicio=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId + '&tipoJornada=' + this.jornada.tipoJornada;
      _axios2.default.get(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.showModalNovaJornada = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    gerarJornadaAjudante: function gerarJornadaAjudante(jornada, ajudante) {
      var self = this;
      self.processando = true;
      self.botaoProcessando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/gravarJornadaAjudante?jornada=' + jornada + '&ajudante=' + ajudante;
      _axios2.default.get(url, config).then(function (response) {
        self.processando = false;
        self.botaoProcessando = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
        self.botaoProcessando = false;
      });
    },
    deletar: function deletar(id) {
      var _this4 = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this4.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/gestaoJornadas/deletar?id=' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção');
              self.buscar();
              dialog.close();
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "mHzP":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosEvento.buscas,
        pagina: this.$store.state.filtrosEvento.pagina,
        quantidade: this.$store.state.filtrosEvento.quantidade,
        status: this.$store.state.filtrosEvento.status
      },
      relatorios: {
        tipo: 0,
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes('')
      },
      selecionada: '0',
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10,
      showModalRelatorios: false,
      isLoading: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosEvento.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_CLIENTE', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/eventos?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/eventos/editar/' + id);
    },
    relatoriosModal: function relatoriosModal() {
      this.showModalRelatorios = true;
    },
    imprimirRelatorios: function imprimirRelatorios() {
      var self = this;
      self.isLoading = true;

      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/eventos/relatorio?tipo=' + self.relatorios.tipo + '&dataInicial=' + self.relatorios.dataInicial + '&dataFinal=' + self.relatorios.dataFinal;
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.isLoading = false;
      });
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Evento?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/eventos/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Evento deletado com sucesso.', 'Atenção');
              url = '/api/eventos?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Evento está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "mx+7":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalMudarMotivo: false,
      showModalDividirTempo: false,
      dividirTempo: {
        id: '0',
        dataHoraInicio: '',
        dataHoraInicioManual: '',
        dataHoraInicioControleManual: '',
        dataHoraFinal: '',
        dataHoraFinalManual: '',
        dataHoraFinalControleManual: '',
        dataHoraDuracao: '',
        statusVeiculo: '',
        motivo: '03',
        tipoMotivo: '',
        observacao: ''
      },
      showModalMapa: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: '',
      mudarMotivoId: '0',
      selecionada: '0',
      selecionados: [],
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      places: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  created: function created() {
    this.buscar();
    this.buscarItens();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        this.selecionados = [];
        this.selecionados.push(item);
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornada = dados;
      });
    },
    buscarItens: function buscarItens() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornadaItens = dados;
      });
    },
    mudarMotorista: function mudarMotorista() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotorista = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    mudarMotivoModal: function mudarMotivoModal() {
      var self = this;
      self.showModalMudarMotivo = true;
    },
    mudarMotivo: function mudarMotivo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '';
      if (self.selecionados.length === 0) {
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id;
      } else {
        var gestaoJornadaItemIds = '';
        for (var i = 0; i < self.selecionados.length; i++) {
          if (i === 0) {
            gestaoJornadaItemIds = self.selecionados[i].id;
          } else {
            gestaoJornadaItemIds = gestaoJornadaItemIds + ';' + self.selecionados[i].id;
          }
        }
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=' + gestaoJornadaItemIds + '&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id;
      }
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotivo = false;
          self.buscar();
          self.buscarItens();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.motoristaId = motorista.id;
      this.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    showDividirTempo: function showDividirTempo(jornadaId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/buscarJornadaItem?id=' + jornadaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        self.showModalDividirTempo = true;
        var dados = response.data;
        self.dividirTempo.id = dados.id;
        self.dividirTempo.dataHoraInicio = dados.dataHoraInicio;
        self.dividirTempo.dataHoraFinal = dados.dataHoraFinal;
        self.dividirTempo.dataHoraDuracao = dados.dataHoraDuracao;
        self.dividirTempo.statusVeiculo = dados.statusVeiculo;
        self.dividirTempo.motivo = dados.motivo;
        self.dividirTempo.tipoMotivo = dados.tipoMotivo;
        self.dividirTempo.observacao = dados.observacao;
      }).catch(function (error) {
        console.log(error);
      });
    },
    gravarDividirTempo: function gravarDividirTempo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + self.dividirTempo.id + '&dataHoraInicio=' + self.dividirTempo.dataHoraInicio + '&dataHoraFinal=' + self.dividirTempo.dataHoraFinal + '&dataHoraDuracao=' + self.dividirTempo.dataHoraDuracao + '&motivo=' + self.dividirTempo.motivo + '&observacao=' + self.dividirTempo.observacao + '&status=' + self.dividirTempo.statusVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalDividirTempo = false;
          self.buscar();
          self.buscarItens();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    visualizarMapa: function visualizarMapa(grid) {
      var self = this;
      self.showModalMapa = true;
      self.adicionarMarkers(grid);
    },
    adicionarMarkers: function adicionarMarkers(grid) {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      var latitudes = grid.latitude.split(';');
      var longitudes = grid.longitude.split(';');
      for (var i = 0; i < latitudes.length; i++) {
        if (latitudes[i] !== '') {
          var marker = {
            lat: parseFloat(latitudes[i]),
            lng: parseFloat(longitudes[i])
          };
          self.markers.push({ position: marker });
          self.center = { lat: marker.lat, lng: marker.lng };

          myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
          bounds = new window.google.maps.LatLngBounds();
          bounds.extend(myLatLng);
        }
      }
      self.$refs.map.fitBounds(bounds);
      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },

    salvar: function salvar() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.jornada), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.$router.replace('/gestaoJornada');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ "n5OU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"readonly":_vm.readonly,"autocomplete":"off","value":"","on-blur":_vm.verificarProduto},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[(_vm.tipoBusca === 'D')?[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("UN: "),_c('strong',[_vm._v(_vm._s(data.unidade))])]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.marca))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.grupo))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("Data: "),_c('strong',[_vm._v(_vm._s(data.vendaData))])]),_vm._v("  "),_c('small',[_vm._v("Venda:"),_c('strong',[_vm._v(_vm._s(data.vendaId))])]),_vm._v("  "),_c('small',[_vm._v("Quantidade Devolver: "),_c('strong',[_vm._v(_vm._s(data.quantidadeDevolver))])]),_vm._v("  "),_c('small',[_vm._v("Preço Padrão: "),_c('strong',[_vm._v(_vm._s(_vm.formatarMonetario(data.precoVendaPadrao)))])]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])]:[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nome))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("UN: "),_c('strong',[_vm._v(_vm._s(data.unidade))])]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.marca))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.grupo))]),_c('br'),_vm._v(" "),_c('small',[_vm._v("Saldo:"),_c('strong',[_vm._v(_vm._s(data.estoqueAtual))])]),_vm._v("  "),_c('small',[_vm._v("Comprometido: "),_c('strong',[_vm._v(_vm._s(data.estoqueComprometido))])]),_vm._v("  "),_c('small',[_vm._v("Total: "),_c('strong',[_vm._v(_vm._s(data.estoqueAtual - data.estoqueComprometido))])]),_vm._v("  "),_c('small',[_vm._v("Preço Padrão: "),_c('strong',[_vm._v(_vm._s(_vm.formatarMonetario(data.precoVendaPadrao)))])]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])]],2)}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "nHb0":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "nUSz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-texto',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "nUbX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"value":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ndIY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ng/p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__ = __webpack_require__("aGmC");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423d200e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__ = __webpack_require__("U9P9");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_423d200e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemPorMotoristaView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "nzKj":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue__ = __webpack_require__("jlLR");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4381f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MotoristasLista_vue__ = __webpack_require__("bICA");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0c4381f5_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MotoristasLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "o106":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "oUvO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__ = __webpack_require__("HP1X");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3629f814_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__ = __webpack_require__("VjHd");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Grid_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3629f814_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Grid_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "oVZj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-cnpj',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('99.999.999/9999-99');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('99.999.999/9999-99');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "ohNw":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-transportador',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,
    readonly: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#transportadorNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#transportadorNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarTransportadoresAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "oipo":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-cpf',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('999.999.999-99');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('999.999.999-99');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "p3ZX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input',{attrs:{"value":""}})}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "p698":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    }
  }
};

/***/ }),

/***/ "pO7K":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'botao-baixa-financeiro',
  props: {
    speed: {
      default: 20
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "pQpl":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sidebar"},[_c('nav',{staticClass:"sidebar-nav"},[_c('ul',{staticClass:"nav"},[_c('li',{staticClass:"nav-item",attrs:{"id":"menu-dashboard"}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/grid"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Home\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"id":"menu-dashboard"}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/dashboard"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Dashboard\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item",attrs:{"id":"menu-dashboard"}},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/monitoramento"}},[_c('i',{staticClass:"icon-speedometer"}),_vm._v(" Monitoramento\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"treeview"},[_vm._m(0),_vm._v(" "),_c('ul',{staticClass:"treeview-menu",staticStyle:{"display":"none"}},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"id":"menuCadastrosClientes","to":"/analiseJornada"}},[_c('i',{staticClass:"icon-note"}),_c('span',{staticClass:"menu-text"},[_vm._v("Análise")])])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"id":"menuCadastrosClientes","to":"/gestaoJornada"}},[_c('i',{staticClass:"icon-note"}),_c('span',{staticClass:"menu-text"},[_vm._v("Gestão Jornada")])])],1)])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/relatorios"}},[_c('i',{staticClass:"icon-calendar"}),_vm._v(" Relatórios\n        ")])],1),_vm._v(" "),_c('li',{staticClass:"divider"}),_vm._v(" "),_c('li',{staticClass:"treeview"},[_vm._m(1),_vm._v(" "),_c('ul',{staticClass:"treeview-menu",staticStyle:{"display":"none"}},[_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/motoristas"}},[_c('i',{staticClass:"icon-calendar"}),_vm._v(" Motoristas\n            ")])],1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('router-link',{staticClass:"nav-link",attrs:{"to":"/veiculos"}},[_c('i',{staticClass:"icon-calendar"}),_vm._v(" Veículos\n            ")])],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-note"}),_vm._v(" Jornada")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',{staticClass:"nav-link nav-dropdown-toggle",attrs:{"href":"#"}},[_c('i',{staticClass:"icon-note"}),_vm._v(" Cadastros")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pQzR":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default
  },
  data: function data() {
    return {
      model: {
        id: '0',
        ativo: true,
        nome: '',
        descricao: '',
        clienteId: '0',
        clienteNomeFantasia: '',
        dataHoraInicio: '',
        dataHoraFinal: '',
        monitoradoPelaCentral: false,
        todosVeiculos: false
      },
      processando: false
    };
  },

  created: function created() {
    this.buscar();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token, 'connection': 'keep-alive' }
      };
      var url = '/api/eventos/' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        console.log(response.data.nomeFantasia);
        var dados = response.data;
        self.model.id = dados.id;
        self.model.ativo = dados.ativo;
        self.model.nome = dados.nome;
        self.model.descricao = dados.descricao;
        if (dados.cliente !== null) {
          self.model.clienteId = dados.cliente.id;
          self.model.clienteNomeFantasia = dados.cliente.nomeFantasia;
        }

        self.model.dataHoraInicio = dados.dataHoraInicio;
        self.model.dataHoraFinal = dados.dataHoraFinal;
        self.model.monitoradoPelaCentral = dados.monitoradoPelaCentral;
        self.model.todosVeiculos = dados.todosVeiculos;
      });
    },
    setarCliente: function setarCliente(cliente) {
      this.model.clienteId = cliente.id;
      this.model.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#clienteNome').val(cliente.nomeFantasia);
    },
    verificarCliente: function verificarCliente() {
      if ($(this.$el).find('#clienteId').val() === '0') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
      if ($(this.$el).find('#clienteNome').val() === '') {
        this.model.clienteId = 0;
        this.model.clienteNome = '';
        $(this.$el).find('#clienteId').val(0);
        $(this.$el).find('#clienteNome').val('');
      }
    },
    adicionarContato: function adicionarContato() {
      var self = this;
      self.model.contatos.push({
        nome: '',
        telefone: '',
        email: ''
      });
    },
    removerContato: function removerContato(i) {
      var self = this;
      self.model.contatos.splice(i, 1);
    },
    salvar: function salvar() {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.model));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          var url = '/api/eventos/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.model), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Motorista gravado com sucesso.', 'Atenção');
              self.$router.replace('/eventos');
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    }
  }
};

/***/ }),

/***/ "pTu9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:((_vm.getClassName('wrapper')) + " autocomplete-wrapper")},[_c('input',{ref:"input",class:((_vm.getClassName('input')) + " autocomplete-input"),attrs:{"type":"text","id":_vm.id,"placeholder":_vm.placeholder,"name":_vm.name,"autocomplete":"off"},on:{"input":_vm.handleInput,"dblclick":_vm.handleDoubleClick,"blur":_vm.handleBlur,"keydown":_vm.handleKeyDown,"focus":_vm.handleFocus}}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.showList && _vm.json.length),expression:"showList && json.length"}],class:((_vm.getClassName('list')) + " autocomplete autocomplete-list")},[_c('ul',_vm._l((_vm.json),function(data,i){return _c('li',{class:_vm.activeClass(i)},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();_vm.selectList(data)},"mousemove":function($event){_vm.mousemove(i)}}},[_c('strong',[_vm._v(_vm._s(data.nomeFantasia))]),_c('br'),_vm._v(" "),_c('small',[_vm._v(_vm._s(data.nome))]),_vm._v(" - "),_c('small',[_vm._v(_vm._s(data.documento))]),_vm._v(" "),(_vm.onShouldRenderChild)?_c('div',{domProps:{"innerHTML":_vm._s(_vm.onShouldRenderChild(data))}}):_vm._e()])])}))])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "pnzP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue__ = __webpack_require__("V3kN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5557d039_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MotoristasEditar_vue__ = __webpack_require__("+j2k");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_MotoristasEditar_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_5557d039_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_MotoristasEditar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "preG":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__ = __webpack_require__("hQ4h");
/* empty harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5bf798c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__ = __webpack_require__("/J54");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_autocomplete_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__vue_loader_lib_template_compiler_index_id_data_v_e5bf798c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_vue_loader_lib_selector_type_template_index_0_autocomplete_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "q0df":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "q55J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"card-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n                "),_c('strong',[_vm._v("Odômetro do GPS: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{on:{"click":function($event){_vm.selecionarItem(dados)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])]),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "qvRI":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue__ = __webpack_require__("P/cy");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8d15a8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesNovoView_vue__ = __webpack_require__("z7My");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioDePosicoesNovoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f8d15a8c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioDePosicoesNovoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "qza3":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{attrs:{"id":"titulo"}},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('input',{staticClass:"btn btn-success",attrs:{"id":"botaoSalvar","type":"submit","value":"Salvar"},on:{"click":_vm.salvar}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"id":"btnNovoCliente","to":"/usuarios"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Fechar\n\t\t\t\t\t\t\t\t")])],1)])]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.id),expression:"model.id"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.id)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "id", $event.target.value)}}}),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-2"},[_c('label',[_vm._v("Ativo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.ativo),expression:"model.ativo"}],staticClass:"form-control pula custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.model, "ativo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"false","label":"Não"}},[_vm._v("Não")]),_vm._v(" "),_c('option',{attrs:{"value":"true","label":"Sim"}},[_vm._v("Sim")])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-10"},[_c('label',[_vm._v("Nome:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.model.nome),expression:"model.nome"}],class:{'input pula form-control': true, 'is-danger': _vm.errors.has('nome') },attrs:{"name":"nome","data-vv-delay":"500","required":"required","autofocus":"autofocus"},domProps:{"value":(_vm.model.nome)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "nome", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Login:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.login),expression:"model.login"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.login)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "login", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Senha:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.senha),expression:"model.senha"}],staticClass:"pula form-control",attrs:{"type":"password"},domProps:{"value":(_vm.model.senha)},on:{"change":_vm.modificarSenha,"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "senha", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.modificaSenha),expression:"model.modificaSenha"}],attrs:{"type":"hidden"},domProps:{"value":(_vm.model.modificaSenha)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "modificaSenha", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Departamento:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.departamento),expression:"model.departamento"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.departamento)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "departamento", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Empresa:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.empresa),expression:"model.empresa"}],staticClass:"pula form-control",domProps:{"value":(_vm.model.empresa)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.model, "empresa", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Sistema\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.acessar),expression:"model.permissoes.acessar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.acessar)?_vm._i(_vm.model.permissoes.acessar,null)>-1:(_vm.model.permissoes.acessar)},on:{"change":function($event){var $$a=_vm.model.permissoes.acessar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "acessar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "acessar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "acessar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ACESSAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuCadastros),expression:"model.permissoes.menuCadastros"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuCadastros)?_vm._i(_vm.model.permissoes.menuCadastros,null)>-1:(_vm.model.permissoes.menuCadastros)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuCadastros,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuCadastros", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuCadastros", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuCadastros", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTROS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuEstoque),expression:"model.permissoes.menuEstoque"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuEstoque)?_vm._i(_vm.model.permissoes.menuEstoque,null)>-1:(_vm.model.permissoes.menuEstoque)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuEstoque,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuEstoque", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuEstoque", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuEstoque", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ESTOQUE")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuBancos),expression:"model.permissoes.menuBancos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuBancos)?_vm._i(_vm.model.permissoes.menuBancos,null)>-1:(_vm.model.permissoes.menuBancos)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuBancos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuBancos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuBancos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuBancos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" BANCOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuFinanceiro),expression:"model.permissoes.menuFinanceiro"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuFinanceiro)?_vm._i(_vm.model.permissoes.menuFinanceiro,null)>-1:(_vm.model.permissoes.menuFinanceiro)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuFinanceiro,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuFinanceiro", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuFinanceiro", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuFinanceiro", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" FINANCEIRO")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuCheques),expression:"model.permissoes.menuCheques"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuCheques)?_vm._i(_vm.model.permissoes.menuCheques,null)>-1:(_vm.model.permissoes.menuCheques)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuCheques,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuCheques", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuCheques", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuCheques", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CHEQUES")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuCompras),expression:"model.permissoes.menuCompras"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuCompras)?_vm._i(_vm.model.permissoes.menuCompras,null)>-1:(_vm.model.permissoes.menuCompras)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuCompras,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuCompras", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuCompras", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuCompras", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" COMPRAS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuFiscal),expression:"model.permissoes.menuFiscal"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuFiscal)?_vm._i(_vm.model.permissoes.menuFiscal,null)>-1:(_vm.model.permissoes.menuFiscal)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuFiscal,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuFiscal", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuFiscal", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuFiscal", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" FISCAL")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.sintegra),expression:"model.permissoes.sintegra"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.sintegra)?_vm._i(_vm.model.permissoes.sintegra,null)>-1:(_vm.model.permissoes.sintegra)},on:{"change":function($event){var $$a=_vm.model.permissoes.sintegra,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "sintegra", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "sintegra", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "sintegra", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" SINTEGRA")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.sped),expression:"model.permissoes.sped"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.sped)?_vm._i(_vm.model.permissoes.sped,null)>-1:(_vm.model.permissoes.sped)},on:{"change":function($event){var $$a=_vm.model.permissoes.sped,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "sped", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "sped", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "sped", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" SPED")])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-12"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.configuracaoFiscalEditar),expression:"model.permissoes.configuracaoFiscalEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.configuracaoFiscalEditar)?_vm._i(_vm.model.permissoes.configuracaoFiscalEditar,null)>-1:(_vm.model.permissoes.configuracaoFiscalEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.configuracaoFiscalEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "configuracaoFiscalEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "configuracaoFiscalEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "configuracaoFiscalEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIGURACAO FISCAL")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuVendas),expression:"model.permissoes.menuVendas"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuVendas)?_vm._i(_vm.model.permissoes.menuVendas,null)>-1:(_vm.model.permissoes.menuVendas)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuVendas,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuVendas", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuVendas", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuVendas", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VENDAS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.configuracaoVendasEditar),expression:"model.permissoes.configuracaoVendasEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.configuracaoVendasEditar)?_vm._i(_vm.model.permissoes.configuracaoVendasEditar,null)>-1:(_vm.model.permissoes.configuracaoVendasEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.configuracaoVendasEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "configuracaoVendasEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "configuracaoVendasEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "configuracaoVendasEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIGURACAO VENDAS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.configuracaoVendasMobileEditar),expression:"model.permissoes.configuracaoVendasMobileEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.configuracaoVendasMobileEditar)?_vm._i(_vm.model.permissoes.configuracaoVendasMobileEditar,null)>-1:(_vm.model.permissoes.configuracaoVendasMobileEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.configuracaoVendasMobileEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "configuracaoVendasMobileEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "configuracaoVendasMobileEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "configuracaoVendasMobileEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIGURACAO VENDAS MOBILE")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.menuSistema),expression:"model.permissoes.menuSistema"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.menuSistema)?_vm._i(_vm.model.permissoes.menuSistema,null)>-1:(_vm.model.permissoes.menuSistema)},on:{"change":function($event){var $$a=_vm.model.permissoes.menuSistema,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "menuSistema", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "menuSistema", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "menuSistema", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" SISTEMA")])])])])])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Clientes\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.clientesCadastrar),expression:"model.permissoes.clientesCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.clientesCadastrar)?_vm._i(_vm.model.permissoes.clientesCadastrar,null)>-1:(_vm.model.permissoes.clientesCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.clientesCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "clientesCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "clientesCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "clientesCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.clientesEditar),expression:"model.permissoes.clientesEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.clientesEditar)?_vm._i(_vm.model.permissoes.clientesEditar,null)>-1:(_vm.model.permissoes.clientesEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.clientesEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "clientesEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "clientesEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "clientesEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.clientesExcluir),expression:"model.permissoes.clientesExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.clientesExcluir)?_vm._i(_vm.model.permissoes.clientesExcluir,null)>-1:(_vm.model.permissoes.clientesExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.clientesExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "clientesExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "clientesExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "clientesExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.clientesVisualizar),expression:"model.permissoes.clientesVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.clientesVisualizar)?_vm._i(_vm.model.permissoes.clientesVisualizar,null)>-1:(_vm.model.permissoes.clientesVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.clientesVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "clientesVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "clientesVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "clientesVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.clientesRelatorios),expression:"model.permissoes.clientesRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.clientesRelatorios)?_vm._i(_vm.model.permissoes.clientesRelatorios,null)>-1:(_vm.model.permissoes.clientesRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.clientesRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "clientesRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "clientesRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "clientesRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Fornecedores\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fornecedoresCadastrar),expression:"model.permissoes.fornecedoresCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fornecedoresCadastrar)?_vm._i(_vm.model.permissoes.fornecedoresCadastrar,null)>-1:(_vm.model.permissoes.fornecedoresCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fornecedoresCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fornecedoresCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fornecedoresCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fornecedoresCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fornecedoresEditar),expression:"model.permissoes.fornecedoresEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fornecedoresEditar)?_vm._i(_vm.model.permissoes.fornecedoresEditar,null)>-1:(_vm.model.permissoes.fornecedoresEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fornecedoresEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fornecedoresEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fornecedoresEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fornecedoresEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fornecedoresExcluir),expression:"model.permissoes.fornecedoresExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fornecedoresExcluir)?_vm._i(_vm.model.permissoes.fornecedoresExcluir,null)>-1:(_vm.model.permissoes.fornecedoresExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.fornecedoresExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fornecedoresExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fornecedoresExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fornecedoresExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fornecedoresVisualizar),expression:"model.permissoes.fornecedoresVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fornecedoresVisualizar)?_vm._i(_vm.model.permissoes.fornecedoresVisualizar,null)>-1:(_vm.model.permissoes.fornecedoresVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fornecedoresVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fornecedoresVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fornecedoresVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fornecedoresVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fornecedoresRelatorios),expression:"model.permissoes.fornecedoresRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fornecedoresRelatorios)?_vm._i(_vm.model.permissoes.fornecedoresRelatorios,null)>-1:(_vm.model.permissoes.fornecedoresRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.fornecedoresRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fornecedoresRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fornecedoresRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fornecedoresRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Transportadores\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.transportadoresCadastrar),expression:"model.permissoes.transportadoresCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.transportadoresCadastrar)?_vm._i(_vm.model.permissoes.transportadoresCadastrar,null)>-1:(_vm.model.permissoes.transportadoresCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.transportadoresCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "transportadoresCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "transportadoresCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "transportadoresCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.transportadoresEditar),expression:"model.permissoes.transportadoresEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.transportadoresEditar)?_vm._i(_vm.model.permissoes.transportadoresEditar,null)>-1:(_vm.model.permissoes.transportadoresEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.transportadoresEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "transportadoresEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "transportadoresEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "transportadoresEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.transportadoresExcluir),expression:"model.permissoes.transportadoresExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.transportadoresExcluir)?_vm._i(_vm.model.permissoes.transportadoresExcluir,null)>-1:(_vm.model.permissoes.transportadoresExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.transportadoresExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "transportadoresExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "transportadoresExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "transportadoresExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.transportadoresVisualizar),expression:"model.permissoes.transportadoresVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.transportadoresVisualizar)?_vm._i(_vm.model.permissoes.transportadoresVisualizar,null)>-1:(_vm.model.permissoes.transportadoresVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.transportadoresVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "transportadoresVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "transportadoresVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "transportadoresVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.transportadoresRelatorios),expression:"model.permissoes.transportadoresRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.transportadoresRelatorios)?_vm._i(_vm.model.permissoes.transportadoresRelatorios,null)>-1:(_vm.model.permissoes.transportadoresRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.transportadoresRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "transportadoresRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "transportadoresRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "transportadoresRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Veiculos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.veiculosCadastrar),expression:"model.permissoes.veiculosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.veiculosCadastrar)?_vm._i(_vm.model.permissoes.veiculosCadastrar,null)>-1:(_vm.model.permissoes.veiculosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.veiculosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "veiculosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "veiculosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "veiculosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.veiculosEditar),expression:"model.permissoes.veiculosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.veiculosEditar)?_vm._i(_vm.model.permissoes.veiculosEditar,null)>-1:(_vm.model.permissoes.veiculosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.veiculosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "veiculosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "veiculosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "veiculosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.veiculosExcluir),expression:"model.permissoes.veiculosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.veiculosExcluir)?_vm._i(_vm.model.permissoes.veiculosExcluir,null)>-1:(_vm.model.permissoes.veiculosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.veiculosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "veiculosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "veiculosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "veiculosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.veiculosVisualizar),expression:"model.permissoes.veiculosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.veiculosVisualizar)?_vm._i(_vm.model.permissoes.veiculosVisualizar,null)>-1:(_vm.model.permissoes.veiculosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.veiculosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "veiculosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "veiculosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "veiculosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.veiculosRelatorios),expression:"model.permissoes.veiculosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.veiculosRelatorios)?_vm._i(_vm.model.permissoes.veiculosRelatorios,null)>-1:(_vm.model.permissoes.veiculosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.veiculosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "veiculosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "veiculosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "veiculosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Vendedores\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendedoresCadastrar),expression:"model.permissoes.vendedoresCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendedoresCadastrar)?_vm._i(_vm.model.permissoes.vendedoresCadastrar,null)>-1:(_vm.model.permissoes.vendedoresCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendedoresCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendedoresCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendedoresCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendedoresCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendedoresEditar),expression:"model.permissoes.vendedoresEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendedoresEditar)?_vm._i(_vm.model.permissoes.vendedoresEditar,null)>-1:(_vm.model.permissoes.vendedoresEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendedoresEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendedoresEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendedoresEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendedoresEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendedoresExcluir),expression:"model.permissoes.vendedoresExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendedoresExcluir)?_vm._i(_vm.model.permissoes.vendedoresExcluir,null)>-1:(_vm.model.permissoes.vendedoresExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendedoresExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendedoresExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendedoresExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendedoresExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendedoresVisualizar),expression:"model.permissoes.vendedoresVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendedoresVisualizar)?_vm._i(_vm.model.permissoes.vendedoresVisualizar,null)>-1:(_vm.model.permissoes.vendedoresVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendedoresVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendedoresVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendedoresVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendedoresVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendedoresRelatorios),expression:"model.permissoes.vendedoresRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendedoresRelatorios)?_vm._i(_vm.model.permissoes.vendedoresRelatorios,null)>-1:(_vm.model.permissoes.vendedoresRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendedoresRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendedoresRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendedoresRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendedoresRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Produtos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCadastrar),expression:"model.permissoes.produtosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCadastrar)?_vm._i(_vm.model.permissoes.produtosCadastrar,null)>-1:(_vm.model.permissoes.produtosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosEditar),expression:"model.permissoes.produtosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosEditar)?_vm._i(_vm.model.permissoes.produtosEditar,null)>-1:(_vm.model.permissoes.produtosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosExcluir),expression:"model.permissoes.produtosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosExcluir)?_vm._i(_vm.model.permissoes.produtosExcluir,null)>-1:(_vm.model.permissoes.produtosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosVisualizar),expression:"model.permissoes.produtosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosVisualizar)?_vm._i(_vm.model.permissoes.produtosVisualizar,null)>-1:(_vm.model.permissoes.produtosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosRelatorios),expression:"model.permissoes.produtosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosRelatorios)?_vm._i(_vm.model.permissoes.produtosRelatorios,null)>-1:(_vm.model.permissoes.produtosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Servicos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.servicosCadastrar),expression:"model.permissoes.servicosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.servicosCadastrar)?_vm._i(_vm.model.permissoes.servicosCadastrar,null)>-1:(_vm.model.permissoes.servicosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.servicosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "servicosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "servicosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "servicosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.servicosEditar),expression:"model.permissoes.servicosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.servicosEditar)?_vm._i(_vm.model.permissoes.servicosEditar,null)>-1:(_vm.model.permissoes.servicosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.servicosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "servicosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "servicosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "servicosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.servicosExcluir),expression:"model.permissoes.servicosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.servicosExcluir)?_vm._i(_vm.model.permissoes.servicosExcluir,null)>-1:(_vm.model.permissoes.servicosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.servicosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "servicosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "servicosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "servicosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.servicosVisualizar),expression:"model.permissoes.servicosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.servicosVisualizar)?_vm._i(_vm.model.permissoes.servicosVisualizar,null)>-1:(_vm.model.permissoes.servicosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.servicosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "servicosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "servicosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "servicosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.servicosRelatorios),expression:"model.permissoes.servicosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.servicosRelatorios)?_vm._i(_vm.model.permissoes.servicosRelatorios,null)>-1:(_vm.model.permissoes.servicosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.servicosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "servicosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "servicosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "servicosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Depositos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.depositosCadastrar),expression:"model.permissoes.depositosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.depositosCadastrar)?_vm._i(_vm.model.permissoes.depositosCadastrar,null)>-1:(_vm.model.permissoes.depositosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.depositosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "depositosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "depositosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "depositosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.depositosEditar),expression:"model.permissoes.depositosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.depositosEditar)?_vm._i(_vm.model.permissoes.depositosEditar,null)>-1:(_vm.model.permissoes.depositosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.depositosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "depositosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "depositosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "depositosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.depositosExcluir),expression:"model.permissoes.depositosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.depositosExcluir)?_vm._i(_vm.model.permissoes.depositosExcluir,null)>-1:(_vm.model.permissoes.depositosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.depositosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "depositosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "depositosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "depositosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.depositosVisualizar),expression:"model.permissoes.depositosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.depositosVisualizar)?_vm._i(_vm.model.permissoes.depositosVisualizar,null)>-1:(_vm.model.permissoes.depositosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.depositosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "depositosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "depositosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "depositosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.depositosRelatorios),expression:"model.permissoes.depositosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.depositosRelatorios)?_vm._i(_vm.model.permissoes.depositosRelatorios,null)>-1:(_vm.model.permissoes.depositosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.depositosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "depositosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "depositosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "depositosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Movimento Estoque\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoEstoqueCadastrar),expression:"model.permissoes.movimentacaoEstoqueCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoEstoqueCadastrar)?_vm._i(_vm.model.permissoes.movimentacaoEstoqueCadastrar,null)>-1:(_vm.model.permissoes.movimentacaoEstoqueCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoEstoqueCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoEstoqueEditar),expression:"model.permissoes.movimentacaoEstoqueEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoEstoqueEditar)?_vm._i(_vm.model.permissoes.movimentacaoEstoqueEditar,null)>-1:(_vm.model.permissoes.movimentacaoEstoqueEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoEstoqueEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoEstoqueExcluir),expression:"model.permissoes.movimentacaoEstoqueExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoEstoqueExcluir)?_vm._i(_vm.model.permissoes.movimentacaoEstoqueExcluir,null)>-1:(_vm.model.permissoes.movimentacaoEstoqueExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoEstoqueExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoEstoqueVisualizar),expression:"model.permissoes.movimentacaoEstoqueVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoEstoqueVisualizar)?_vm._i(_vm.model.permissoes.movimentacaoEstoqueVisualizar,null)>-1:(_vm.model.permissoes.movimentacaoEstoqueVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoEstoqueVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoEstoqueRelatorios),expression:"model.permissoes.movimentacaoEstoqueRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoEstoqueRelatorios)?_vm._i(_vm.model.permissoes.movimentacaoEstoqueRelatorios,null)>-1:(_vm.model.permissoes.movimentacaoEstoqueRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoEstoqueRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoEstoqueRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Balanco de Estoque\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.balancoEstoqueCadastrar),expression:"model.permissoes.balancoEstoqueCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.balancoEstoqueCadastrar)?_vm._i(_vm.model.permissoes.balancoEstoqueCadastrar,null)>-1:(_vm.model.permissoes.balancoEstoqueCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.balancoEstoqueCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "balancoEstoqueCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.balancoEstoqueEditar),expression:"model.permissoes.balancoEstoqueEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.balancoEstoqueEditar)?_vm._i(_vm.model.permissoes.balancoEstoqueEditar,null)>-1:(_vm.model.permissoes.balancoEstoqueEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.balancoEstoqueEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "balancoEstoqueEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.balancoEstoqueExcluir),expression:"model.permissoes.balancoEstoqueExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.balancoEstoqueExcluir)?_vm._i(_vm.model.permissoes.balancoEstoqueExcluir,null)>-1:(_vm.model.permissoes.balancoEstoqueExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.balancoEstoqueExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "balancoEstoqueExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.balancoEstoqueVisualizar),expression:"model.permissoes.balancoEstoqueVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.balancoEstoqueVisualizar)?_vm._i(_vm.model.permissoes.balancoEstoqueVisualizar,null)>-1:(_vm.model.permissoes.balancoEstoqueVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.balancoEstoqueVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "balancoEstoqueVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.balancoEstoqueRelatorios),expression:"model.permissoes.balancoEstoqueRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.balancoEstoqueRelatorios)?_vm._i(_vm.model.permissoes.balancoEstoqueRelatorios,null)>-1:(_vm.model.permissoes.balancoEstoqueRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.balancoEstoqueRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "balancoEstoqueRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "balancoEstoqueRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Financeiro\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fluxoCaixaCadastrar),expression:"model.permissoes.fluxoCaixaCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fluxoCaixaCadastrar)?_vm._i(_vm.model.permissoes.fluxoCaixaCadastrar,null)>-1:(_vm.model.permissoes.fluxoCaixaCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fluxoCaixaCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fluxoCaixaCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fluxoCaixaEditar),expression:"model.permissoes.fluxoCaixaEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fluxoCaixaEditar)?_vm._i(_vm.model.permissoes.fluxoCaixaEditar,null)>-1:(_vm.model.permissoes.fluxoCaixaEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fluxoCaixaEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fluxoCaixaEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fluxoCaixaExcluir),expression:"model.permissoes.fluxoCaixaExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fluxoCaixaExcluir)?_vm._i(_vm.model.permissoes.fluxoCaixaExcluir,null)>-1:(_vm.model.permissoes.fluxoCaixaExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.fluxoCaixaExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fluxoCaixaExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fluxoCaixaVisualizar),expression:"model.permissoes.fluxoCaixaVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fluxoCaixaVisualizar)?_vm._i(_vm.model.permissoes.fluxoCaixaVisualizar,null)>-1:(_vm.model.permissoes.fluxoCaixaVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.fluxoCaixaVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fluxoCaixaVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.fluxoCaixaRelatorios),expression:"model.permissoes.fluxoCaixaRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.fluxoCaixaRelatorios)?_vm._i(_vm.model.permissoes.fluxoCaixaRelatorios,null)>-1:(_vm.model.permissoes.fluxoCaixaRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.fluxoCaixaRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "fluxoCaixaRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "fluxoCaixaRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Contas a Pagar\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasPagarCadastrar),expression:"model.permissoes.contasPagarCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasPagarCadastrar)?_vm._i(_vm.model.permissoes.contasPagarCadastrar,null)>-1:(_vm.model.permissoes.contasPagarCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasPagarCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasPagarCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasPagarCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasPagarCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasPagarEditar),expression:"model.permissoes.contasPagarEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasPagarEditar)?_vm._i(_vm.model.permissoes.contasPagarEditar,null)>-1:(_vm.model.permissoes.contasPagarEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasPagarEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasPagarEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasPagarEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasPagarEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasPagarExcluir),expression:"model.permissoes.contasPagarExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasPagarExcluir)?_vm._i(_vm.model.permissoes.contasPagarExcluir,null)>-1:(_vm.model.permissoes.contasPagarExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasPagarExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasPagarExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasPagarExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasPagarExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasPagarVisualizar),expression:"model.permissoes.contasPagarVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasPagarVisualizar)?_vm._i(_vm.model.permissoes.contasPagarVisualizar,null)>-1:(_vm.model.permissoes.contasPagarVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasPagarVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasPagarVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasPagarVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasPagarVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasPagarRelatorios),expression:"model.permissoes.contasPagarRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasPagarRelatorios)?_vm._i(_vm.model.permissoes.contasPagarRelatorios,null)>-1:(_vm.model.permissoes.contasPagarRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasPagarRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasPagarRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasPagarRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasPagarRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Financeiro\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasReceberCadastrar),expression:"model.permissoes.contasReceberCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasReceberCadastrar)?_vm._i(_vm.model.permissoes.contasReceberCadastrar,null)>-1:(_vm.model.permissoes.contasReceberCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasReceberCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasReceberCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasReceberCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasReceberCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasReceberEditar),expression:"model.permissoes.contasReceberEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasReceberEditar)?_vm._i(_vm.model.permissoes.contasReceberEditar,null)>-1:(_vm.model.permissoes.contasReceberEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasReceberEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasReceberEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasReceberEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasReceberEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasReceberExcluir),expression:"model.permissoes.contasReceberExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasReceberExcluir)?_vm._i(_vm.model.permissoes.contasReceberExcluir,null)>-1:(_vm.model.permissoes.contasReceberExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasReceberExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasReceberExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasReceberExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasReceberExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasReceberVisualizar),expression:"model.permissoes.contasReceberVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasReceberVisualizar)?_vm._i(_vm.model.permissoes.contasReceberVisualizar,null)>-1:(_vm.model.permissoes.contasReceberVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasReceberVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasReceberVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasReceberVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasReceberVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasReceberRelatorios),expression:"model.permissoes.contasReceberRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasReceberRelatorios)?_vm._i(_vm.model.permissoes.contasReceberRelatorios,null)>-1:(_vm.model.permissoes.contasReceberRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasReceberRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasReceberRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasReceberRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasReceberRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Bancos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.bancosCadastrar),expression:"model.permissoes.bancosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.bancosCadastrar)?_vm._i(_vm.model.permissoes.bancosCadastrar,null)>-1:(_vm.model.permissoes.bancosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.bancosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "bancosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "bancosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "bancosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.bancosEditar),expression:"model.permissoes.bancosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.bancosEditar)?_vm._i(_vm.model.permissoes.bancosEditar,null)>-1:(_vm.model.permissoes.bancosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.bancosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "bancosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "bancosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "bancosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.bancosExcluir),expression:"model.permissoes.bancosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.bancosExcluir)?_vm._i(_vm.model.permissoes.bancosExcluir,null)>-1:(_vm.model.permissoes.bancosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.bancosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "bancosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "bancosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "bancosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.bancosVisualizar),expression:"model.permissoes.bancosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.bancosVisualizar)?_vm._i(_vm.model.permissoes.bancosVisualizar,null)>-1:(_vm.model.permissoes.bancosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.bancosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "bancosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "bancosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "bancosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.bancosRelatorios),expression:"model.permissoes.bancosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.bancosRelatorios)?_vm._i(_vm.model.permissoes.bancosRelatorios,null)>-1:(_vm.model.permissoes.bancosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.bancosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "bancosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "bancosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "bancosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Movimento Banco\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBancariaCadastrar),expression:"model.permissoes.movimentacaoBancariaCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBancariaCadastrar)?_vm._i(_vm.model.permissoes.movimentacaoBancariaCadastrar,null)>-1:(_vm.model.permissoes.movimentacaoBancariaCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBancariaCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBancariaCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBancariaEditar),expression:"model.permissoes.movimentacaoBancariaEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBancariaEditar)?_vm._i(_vm.model.permissoes.movimentacaoBancariaEditar,null)>-1:(_vm.model.permissoes.movimentacaoBancariaEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBancariaEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBancariaEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBancariaExcluir),expression:"model.permissoes.movimentacaoBancariaExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBancariaExcluir)?_vm._i(_vm.model.permissoes.movimentacaoBancariaExcluir,null)>-1:(_vm.model.permissoes.movimentacaoBancariaExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBancariaExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBancariaExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBancariaVisualizar),expression:"model.permissoes.movimentacaoBancariaVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBancariaVisualizar)?_vm._i(_vm.model.permissoes.movimentacaoBancariaVisualizar,null)>-1:(_vm.model.permissoes.movimentacaoBancariaVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBancariaVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBancariaVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBancariaRelatorios),expression:"model.permissoes.movimentacaoBancariaRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBancariaRelatorios)?_vm._i(_vm.model.permissoes.movimentacaoBancariaRelatorios,null)>-1:(_vm.model.permissoes.movimentacaoBancariaRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBancariaRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBancariaRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBancariaRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Movimentacao Boletos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBoletosCadastrar),expression:"model.permissoes.movimentacaoBoletosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBoletosCadastrar)?_vm._i(_vm.model.permissoes.movimentacaoBoletosCadastrar,null)>-1:(_vm.model.permissoes.movimentacaoBoletosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBoletosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBoletosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBoletosEditar),expression:"model.permissoes.movimentacaoBoletosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBoletosEditar)?_vm._i(_vm.model.permissoes.movimentacaoBoletosEditar,null)>-1:(_vm.model.permissoes.movimentacaoBoletosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBoletosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBoletosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBoletosExcluir),expression:"model.permissoes.movimentacaoBoletosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBoletosExcluir)?_vm._i(_vm.model.permissoes.movimentacaoBoletosExcluir,null)>-1:(_vm.model.permissoes.movimentacaoBoletosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBoletosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBoletosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBoletosVisualizar),expression:"model.permissoes.movimentacaoBoletosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBoletosVisualizar)?_vm._i(_vm.model.permissoes.movimentacaoBoletosVisualizar,null)>-1:(_vm.model.permissoes.movimentacaoBoletosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBoletosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBoletosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.movimentacaoBoletosRelatorios),expression:"model.permissoes.movimentacaoBoletosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.movimentacaoBoletosRelatorios)?_vm._i(_vm.model.permissoes.movimentacaoBoletosRelatorios,null)>-1:(_vm.model.permissoes.movimentacaoBoletosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.movimentacaoBoletosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "movimentacaoBoletosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "movimentacaoBoletosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Cheques Emitidos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesEmitidosCadastrar),expression:"model.permissoes.chequesEmitidosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesEmitidosCadastrar)?_vm._i(_vm.model.permissoes.chequesEmitidosCadastrar,null)>-1:(_vm.model.permissoes.chequesEmitidosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesEmitidosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesEmitidosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesEmitidosEditar),expression:"model.permissoes.chequesEmitidosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesEmitidosEditar)?_vm._i(_vm.model.permissoes.chequesEmitidosEditar,null)>-1:(_vm.model.permissoes.chequesEmitidosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesEmitidosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesEmitidosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesEmitidosExcluir),expression:"model.permissoes.chequesEmitidosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesEmitidosExcluir)?_vm._i(_vm.model.permissoes.chequesEmitidosExcluir,null)>-1:(_vm.model.permissoes.chequesEmitidosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesEmitidosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesEmitidosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesEmitidosVisualizar),expression:"model.permissoes.chequesEmitidosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesEmitidosVisualizar)?_vm._i(_vm.model.permissoes.chequesEmitidosVisualizar,null)>-1:(_vm.model.permissoes.chequesEmitidosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesEmitidosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesEmitidosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesEmitidosRelatorios),expression:"model.permissoes.chequesEmitidosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesEmitidosRelatorios)?_vm._i(_vm.model.permissoes.chequesEmitidosRelatorios,null)>-1:(_vm.model.permissoes.chequesEmitidosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesEmitidosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesEmitidosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesEmitidosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                    Cheques Repasse\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesRepasseCadastrar),expression:"model.permissoes.chequesRepasseCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesRepasseCadastrar)?_vm._i(_vm.model.permissoes.chequesRepasseCadastrar,null)>-1:(_vm.model.permissoes.chequesRepasseCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesRepasseCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesRepasseCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesRepasseCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesRepasseCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesRepasseEditar),expression:"model.permissoes.chequesRepasseEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesRepasseEditar)?_vm._i(_vm.model.permissoes.chequesRepasseEditar,null)>-1:(_vm.model.permissoes.chequesRepasseEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesRepasseEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesRepasseEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesRepasseEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesRepasseEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesRepasseExcluir),expression:"model.permissoes.chequesRepasseExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesRepasseExcluir)?_vm._i(_vm.model.permissoes.chequesRepasseExcluir,null)>-1:(_vm.model.permissoes.chequesRepasseExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesRepasseExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesRepasseExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesRepasseExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesRepasseExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesRepasseVisualizar),expression:"model.permissoes.chequesRepasseVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesRepasseVisualizar)?_vm._i(_vm.model.permissoes.chequesRepasseVisualizar,null)>-1:(_vm.model.permissoes.chequesRepasseVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesRepasseVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesRepasseVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesRepasseVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesRepasseVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.chequesRepasseRelatorios),expression:"model.permissoes.chequesRepasseRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.chequesRepasseRelatorios)?_vm._i(_vm.model.permissoes.chequesRepasseRelatorios,null)>-1:(_vm.model.permissoes.chequesRepasseRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.chequesRepasseRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "chequesRepasseRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "chequesRepasseRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "chequesRepasseRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                    Cheque Status\n                  ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.statusChequeCadastrar),expression:"model.permissoes.statusChequeCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.statusChequeCadastrar)?_vm._i(_vm.model.permissoes.statusChequeCadastrar,null)>-1:(_vm.model.permissoes.statusChequeCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.statusChequeCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "statusChequeCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "statusChequeCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "statusChequeCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.statusChequeEditar),expression:"model.permissoes.statusChequeEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.statusChequeEditar)?_vm._i(_vm.model.permissoes.statusChequeEditar,null)>-1:(_vm.model.permissoes.statusChequeEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.statusChequeEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "statusChequeEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "statusChequeEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "statusChequeEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.statusChequeExcluir),expression:"model.permissoes.statusChequeExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.statusChequeExcluir)?_vm._i(_vm.model.permissoes.statusChequeExcluir,null)>-1:(_vm.model.permissoes.statusChequeExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.statusChequeExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "statusChequeExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "statusChequeExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "statusChequeExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.statusChequeVisualizar),expression:"model.permissoes.statusChequeVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.statusChequeVisualizar)?_vm._i(_vm.model.permissoes.statusChequeVisualizar,null)>-1:(_vm.model.permissoes.statusChequeVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.statusChequeVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "statusChequeVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "statusChequeVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "statusChequeVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.statusChequeRelatorios),expression:"model.permissoes.statusChequeRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.statusChequeRelatorios)?_vm._i(_vm.model.permissoes.statusChequeRelatorios,null)>-1:(_vm.model.permissoes.statusChequeRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.statusChequeRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "statusChequeRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "statusChequeRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "statusChequeRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Compras\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasCadastrar),expression:"model.permissoes.comprasCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasCadastrar)?_vm._i(_vm.model.permissoes.comprasCadastrar,null)>-1:(_vm.model.permissoes.comprasCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasEditar),expression:"model.permissoes.comprasEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasEditar)?_vm._i(_vm.model.permissoes.comprasEditar,null)>-1:(_vm.model.permissoes.comprasEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasConfirmar),expression:"model.permissoes.comprasConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasConfirmar)?_vm._i(_vm.model.permissoes.comprasConfirmar,null)>-1:(_vm.model.permissoes.comprasConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasCancelar),expression:"model.permissoes.comprasCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasCancelar)?_vm._i(_vm.model.permissoes.comprasCancelar,null)>-1:(_vm.model.permissoes.comprasCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasVisualizar),expression:"model.permissoes.comprasVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasVisualizar)?_vm._i(_vm.model.permissoes.comprasVisualizar,null)>-1:(_vm.model.permissoes.comprasVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.comprasRelatorios),expression:"model.permissoes.comprasRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.comprasRelatorios)?_vm._i(_vm.model.permissoes.comprasRelatorios,null)>-1:(_vm.model.permissoes.comprasRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.comprasRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "comprasRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "comprasRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "comprasRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Analise de Compra\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraCadastrar),expression:"model.permissoes.analiseCompraCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraCadastrar)?_vm._i(_vm.model.permissoes.analiseCompraCadastrar,null)>-1:(_vm.model.permissoes.analiseCompraCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraEditar),expression:"model.permissoes.analiseCompraEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraEditar)?_vm._i(_vm.model.permissoes.analiseCompraEditar,null)>-1:(_vm.model.permissoes.analiseCompraEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraConfirmar),expression:"model.permissoes.analiseCompraConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraConfirmar)?_vm._i(_vm.model.permissoes.analiseCompraConfirmar,null)>-1:(_vm.model.permissoes.analiseCompraConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraCancelar),expression:"model.permissoes.analiseCompraCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraCancelar)?_vm._i(_vm.model.permissoes.analiseCompraCancelar,null)>-1:(_vm.model.permissoes.analiseCompraCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraVisualizar),expression:"model.permissoes.analiseCompraVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraVisualizar)?_vm._i(_vm.model.permissoes.analiseCompraVisualizar,null)>-1:(_vm.model.permissoes.analiseCompraVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.analiseCompraRelatorios),expression:"model.permissoes.analiseCompraRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.analiseCompraRelatorios)?_vm._i(_vm.model.permissoes.analiseCompraRelatorios,null)>-1:(_vm.model.permissoes.analiseCompraRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.analiseCompraRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "analiseCompraRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "analiseCompraRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "analiseCompraRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Cotacao de Compras\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraCadastrar),expression:"model.permissoes.cotacaoCompraCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraCadastrar)?_vm._i(_vm.model.permissoes.cotacaoCompraCadastrar,null)>-1:(_vm.model.permissoes.cotacaoCompraCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraEditar),expression:"model.permissoes.cotacaoCompraEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraEditar)?_vm._i(_vm.model.permissoes.cotacaoCompraEditar,null)>-1:(_vm.model.permissoes.cotacaoCompraEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraConfirmar),expression:"model.permissoes.cotacaoCompraConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraConfirmar)?_vm._i(_vm.model.permissoes.cotacaoCompraConfirmar,null)>-1:(_vm.model.permissoes.cotacaoCompraConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraCancelar),expression:"model.permissoes.cotacaoCompraCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraCancelar)?_vm._i(_vm.model.permissoes.cotacaoCompraCancelar,null)>-1:(_vm.model.permissoes.cotacaoCompraCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraVisualizar),expression:"model.permissoes.cotacaoCompraVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraVisualizar)?_vm._i(_vm.model.permissoes.cotacaoCompraVisualizar,null)>-1:(_vm.model.permissoes.cotacaoCompraVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cotacaoCompraRelatorios),expression:"model.permissoes.cotacaoCompraRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cotacaoCompraRelatorios)?_vm._i(_vm.model.permissoes.cotacaoCompraRelatorios,null)>-1:(_vm.model.permissoes.cotacaoCompraRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.cotacaoCompraRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cotacaoCompraRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cotacaoCompraRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Vendas de Produtos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosCadastrar),expression:"model.permissoes.vendasProdutosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosCadastrar)?_vm._i(_vm.model.permissoes.vendasProdutosCadastrar,null)>-1:(_vm.model.permissoes.vendasProdutosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosEditar),expression:"model.permissoes.vendasProdutosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosEditar)?_vm._i(_vm.model.permissoes.vendasProdutosEditar,null)>-1:(_vm.model.permissoes.vendasProdutosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosConfirmar),expression:"model.permissoes.vendasProdutosConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosConfirmar)?_vm._i(_vm.model.permissoes.vendasProdutosConfirmar,null)>-1:(_vm.model.permissoes.vendasProdutosConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosCancelar),expression:"model.permissoes.vendasProdutosCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosCancelar)?_vm._i(_vm.model.permissoes.vendasProdutosCancelar,null)>-1:(_vm.model.permissoes.vendasProdutosCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosVisualizar),expression:"model.permissoes.vendasProdutosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosVisualizar)?_vm._i(_vm.model.permissoes.vendasProdutosVisualizar,null)>-1:(_vm.model.permissoes.vendasProdutosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosRelatorios),expression:"model.permissoes.vendasProdutosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosRelatorios)?_vm._i(_vm.model.permissoes.vendasProdutosRelatorios,null)>-1:(_vm.model.permissoes.vendasProdutosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Devolucao de Produtos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosCadastrar),expression:"model.permissoes.devolucaoProdutosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosCadastrar)?_vm._i(_vm.model.permissoes.devolucaoProdutosCadastrar,null)>-1:(_vm.model.permissoes.devolucaoProdutosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosEditar),expression:"model.permissoes.devolucaoProdutosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosEditar)?_vm._i(_vm.model.permissoes.devolucaoProdutosEditar,null)>-1:(_vm.model.permissoes.devolucaoProdutosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosConfirmar),expression:"model.permissoes.devolucaoProdutosConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosConfirmar)?_vm._i(_vm.model.permissoes.devolucaoProdutosConfirmar,null)>-1:(_vm.model.permissoes.devolucaoProdutosConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosCancelar),expression:"model.permissoes.devolucaoProdutosCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosCancelar)?_vm._i(_vm.model.permissoes.devolucaoProdutosCancelar,null)>-1:(_vm.model.permissoes.devolucaoProdutosCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosVisualizar),expression:"model.permissoes.devolucaoProdutosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosVisualizar)?_vm._i(_vm.model.permissoes.devolucaoProdutosVisualizar,null)>-1:(_vm.model.permissoes.devolucaoProdutosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.devolucaoProdutosRelatorios),expression:"model.permissoes.devolucaoProdutosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.devolucaoProdutosRelatorios)?_vm._i(_vm.model.permissoes.devolucaoProdutosRelatorios,null)>-1:(_vm.model.permissoes.devolucaoProdutosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.devolucaoProdutosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "devolucaoProdutosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "devolucaoProdutosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Vendas de Servicos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosCadastrar),expression:"model.permissoes.vendasServicosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosCadastrar)?_vm._i(_vm.model.permissoes.vendasServicosCadastrar,null)>-1:(_vm.model.permissoes.vendasServicosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosEditar),expression:"model.permissoes.vendasServicosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosEditar)?_vm._i(_vm.model.permissoes.vendasServicosEditar,null)>-1:(_vm.model.permissoes.vendasServicosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosConfirmar),expression:"model.permissoes.vendasServicosConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosConfirmar)?_vm._i(_vm.model.permissoes.vendasServicosConfirmar,null)>-1:(_vm.model.permissoes.vendasServicosConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosCancelar),expression:"model.permissoes.vendasServicosCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosCancelar)?_vm._i(_vm.model.permissoes.vendasServicosCancelar,null)>-1:(_vm.model.permissoes.vendasServicosCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosVisualizar),expression:"model.permissoes.vendasServicosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosVisualizar)?_vm._i(_vm.model.permissoes.vendasServicosVisualizar,null)>-1:(_vm.model.permissoes.vendasServicosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasServicosRelatorios),expression:"model.permissoes.vendasServicosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasServicosRelatorios)?_vm._i(_vm.model.permissoes.vendasServicosRelatorios,null)>-1:(_vm.model.permissoes.vendasServicosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasServicosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasServicosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasServicosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasServicosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Vendas PDV\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvCadastrar),expression:"model.permissoes.vendasProdutosPdvCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvCadastrar)?_vm._i(_vm.model.permissoes.vendasProdutosPdvCadastrar,null)>-1:(_vm.model.permissoes.vendasProdutosPdvCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvEditar),expression:"model.permissoes.vendasProdutosPdvEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvEditar)?_vm._i(_vm.model.permissoes.vendasProdutosPdvEditar,null)>-1:(_vm.model.permissoes.vendasProdutosPdvEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvConfirmar),expression:"model.permissoes.vendasProdutosPdvConfirmar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvConfirmar)?_vm._i(_vm.model.permissoes.vendasProdutosPdvConfirmar,null)>-1:(_vm.model.permissoes.vendasProdutosPdvConfirmar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvConfirmar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvConfirmar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvConfirmar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvConfirmar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CONFIRMAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvCancelar),expression:"model.permissoes.vendasProdutosPdvCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvCancelar)?_vm._i(_vm.model.permissoes.vendasProdutosPdvCancelar,null)>-1:(_vm.model.permissoes.vendasProdutosPdvCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvVisualizar),expression:"model.permissoes.vendasProdutosPdvVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvVisualizar)?_vm._i(_vm.model.permissoes.vendasProdutosPdvVisualizar,null)>-1:(_vm.model.permissoes.vendasProdutosPdvVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.vendasProdutosPdvRelatorios),expression:"model.permissoes.vendasProdutosPdvRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.vendasProdutosPdvRelatorios)?_vm._i(_vm.model.permissoes.vendasProdutosPdvRelatorios,null)>-1:(_vm.model.permissoes.vendasProdutosPdvRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.vendasProdutosPdvRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "vendasProdutosPdvRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "vendasProdutosPdvRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  NFE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeCadastrar),expression:"model.permissoes.nfeCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeCadastrar)?_vm._i(_vm.model.permissoes.nfeCadastrar,null)>-1:(_vm.model.permissoes.nfeCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeEditar),expression:"model.permissoes.nfeEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeEditar)?_vm._i(_vm.model.permissoes.nfeEditar,null)>-1:(_vm.model.permissoes.nfeEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeEnviar),expression:"model.permissoes.nfeEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeEnviar)?_vm._i(_vm.model.permissoes.nfeEnviar,null)>-1:(_vm.model.permissoes.nfeEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeCancelar),expression:"model.permissoes.nfeCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeCancelar)?_vm._i(_vm.model.permissoes.nfeCancelar,null)>-1:(_vm.model.permissoes.nfeCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeEventos),expression:"model.permissoes.nfeEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeEventos)?_vm._i(_vm.model.permissoes.nfeEventos,null)>-1:(_vm.model.permissoes.nfeEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeVisualizar),expression:"model.permissoes.nfeVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeVisualizar)?_vm._i(_vm.model.permissoes.nfeVisualizar,null)>-1:(_vm.model.permissoes.nfeVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfeRelatorios),expression:"model.permissoes.nfeRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfeRelatorios)?_vm._i(_vm.model.permissoes.nfeRelatorios,null)>-1:(_vm.model.permissoes.nfeRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfeRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfeRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfeRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfeRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  NFCE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceCadastrar),expression:"model.permissoes.nfceCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceCadastrar)?_vm._i(_vm.model.permissoes.nfceCadastrar,null)>-1:(_vm.model.permissoes.nfceCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceEditar),expression:"model.permissoes.nfceEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceEditar)?_vm._i(_vm.model.permissoes.nfceEditar,null)>-1:(_vm.model.permissoes.nfceEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceEnviar),expression:"model.permissoes.nfceEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceEnviar)?_vm._i(_vm.model.permissoes.nfceEnviar,null)>-1:(_vm.model.permissoes.nfceEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceCancelar),expression:"model.permissoes.nfceCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceCancelar)?_vm._i(_vm.model.permissoes.nfceCancelar,null)>-1:(_vm.model.permissoes.nfceCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceEventos),expression:"model.permissoes.nfceEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceEventos)?_vm._i(_vm.model.permissoes.nfceEventos,null)>-1:(_vm.model.permissoes.nfceEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceVisualizar),expression:"model.permissoes.nfceVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceVisualizar)?_vm._i(_vm.model.permissoes.nfceVisualizar,null)>-1:(_vm.model.permissoes.nfceVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfceRelatorios),expression:"model.permissoes.nfceRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfceRelatorios)?_vm._i(_vm.model.permissoes.nfceRelatorios,null)>-1:(_vm.model.permissoes.nfceRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfceRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfceRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfceRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfceRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  NFSE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseCadastrar),expression:"model.permissoes.nfseCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseCadastrar)?_vm._i(_vm.model.permissoes.nfseCadastrar,null)>-1:(_vm.model.permissoes.nfseCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseEditar),expression:"model.permissoes.nfseEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseEditar)?_vm._i(_vm.model.permissoes.nfseEditar,null)>-1:(_vm.model.permissoes.nfseEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseEnviar),expression:"model.permissoes.nfseEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseEnviar)?_vm._i(_vm.model.permissoes.nfseEnviar,null)>-1:(_vm.model.permissoes.nfseEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseCancelar),expression:"model.permissoes.nfseCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseCancelar)?_vm._i(_vm.model.permissoes.nfseCancelar,null)>-1:(_vm.model.permissoes.nfseCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseEventos),expression:"model.permissoes.nfseEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseEventos)?_vm._i(_vm.model.permissoes.nfseEventos,null)>-1:(_vm.model.permissoes.nfseEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseVisualizar),expression:"model.permissoes.nfseVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseVisualizar)?_vm._i(_vm.model.permissoes.nfseVisualizar,null)>-1:(_vm.model.permissoes.nfseVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.nfseRelatorios),expression:"model.permissoes.nfseRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.nfseRelatorios)?_vm._i(_vm.model.permissoes.nfseRelatorios,null)>-1:(_vm.model.permissoes.nfseRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.nfseRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "nfseRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "nfseRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "nfseRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  MDFE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeCadastrar),expression:"model.permissoes.mdfeCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeCadastrar)?_vm._i(_vm.model.permissoes.mdfeCadastrar,null)>-1:(_vm.model.permissoes.mdfeCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeEditar),expression:"model.permissoes.mdfeEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeEditar)?_vm._i(_vm.model.permissoes.mdfeEditar,null)>-1:(_vm.model.permissoes.mdfeEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeEnviar),expression:"model.permissoes.mdfeEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeEnviar)?_vm._i(_vm.model.permissoes.mdfeEnviar,null)>-1:(_vm.model.permissoes.mdfeEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeCancelar),expression:"model.permissoes.mdfeCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeCancelar)?_vm._i(_vm.model.permissoes.mdfeCancelar,null)>-1:(_vm.model.permissoes.mdfeCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeEventos),expression:"model.permissoes.mdfeEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeEventos)?_vm._i(_vm.model.permissoes.mdfeEventos,null)>-1:(_vm.model.permissoes.mdfeEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeVisualizar),expression:"model.permissoes.mdfeVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeVisualizar)?_vm._i(_vm.model.permissoes.mdfeVisualizar,null)>-1:(_vm.model.permissoes.mdfeVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mdfeRelatorios),expression:"model.permissoes.mdfeRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mdfeRelatorios)?_vm._i(_vm.model.permissoes.mdfeRelatorios,null)>-1:(_vm.model.permissoes.mdfeRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.mdfeRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mdfeRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mdfeRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mdfeRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  CTE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteCadastrar),expression:"model.permissoes.cteCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteCadastrar)?_vm._i(_vm.model.permissoes.cteCadastrar,null)>-1:(_vm.model.permissoes.cteCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteEditar),expression:"model.permissoes.cteEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteEditar)?_vm._i(_vm.model.permissoes.cteEditar,null)>-1:(_vm.model.permissoes.cteEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteEnviar),expression:"model.permissoes.cteEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteEnviar)?_vm._i(_vm.model.permissoes.cteEnviar,null)>-1:(_vm.model.permissoes.cteEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteCancelar),expression:"model.permissoes.cteCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteCancelar)?_vm._i(_vm.model.permissoes.cteCancelar,null)>-1:(_vm.model.permissoes.cteCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteEventos),expression:"model.permissoes.cteEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteEventos)?_vm._i(_vm.model.permissoes.cteEventos,null)>-1:(_vm.model.permissoes.cteEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteVisualizar),expression:"model.permissoes.cteVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteVisualizar)?_vm._i(_vm.model.permissoes.cteVisualizar,null)>-1:(_vm.model.permissoes.cteVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cteRelatorios),expression:"model.permissoes.cteRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cteRelatorios)?_vm._i(_vm.model.permissoes.cteRelatorios,null)>-1:(_vm.model.permissoes.cteRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.cteRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cteRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cteRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cteRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Guia de Trafego\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoCadastrar),expression:"model.permissoes.guiaTrafegoCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoCadastrar)?_vm._i(_vm.model.permissoes.guiaTrafegoCadastrar,null)>-1:(_vm.model.permissoes.guiaTrafegoCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoEditar),expression:"model.permissoes.guiaTrafegoEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoEditar)?_vm._i(_vm.model.permissoes.guiaTrafegoEditar,null)>-1:(_vm.model.permissoes.guiaTrafegoEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoEnviar),expression:"model.permissoes.guiaTrafegoEnviar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoEnviar)?_vm._i(_vm.model.permissoes.guiaTrafegoEnviar,null)>-1:(_vm.model.permissoes.guiaTrafegoEnviar)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoEnviar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEnviar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEnviar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoEnviar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" ENVIAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoCancelar),expression:"model.permissoes.guiaTrafegoCancelar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoCancelar)?_vm._i(_vm.model.permissoes.guiaTrafegoCancelar,null)>-1:(_vm.model.permissoes.guiaTrafegoCancelar)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoCancelar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoCancelar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoCancelar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoCancelar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CANCELAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoEventos),expression:"model.permissoes.guiaTrafegoEventos"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoEventos)?_vm._i(_vm.model.permissoes.guiaTrafegoEventos,null)>-1:(_vm.model.permissoes.guiaTrafegoEventos)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoEventos,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEventos", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoEventos", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoEventos", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EVENTOS")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoVisualizar),expression:"model.permissoes.guiaTrafegoVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoVisualizar)?_vm._i(_vm.model.permissoes.guiaTrafegoVisualizar,null)>-1:(_vm.model.permissoes.guiaTrafegoVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.guiaTrafegoRelatorios),expression:"model.permissoes.guiaTrafegoRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.guiaTrafegoRelatorios)?_vm._i(_vm.model.permissoes.guiaTrafegoRelatorios,null)>-1:(_vm.model.permissoes.guiaTrafegoRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.guiaTrafegoRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "guiaTrafegoRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "guiaTrafegoRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Mensagens NFE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfeCadastrar),expression:"model.permissoes.mensagensNfeCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfeCadastrar)?_vm._i(_vm.model.permissoes.mensagensNfeCadastrar,null)>-1:(_vm.model.permissoes.mensagensNfeCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfeCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfeCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfeCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfeCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfeEditar),expression:"model.permissoes.mensagensNfeEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfeEditar)?_vm._i(_vm.model.permissoes.mensagensNfeEditar,null)>-1:(_vm.model.permissoes.mensagensNfeEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfeEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfeEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfeEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfeEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfeExcluir),expression:"model.permissoes.mensagensNfeExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfeExcluir)?_vm._i(_vm.model.permissoes.mensagensNfeExcluir,null)>-1:(_vm.model.permissoes.mensagensNfeExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfeExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfeExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfeExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfeExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfeVisualizar),expression:"model.permissoes.mensagensNfeVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfeVisualizar)?_vm._i(_vm.model.permissoes.mensagensNfeVisualizar,null)>-1:(_vm.model.permissoes.mensagensNfeVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfeVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfeVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfeVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfeVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfeRelatorios),expression:"model.permissoes.mensagensNfeRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfeRelatorios)?_vm._i(_vm.model.permissoes.mensagensNfeRelatorios,null)>-1:(_vm.model.permissoes.mensagensNfeRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfeRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfeRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfeRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfeRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Mensagens NFSE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfseCadastrar),expression:"model.permissoes.mensagensNfseCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfseCadastrar)?_vm._i(_vm.model.permissoes.mensagensNfseCadastrar,null)>-1:(_vm.model.permissoes.mensagensNfseCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfseCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfseCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfseCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfseCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfseEditar),expression:"model.permissoes.mensagensNfseEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfseEditar)?_vm._i(_vm.model.permissoes.mensagensNfseEditar,null)>-1:(_vm.model.permissoes.mensagensNfseEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfseEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfseEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfseEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfseEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfseExcluir),expression:"model.permissoes.mensagensNfseExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfseExcluir)?_vm._i(_vm.model.permissoes.mensagensNfseExcluir,null)>-1:(_vm.model.permissoes.mensagensNfseExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfseExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfseExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfseExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfseExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfseVisualizar),expression:"model.permissoes.mensagensNfseVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfseVisualizar)?_vm._i(_vm.model.permissoes.mensagensNfseVisualizar,null)>-1:(_vm.model.permissoes.mensagensNfseVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfseVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfseVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfseVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfseVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensNfseRelatorios),expression:"model.permissoes.mensagensNfseRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensNfseRelatorios)?_vm._i(_vm.model.permissoes.mensagensNfseRelatorios,null)>-1:(_vm.model.permissoes.mensagensNfseRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensNfseRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensNfseRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensNfseRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensNfseRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Mensagens MDFE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensMdfeCadastrar),expression:"model.permissoes.mensagensMdfeCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensMdfeCadastrar)?_vm._i(_vm.model.permissoes.mensagensMdfeCadastrar,null)>-1:(_vm.model.permissoes.mensagensMdfeCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensMdfeCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensMdfeCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensMdfeEditar),expression:"model.permissoes.mensagensMdfeEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensMdfeEditar)?_vm._i(_vm.model.permissoes.mensagensMdfeEditar,null)>-1:(_vm.model.permissoes.mensagensMdfeEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensMdfeEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensMdfeEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensMdfeExcluir),expression:"model.permissoes.mensagensMdfeExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensMdfeExcluir)?_vm._i(_vm.model.permissoes.mensagensMdfeExcluir,null)>-1:(_vm.model.permissoes.mensagensMdfeExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensMdfeExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensMdfeExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensMdfeVisualizar),expression:"model.permissoes.mensagensMdfeVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensMdfeVisualizar)?_vm._i(_vm.model.permissoes.mensagensMdfeVisualizar,null)>-1:(_vm.model.permissoes.mensagensMdfeVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensMdfeVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensMdfeVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensMdfeRelatorios),expression:"model.permissoes.mensagensMdfeRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensMdfeRelatorios)?_vm._i(_vm.model.permissoes.mensagensMdfeRelatorios,null)>-1:(_vm.model.permissoes.mensagensMdfeRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensMdfeRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensMdfeRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensMdfeRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Mensagens CTE\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensCteCadastrar),expression:"model.permissoes.mensagensCteCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensCteCadastrar)?_vm._i(_vm.model.permissoes.mensagensCteCadastrar,null)>-1:(_vm.model.permissoes.mensagensCteCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensCteCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensCteCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensCteCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensCteCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensCteEditar),expression:"model.permissoes.mensagensCteEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensCteEditar)?_vm._i(_vm.model.permissoes.mensagensCteEditar,null)>-1:(_vm.model.permissoes.mensagensCteEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensCteEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensCteEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensCteEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensCteEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensCteExcluir),expression:"model.permissoes.mensagensCteExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensCteExcluir)?_vm._i(_vm.model.permissoes.mensagensCteExcluir,null)>-1:(_vm.model.permissoes.mensagensCteExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensCteExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensCteExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensCteExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensCteExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensCteVisualizar),expression:"model.permissoes.mensagensCteVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensCteVisualizar)?_vm._i(_vm.model.permissoes.mensagensCteVisualizar,null)>-1:(_vm.model.permissoes.mensagensCteVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensCteVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensCteVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensCteVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensCteVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.mensagensCteRelatorios),expression:"model.permissoes.mensagensCteRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.mensagensCteRelatorios)?_vm._i(_vm.model.permissoes.mensagensCteRelatorios,null)>-1:(_vm.model.permissoes.mensagensCteRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.mensagensCteRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "mensagensCteRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "mensagensCteRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "mensagensCteRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Formas de Pagamento\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.formasPagamentoCadastrar),expression:"model.permissoes.formasPagamentoCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.formasPagamentoCadastrar)?_vm._i(_vm.model.permissoes.formasPagamentoCadastrar,null)>-1:(_vm.model.permissoes.formasPagamentoCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.formasPagamentoCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "formasPagamentoCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "formasPagamentoCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "formasPagamentoCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.formasPagamentoEditar),expression:"model.permissoes.formasPagamentoEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.formasPagamentoEditar)?_vm._i(_vm.model.permissoes.formasPagamentoEditar,null)>-1:(_vm.model.permissoes.formasPagamentoEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.formasPagamentoEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "formasPagamentoEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "formasPagamentoEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "formasPagamentoEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.formasPagamentoExcluir),expression:"model.permissoes.formasPagamentoExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.formasPagamentoExcluir)?_vm._i(_vm.model.permissoes.formasPagamentoExcluir,null)>-1:(_vm.model.permissoes.formasPagamentoExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.formasPagamentoExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "formasPagamentoExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "formasPagamentoExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "formasPagamentoExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.formasPagamentoVisualizar),expression:"model.permissoes.formasPagamentoVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.formasPagamentoVisualizar)?_vm._i(_vm.model.permissoes.formasPagamentoVisualizar,null)>-1:(_vm.model.permissoes.formasPagamentoVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.formasPagamentoVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "formasPagamentoVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "formasPagamentoVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "formasPagamentoVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.formasPagamentoRelatorios),expression:"model.permissoes.formasPagamentoRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.formasPagamentoRelatorios)?_vm._i(_vm.model.permissoes.formasPagamentoRelatorios,null)>-1:(_vm.model.permissoes.formasPagamentoRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.formasPagamentoRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "formasPagamentoRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "formasPagamentoRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "formasPagamentoRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Codigos NCM\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigosNcmsCadastrar),expression:"model.permissoes.codigosNcmsCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigosNcmsCadastrar)?_vm._i(_vm.model.permissoes.codigosNcmsCadastrar,null)>-1:(_vm.model.permissoes.codigosNcmsCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigosNcmsCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigosNcmsCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigosNcmsCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigosNcmsCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigosNcmsEditar),expression:"model.permissoes.codigosNcmsEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigosNcmsEditar)?_vm._i(_vm.model.permissoes.codigosNcmsEditar,null)>-1:(_vm.model.permissoes.codigosNcmsEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigosNcmsEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigosNcmsEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigosNcmsEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigosNcmsEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigosNcmsExcluir),expression:"model.permissoes.codigosNcmsExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigosNcmsExcluir)?_vm._i(_vm.model.permissoes.codigosNcmsExcluir,null)>-1:(_vm.model.permissoes.codigosNcmsExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigosNcmsExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigosNcmsExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigosNcmsExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigosNcmsExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigosNcmsVisualizar),expression:"model.permissoes.codigosNcmsVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigosNcmsVisualizar)?_vm._i(_vm.model.permissoes.codigosNcmsVisualizar,null)>-1:(_vm.model.permissoes.codigosNcmsVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigosNcmsVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigosNcmsVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigosNcmsVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigosNcmsVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigosNcmsRelatorios),expression:"model.permissoes.codigosNcmsRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigosNcmsRelatorios)?_vm._i(_vm.model.permissoes.codigosNcmsRelatorios,null)>-1:(_vm.model.permissoes.codigosNcmsRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigosNcmsRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigosNcmsRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigosNcmsRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigosNcmsRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Cidades\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cidadesCadastrar),expression:"model.permissoes.cidadesCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cidadesCadastrar)?_vm._i(_vm.model.permissoes.cidadesCadastrar,null)>-1:(_vm.model.permissoes.cidadesCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cidadesCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cidadesCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cidadesCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cidadesCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cidadesEditar),expression:"model.permissoes.cidadesEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cidadesEditar)?_vm._i(_vm.model.permissoes.cidadesEditar,null)>-1:(_vm.model.permissoes.cidadesEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cidadesEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cidadesEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cidadesEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cidadesEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cidadesExcluir),expression:"model.permissoes.cidadesExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cidadesExcluir)?_vm._i(_vm.model.permissoes.cidadesExcluir,null)>-1:(_vm.model.permissoes.cidadesExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.cidadesExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cidadesExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cidadesExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cidadesExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cidadesVisualizar),expression:"model.permissoes.cidadesVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cidadesVisualizar)?_vm._i(_vm.model.permissoes.cidadesVisualizar,null)>-1:(_vm.model.permissoes.cidadesVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.cidadesVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cidadesVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cidadesVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cidadesVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.cidadesRelatorios),expression:"model.permissoes.cidadesRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.cidadesRelatorios)?_vm._i(_vm.model.permissoes.cidadesRelatorios,null)>-1:(_vm.model.permissoes.cidadesRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.cidadesRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "cidadesRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "cidadesRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "cidadesRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Centros de Custos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.centrosCustosCadastrar),expression:"model.permissoes.centrosCustosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.centrosCustosCadastrar)?_vm._i(_vm.model.permissoes.centrosCustosCadastrar,null)>-1:(_vm.model.permissoes.centrosCustosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.centrosCustosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "centrosCustosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "centrosCustosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "centrosCustosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.centrosCustosEditar),expression:"model.permissoes.centrosCustosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.centrosCustosEditar)?_vm._i(_vm.model.permissoes.centrosCustosEditar,null)>-1:(_vm.model.permissoes.centrosCustosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.centrosCustosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "centrosCustosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "centrosCustosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "centrosCustosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.centrosCustosExcluir),expression:"model.permissoes.centrosCustosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.centrosCustosExcluir)?_vm._i(_vm.model.permissoes.centrosCustosExcluir,null)>-1:(_vm.model.permissoes.centrosCustosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.centrosCustosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "centrosCustosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "centrosCustosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "centrosCustosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.centrosCustosVisualizar),expression:"model.permissoes.centrosCustosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.centrosCustosVisualizar)?_vm._i(_vm.model.permissoes.centrosCustosVisualizar,null)>-1:(_vm.model.permissoes.centrosCustosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.centrosCustosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "centrosCustosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "centrosCustosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "centrosCustosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.centrosCustosRelatorios),expression:"model.permissoes.centrosCustosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.centrosCustosRelatorios)?_vm._i(_vm.model.permissoes.centrosCustosRelatorios,null)>-1:(_vm.model.permissoes.centrosCustosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.centrosCustosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "centrosCustosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "centrosCustosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "centrosCustosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Conceitos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.conceitosCadastrar),expression:"model.permissoes.conceitosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.conceitosCadastrar)?_vm._i(_vm.model.permissoes.conceitosCadastrar,null)>-1:(_vm.model.permissoes.conceitosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.conceitosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "conceitosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "conceitosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "conceitosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.conceitosEditar),expression:"model.permissoes.conceitosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.conceitosEditar)?_vm._i(_vm.model.permissoes.conceitosEditar,null)>-1:(_vm.model.permissoes.conceitosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.conceitosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "conceitosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "conceitosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "conceitosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.conceitosExcluir),expression:"model.permissoes.conceitosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.conceitosExcluir)?_vm._i(_vm.model.permissoes.conceitosExcluir,null)>-1:(_vm.model.permissoes.conceitosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.conceitosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "conceitosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "conceitosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "conceitosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.conceitosVisualizar),expression:"model.permissoes.conceitosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.conceitosVisualizar)?_vm._i(_vm.model.permissoes.conceitosVisualizar,null)>-1:(_vm.model.permissoes.conceitosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.conceitosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "conceitosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "conceitosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "conceitosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.conceitosRelatorios),expression:"model.permissoes.conceitosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.conceitosRelatorios)?_vm._i(_vm.model.permissoes.conceitosRelatorios,null)>-1:(_vm.model.permissoes.conceitosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.conceitosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "conceitosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "conceitosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "conceitosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Contas Caixa\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasCaixaCadastrar),expression:"model.permissoes.contasCaixaCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasCaixaCadastrar)?_vm._i(_vm.model.permissoes.contasCaixaCadastrar,null)>-1:(_vm.model.permissoes.contasCaixaCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasCaixaCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasCaixaCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasCaixaCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasCaixaCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasCaixaEditar),expression:"model.permissoes.contasCaixaEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasCaixaEditar)?_vm._i(_vm.model.permissoes.contasCaixaEditar,null)>-1:(_vm.model.permissoes.contasCaixaEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasCaixaEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasCaixaEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasCaixaEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasCaixaEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasCaixaExcluir),expression:"model.permissoes.contasCaixaExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasCaixaExcluir)?_vm._i(_vm.model.permissoes.contasCaixaExcluir,null)>-1:(_vm.model.permissoes.contasCaixaExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasCaixaExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasCaixaExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasCaixaExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasCaixaExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasCaixaVisualizar),expression:"model.permissoes.contasCaixaVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasCaixaVisualizar)?_vm._i(_vm.model.permissoes.contasCaixaVisualizar,null)>-1:(_vm.model.permissoes.contasCaixaVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasCaixaVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasCaixaVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasCaixaVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasCaixaVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.contasCaixaRelatorios),expression:"model.permissoes.contasCaixaRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.contasCaixaRelatorios)?_vm._i(_vm.model.permissoes.contasCaixaRelatorios,null)>-1:(_vm.model.permissoes.contasCaixaRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.contasCaixaRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "contasCaixaRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "contasCaixaRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "contasCaixaRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Codigos CFOP\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopCadastrar),expression:"model.permissoes.codigoCfopCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopCadastrar)?_vm._i(_vm.model.permissoes.codigoCfopCadastrar,null)>-1:(_vm.model.permissoes.codigoCfopCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopEditar),expression:"model.permissoes.codigoCfopEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopEditar)?_vm._i(_vm.model.permissoes.codigoCfopEditar,null)>-1:(_vm.model.permissoes.codigoCfopEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopExcluir),expression:"model.permissoes.codigoCfopExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopExcluir)?_vm._i(_vm.model.permissoes.codigoCfopExcluir,null)>-1:(_vm.model.permissoes.codigoCfopExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopVisualizar),expression:"model.permissoes.codigoCfopVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopVisualizar)?_vm._i(_vm.model.permissoes.codigoCfopVisualizar,null)>-1:(_vm.model.permissoes.codigoCfopVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRelatorios),expression:"model.permissoes.codigoCfopRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRelatorios)?_vm._i(_vm.model.permissoes.codigoCfopRelatorios,null)>-1:(_vm.model.permissoes.codigoCfopRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Codigos CFOP Regras\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRegrasCadastrar),expression:"model.permissoes.codigoCfopRegrasCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRegrasCadastrar)?_vm._i(_vm.model.permissoes.codigoCfopRegrasCadastrar,null)>-1:(_vm.model.permissoes.codigoCfopRegrasCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRegrasCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRegrasCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRegrasEditar),expression:"model.permissoes.codigoCfopRegrasEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRegrasEditar)?_vm._i(_vm.model.permissoes.codigoCfopRegrasEditar,null)>-1:(_vm.model.permissoes.codigoCfopRegrasEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRegrasEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRegrasEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRegrasExcluir),expression:"model.permissoes.codigoCfopRegrasExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRegrasExcluir)?_vm._i(_vm.model.permissoes.codigoCfopRegrasExcluir,null)>-1:(_vm.model.permissoes.codigoCfopRegrasExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRegrasExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRegrasExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRegrasVisualizar),expression:"model.permissoes.codigoCfopRegrasVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRegrasVisualizar)?_vm._i(_vm.model.permissoes.codigoCfopRegrasVisualizar,null)>-1:(_vm.model.permissoes.codigoCfopRegrasVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRegrasVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRegrasVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.codigoCfopRegrasRelatorios),expression:"model.permissoes.codigoCfopRegrasRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.codigoCfopRegrasRelatorios)?_vm._i(_vm.model.permissoes.codigoCfopRegrasRelatorios,null)>-1:(_vm.model.permissoes.codigoCfopRegrasRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.codigoCfopRegrasRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "codigoCfopRegrasRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "codigoCfopRegrasRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Planos de Contas\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.planosContasCadastrar),expression:"model.permissoes.planosContasCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.planosContasCadastrar)?_vm._i(_vm.model.permissoes.planosContasCadastrar,null)>-1:(_vm.model.permissoes.planosContasCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.planosContasCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "planosContasCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "planosContasCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "planosContasCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.planosContasEditar),expression:"model.permissoes.planosContasEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.planosContasEditar)?_vm._i(_vm.model.permissoes.planosContasEditar,null)>-1:(_vm.model.permissoes.planosContasEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.planosContasEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "planosContasEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "planosContasEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "planosContasEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.planosContasExcluir),expression:"model.permissoes.planosContasExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.planosContasExcluir)?_vm._i(_vm.model.permissoes.planosContasExcluir,null)>-1:(_vm.model.permissoes.planosContasExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.planosContasExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "planosContasExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "planosContasExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "planosContasExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.planosContasVisualizar),expression:"model.permissoes.planosContasVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.planosContasVisualizar)?_vm._i(_vm.model.permissoes.planosContasVisualizar,null)>-1:(_vm.model.permissoes.planosContasVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.planosContasVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "planosContasVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "planosContasVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "planosContasVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.planosContasRelatorios),expression:"model.permissoes.planosContasRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.planosContasRelatorios)?_vm._i(_vm.model.permissoes.planosContasRelatorios,null)>-1:(_vm.model.permissoes.planosContasRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.planosContasRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "planosContasRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "planosContasRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "planosContasRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Marcas\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosMarcasCadastrar),expression:"model.permissoes.produtosMarcasCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosMarcasCadastrar)?_vm._i(_vm.model.permissoes.produtosMarcasCadastrar,null)>-1:(_vm.model.permissoes.produtosMarcasCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosMarcasCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosMarcasCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosMarcasCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosMarcasCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosMarcasEditar),expression:"model.permissoes.produtosMarcasEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosMarcasEditar)?_vm._i(_vm.model.permissoes.produtosMarcasEditar,null)>-1:(_vm.model.permissoes.produtosMarcasEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosMarcasEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosMarcasEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosMarcasEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosMarcasEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosMarcasExcluir),expression:"model.permissoes.produtosMarcasExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosMarcasExcluir)?_vm._i(_vm.model.permissoes.produtosMarcasExcluir,null)>-1:(_vm.model.permissoes.produtosMarcasExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosMarcasExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosMarcasExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosMarcasExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosMarcasExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosMarcasVisualizar),expression:"model.permissoes.produtosMarcasVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosMarcasVisualizar)?_vm._i(_vm.model.permissoes.produtosMarcasVisualizar,null)>-1:(_vm.model.permissoes.produtosMarcasVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosMarcasVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosMarcasVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosMarcasVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosMarcasVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosMarcasRelatorios),expression:"model.permissoes.produtosMarcasRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosMarcasRelatorios)?_vm._i(_vm.model.permissoes.produtosMarcasRelatorios,null)>-1:(_vm.model.permissoes.produtosMarcasRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosMarcasRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosMarcasRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosMarcasRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosMarcasRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Grupos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosGruposCadastrar),expression:"model.permissoes.produtosGruposCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosGruposCadastrar)?_vm._i(_vm.model.permissoes.produtosGruposCadastrar,null)>-1:(_vm.model.permissoes.produtosGruposCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosGruposCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosGruposCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosGruposCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosGruposCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosGruposEditar),expression:"model.permissoes.produtosGruposEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosGruposEditar)?_vm._i(_vm.model.permissoes.produtosGruposEditar,null)>-1:(_vm.model.permissoes.produtosGruposEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosGruposEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosGruposEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosGruposEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosGruposEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosGruposExcluir),expression:"model.permissoes.produtosGruposExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosGruposExcluir)?_vm._i(_vm.model.permissoes.produtosGruposExcluir,null)>-1:(_vm.model.permissoes.produtosGruposExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosGruposExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosGruposExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosGruposExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosGruposExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosGruposVisualizar),expression:"model.permissoes.produtosGruposVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosGruposVisualizar)?_vm._i(_vm.model.permissoes.produtosGruposVisualizar,null)>-1:(_vm.model.permissoes.produtosGruposVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosGruposVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosGruposVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosGruposVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosGruposVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosGruposRelatorios),expression:"model.permissoes.produtosGruposRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosGruposRelatorios)?_vm._i(_vm.model.permissoes.produtosGruposRelatorios,null)>-1:(_vm.model.permissoes.produtosGruposRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosGruposRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosGruposRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosGruposRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosGruposRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Sub Grupos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosSubGruposCadastrar),expression:"model.permissoes.produtosSubGruposCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosSubGruposCadastrar)?_vm._i(_vm.model.permissoes.produtosSubGruposCadastrar,null)>-1:(_vm.model.permissoes.produtosSubGruposCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosSubGruposCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosSubGruposCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosSubGruposEditar),expression:"model.permissoes.produtosSubGruposEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosSubGruposEditar)?_vm._i(_vm.model.permissoes.produtosSubGruposEditar,null)>-1:(_vm.model.permissoes.produtosSubGruposEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosSubGruposEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosSubGruposEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosSubGruposExcluir),expression:"model.permissoes.produtosSubGruposExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosSubGruposExcluir)?_vm._i(_vm.model.permissoes.produtosSubGruposExcluir,null)>-1:(_vm.model.permissoes.produtosSubGruposExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosSubGruposExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosSubGruposExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosSubGruposVisualizar),expression:"model.permissoes.produtosSubGruposVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosSubGruposVisualizar)?_vm._i(_vm.model.permissoes.produtosSubGruposVisualizar,null)>-1:(_vm.model.permissoes.produtosSubGruposVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosSubGruposVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosSubGruposVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosSubGruposRelatorios),expression:"model.permissoes.produtosSubGruposRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosSubGruposRelatorios)?_vm._i(_vm.model.permissoes.produtosSubGruposRelatorios,null)>-1:(_vm.model.permissoes.produtosSubGruposRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosSubGruposRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosSubGruposRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosSubGruposRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Cores\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCoresCadastrar),expression:"model.permissoes.produtosCoresCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCoresCadastrar)?_vm._i(_vm.model.permissoes.produtosCoresCadastrar,null)>-1:(_vm.model.permissoes.produtosCoresCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCoresCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCoresCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCoresCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCoresCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCoresEditar),expression:"model.permissoes.produtosCoresEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCoresEditar)?_vm._i(_vm.model.permissoes.produtosCoresEditar,null)>-1:(_vm.model.permissoes.produtosCoresEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCoresEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCoresEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCoresEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCoresEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCoresExcluir),expression:"model.permissoes.produtosCoresExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCoresExcluir)?_vm._i(_vm.model.permissoes.produtosCoresExcluir,null)>-1:(_vm.model.permissoes.produtosCoresExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCoresExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCoresExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCoresExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCoresExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCoresVisualizar),expression:"model.permissoes.produtosCoresVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCoresVisualizar)?_vm._i(_vm.model.permissoes.produtosCoresVisualizar,null)>-1:(_vm.model.permissoes.produtosCoresVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCoresVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCoresVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCoresVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCoresVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosCoresRelatorios),expression:"model.permissoes.produtosCoresRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosCoresRelatorios)?_vm._i(_vm.model.permissoes.produtosCoresRelatorios,null)>-1:(_vm.model.permissoes.produtosCoresRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosCoresRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosCoresRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosCoresRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosCoresRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Tamanhos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTamanhosCadastrar),expression:"model.permissoes.produtosTamanhosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTamanhosCadastrar)?_vm._i(_vm.model.permissoes.produtosTamanhosCadastrar,null)>-1:(_vm.model.permissoes.produtosTamanhosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTamanhosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTamanhosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTamanhosEditar),expression:"model.permissoes.produtosTamanhosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTamanhosEditar)?_vm._i(_vm.model.permissoes.produtosTamanhosEditar,null)>-1:(_vm.model.permissoes.produtosTamanhosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTamanhosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTamanhosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTamanhosExcluir),expression:"model.permissoes.produtosTamanhosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTamanhosExcluir)?_vm._i(_vm.model.permissoes.produtosTamanhosExcluir,null)>-1:(_vm.model.permissoes.produtosTamanhosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTamanhosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTamanhosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTamanhosVisualizar),expression:"model.permissoes.produtosTamanhosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTamanhosVisualizar)?_vm._i(_vm.model.permissoes.produtosTamanhosVisualizar,null)>-1:(_vm.model.permissoes.produtosTamanhosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTamanhosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTamanhosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTamanhosRelatorios),expression:"model.permissoes.produtosTamanhosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTamanhosRelatorios)?_vm._i(_vm.model.permissoes.produtosTamanhosRelatorios,null)>-1:(_vm.model.permissoes.produtosTamanhosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTamanhosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTamanhosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTamanhosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Unidades\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosUnidadesCadastrar),expression:"model.permissoes.produtosUnidadesCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosUnidadesCadastrar)?_vm._i(_vm.model.permissoes.produtosUnidadesCadastrar,null)>-1:(_vm.model.permissoes.produtosUnidadesCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosUnidadesCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosUnidadesCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosUnidadesEditar),expression:"model.permissoes.produtosUnidadesEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosUnidadesEditar)?_vm._i(_vm.model.permissoes.produtosUnidadesEditar,null)>-1:(_vm.model.permissoes.produtosUnidadesEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosUnidadesEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosUnidadesEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosUnidadesExcluir),expression:"model.permissoes.produtosUnidadesExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosUnidadesExcluir)?_vm._i(_vm.model.permissoes.produtosUnidadesExcluir,null)>-1:(_vm.model.permissoes.produtosUnidadesExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosUnidadesExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosUnidadesExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosUnidadesVisualizar),expression:"model.permissoes.produtosUnidadesVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosUnidadesVisualizar)?_vm._i(_vm.model.permissoes.produtosUnidadesVisualizar,null)>-1:(_vm.model.permissoes.produtosUnidadesVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosUnidadesVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosUnidadesVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosUnidadesRelatorios),expression:"model.permissoes.produtosUnidadesRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosUnidadesRelatorios)?_vm._i(_vm.model.permissoes.produtosUnidadesRelatorios,null)>-1:(_vm.model.permissoes.produtosUnidadesRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosUnidadesRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosUnidadesRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosUnidadesRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Departamentos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosDepartamentosCadastrar),expression:"model.permissoes.produtosDepartamentosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosDepartamentosCadastrar)?_vm._i(_vm.model.permissoes.produtosDepartamentosCadastrar,null)>-1:(_vm.model.permissoes.produtosDepartamentosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosDepartamentosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosDepartamentosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosDepartamentosEditar),expression:"model.permissoes.produtosDepartamentosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosDepartamentosEditar)?_vm._i(_vm.model.permissoes.produtosDepartamentosEditar,null)>-1:(_vm.model.permissoes.produtosDepartamentosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosDepartamentosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosDepartamentosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosDepartamentosExcluir),expression:"model.permissoes.produtosDepartamentosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosDepartamentosExcluir)?_vm._i(_vm.model.permissoes.produtosDepartamentosExcluir,null)>-1:(_vm.model.permissoes.produtosDepartamentosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosDepartamentosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosDepartamentosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosDepartamentosVisualizar),expression:"model.permissoes.produtosDepartamentosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosDepartamentosVisualizar)?_vm._i(_vm.model.permissoes.produtosDepartamentosVisualizar,null)>-1:(_vm.model.permissoes.produtosDepartamentosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosDepartamentosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosDepartamentosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosDepartamentosRelatorios),expression:"model.permissoes.produtosDepartamentosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosDepartamentosRelatorios)?_vm._i(_vm.model.permissoes.produtosDepartamentosRelatorios,null)>-1:(_vm.model.permissoes.produtosDepartamentosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosDepartamentosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosDepartamentosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosDepartamentosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Tabelas de Preços\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTabelasPrecosCadastrar),expression:"model.permissoes.produtosTabelasPrecosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTabelasPrecosCadastrar)?_vm._i(_vm.model.permissoes.produtosTabelasPrecosCadastrar,null)>-1:(_vm.model.permissoes.produtosTabelasPrecosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTabelasPrecosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTabelasPrecosEditar),expression:"model.permissoes.produtosTabelasPrecosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTabelasPrecosEditar)?_vm._i(_vm.model.permissoes.produtosTabelasPrecosEditar,null)>-1:(_vm.model.permissoes.produtosTabelasPrecosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTabelasPrecosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTabelasPrecosExcluir),expression:"model.permissoes.produtosTabelasPrecosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTabelasPrecosExcluir)?_vm._i(_vm.model.permissoes.produtosTabelasPrecosExcluir,null)>-1:(_vm.model.permissoes.produtosTabelasPrecosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTabelasPrecosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTabelasPrecosVisualizar),expression:"model.permissoes.produtosTabelasPrecosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTabelasPrecosVisualizar)?_vm._i(_vm.model.permissoes.produtosTabelasPrecosVisualizar,null)>-1:(_vm.model.permissoes.produtosTabelasPrecosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTabelasPrecosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.produtosTabelasPrecosRelatorios),expression:"model.permissoes.produtosTabelasPrecosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.produtosTabelasPrecosRelatorios)?_vm._i(_vm.model.permissoes.produtosTabelasPrecosRelatorios,null)>-1:(_vm.model.permissoes.produtosTabelasPrecosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.produtosTabelasPrecosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "produtosTabelasPrecosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Unidade de Negócio\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.unidadesNegocioCadastrar),expression:"model.permissoes.unidadesNegocioCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.unidadesNegocioCadastrar)?_vm._i(_vm.model.permissoes.unidadesNegocioCadastrar,null)>-1:(_vm.model.permissoes.unidadesNegocioCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.unidadesNegocioCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "unidadesNegocioCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.unidadesNegocioEditar),expression:"model.permissoes.unidadesNegocioEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.unidadesNegocioEditar)?_vm._i(_vm.model.permissoes.unidadesNegocioEditar,null)>-1:(_vm.model.permissoes.unidadesNegocioEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.unidadesNegocioEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "unidadesNegocioEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.unidadesNegocioExcluir),expression:"model.permissoes.unidadesNegocioExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.unidadesNegocioExcluir)?_vm._i(_vm.model.permissoes.unidadesNegocioExcluir,null)>-1:(_vm.model.permissoes.unidadesNegocioExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.unidadesNegocioExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "unidadesNegocioExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.unidadesNegocioVisualizar),expression:"model.permissoes.unidadesNegocioVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.unidadesNegocioVisualizar)?_vm._i(_vm.model.permissoes.unidadesNegocioVisualizar,null)>-1:(_vm.model.permissoes.unidadesNegocioVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.unidadesNegocioVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "unidadesNegocioVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.unidadesNegocioRelatorios),expression:"model.permissoes.unidadesNegocioRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.unidadesNegocioRelatorios)?_vm._i(_vm.model.permissoes.unidadesNegocioRelatorios,null)>-1:(_vm.model.permissoes.unidadesNegocioRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.unidadesNegocioRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "unidadesNegocioRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "unidadesNegocioRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Tipo de Contato\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposContatosCadastrar),expression:"model.permissoes.tiposContatosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposContatosCadastrar)?_vm._i(_vm.model.permissoes.tiposContatosCadastrar,null)>-1:(_vm.model.permissoes.tiposContatosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposContatosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposContatosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposContatosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposContatosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposContatosEditar),expression:"model.permissoes.tiposContatosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposContatosEditar)?_vm._i(_vm.model.permissoes.tiposContatosEditar,null)>-1:(_vm.model.permissoes.tiposContatosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposContatosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposContatosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposContatosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposContatosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposContatosExcluir),expression:"model.permissoes.tiposContatosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposContatosExcluir)?_vm._i(_vm.model.permissoes.tiposContatosExcluir,null)>-1:(_vm.model.permissoes.tiposContatosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposContatosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposContatosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposContatosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposContatosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposContatosVisualizar),expression:"model.permissoes.tiposContatosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposContatosVisualizar)?_vm._i(_vm.model.permissoes.tiposContatosVisualizar,null)>-1:(_vm.model.permissoes.tiposContatosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposContatosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposContatosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposContatosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposContatosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposContatosRelatorios),expression:"model.permissoes.tiposContatosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposContatosRelatorios)?_vm._i(_vm.model.permissoes.tiposContatosRelatorios,null)>-1:(_vm.model.permissoes.tiposContatosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposContatosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposContatosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposContatosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposContatosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Tipos Enderecos\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposEnderecosCadastrar),expression:"model.permissoes.tiposEnderecosCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposEnderecosCadastrar)?_vm._i(_vm.model.permissoes.tiposEnderecosCadastrar,null)>-1:(_vm.model.permissoes.tiposEnderecosCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposEnderecosCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposEnderecosCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposEnderecosEditar),expression:"model.permissoes.tiposEnderecosEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposEnderecosEditar)?_vm._i(_vm.model.permissoes.tiposEnderecosEditar,null)>-1:(_vm.model.permissoes.tiposEnderecosEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposEnderecosEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposEnderecosEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposEnderecosExcluir),expression:"model.permissoes.tiposEnderecosExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposEnderecosExcluir)?_vm._i(_vm.model.permissoes.tiposEnderecosExcluir,null)>-1:(_vm.model.permissoes.tiposEnderecosExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposEnderecosExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposEnderecosExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposEnderecosVisualizar),expression:"model.permissoes.tiposEnderecosVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposEnderecosVisualizar)?_vm._i(_vm.model.permissoes.tiposEnderecosVisualizar,null)>-1:(_vm.model.permissoes.tiposEnderecosVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposEnderecosVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposEnderecosVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposEnderecosRelatorios),expression:"model.permissoes.tiposEnderecosRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposEnderecosRelatorios)?_vm._i(_vm.model.permissoes.tiposEnderecosRelatorios,null)>-1:(_vm.model.permissoes.tiposEnderecosRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposEnderecosRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposEnderecosRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposEnderecosRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Tipos Interacoes\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposInteracoesCadastrar),expression:"model.permissoes.tiposInteracoesCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposInteracoesCadastrar)?_vm._i(_vm.model.permissoes.tiposInteracoesCadastrar,null)>-1:(_vm.model.permissoes.tiposInteracoesCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposInteracoesCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposInteracoesCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposInteracoesEditar),expression:"model.permissoes.tiposInteracoesEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposInteracoesEditar)?_vm._i(_vm.model.permissoes.tiposInteracoesEditar,null)>-1:(_vm.model.permissoes.tiposInteracoesEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposInteracoesEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposInteracoesEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposInteracoesExcluir),expression:"model.permissoes.tiposInteracoesExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposInteracoesExcluir)?_vm._i(_vm.model.permissoes.tiposInteracoesExcluir,null)>-1:(_vm.model.permissoes.tiposInteracoesExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposInteracoesExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposInteracoesExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposInteracoesVisualizar),expression:"model.permissoes.tiposInteracoesVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposInteracoesVisualizar)?_vm._i(_vm.model.permissoes.tiposInteracoesVisualizar,null)>-1:(_vm.model.permissoes.tiposInteracoesVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposInteracoesVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposInteracoesVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.tiposInteracoesRelatorios),expression:"model.permissoes.tiposInteracoesRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.tiposInteracoesRelatorios)?_vm._i(_vm.model.permissoes.tiposInteracoesRelatorios,null)>-1:(_vm.model.permissoes.tiposInteracoesRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.tiposInteracoesRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "tiposInteracoesRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "tiposInteracoesRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Motivos Cancelamento\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosCancelamentoCadastrar),expression:"model.permissoes.motivosCancelamentoCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosCancelamentoCadastrar)?_vm._i(_vm.model.permissoes.motivosCancelamentoCadastrar,null)>-1:(_vm.model.permissoes.motivosCancelamentoCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosCancelamentoCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosCancelamentoCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosCancelamentoEditar),expression:"model.permissoes.motivosCancelamentoEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosCancelamentoEditar)?_vm._i(_vm.model.permissoes.motivosCancelamentoEditar,null)>-1:(_vm.model.permissoes.motivosCancelamentoEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosCancelamentoEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosCancelamentoEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosCancelamentoExcluir),expression:"model.permissoes.motivosCancelamentoExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosCancelamentoExcluir)?_vm._i(_vm.model.permissoes.motivosCancelamentoExcluir,null)>-1:(_vm.model.permissoes.motivosCancelamentoExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosCancelamentoExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosCancelamentoExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosCancelamentoVisualizar),expression:"model.permissoes.motivosCancelamentoVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosCancelamentoVisualizar)?_vm._i(_vm.model.permissoes.motivosCancelamentoVisualizar,null)>-1:(_vm.model.permissoes.motivosCancelamentoVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosCancelamentoVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosCancelamentoVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosCancelamentoRelatorios),expression:"model.permissoes.motivosCancelamentoRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosCancelamentoRelatorios)?_vm._i(_vm.model.permissoes.motivosCancelamentoRelatorios,null)>-1:(_vm.model.permissoes.motivosCancelamentoRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosCancelamentoRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosCancelamentoRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosCancelamentoRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Motivos Devolucoes\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosDevolucaoCadastrar),expression:"model.permissoes.motivosDevolucaoCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosDevolucaoCadastrar)?_vm._i(_vm.model.permissoes.motivosDevolucaoCadastrar,null)>-1:(_vm.model.permissoes.motivosDevolucaoCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosDevolucaoCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosDevolucaoCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosDevolucaoEditar),expression:"model.permissoes.motivosDevolucaoEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosDevolucaoEditar)?_vm._i(_vm.model.permissoes.motivosDevolucaoEditar,null)>-1:(_vm.model.permissoes.motivosDevolucaoEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosDevolucaoEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosDevolucaoEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosDevolucaoExcluir),expression:"model.permissoes.motivosDevolucaoExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosDevolucaoExcluir)?_vm._i(_vm.model.permissoes.motivosDevolucaoExcluir,null)>-1:(_vm.model.permissoes.motivosDevolucaoExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosDevolucaoExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosDevolucaoExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosDevolucaoVisualizar),expression:"model.permissoes.motivosDevolucaoVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosDevolucaoVisualizar)?_vm._i(_vm.model.permissoes.motivosDevolucaoVisualizar,null)>-1:(_vm.model.permissoes.motivosDevolucaoVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosDevolucaoVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosDevolucaoVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosDevolucaoRelatorios),expression:"model.permissoes.motivosDevolucaoRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosDevolucaoRelatorios)?_vm._i(_vm.model.permissoes.motivosDevolucaoRelatorios,null)>-1:(_vm.model.permissoes.motivosDevolucaoRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosDevolucaoRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosDevolucaoRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosDevolucaoRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Motivos Interacoes\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosInteracoesCadastrar),expression:"model.permissoes.motivosInteracoesCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosInteracoesCadastrar)?_vm._i(_vm.model.permissoes.motivosInteracoesCadastrar,null)>-1:(_vm.model.permissoes.motivosInteracoesCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosInteracoesCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosInteracoesCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosInteracoesEditar),expression:"model.permissoes.motivosInteracoesEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosInteracoesEditar)?_vm._i(_vm.model.permissoes.motivosInteracoesEditar,null)>-1:(_vm.model.permissoes.motivosInteracoesEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosInteracoesEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosInteracoesEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosInteracoesExcluir),expression:"model.permissoes.motivosInteracoesExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosInteracoesExcluir)?_vm._i(_vm.model.permissoes.motivosInteracoesExcluir,null)>-1:(_vm.model.permissoes.motivosInteracoesExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosInteracoesExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosInteracoesExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosInteracoesVisualizar),expression:"model.permissoes.motivosInteracoesVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosInteracoesVisualizar)?_vm._i(_vm.model.permissoes.motivosInteracoesVisualizar,null)>-1:(_vm.model.permissoes.motivosInteracoesVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosInteracoesVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosInteracoesVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.motivosInteracoesRelatorios),expression:"model.permissoes.motivosInteracoesRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.motivosInteracoesRelatorios)?_vm._i(_vm.model.permissoes.motivosInteracoesRelatorios,null)>-1:(_vm.model.permissoes.motivosInteracoesRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.motivosInteracoesRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "motivosInteracoesRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "motivosInteracoesRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Usuários\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.usuarioCadastrar),expression:"model.permissoes.usuarioCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.usuarioCadastrar)?_vm._i(_vm.model.permissoes.usuarioCadastrar,null)>-1:(_vm.model.permissoes.usuarioCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.usuarioCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "usuarioCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "usuarioCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "usuarioCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.usuarioEditar),expression:"model.permissoes.usuarioEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.usuarioEditar)?_vm._i(_vm.model.permissoes.usuarioEditar,null)>-1:(_vm.model.permissoes.usuarioEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.usuarioEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "usuarioEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "usuarioEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "usuarioEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.usuarioExcluir),expression:"model.permissoes.usuarioExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.usuarioExcluir)?_vm._i(_vm.model.permissoes.usuarioExcluir,null)>-1:(_vm.model.permissoes.usuarioExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.usuarioExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "usuarioExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "usuarioExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "usuarioExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.usuarioVisualizar),expression:"model.permissoes.usuarioVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.usuarioVisualizar)?_vm._i(_vm.model.permissoes.usuarioVisualizar,null)>-1:(_vm.model.permissoes.usuarioVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.usuarioVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "usuarioVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "usuarioVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "usuarioVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.usuarioRelatorios),expression:"model.permissoes.usuarioRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.usuarioRelatorios)?_vm._i(_vm.model.permissoes.usuarioRelatorios,null)>-1:(_vm.model.permissoes.usuarioRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.usuarioRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "usuarioRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "usuarioRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "usuarioRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Empresa\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.empresaCadastrar),expression:"model.permissoes.empresaCadastrar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.empresaCadastrar)?_vm._i(_vm.model.permissoes.empresaCadastrar,null)>-1:(_vm.model.permissoes.empresaCadastrar)},on:{"change":function($event){var $$a=_vm.model.permissoes.empresaCadastrar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "empresaCadastrar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "empresaCadastrar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "empresaCadastrar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" CADASTRAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.empresaEditar),expression:"model.permissoes.empresaEditar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.empresaEditar)?_vm._i(_vm.model.permissoes.empresaEditar,null)>-1:(_vm.model.permissoes.empresaEditar)},on:{"change":function($event){var $$a=_vm.model.permissoes.empresaEditar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "empresaEditar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "empresaEditar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "empresaEditar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EDITAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.empresaExcluir),expression:"model.permissoes.empresaExcluir"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.empresaExcluir)?_vm._i(_vm.model.permissoes.empresaExcluir,null)>-1:(_vm.model.permissoes.empresaExcluir)},on:{"change":function($event){var $$a=_vm.model.permissoes.empresaExcluir,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "empresaExcluir", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "empresaExcluir", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "empresaExcluir", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" EXCLUIR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.empresaVisualizar),expression:"model.permissoes.empresaVisualizar"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.empresaVisualizar)?_vm._i(_vm.model.permissoes.empresaVisualizar,null)>-1:(_vm.model.permissoes.empresaVisualizar)},on:{"change":function($event){var $$a=_vm.model.permissoes.empresaVisualizar,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "empresaVisualizar", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "empresaVisualizar", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "empresaVisualizar", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" VISUALIZAR")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.empresaRelatorios),expression:"model.permissoes.empresaRelatorios"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.empresaRelatorios)?_vm._i(_vm.model.permissoes.empresaRelatorios,null)>-1:(_vm.model.permissoes.empresaRelatorios)},on:{"change":function($event){var $$a=_vm.model.permissoes.empresaRelatorios,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "empresaRelatorios", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "empresaRelatorios", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "empresaRelatorios", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" RELATORIOS")])])])])])]),_vm._v(" "),_c('div',{staticClass:"form-group col-md-4"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_vm._v("\n                  Parametros\n                ")]),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.parametroBloquearPrecoVenda),expression:"model.permissoes.parametroBloquearPrecoVenda"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.parametroBloquearPrecoVenda)?_vm._i(_vm.model.permissoes.parametroBloquearPrecoVenda,null)>-1:(_vm.model.permissoes.parametroBloquearPrecoVenda)},on:{"change":function($event){var $$a=_vm.model.permissoes.parametroBloquearPrecoVenda,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoVenda", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoVenda", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoVenda", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" Bloquear Preço Venda")])])]),_vm._v(" "),_c('div',{staticClass:"form-check"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model.permissoes.parametroBloquearPrecoPedido),expression:"model.permissoes.parametroBloquearPrecoPedido"}],attrs:{"type":"checkbox","id":"checkbox"},domProps:{"checked":Array.isArray(_vm.model.permissoes.parametroBloquearPrecoPedido)?_vm._i(_vm.model.permissoes.parametroBloquearPrecoPedido,null)>-1:(_vm.model.permissoes.parametroBloquearPrecoPedido)},on:{"change":function($event){var $$a=_vm.model.permissoes.parametroBloquearPrecoPedido,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoPedido", $$a.concat([$$v])))}else{$$i>-1&&(_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoPedido", $$a.slice(0,$$i).concat($$a.slice($$i+1))))}}else{_vm.$set(_vm.model.permissoes, "parametroBloquearPrecoPedido", $$c)}}}}),_c('span',{staticClass:"label-text"},[_vm._v(" Bloquear Preço Pedido")])])])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('h4',[_vm._v("Editar Usuário")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "r15W":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__ = __webpack_require__("xKc6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue__);
/* unused harmony namespace reexport */
function injectStyle (ssrContext) {
  __webpack_require__("X7DP")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */
var __vue_template__ = null
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_vue_loader_lib_selector_type_script_index_0_progress_vue___default.a,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "r1zz":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      processando: false,
      showModalMudarMotorista: false,
      showModalMudarMotivo: false,
      showModalAdicionarDiaria: false,
      adicionarDiaria: {
        id: '0',
        dataHoraInicio: '',
        dataHoraInicioManual: '',
        dataHoraInicioControleManual: '',
        dataHoraFinal: '',
        dataHoraFinalManual: '',
        dataHoraFinalControleManual: '',
        dataHoraDuracao: '',
        statusVeiculo: '',
        motivo: '34',
        tipoMotivo: '',
        observacao: ''
      },
      showModalDividirTempo: false,
      dividirTempo: {
        id: '0',
        dataHoraInicio: '',
        dataHoraInicioManual: '',
        dataHoraInicioControleManual: '',
        dataHoraFinal: '',
        dataHoraFinalManual: '',
        dataHoraFinalControleManual: '',
        dataHoraDuracao: '',
        statusVeiculo: '',
        motivo: '03',
        tipoMotivo: '',
        observacao: ''
      },
      showModalMapa: false,
      jornada: [],
      jornadaItens: [],
      motoristaId: '0',
      motoristaNome: '',
      mudarMotivoId: '0',
      selecionada: '0',
      selecionados: [],
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      places: [],
      currentPlace: null,
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      }
    };
  },

  created: function created() {
    this.buscar();
    this.buscarItens();
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        this.selecionados = [];
        this.selecionados.push(item);
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    buscar: function buscar() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/editar?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornada = dados;
      });
    },
    buscarItens: function buscarItens() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gestaoJornadas/itens?id=' + this.$route.params.id;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.jornadaItens = dados;
      });
    },
    mudarMotorista: function mudarMotorista() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/mudarMotorista?jornadaId=' + this.$route.params.id + '&motoristaId=' + self.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotorista = false;
          self.buscar();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    mudarMotivoModal: function mudarMotivoModal() {
      var self = this;
      self.showModalMudarMotivo = true;
    },
    mudarMotivo: function mudarMotivo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '';
      if (self.selecionados.length === 0) {
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id;
      } else {
        var gestaoJornadaItemIds = '';
        for (var i = 0; i < self.selecionados.length; i++) {
          if (i === 0) {
            gestaoJornadaItemIds = self.selecionados[i].id;
          } else {
            gestaoJornadaItemIds = gestaoJornadaItemIds + ';' + self.selecionados[i].id;
          }
        }
        url = '/api/gestaoJornadas/mudarMotivos?gestaoJornadaItemId=' + gestaoJornadaItemIds + '&motivo=' + self.mudarMotivoId + '&gestaoJornadaId=' + this.$route.params.id;
      }
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalMudarMotivo = false;
          self.buscar();
          self.buscarItens();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    setarMotorista: function setarMotorista(motorista) {
      this.motoristaId = motorista.id;
      this.motoristaNome = motorista.nome;
      $(this.$el).find('#motoristaNome').val(motorista.nome);
    },
    verificarMotorista: function verificarMotorista() {
      if ($(this.$el).find('#motoristaId').val() === '0') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
      if ($(this.$el).find('#motoristaNome').val() === '') {
        this.motoristaId = 0;
        this.motoristaNome = '';
        $(this.$el).find('#motoristaId').val(0);
        $(this.$el).find('#motoristaNome').val('');
      }
    },
    showAdicionarDiaria: function showAdicionarDiaria(jornadaId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/buscarJornadaItem?id=' + jornadaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        self.showModalAdicionarDiaria = true;
        var dados = response.data;
        self.adicionarDiaria.id = dados.id;
        self.adicionarDiaria.dataHoraInicio = dados.dataHoraInicio;
        self.adicionarDiaria.dataHoraFinal = dados.dataHoraFinal;
        self.adicionarDiaria.dataHoraDuracao = dados.dataHoraDuracao;
        self.adicionarDiaria.statusVeiculo = dados.statusVeiculo;

        self.adicionarDiaria.tipoMotivo = dados.tipoMotivo;
        self.adicionarDiaria.observacao = dados.observacao;
      }).catch(function (error) {
        console.log(error);
      });
    },
    gravarAdicionarDiaria: function gravarAdicionarDiaria() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/gravarInsercaoItem?id=' + self.adicionarDiaria.id + '&dataHoraInicio=' + self.adicionarDiaria.dataHoraInicio + '&dataHoraFinal=' + self.adicionarDiaria.dataHoraFinal + '&dataHoraDuracao=' + self.adicionarDiaria.dataHoraDuracao + '&motivo=' + self.adicionarDiaria.motivo + '&observacao=' + self.adicionarDiaria.observacao + '&status=' + self.adicionarDiaria.statusVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalAdicionarDiaria = false;
          self.buscar();
          self.buscarItens();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    showDividirTempo: function showDividirTempo(jornadaId) {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/buscarJornadaItem?id=' + jornadaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        self.processando = false;
        self.showModalDividirTempo = true;
        var dados = response.data;
        self.dividirTempo.id = dados.id;
        self.dividirTempo.dataHoraInicio = dados.dataHoraInicio;
        self.dividirTempo.dataHoraFinal = dados.dataHoraFinal;
        self.dividirTempo.dataHoraDuracao = dados.dataHoraDuracao;
        self.dividirTempo.statusVeiculo = dados.statusVeiculo;
        self.dividirTempo.motivo = dados.motivo;
        self.dividirTempo.tipoMotivo = dados.tipoMotivo;
        self.dividirTempo.observacao = dados.observacao;
      }).catch(function (error) {
        console.log(error);
      });
    },
    gravarDividirTempo: function gravarDividirTempo() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/gravarDivisaoGestaoJornadaItem?id=' + self.dividirTempo.id + '&dataHoraInicio=' + self.dividirTempo.dataHoraInicio + '&dataHoraFinal=' + self.dividirTempo.dataHoraFinal + '&dataHoraDuracao=' + self.dividirTempo.dataHoraDuracao + '&motivo=' + self.dividirTempo.motivo + '&observacao=' + self.dividirTempo.observacao + '&status=' + self.dividirTempo.statusVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.showModalDividirTempo = false;
          self.buscar();
          self.buscarItens();
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    visualizarMapa: function visualizarMapa(grid) {
      var self = this;
      self.showModalMapa = true;
      self.adicionarMarkers(grid);
    },
    adicionarMarkers: function adicionarMarkers(grid) {
      var self = this;
      self.removerMarkers();
      var bounds = null;
      var myLatLng = null;
      var latitudes = grid.latitude.split(';');
      var longitudes = grid.longitude.split(';');
      for (var i = 0; i < latitudes.length; i++) {
        if (latitudes[i] !== '') {
          var marker = {
            lat: parseFloat(latitudes[i]),
            lng: parseFloat(longitudes[i])
          };
          self.markers.push({ position: marker });
          self.center = { lat: marker.lat, lng: marker.lng };

          myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
          bounds = new window.google.maps.LatLngBounds();
          bounds.extend(myLatLng);
        }
      }
      self.$refs.map.fitBounds(bounds);
      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },

    salvar: function salvar() {
      var self = this;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      self.processando = true;
      var url = '/api/gestaoJornadas/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.jornada), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.$router.replace('/gestaoJornada');
        }
      }).catch(function (error) {
        console.log(error);
      });
    }
  }
};

/***/ }),

/***/ "r9Uq":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosRelatorios: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarRelatorio();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    buscarRelatorio: function buscarRelatorio() {
      var self = this;
      self.processando = true;
      var veiculoId = this.$route.params.veiculo;
      var dataHoraInicial = this.$route.params.dataHoraInicial;
      dataHoraInicial = dataHoraInicial.replace(/-/g, '/');
      var dataHoraFinal = this.$route.params.dataHoraFinal;
      dataHoraFinal = dataHoraFinal.replace(/-/g, '/');
      var filtroVelocidade = this.$route.params.filtroVelocidade;
      var desprezarVelocidade = this.$route.params.desprezarVelocidade;
      var agruparPosicoes = this.$route.params.agruparPosicoes;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/relatorios/relatorioDePosicoes?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal + '&filtroVelocidade=' + filtroVelocidade + '&desprezarVelocidade=' + desprezarVelocidade + '&agruparPosicoes=' + agruparPosicoes;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosRelatorios = dadosCadastro;
        self.processando = false;
      });
    }
  }
};

/***/ }),

/***/ "rKAy":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-5"},[_c('div',{attrs:{"id":"veiculoPeriodo"}},[_c('div',{staticClass:"panel panel-default"},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12",attrs:{"id":"lista-veiculos"}},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.veiculoId),expression:"filtros.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.filtros.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.clienteId),expression:"filtros.clienteId"}],staticClass:"form-control",attrs:{"id":"clienteId","type":"hidden"},domProps:{"value":(_vm.filtros.clienteId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "clienteId", $event.target.value)}}}),_vm._v(" "),_c('h4',{staticClass:"panel-title"},[_vm._v("Veículo:")]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.buscaVeiculo),expression:"buscaVeiculo"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","placeholder":"Filtrar veículo","type":"text"},domProps:{"value":(_vm.buscaVeiculo)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarVeiculos($event)},"input":function($event){if($event.target.composing){ return; }_vm.buscaVeiculo=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.buscarVeiculos}},[_vm._v("Buscar")])])]),_vm._v(" "),_c('div',{attrs:{"id":"dados-analise-jornada-lista-veiculos"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(0),_vm._v(" "),_vm._l((_vm.dadosGrid),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dadosGrid[i].clienteIdVeiculo != _vm.dadosGrid[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'selecionado': _vm.selecionado(grid) },on:{"click":function($event){_vm.selecionarItem(grid)},"dblclick":function($event){_vm.editar(grid.idVeiculo)}}},[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))]),_vm._v(" "),(grid.marcaEquipamento == 'OBD')?[_c('img',{attrs:{"src":"/static/images/obd.png"}})]:_vm._e()],2)])],2)})],2)])])])])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-7"},[_c('div',{staticClass:"row row-margin"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data inicial:")]),_c('br'),_vm._v(" "),_c('input-data-format',{staticClass:"form-control pula data",attrs:{"id":'dataInicial'},nativeOn:{"blur":function($event){return _vm.setarDataInicial($event)}},model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Hora inicial: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",attrs:{"id":'horaInicial'},model:{value:(_vm.filtros.horaInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "horaInicial", $$v)},expression:"filtros.horaInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"id":"dataFinalLabel"}},[_vm._v("Data final:")]),_c('br'),_vm._v(" "),_c('input-data-format',{staticClass:"form-control pula data",attrs:{"id":'dataFinal'},nativeOn:{"blur":function($event){return _vm.setarDataFinal($event)}},model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"id":"horaFinalLabel"}},[_vm._v("Hora final: ")]),_c('br'),_vm._v(" "),_c('input-hora-picker-ss',{staticClass:"form-control pula hora",attrs:{"id":'horaFinal'},model:{value:(_vm.filtros.horaFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "horaFinal", $$v)},expression:"filtros.horaFinal"}})],1)]),_vm._v(" "),_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{attrs:{"id":"opcoesRelatorio"}},[_c('div',{staticClass:"panel panel-default"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"panel-body"},[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"0"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"0")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "0")}}}),_vm._v(" Relatório de Posições ")]),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.filtros.veiculoMarcaEquipamento == 'OBD')?[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"1"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"1")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "1")}}}),_vm._v(" Relatório de Posições OBD ")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"4"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"4")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "4")}}}),_vm._v(" Relatório de Posições OBD Viagem")]),_vm._v(" "),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"5"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"5")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "5")}}}),_vm._v(" Relatório de Posições OBD Fahas")]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"2"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"2")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "2")}}}),_vm._v(" Relatório de Análise de Trabalho e Produção ")]),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"3"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"3")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "3")}}}),_vm._v(" Relatório de Análise de Trabalho e Produção Sintético ")]),_c('br'),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"6"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"6")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "6")}}}),_vm._v(" Relatório de Km Rodado por Veículo")]),_c('br'),_vm._v(" "),_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"7"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"7")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "7")}}}),_vm._v(" Relatório de Km Rodado por Frota")]),_c('br')]:_vm._e(),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('label',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.relatorio),expression:"filtros.relatorio"}],attrs:{"type":"radio","name":"tipoRelatorio","value":"100"},domProps:{"checked":_vm._q(_vm.filtros.relatorio,"100")},on:{"change":function($event){_vm.$set(_vm.filtros, "relatorio", "100")}}}),_vm._v(" TESTE Relatório de Posições")]),_vm._v(" "),_c('br')]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),(_vm.filtros.relatorio !== '2' && _vm.filtros.relatorio !== '3')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Filtrar velocidade maior que: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.filtroVelocidade),expression:"filtros.filtroVelocidade"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.filtroVelocidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "filtroVelocidade", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Velocidade mínima para média: ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.desprezarVelocidade),expression:"filtros.desprezarVelocidade"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.desprezarVelocidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "desprezarVelocidade", $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.filtros.relatorio === '5')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Filtrar velocidade mínima: ")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.filtroVelocidadeMinima),expression:"filtros.filtroVelocidadeMinima"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.filtroVelocidadeMinima)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "filtroVelocidadeMinima", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Filtrar velocidade máxima: ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.filtroVelocidadeMaxima),expression:"filtros.filtroVelocidadeMaxima"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.filtroVelocidadeMaxima)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "filtroVelocidadeMaxima", $event.target.value)}}})])])]:_vm._e(),_vm._v(" "),(_vm.filtros.relatorio === '0' || _vm.filtros.relatorio === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',{attrs:{"id":"agruparPosicoesLabel"}},[_vm._v("Agrupar Posições")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.agruparPosicoes),expression:"filtros.agruparPosicoes"}],staticClass:"form-control",attrs:{"id":"agruparPosicoes"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "agruparPosicoes", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"N"}},[_vm._v("Não Agrupar")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("5 Minutos")]),_vm._v(" "),_c('option',{attrs:{"value":"10"}},[_vm._v("10 Minutos")])])])])]:_vm._e(),_vm._v(" "),(_vm.filtros.relatorio === '2' || _vm.filtros.relatorio === '3')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{attrs:{"id":"entradaLabel"}},[_vm._v("Entrada Analisada:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.entrada),expression:"filtros.entrada"}],staticClass:"form-control",attrs:{"id":"entrada"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "entrada", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"ignicao"}},[_vm._v("Ignição")]),_vm._v(" "),_c('option',{attrs:{"value":"velocidade"}},[_vm._v("Velocidade")]),_vm._v(" "),_c('option',{attrs:{"value":"entrada1"}},[_vm._v("Entrada 1")]),_vm._v(" "),_c('option',{attrs:{"value":"entrada2"}},[_vm._v("Entrada 2")]),_vm._v(" "),_c('option',{attrs:{"value":"entrada3"}},[_vm._v("Entrada 3")]),_vm._v(" "),_c('option',{attrs:{"value":"entrada4"}},[_vm._v("Entrada 4")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[(_vm.filtros.entrada === 'velocidade')?[_c('label',[_vm._v("Filtrar velocidade máxima: ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.entradaVelocidade),expression:"filtros.entradaVelocidade"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.entradaVelocidade)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "entradaVelocidade", $event.target.value)}}})]:_vm._e()],2)])]:_vm._e(),_vm._v(" "),(_vm.filtros.relatorio === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Ignição: ")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.obdIgnicao),expression:"filtros.obdIgnicao"}],staticClass:"form-control",attrs:{"id":"entrada"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "obdIgnicao", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"todas"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"ligada"}},[_vm._v("Ligada")]),_vm._v(" "),_c('option',{attrs:{"value":"desligada"}},[_vm._v("Desligada")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("RPM: ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.obdRpm),expression:"filtros.obdRpm"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.obdRpm)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "obdRpm", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Temperatura: ")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.obdTemperatura),expression:"filtros.obdTemperatura"}],staticClass:"form-control",domProps:{"value":(_vm.filtros.obdTemperatura)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "obdTemperatura", $event.target.value)}}})]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('label',[_vm._v("Erro: ")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.obdErro),expression:"filtros.obdErro"}],staticClass:"form-control",attrs:{"id":"entrada"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "obdErro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"todas"}},[_vm._v("Todas")]),_vm._v(" "),_c('option',{attrs:{"value":"sim"}},[_vm._v("Sim")]),_vm._v(" "),_c('option',{attrs:{"value":"nao"}},[_vm._v("Não")])])])])]:_vm._e(),_vm._v(" "),_c('br'),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success btn-lg btn-block",attrs:{"id":"gerarRelatorio","type":"button"},on:{"click":_vm.gerarRelatorio}},[_c('span',{staticClass:"glyphicon glyphicon-star",attrs:{"aria-hidden":"true"}}),_vm._v(" Gerar Relatório\n                    ")])])])],2)])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Período:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"text-right"},[_c('small',[_vm._v("*Os dados de rastreamento ficam armazenados por 90 dias.")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"panel-heading"},[_c('h4',{staticClass:"panel-title"},[_vm._v("Relatório")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rZ8Y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalNovaJornada)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Tipo Jornada:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.tipoJornada),expression:"jornada.tipoJornada"}],staticClass:"form-control",attrs:{"id":"modalItemTipoJornada","required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.jornada, "tipoJornada", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Jornada")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("Falta")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("Folga")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("Folga Semanal")]),_vm._v(" "),_c('option',{attrs:{"value":"9"}},[_vm._v("Folga I.J.")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("Feriado")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("Atestado")]),_vm._v(" "),_c('option',{attrs:{"value":"8"}},[_vm._v("Ferias")])])])]),_vm._v(" "),(_vm.jornada.tipoJornada === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora Final:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraFinal", $$v)},expression:"jornada.dataHoraFinal"}})],1)])]:(_vm.jornada.tipoJornada === '8')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraFinal),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraFinal", $$v)},expression:"jornada.dataHoraFinal"}})],1)])]:[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-12"},[_c('label',[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.jornada.dataHoraInicial),callback:function ($$v) {_vm.$set(_vm.jornada, "dataHoraInicial", $$v)},expression:"jornada.dataHoraInicial"}})],1)])],_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.motoristaId),expression:"jornada.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNovaJornadaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotoristaNovaJornada,"on-blur":_vm.verificarMotoristaNovaJornada},model:{value:(_vm.jornada.motoristaNome),callback:function ($$v) {_vm.$set(_vm.jornada, "motoristaNome", $$v)},expression:"jornada.motoristaNome"}})],1)]),_vm._v(" "),(_vm.jornada.tipoJornada === '1')?[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.jornada.veiculoId),expression:"jornada.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoNovaJornadaId","type":"hidden"},domProps:{"value":(_vm.jornada.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.jornada, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('buscar-veiculo',{attrs:{"type":"search","id":"veiculoNovaJornadaDescricao","placeholder":"Selecione um veículo..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarVeiculoNovaJornada,"on-blur":_vm.verificarVeiculoNovaJornada},model:{value:(_vm.jornada.veiculoDescricao),callback:function ($$v) {_vm.$set(_vm.jornada, "veiculoDescricao", $$v)},expression:"jornada.veiculoDescricao"}})],1)])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarNovaJornada}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalNovaJornada = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),(_vm.showModalRelatorioSintetico)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('label',[_vm._v("Tipo Relatório:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.tipo),expression:"relatorio.tipo"}],staticClass:"form-control",attrs:{"required":"required"},on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorio, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1"}},[_vm._v("Relatório Sintetico")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataInicial", $$v)},expression:"relatorio.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.relatorio.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorio, "dataFinal", $$v)},expression:"relatorio.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorio.motoristaId),expression:"relatorio.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.relatorio.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.relatorio, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.relatorio.motoristaNome),callback:function ($$v) {_vm.$set(_vm.relatorio, "motoristaNome", $$v)},expression:"relatorio.motoristaNome"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.gerarRelatorioSintetico}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorioSintetico = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(3),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalNovaJornada = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Nova Jornada Manual\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.juntarJornada}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Juntar Jornadas\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":_vm.duplicarJornada}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Duplicar Jornada\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"type":"button"},on:{"click":function($event){_vm.showModalRelatorioSintetico = true}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatório Sintético\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button"},on:{"click":_vm.deletarMultiplas}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Deletar Jornadas\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})])])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Periodo:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataInicial),callback:function ($$v) {_vm.$set(_vm.filtros, "dataInicial", $$v)},expression:"filtros.dataInicial"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.filtros.dataFinal),callback:function ($$v) {_vm.$set(_vm.filtros, "dataFinal", $$v)},expression:"filtros.dataFinal"}})],1)]),_vm._v(" "),_c('div',{staticClass:"col-sm-8 col-md-8"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar()},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"todos","selected":"selected"}},[_vm._v("Todos")]),_vm._v(" "),_c('option',{attrs:{"value":"aprovadacom"}},[_vm._v("Aprovada com Documento")]),_vm._v(" "),_c('option',{attrs:{"value":"aprovadasem"}},[_vm._v("Aprovada")]),_vm._v(" "),_c('option',{attrs:{"value":"gerado"}},[_vm._v("Gerado pelo Sistema")]),_vm._v(" "),_c('option',{attrs:{"value":"editado"}},[_vm._v("Editado Manual")])])])]),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar()}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-limpo"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(4),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(jornada){return _c('tr',{class:{ 'selecionado': _vm.selecionado(jornada) },on:{"click":function($event){_vm.selecionarItem(jornada, $event)},"dblclick":function($event){_vm.editar(jornada.id)}}},[_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(jornada.id))]),_vm._v(" "),_c('td',{attrs:{"width":"155"}},[_vm._v(_vm._s(jornada.dataHoraInicial)),_c('br'),_vm._v(_vm._s(jornada.dataHoraFinal))]),_vm._v(" "),_c('td',[(jornada.diaria === true)?[_c('strong',[_vm._v("DIÁRIA")])]:_vm._e(),_vm._v(" "),(jornada.folga === true)?[_c('strong',[_vm._v("FOLGA")])]:_vm._e(),_vm._v(" "),(jornada.folgaSemanal === true)?[_c('strong',[_vm._v("FOLGA SEMANAL")])]:_vm._e(),_vm._v(" "),(jornada.folgaIJ === true)?[_c('strong',[_vm._v("FOLGA I.J.")])]:_vm._e(),_vm._v(" "),(jornada.falta === true)?[_c('strong',[_vm._v("FALTA")])]:_vm._e(),_vm._v(" "),(jornada.feriado === true)?[_c('strong',[_vm._v("FERIADO")])]:_vm._e(),_vm._v(" "),(jornada.atestado === true)?[_c('strong',[_vm._v("ATESTADO")])]:_vm._e(),_vm._v(" "),(jornada.ferias === true)?[_c('strong',[_vm._v("FÉRIAS")])]:_vm._e(),_vm._v(" "),(jornada.veiculoDescricao !== null)?[_c('strong',[_vm._v(_vm._s(jornada.veiculoDescricao))])]:_vm._e()],2),_vm._v(" "),_c('td',[_vm._v(_vm._s(jornada.motoristaNome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(jornada.status))]),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[(jornada.ajudante1Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 1'),expression:"'Gerar Jornada Ajudante 1'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 1)}}})]:_vm._e(),_vm._v(" "),(jornada.ajudante2Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 2'),expression:"'Gerar Jornada Ajudante 2'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 2)}}})]:_vm._e(),_vm._v(" "),(jornada.ajudante3Id !== null)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Gerar Jornada Ajudante 3'),expression:"'Gerar Jornada Ajudante 3'"}],attrs:{"src":"/static/images/motorista.png"},on:{"click":function($event){_vm.gerarJornadaAjudante(jornada.id, 3)}}})]:_vm._e()],2),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Imprimir'),expression:"'Imprimir'"}],attrs:{"src":"/static/images/imprimir.png"},on:{"click":function($event){_vm.imprimir(jornada.id)}}}),_vm._v(" "),_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'GestaoJornadasEditar', params: { id: jornada.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(jornada.id)}}})],1)])}))])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Nova Jornada")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatório Sintético")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Gestão de Jornadas")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Cód")]),_vm._v(" "),_c('th',[_vm._v("Período")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Motorista")]),_vm._v(" "),_c('th',[_vm._v("Status")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rfTd":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{staticClass:"btn btn-success",attrs:{"id":"btnNovoVeiculo","to":"/veiculos/novo"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_vm._m(1)],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaVeiculos","width":"100%"}},[_vm._m(2),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(veiculo){return _c('tr',{class:{ 'selecionado': _vm.selecionado(veiculo) },on:{"click":function($event){_vm.selecionarItem(veiculo)},"dblclick":function($event){_vm.editar(veiculo.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":veiculo.id}}),_vm._v(" "),(veiculo.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(veiculo.id))]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.clienteNome))])]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.descricao))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(veiculo.placa))])]),_vm._v(" "),_c('td',{attrs:{"width":"450"}},[_c('strong',[_vm._v(_vm._s(veiculo.modelo))]),_vm._v(" "),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(veiculo.marca))])]),_vm._v(" "),_c('td',{attrs:{"width":"80"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'VeiculosEditar', params: { id: veiculo.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})])],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Veiculos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Cliente")]),_vm._v(" "),_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',[_vm._v("Marca")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "rrPM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "rrxP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__ = __webpack_require__("xam5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b968885e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesLista_vue__ = __webpack_require__("c6lI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ClientesLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b968885e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ClientesLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "s49b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue__ = __webpack_require__("ujY6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e86b7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosDisparadosLista_vue__ = __webpack_require__("BpKa");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_EventosDisparadosLista_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_14e86b7a_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_EventosDisparadosLista_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sDeo":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":{'Data': 'data', 'Hora': 'hora',  'Ponto Mais Próximo': 'pontoMaisProximo',
              'Velocidade': 'velocidade', 'Deslocamento': 'deslocamento', 'Ignição': 'ignicao', 'GPS': 'gps', 'GPRS': 'gprs', 'Movimento': 'movimento', 'Volt': 'tensao', 'Motivo Transmissão': 'motivoTransmissao'  },"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Distância Percorrida: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida) + 'Km' + '\n  Odômetro do GPS: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro) + ' Km ' + '\n  Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima) + ' Km/h ',"footer":_vm.dadosRelatorios.data,"worksheet":"My Worksheet","name":"filename.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Odômetro do GPS: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[(dados.alertaVelocidade === 'true')?[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicaoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimentoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(dados.tensao))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))]),_vm._v(" "),(dados.motorista !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])]:_vm._e()],2)])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sEs6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _promise = __webpack_require__("//Fk");

var _promise2 = _interopRequireDefault(_promise);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _PieChart = __webpack_require__("D+CC");

var _PieChart2 = _interopRequireDefault(_PieChart);

var _BarChart = __webpack_require__("bYtI");

var _BarChart2 = _interopRequireDefault(_BarChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default,
    PieChart: _PieChart2.default,
    BarChart: _BarChart2.default
  },
  data: function data() {
    return {
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false,
      atualizarGrid: 0,
      atualizarGridInterval: '',
      selecionada: '0',
      veiculosAlertaBateria: [],
      veiculosAlertaBateriaTotal: '0',
      veiculosAlertaSemTransmissao: [],
      veiculosAlertaSemTransmissaoTotal: '0',
      totalVeiculos: '0',
      totalVeiculosMonitorados: '0',
      processando: false,
      showModalDadosVeiculo: false,
      dadosVeiculo: [],
      dadosVeiculoContatoCliente: [],
      dadosVeiculoContatoClientePaga: [],
      dadosVeiculoAcoesCliente: [],
      dashboardJornadaMotoristas: [],
      dashboardJornadaVeiculos: [],
      dashboardJornadaDiario: [],
      dashboardJornadaHoraExtra: [],
      dashboardJornadaAcumulado: [],
      atualizandoDashboardJornadaMotoristas: false,
      atualizandoDashboardJornadaVeiculos: false,
      atualizandoDashboardJornadaDiario: false,
      atualizandoDashboardJornadaHoraExtra: false,
      atualizandoDashboardJornadaAcumulado: false,
      campoBuscaDashboardJornadaDiario: '',
      dataDashboardJornadaDiario: this.dataOntem(),
      campoBuscaDashboardJornadaHoraExtra: '',
      dataDashboardJornadaHoraExtra: this.dataOntem(),
      dataInicialDashboardJornadaAcumulado: this.dataOntem(),
      dataFinalDashboardJornadaAcumulado: this.dataOntem(),
      interacao: {
        dataLancamento: this.dataHoraAtual(),
        titularId: '0',
        titularTipo: '',
        titularNome: '',
        titular: '',
        descricao: '',
        motivoInteracaoId: '0',
        motivoInteracaoNome: ''
      },
      motivosInteracoes: [],
      motivosContatos: [],
      showModalMapa: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      markers: [],
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null
    };
  },

  created: function created() {
    this.buscarAlertaSemTransmissao();

    this.buscarTotalVeiculos();
    this.buscarTotalVeiculosMonitorados();
  },
  methods: {
    buscarTotalVeiculos: function buscarTotalVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/totalVeiculos?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.totalVeiculos = dadosCadastro;
        self.processando = false;
      });
    },
    buscarTotalVeiculosMonitorados: function buscarTotalVeiculosMonitorados() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/totalVeiculosMonitorados?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.totalVeiculosMonitorados = dadosCadastro;
        self.processando = false;
      });
    },
    buscarAlertaBateria: function buscarAlertaBateria() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/alertaBateria?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.veiculosAlertaBateria = dadosCadastro.dados;
        self.processando = false;
      });
    },
    buscarAlertaBateriaTotal: function buscarAlertaBateriaTotal() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/alertaBateriaTotal?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.veiculosAlertaBateriaTotal = dadosCadastro;
        self.processando = false;
      });
    },
    buscarAlertaSemTransmissao: function buscarAlertaSemTransmissao() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/alertaSemTransmissao?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.veiculosAlertaSemTransmissao = dadosCadastro.dados;
        self.processando = false;
        self.buscarAlertaSemTransmissaoTotal();
      });
    },
    buscarAlertaSemTransmissaoTotal: function buscarAlertaSemTransmissaoTotal() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/dashboard/alertaSemTransmissaoTotal?busca=' + this.busca + '&tensao=' + this.tensao + '&velocidade=' + this.velocidade + '&semTransmissao=' + this.semTransmissao + '&onLine=' + this.onLine + '&bateriaBaixa=' + this.bateriaBaixa + '&vencidos=' + this.vencidos;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.veiculosAlertaSemTransmissaoTotal = dadosCadastro;
        self.processando = false;
      });
    },
    mostrarDadosVeiculo: function mostrarDadosVeiculo(veiculo) {
      var self = this;
      self.dadosVeiculo = [];
      self.processando = true;
      self.showModalDadosVeiculo = true;
      self.interacao.dataLancamento = self.dataHoraAtual();
      self.interacao.titularId = '0';
      self.interacao.titularTipo = '';
      self.interacao.titularNome = '';
      self.interacao.titular = '';
      self.interacao.descricao = '';
      self.interacao.motivoInteracaoId = '0';
      self.interacao.motivoInteracaoNome = '';
      self.buscarGridDadosVeiculo(veiculo);
      self.buscarMotivosInteracoes();
      self.buscarMotivosContatos();
    },
    buscarGridDadosVeiculo: function buscarGridDadosVeiculo(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/gridDadosVeiculo?veiculo=' + veiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculo = dadosCadastro;
        self.processando = false;
      });
    },
    buscarGridDadosVeiculoContatoCliente: function buscarGridDadosVeiculoContatoCliente(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clienteId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculoContatoCliente = dadosCadastro;
        self.processando = false;
      });
    },
    buscarGridDadosVeiculoContatoClientePaga: function buscarGridDadosVeiculoContatoClientePaga(veiculo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarClientesContatos/' + self.dadosVeiculo.clientePagaId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculoContatoClientePaga = dadosCadastro;
        self.processando = false;
      });
    },
    buscarMotivosInteracoes: function buscarMotivosInteracoes() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarMotivosInteracoesAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.motivosInteracoes = response.data;
        for (var i = 0; i < self.motivosInteracoes.length; i++) {
          if (i === 0) {
            self.interacao.motivoInteracaoId = self.motivosInteracoes[i].id;
          }
        }
      });
    },
    buscarMotivosContatos: function buscarMotivosContatos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarMotivosContatosAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.motivosContatos = response.data;
        for (var i = 0; i < self.motivosContatos.length; i++) {
          if (i === 0) {
            self.interacao.motivoContatoId = self.motivosContatos[i].id;
          }
        }
      });
    },
    buscarGridDadosVeiculoAcoesCliente: function buscarGridDadosVeiculoAcoesCliente(veiculoo) {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/clientesHistoricoInteracoes/' + self.dadosVeiculo.clienteId;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculoAcoesCliente = dadosCadastro;
        self.interacao.titularId = self.dadosVeiculo.clienteId;
        self.interacao.titularTipo = 'C';
        self.interacao.titularNome = self.dadosVeiculo.clienteNome;
        self.processando = false;
      });
    },
    gravarInteracao: function gravarInteracao(titular) {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.interacao));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.isLoading = true;
          var url = '/api/titularesInteracoes/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.interacao), config).then(function (response) {
            console.log(response);
            if (response.status === 200) {
              self.$toastr('success', 'Interação gravada com sucesso.', 'Atenção');
              self.buscarGridDadosVeiculoAcoesCliente();
              self.isLoading = false;
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    },

    buscarDashboardJornadaMotoristas: function buscarDashboardJornadaMotoristas() {
      var self = this;
      self.processando = true;
      self.atualizandoDashboardJornadaMotoristas = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadaDashboardMotorista/';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.dashboardJornadaMotoristas = response.data;
        self.processando = false;
        self.atualizandoDashboardJornadaMotoristas = false;
      });
    },
    buscarDashboardJornadaVeiculos: function buscarDashboardJornadaVeiculos() {
      var self = this;
      self.processando = true;
      self.atualizandoDashboardJornadaVeiculos = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadaDashboardVeiculo/';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.dashboardJornadaVeiculos = response.data;
        self.processando = false;
        self.atualizandoDashboardJornadaVeiculos = false;
      });
    },
    buscarDashboardJornadaDiario: function buscarDashboardJornadaDiario() {
      var self = this;
      self.processando = true;
      self.atualizandoDashboardJornadaDiario = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadaDashboardDiario?data=' + self.dataDashboardJornadaDiario + '&busca=' + self.campoBuscaDashboardJornadaDiario;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.dashboardJornadaDiario = response.data;
        self.processando = false;
        self.atualizandoDashboardJornadaDiario = false;
      });
    },
    buscarDashboardJornadaHoraExtra: function buscarDashboardJornadaHoraExtra() {
      var self = this;
      self.processando = true;
      self.atualizandoDashboardJornadaHoraExtra = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadaDashboardHoraExtra?data=' + self.dataDashboardJornadaHoraExtra + '&busca=' + self.campoBuscaDashboardJornadaHoraExtra;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.dashboardJornadaHoraExtra = response.data;
        self.processando = false;
        self.atualizandoDashboardJornadaHoraExtra = false;
      });
    },
    buscarDashboardJornadaAcumulado: function buscarDashboardJornadaAcumulado() {
      var self = this;
      self.processando = true;
      self.atualizandoDashboardJornadaAcumulado = true;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/jornadaDashboardAcumulado?dataInicial=' + self.dataInicialDashboardJornadaAcumulado + '&dataFinal=' + self.dataFinalDashboardJornadaAcumulado;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.dashboardJornadaAcumulado = response.data;
        self.processando = false;
        self.atualizandoDashboardJornadaAcumulado = false;
      });
    },
    visualizarMapa: function visualizarMapa(posicao, tipo) {
      var _this2 = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var self;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                self = _this2;

                self.removerMarkers();
                self.showModalMapa = true;
                _context.next = 5;
                return new _promise2.default(function (resolve) {
                  return setTimeout(resolve, 3000);
                });

              case 5:
                self.adicionarMarker(posicao, tipo);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this2);
      }))();
    },
    adicionarMarker: function adicionarMarker(posicao, tipo) {
      var self = this;
      self.removerMarkers();
      var marker = null;
      var bounds = null;
      var myLatLng = null;
      if (tipo === 'macro') {
        marker = {
          lat: posicao.latitudeMacro,
          lng: posicao.longitudeMacro
        };
      } else if (tipo === 'alive') {
        marker = {
          lat: posicao.latitudeAlive,
          lng: posicao.longitudeAlive
        };
      } else if (tipo === 'jornada') {
        marker = {
          lat: posicao.latitudeJornadaDia,
          lng: posicao.longitudeJornadaDia
        };
      } else if (tipo === 'alimentacao') {
        marker = {
          lat: posicao.latitudeAlimentacaoJornadaDia,
          lng: posicao.longitudeAlimentacaoJornadaDia
        };
      }
      self.markers.push({ position: marker, motorista: posicao.motoristaNome, dataHora: posicao.dataHora });

      self.center = marker;
      myLatLng = new window.google.maps.LatLng({ lat: marker.lat, lng: marker.lng });
      if (bounds === null) {
        bounds = new window.google.maps.LatLngBounds();
      }
      bounds.extend(myLatLng);
      self.$nextTick(function () {
        console.log(bounds);
        self.setMapBounds();
      });
      self.currentPlace = null;
    },
    removerMarkers: function removerMarkers() {
      var self = this;
      self.markers = [];
      self.path = [];
    },
    setMapBounds: function setMapBounds() {
      var self = this;
      var bounds = new window.google.maps.LatLngBounds();
      for (var i = 0; i < this.markers.length; i++) {
        var myLatLng = new window.google.maps.LatLng({ lat: this.markers[i].position.lat, lng: this.markers[i].position.lng });
        bounds.extend(myLatLng);
      }

      setTimeout(function () {
        self.$refs.map.fitBounds(bounds);
        if (self.$refs.map.$mapObject.zoom > 18) {
          self.$refs.map.$mapObject.setZoom(18);
        }
      }, 500);

      console.log(self.$refs.map.$mapObject.zoom);
      console.log(self.$refs.map.zoom);
    },

    toggleInfoWindow: function toggleInfoWindow(marker, idx) {
      this.infoWindowPos = marker.position;
      this.infoContent = '';

      if (this.currentMidx === idx) {
        this.infoWinOpen = !this.infoWinOpen;
      } else {
        this.infoWinOpen = true;
        this.currentMidx = idx;
      }
    }
  }
};

/***/ }),

/***/ "sLWx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue__ = __webpack_require__("VWha");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c984e2ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCep_vue__ = __webpack_require__("nUbX");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputCep_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_c984e2ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputCep_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "sUT7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[(_vm.showModalRelatorios)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalRelatoriosVenda","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Tipo do Relatório:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.relatorios.tipo),expression:"relatorios.tipo"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.relatorios, "tipo", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"1","label":"Relação de Eventos"}},[_vm._v("Relação de Eventos")]),_vm._v(" "),_c('option',{attrs:{"value":"2","label":"Aniversariantes"}},[_vm._v("Aniversariantes")]),_vm._v(" "),_c('option',{attrs:{"value":"3","label":"Ranking de Eventos"}},[_vm._v("Ranking de Eventos")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Inicial:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataInicial),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataInicial", $$v)},expression:"relatorios.dataInicial"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Final:")]),_vm._v(" "),_c('input-data-picker',{staticClass:"pula data form-control",model:{value:(_vm.relatorios.dataFinal),callback:function ($$v) {_vm.$set(_vm.relatorios, "dataFinal", $$v)},expression:"relatorios.dataFinal"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"id":"imprimirVendaModal","type":"button"},on:{"click":_vm.imprimirRelatorios}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Imprimir\n            ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalRelatorios = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"panel panel-default",attrs:{"id":"titulo"}},[_c('div',{staticClass:"panel-body"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],staticClass:"btn btn-success",attrs:{"to":{name: 'EventosEditar', params: { id: '0' }}}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Novo\n                  ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-primary",attrs:{"id":"relatorios","type":"button"},on:{"click":_vm.relatoriosModal}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Relatórios\n                  ")]),_vm._v(" "),_c('span',{attrs:{"id":"imprimirLinks"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"panel panel-default",attrs:{"id":"filtros"}},[_c('div',{staticClass:"panel-body"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.status),expression:"filtros.status"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "status", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"A","label":"Ativos"}},[_vm._v("Ativos")]),_vm._v(" "),_c('option',{attrs:{"value":"D","label":"Desativados"}},[_vm._v("Desativados")]),_vm._v(" "),_c('option',{attrs:{"value":"T","label":"Todos"}},[_vm._v("Todos")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.buscas),expression:"filtros.buscas"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.filtros.buscas)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscar(1)},"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.filtros, "buscas", $event.target.value)}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Exibir:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.filtros.quantidade),expression:"filtros.quantidade"}],staticClass:"form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.filtros, "quantidade", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"15","label":"15"}},[_vm._v("15")]),_vm._v(" "),_c('option',{attrs:{"value":"30","label":"30"}},[_vm._v("30")]),_vm._v(" "),_c('option',{attrs:{"value":"50","label":"50"}},[_vm._v("50")])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-1 col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscar(1)}}})])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{attrs:{"id":"dados-paginacao"}},[_c('input',{attrs:{"id":"idsSelecionados","type":"hidden"}}),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tabelaEventos","width":"100%"}},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosTabela),function(evento){return _c('tr',{class:{ 'selecionado': _vm.selecionado(evento) },on:{"click":function($event){_vm.selecionarItem(evento)},"dblclick":function($event){_vm.editar(evento.id)}}},[_c('td',{attrs:{"width":"40"}},[_c('input',{staticClass:"id",attrs:{"type":"hidden","id":evento.id}}),_vm._v(" "),(evento.ativo)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',{attrs:{"width":"50"}},[_vm._v(_vm._s(evento.id))]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(evento.nome))])]),_vm._v(" "),_c('td',{attrs:{"width":"60"}},[_c('router-link',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Editar'),expression:"'Editar'"}],attrs:{"to":{name: 'EventosEditar', params: { id: evento.id }}}},[_c('img',{attrs:{"src":"/static/images/editar.png"}})]),_vm._v(" "),_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Deletar'),expression:"'Deletar'"}],attrs:{"src":"/static/images/deletar.png"},on:{"click":function($event){_vm.deletar(evento.id)}}})],1)])}))])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[_c('vue-pages',{attrs:{"url":_vm.url,"total":_vm.totalPaginas,"counts":_vm.counts,"current":_vm.filtros.pagina,"fn":_vm.paginacao}})],1)])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Relatórios de Eventos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h6',[_vm._v("Opções:")])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('h4',[_vm._v("Lista de Eventos")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Ativo")]),_vm._v(" "),_c('th',[_vm._v("Código")]),_vm._v(" "),_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th')])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sUt0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue__ = __webpack_require__("ToLT");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8dcae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasView_vue__ = __webpack_require__("9osO");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AnaliseJornadasView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9c8dcae6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AnaliseJornadasView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "seUh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue__ = __webpack_require__("PpwH");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3172134f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundView_vue__ = __webpack_require__("OQxC");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3172134f_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "slZv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__ = __webpack_require__("QO3c");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38f26b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agenda_vue__ = __webpack_require__("Breq");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Agenda_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_38f26b24_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Agenda_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "tB6P":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      buscas: '',
      pagina: '1',
      quantidade: '15',
      status: 'A',
      selecionada: '0',
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10
    };
  },

  created: function created() {
    this.buscar(1);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar(pagina) {
      this.pagina = pagina;
      var self = this;

      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/usuarios?buscas=' + this.buscas + '&pagina=' + this.pagina + '&quantidade=' + this.quantidade + '&status=' + this.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/usuarios/editar/' + id);
    },
    deletar: function deletar(id) {
      var message = 'Are you sure?';
      var options = {
        html: false,
        loader: false,
        reverse: false,
        okText: 'Continue',
        cancelText: 'Close',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function () {
        console.log('Clicked on proceed');
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "tls5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue__ = __webpack_require__("+ghM");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c9a05b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataHoraPicker_vue__ = __webpack_require__("NyJI");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputDataHoraPicker_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_44c9a05b_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputDataHoraPicker_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "uRTQ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-lista-motorista',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#motoristaNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#motoristaNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarMotoristasAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "uZDI":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-cliente',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,
    readonly: Boolean,
    errors: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    isRequired: function isRequired() {
      console.log('LOG: ' + this.name);
      console.dir(this.errors);
      if (this.required) {
        return 'required';
      }
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      console.log('setValue');
      $(this.$el).find('#clienteNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#clienteNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarClientesAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "uZUK":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getIterator2 = __webpack_require__("BO1k");

var _getIterator3 = _interopRequireDefault(_getIterator2);

var _typeof2 = __webpack_require__("pFYg");

var _typeof3 = _interopRequireDefault(_typeof2);

var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _regenerator = __webpack_require__("Xxa5");

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = __webpack_require__("exGp");

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _downloadjs = __webpack_require__("sJst");

var _downloadjs2 = _interopRequireDefault(_downloadjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  props: {
    type: {
      type: String,
      default: "xls"
    },

    data: {
      type: Array,
      required: false,
      default: null
    },

    fields: {
      type: Object,
      required: false
    },

    exportFields: {
      type: Object,
      required: false
    },

    defaultValue: {
      type: String,
      required: false,
      default: ""
    },

    title: {
      default: null
    },

    footer: {
      default: null
    },

    name: {
      type: String,
      default: "data.xls"
    },
    fetch: {
      type: Function
    },
    meta: {
      type: Array,
      default: function _default() {
        return [];
      }
    },
    worksheet: {
      type: String,
      default: "Sheet1"
    },

    beforeGenerate: {
      type: Function
    },

    beforeFinish: {
      type: Function
    }
  },
  computed: {
    idName: function idName() {
      var now = new Date().getTime();
      return "export_" + now;
    },
    downloadFields: function downloadFields() {
      if (this.fields !== undefined) return this.fields;

      if (this.exportFields !== undefined) return this.exportFields;
    }
  },
  methods: {
    generate: function generate() {
      var _this = this;

      return (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee() {
        var data, json;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(typeof _this.beforeGenerate === 'function')) {
                  _context.next = 3;
                  break;
                }

                _context.next = 3;
                return _this.beforeGenerate();

              case 3:
                data = _this.data;

                if (!(typeof _this.fetch === 'function' || !data)) {
                  _context.next = 8;
                  break;
                }

                _context.next = 7;
                return _this.fetch();

              case 7:
                data = _context.sent;

              case 8:
                if (!(!data || !data.length)) {
                  _context.next = 10;
                  break;
                }

                return _context.abrupt("return");

              case 10:
                json = _this.getProcessedJson(data, _this.downloadFields);

                if (!(_this.type === "html")) {
                  _context.next = 15;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name.replace(".xls", ".html"), "text/html"));

              case 15:
                if (!(_this.type === "csv")) {
                  _context.next = 17;
                  break;
                }

                return _context.abrupt("return", _this.export(_this.jsonToCSV(json), _this.name.replace(".xls", ".csv"), "application/csv"));

              case 17:
                return _context.abrupt("return", _this.export(_this.jsonToXLS(json), _this.name, "application/vnd.ms-excel"));

              case 18:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    },

    export: function () {
      var _ref = (0, _asyncToGenerator3.default)(_regenerator2.default.mark(function _callee2(data, filename, mime) {
        var blob;
        return _regenerator2.default.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                blob = this.base64ToBlob(data, mime);

                if (!(typeof this.beforeFinish === 'function')) {
                  _context2.next = 4;
                  break;
                }

                _context2.next = 4;
                return this.beforeFinish();

              case 4:
                (0, _downloadjs2.default)(blob, filename, mime);

              case 5:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function _export(_x, _x2, _x3) {
        return _ref.apply(this, arguments);
      }

      return _export;
    }(),
    jsonToXLS: function jsonToXLS(data) {
      var xlsTemp = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><meta name=ProgId content=Excel.Sheet> <meta name=Generator content="Microsoft Excel 11"><meta http-equiv="Content-Type" content="text/html; charset=UTF-8"><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>${worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--><style>br {mso-data-placement: same-cell;}</style></head><body><table>${table}</table></body></html>';
      var xlsData = "<thead>";
      var colspan = (0, _keys2.default)(data[0]).length;
      var _self = this;

      if (this.title != null) {
        xlsData += this.parseExtraData(this.title, '<tr><th colspan="' + colspan + '">${data}</th></tr>');
      }

      xlsData += "<tr>";
      for (var key in data[0]) {
        xlsData += "<th>" + key + "</th>";
      }
      xlsData += "</tr>";
      xlsData += "</thead>";

      xlsData += "<tbody>";
      data.map(function (item, index) {
        xlsData += "<tr>";
        for (var _key in item) {
          xlsData += "<td>" + _self.valueReformattedForMultilines(item[_key]) + "</td>";
        }
        xlsData += "</tr>";
      });
      xlsData += "</tbody>";

      if (this.footer != null) {
        xlsData += "<tfoot>";
        xlsData += this.parseExtraData(this.footer, '<tr><td colspan="' + colspan + '">${data}</td></tr>');
        xlsData += "</tfoot>";
      }

      return xlsTemp.replace("${table}", xlsData).replace("${worksheet}", this.worksheet);
    },
    jsonToCSV: function jsonToCSV(data) {
      var csvData = [];

      if (this.title != null) {
        csvData.push(this.parseExtraData(this.title, "${data}\r\n"));
      }

      for (var key in data[0]) {
        csvData.push(key);
        csvData.push(",");
      }
      csvData.pop();
      csvData.push("\r\n");

      data.map(function (item) {
        for (var _key2 in item) {
          var escapedCSV = '=\"' + item[_key2] + '\"';
          if (escapedCSV.match(/[,"\n]/)) {
            escapedCSV = '"' + escapedCSV.replace(/\"/g, '""') + '"';
          }
          csvData.push(escapedCSV);
          csvData.push(",");
        }
        csvData.pop();
        csvData.push("\r\n");
      });

      if (this.footer != null) {
        csvData.push(this.parseExtraData(this.footer, "${data}\r\n"));
      }
      return csvData.join("");
    },
    getProcessedJson: function getProcessedJson(data, header) {
      var keys = this.getKeys(data, header);
      var newData = [];
      var _self = this;
      data.map(function (item, index) {
        var newItem = {};
        for (var label in keys) {
          var property = keys[label];
          newItem[label] = _self.getValue(property, item);
        }
        newData.push(newItem);
      });

      return newData;
    },
    getKeys: function getKeys(data, header) {
      if (header) {
        return header;
      }

      var keys = {};
      for (var key in data[0]) {
        keys[key] = key;
      }
      return keys;
    },
    parseExtraData: function parseExtraData(extraData, format) {
      var parseData = "";
      if (Array.isArray(extraData)) {
        for (var i = 0; i < extraData.length; i++) {
          parseData += format.replace("${data}", extraData[i]);
        }
      } else {
        parseData += format.replace("${data}", extraData);
      }
      return parseData;
    },
    getValue: function getValue(key, item) {
      var field = (typeof key === "undefined" ? "undefined" : (0, _typeof3.default)(key)) !== "object" ? key : key.field;
      var indexes = typeof field !== "string" ? [] : field.split(".");
      var value = this.defaultValue;

      if (!field) value = item;else if (indexes.length > 1) value = this.getValueFromNestedItem(item, indexes);else value = this.parseValue(item[field]);

      if (key.hasOwnProperty('callback')) value = this.getValueFromCallback(value, key.callback);

      return value;
    },
    valueReformattedForMultilines: function valueReformattedForMultilines(value) {
      if (typeof value == "string") return value.replace(/\n/ig, "<br/>");else return value;
    },
    getValueFromNestedItem: function getValueFromNestedItem(item, indexes) {
      var nestedItem = item;
      var _iteratorNormalCompletion = true;
      var _didIteratorError = false;
      var _iteratorError = undefined;

      try {
        for (var _iterator = (0, _getIterator3.default)(indexes), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
          var index = _step.value;

          if (nestedItem) nestedItem = nestedItem[index];
        }
      } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
      } finally {
        try {
          if (!_iteratorNormalCompletion && _iterator.return) {
            _iterator.return();
          }
        } finally {
          if (_didIteratorError) {
            throw _iteratorError;
          }
        }
      }

      return this.parseValue(nestedItem);
    },
    getValueFromCallback: function getValueFromCallback(item, callback) {
      if (typeof callback !== "function") return this.defaultValue;
      var value = callback(item);
      return this.parseValue(value);
    },
    parseValue: function parseValue(value) {
      return value || value === 0 || typeof value === 'boolean' ? value : this.defaultValue;
    },
    base64ToBlob: function base64ToBlob(data, mime) {
      var base64 = window.btoa(window.unescape(encodeURIComponent(data)));
      var bstr = atob(base64);
      var n = bstr.length;
      var u8arr = new Uint8ClampedArray(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type: mime });
    }
  } };

/***/ }),

/***/ "ujY6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        dataInicial: this.dataAtual(),
        dataFinal: this.dataAtual(),
        buscas: this.$store.state.filtrosEventoDisparado.buscas,
        eventoId: this.$store.state.filtrosEventoDisparado.eventoId,
        status: this.$store.state.filtrosEventoDisparado.status
      },
      tratarEvento: {
        mensagemEventoDisparado: 'Evento visualizado',
        adiarEventoDisparado: '',
        tratarTodosEventos: true
      },
      relatorio: {
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes(''),
        veiculoId: '0',
        veiculoNome: ''
      },
      dadosTabela: [],
      selecionada: '',
      selecionados: [],
      eventos: [],
      processando: false,
      showModalRelatorio: false,
      showModalMapa: false,
      showModalTratarEvento: false,
      center: { lat: -17.7455301, lng: -60.6698182 },
      infoContent: '',
      infoWindowPos: null,
      infoWinOpen: false,
      currentMidx: null,
      infoOptions: {
        pixelOffset: {
          width: 0,
          height: -35
        }
      },
      markers: [],
      path: []
    };
  },

  created: function created() {
    this.buscar();
    this.buscarEventos();
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item, event) {
      this.selecionada = item.id;
      if (event.ctrlKey || event.metaKey) {
        if (this.selecionados.includes(item)) {
          var p = this.selecionados.indexOf(item);
          this.selecionados.splice(p, 1);
        } else {
          this.selecionados.push(item);
        }
      } else {
        if (this.selecionados.includes(item)) {
          var _p = this.selecionados.indexOf(item);
          this.selecionados.splice(_p, 1);
        } else {
          this.selecionados = [];
          this.selecionados.push(item);
        }
      }
    },
    selecionado: function selecionado(item) {
      return this.selecionados.includes(item);
    },
    paginacao: function paginacao(d, e) {
      this.pagina = d;
      this.buscar(this.pagina);
    },

    buscar: function buscar() {
      var self = this;
      this.$store.commit('SET_FILTROS_EVENTO_DISPARADO', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      self.processando = true;
      var url = '/api/eventosDisparados?buscas=' + this.filtros.buscas + '&dataInicial=' + this.filtros.dataInicial + '&dataFinal=' + this.filtros.dataFinal + '&eventoId=' + this.filtros.eventoId + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.processando = false;
      });
    },
    buscarEventos: function buscarEventos() {
      var self = this;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarEventosAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        dadosCadastro = response.data;
        self.eventos = dadosCadastro;
      });
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.relatorio.veiculoId = veiculo.idVeiculo;
      this.relatorio.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.relatorio.veiculoId = 0;
        this.relatorio.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.relatorio.veiculoId = 0;
        this.relatorio.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    tratarEventoModal: function tratarEventoModal() {
      var self = this;
      if (self.selecionados.length < 1) {
        self.$toastr('error', 'Selecione um evento para tratar.', 'Atenção');
        return;
      }
      self.showModalTratarEvento = true;
    },
    gravarTratarEvento: function gravarTratarEvento() {
      var self = this;
      if (self.selecionados.length < 1) {
        self.$toastr('error', 'Selecione um evento para tratar.', 'Atenção');
        return;
      }
      self.processando = true;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var sel = '';
      for (var i = 0; i < self.selecionados.length; i++) {
        if (i === 0) {
          sel = self.selecionados[i].id;
        } else {
          sel = sel + ';' + self.selecionados[i].id;
        }
      }
      var url = '/api/tratarEventoDisparado?id=' + sel + '&mensagemEventoDisparado=' + self.tratarEvento.mensagemEventoDisparado + '&adiarEventoDisparado=' + self.tratarEvento.adiarEventoDisparado + '&tratarTodosEventos=' + self.tratarEvento.tratarTodosEventos;
      _axios2.default.get(url, config).then(function (response) {
        self.showModalTratarEvento = false;
        self.processando = false;
        if (response.data === 'OK') {
          self.$toastr('success', 'Evento tratado com sucesso.', 'Atenção');
          self.buscar();
          self.tratarEvento.mensagemEventoDisparado = 'Evento visualizado';
          self.tratarEvento.adiarEventoDisparado = '';
          self.tratarEvento.tratarTodosEventos = true;
        } else {
          self.$toastr('error', 'Erro ao tratar Evento.', 'Atenção');
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    imprimir: function imprimir(id) {
      var self = this;
      self.processando = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/imprimirJornadaAnalitica?id=' + id + '&semMovimento=0';
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.processando = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
      });
    },
    gerarRelatorio: function gerarRelatorio(e) {
      var self = this;
      self.isLoadingVisualizar = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/imprimirJornadaSintetica?dataHoraInicio=' + this.relatorio.dataInicial + ' 00:00:00&dataHoraFinal=' + this.relatorio.dataFinal + ' 23:59:59&motoristaId=' + this.relatorio.motoristaId;
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;

        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.isLoadingVisualizar = false;
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
      });
    },
    gerarNovaJornada: function gerarNovaJornada(e) {
      var self = this;
      self.isLoadingVisualizar = true;
      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/gestaoJornadas/novo?dataHoraInicio=' + this.jornada.dataHoraInicial + '&dataHoraFinal=' + this.jornada.dataHoraFinal + '&veiculoId=' + this.jornada.veiculoId + '&motoristaId=' + this.jornada.motoristaId + '&tipoJornada=' + this.jornada.tipoJornada;
      _axios2.default.get(url, config).then(function (response) {
        self.isLoadingVisualizar = false;
        self.showModalNovaJornada = false;
        self.buscar();
      }).catch(function (error) {
        console.log(error);
        self.processando = false;
      });
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var message = 'Deseja realmente deletar essa Jornada?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Sim',
        cancelText: 'Não',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/gestaoJornadas/deletar?id=' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Jornada deletada com sucesso.', 'Atenção');
              self.buscar();
              dialog.close();
            } else {
              self.$toastr('error', 'Essa Jornada está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "uslO":
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": "3CJN",
	"./af.js": "3CJN",
	"./ar": "3MVc",
	"./ar-dz": "tkWw",
	"./ar-dz.js": "tkWw",
	"./ar-kw": "j8cJ",
	"./ar-kw.js": "j8cJ",
	"./ar-ly": "wPpW",
	"./ar-ly.js": "wPpW",
	"./ar-ma": "dURR",
	"./ar-ma.js": "dURR",
	"./ar-sa": "7OnE",
	"./ar-sa.js": "7OnE",
	"./ar-tn": "BEem",
	"./ar-tn.js": "BEem",
	"./ar.js": "3MVc",
	"./az": "eHwN",
	"./az.js": "eHwN",
	"./be": "3hfc",
	"./be.js": "3hfc",
	"./bg": "lOED",
	"./bg.js": "lOED",
	"./bm": "hng5",
	"./bm.js": "hng5",
	"./bn": "aM0x",
	"./bn.js": "aM0x",
	"./bo": "w2Hs",
	"./bo.js": "w2Hs",
	"./br": "OSsP",
	"./br.js": "OSsP",
	"./bs": "aqvp",
	"./bs.js": "aqvp",
	"./ca": "wIgY",
	"./ca.js": "wIgY",
	"./cs": "ssxj",
	"./cs.js": "ssxj",
	"./cv": "N3vo",
	"./cv.js": "N3vo",
	"./cy": "ZFGz",
	"./cy.js": "ZFGz",
	"./da": "YBA/",
	"./da.js": "YBA/",
	"./de": "DOkx",
	"./de-at": "8v14",
	"./de-at.js": "8v14",
	"./de-ch": "Frex",
	"./de-ch.js": "Frex",
	"./de.js": "DOkx",
	"./dv": "rIuo",
	"./dv.js": "rIuo",
	"./el": "CFqe",
	"./el.js": "CFqe",
	"./en-au": "Sjoy",
	"./en-au.js": "Sjoy",
	"./en-ca": "Tqun",
	"./en-ca.js": "Tqun",
	"./en-gb": "hPuz",
	"./en-gb.js": "hPuz",
	"./en-ie": "ALEw",
	"./en-ie.js": "ALEw",
	"./en-il": "QZk1",
	"./en-il.js": "QZk1",
	"./en-nz": "dyB6",
	"./en-nz.js": "dyB6",
	"./eo": "Nd3h",
	"./eo.js": "Nd3h",
	"./es": "LT9G",
	"./es-do": "7MHZ",
	"./es-do.js": "7MHZ",
	"./es-us": "INcR",
	"./es-us.js": "INcR",
	"./es.js": "LT9G",
	"./et": "XlWM",
	"./et.js": "XlWM",
	"./eu": "sqLM",
	"./eu.js": "sqLM",
	"./fa": "2pmY",
	"./fa.js": "2pmY",
	"./fi": "nS2h",
	"./fi.js": "nS2h",
	"./fo": "OVPi",
	"./fo.js": "OVPi",
	"./fr": "tzHd",
	"./fr-ca": "bXQP",
	"./fr-ca.js": "bXQP",
	"./fr-ch": "VK9h",
	"./fr-ch.js": "VK9h",
	"./fr.js": "tzHd",
	"./fy": "g7KF",
	"./fy.js": "g7KF",
	"./gd": "nLOz",
	"./gd.js": "nLOz",
	"./gl": "FuaP",
	"./gl.js": "FuaP",
	"./gom-latn": "+27R",
	"./gom-latn.js": "+27R",
	"./gu": "rtsW",
	"./gu.js": "rtsW",
	"./he": "Nzt2",
	"./he.js": "Nzt2",
	"./hi": "ETHv",
	"./hi.js": "ETHv",
	"./hr": "V4qH",
	"./hr.js": "V4qH",
	"./hu": "xne+",
	"./hu.js": "xne+",
	"./hy-am": "GrS7",
	"./hy-am.js": "GrS7",
	"./id": "yRTJ",
	"./id.js": "yRTJ",
	"./is": "upln",
	"./is.js": "upln",
	"./it": "FKXc",
	"./it.js": "FKXc",
	"./ja": "ORgI",
	"./ja.js": "ORgI",
	"./jv": "JwiF",
	"./jv.js": "JwiF",
	"./ka": "RnJI",
	"./ka.js": "RnJI",
	"./kk": "j+vx",
	"./kk.js": "j+vx",
	"./km": "5j66",
	"./km.js": "5j66",
	"./kn": "gEQe",
	"./kn.js": "gEQe",
	"./ko": "eBB/",
	"./ko.js": "eBB/",
	"./ky": "6cf8",
	"./ky.js": "6cf8",
	"./lb": "z3hR",
	"./lb.js": "z3hR",
	"./lo": "nE8X",
	"./lo.js": "nE8X",
	"./lt": "/6P1",
	"./lt.js": "/6P1",
	"./lv": "jxEH",
	"./lv.js": "jxEH",
	"./me": "svD2",
	"./me.js": "svD2",
	"./mi": "gEU3",
	"./mi.js": "gEU3",
	"./mk": "Ab7C",
	"./mk.js": "Ab7C",
	"./ml": "oo1B",
	"./ml.js": "oo1B",
	"./mn": "CqHt",
	"./mn.js": "CqHt",
	"./mr": "5vPg",
	"./mr.js": "5vPg",
	"./ms": "ooba",
	"./ms-my": "G++c",
	"./ms-my.js": "G++c",
	"./ms.js": "ooba",
	"./mt": "oCzW",
	"./mt.js": "oCzW",
	"./my": "F+2e",
	"./my.js": "F+2e",
	"./nb": "FlzV",
	"./nb.js": "FlzV",
	"./ne": "/mhn",
	"./ne.js": "/mhn",
	"./nl": "3K28",
	"./nl-be": "Bp2f",
	"./nl-be.js": "Bp2f",
	"./nl.js": "3K28",
	"./nn": "C7av",
	"./nn.js": "C7av",
	"./pa-in": "pfs9",
	"./pa-in.js": "pfs9",
	"./pl": "7LV+",
	"./pl.js": "7LV+",
	"./pt": "ZoSI",
	"./pt-br": "AoDM",
	"./pt-br.js": "AoDM",
	"./pt.js": "ZoSI",
	"./ro": "wT5f",
	"./ro.js": "wT5f",
	"./ru": "ulq9",
	"./ru.js": "ulq9",
	"./sd": "fW1y",
	"./sd.js": "fW1y",
	"./se": "5Omq",
	"./se.js": "5Omq",
	"./si": "Lgqo",
	"./si.js": "Lgqo",
	"./sk": "OUMt",
	"./sk.js": "OUMt",
	"./sl": "2s1U",
	"./sl.js": "2s1U",
	"./sq": "V0td",
	"./sq.js": "V0td",
	"./sr": "f4W3",
	"./sr-cyrl": "c1x4",
	"./sr-cyrl.js": "c1x4",
	"./sr.js": "f4W3",
	"./ss": "7Q8x",
	"./ss.js": "7Q8x",
	"./sv": "Fpqq",
	"./sv.js": "Fpqq",
	"./sw": "DSXN",
	"./sw.js": "DSXN",
	"./ta": "+7/x",
	"./ta.js": "+7/x",
	"./te": "Nlnz",
	"./te.js": "Nlnz",
	"./tet": "gUgh",
	"./tet.js": "gUgh",
	"./tg": "5SNd",
	"./tg.js": "5SNd",
	"./th": "XzD+",
	"./th.js": "XzD+",
	"./tl-ph": "3LKG",
	"./tl-ph.js": "3LKG",
	"./tlh": "m7yE",
	"./tlh.js": "m7yE",
	"./tr": "k+5o",
	"./tr.js": "k+5o",
	"./tzl": "iNtv",
	"./tzl.js": "iNtv",
	"./tzm": "FRPF",
	"./tzm-latn": "krPU",
	"./tzm-latn.js": "krPU",
	"./tzm.js": "FRPF",
	"./ug-cn": "To0v",
	"./ug-cn.js": "To0v",
	"./uk": "ntHu",
	"./uk.js": "ntHu",
	"./ur": "uSe8",
	"./ur.js": "uSe8",
	"./uz": "XU1s",
	"./uz-latn": "/bsm",
	"./uz-latn.js": "/bsm",
	"./uz.js": "XU1s",
	"./vi": "0X8Q",
	"./vi.js": "0X8Q",
	"./x-pseudo": "e/KL",
	"./x-pseudo.js": "e/KL",
	"./yo": "YXlc",
	"./yo.js": "YXlc",
	"./zh-cn": "Vz2w",
	"./zh-cn.js": "Vz2w",
	"./zh-hk": "ZUyn",
	"./zh-hk.js": "ZUyn",
	"./zh-tw": "BbgG",
	"./zh-tw.js": "BbgG"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "uslO";

/***/ }),

/***/ "v6Pz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__ = __webpack_require__("GB0m");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cca249c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__ = __webpack_require__("/XTD");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_AuthLayout_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_9cca249c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_AuthLayout_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vGaq":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-sm-12 col-md-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"animated fadeIn"},[(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})})],2)],1)])])]):_vm._e(),_vm._v(" "),(_vm.showModalDadosVeiculo)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"tabbable"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(1),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tab2","data-toggle":"tab"},on:{"click":function($event){_vm.buscarGridDadosVeiculoContatoCliente(), _vm.buscarGridDadosVeiculoContatoClientePaga()}}},[_vm._v("Contatos")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tab3","data-toggle":"tab"},on:{"click":function($event){_vm.buscarGridDadosVeiculoAcoesCliente()}}},[_vm._v("Ações")])])]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tab1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(2),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoDataCadastro)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(3),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoMarca)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(4),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoModelo)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(5),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoDataInstalacao)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(6),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoSerial)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(7),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoMarca)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(8),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoModelo)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(9),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoOperadora)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(10),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.equipamentoNumero)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(11),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoObservação01)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(12),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoObservação02)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_vm._m(13),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.veiculoSenha)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(14),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clienteNome)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(15),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clienteTelefone)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_vm._m(16),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clienteEmail)+"\n                              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_vm._m(17),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clientePagaNome)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-2 col-md-2"},[_vm._m(18),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clientePagaTelefone)+"\n                              ")]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-6 col-md-6"},[_vm._m(19),_c('br'),_vm._v("\n                                "+_vm._s(_vm.dadosVeiculo.clientePagaEmail)+"\n                              ")])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab2"}},[_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"contatosAdicionais","width":"100%"}},[_vm._m(20),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosVeiculoContatoCliente),function(contato,i){return _c('tr',[_c('td',[_vm._v(_vm._s(contato.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.email))])])}))]),_vm._v(" "),_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"id":"contatosAdicionais","width":"100%"}},[_vm._m(21),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosVeiculoContatoClientePaga),function(contato,i){return _c('tr',[_c('td',[_vm._v(_vm._s(contato.nome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.telefone))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(contato.email))])])}))])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tab3"}},[_vm._m(22),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3 form-group"},[_c('label',[_vm._v("Data Lançamento:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{staticClass:"data-hora form-control",model:{value:(_vm.interacao.dataLancamento),callback:function ($$v) {_vm.$set(_vm.interacao, "dataLancamento", $$v)},expression:"interacao.dataLancamento"}})],1),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Motivo de Interação:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.motivoInteracaoId),expression:"interacao.motivoInteracaoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.interacao, "motivoInteracaoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.motivosInteracoes),function(motivoInteracao){return _c('option',{domProps:{"value":motivoInteracao.id}},[_vm._v(_vm._s(motivoInteracao.nome))])}))]),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-4 col-md-4"},[_c('label',[_vm._v("Motivo de Contato:")]),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.motivoContatoId),expression:"interacao.motivoContatoId"}],staticClass:"pula form-control custom",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.interacao, "motivoContatoId", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},_vm._l((_vm.motivosContatos),function(motivoContato){return _c('option',{domProps:{"value":motivoContato.id}},[_vm._v(_vm._s(motivoContato.nome))])}))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Titular:")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.titularId),expression:"interacao.titularId"}],attrs:{"type":"hidden","name":"titularInteracoesId"},domProps:{"value":(_vm.interacao.titularId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "titularId", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.interacao.titularTipo),expression:"interacao.titularTipo"}],attrs:{"type":"hidden","name":"titularInteracoesTipo"},domProps:{"value":(_vm.interacao.titularTipo)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "titularTipo", $event.target.value)}}}),_c('br'),_vm._v(" "),_c('strong',[_vm._v(_vm._s(_vm.interacao.titularNome))])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Descrição:")]),_c('br'),_vm._v(" "),_c('textarea',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"},{name:"model",rawName:"v-model",value:(_vm.interacao.descricao),expression:"interacao.descricao"}],staticClass:"pula form-control",attrs:{"rows":"4"},domProps:{"value":(_vm.interacao.descricao)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.interacao, "descricao", $event.target.value)}}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-9 col-md-9"}),_vm._v(" "),_c('div',{staticClass:"form-group col-sm-3 col-md-3"},[_c('button',{staticClass:"btn btn-block btn-success",attrs:{"id":"imprimirVendaModal","type":"button"},on:{"click":_vm.gravarInteracao}},[(_vm.isLoading)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gravar\n                                ")])])]),_vm._v(" "),_c('div',{staticStyle:{"height":"250px","overflow":"auto"}},[_c('table',{staticClass:"responsive datatable_ajax display table table-striped table-hover",attrs:{"width":"100%"}},[_vm._m(23),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosVeiculoAcoesCliente),function(interacao){return _c('tr',[_c('td',[_vm._v(_vm._s(interacao.id))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.motivoInteracaoNome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.motivoContatoNome))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.dataLancamento))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.descricao))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(interacao.usuarioNome))])])}))])])])])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalDadosVeiculo = false}}},[_vm._v("Fechar")])])])])]):_vm._e()]),_vm._v(" "),(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(24)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"tabbable"},[_c('ul',{staticClass:"nav nav-tabs"},[_vm._m(25),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabDash2","data-toggle":"tab"},on:{"click":function($event){_vm.buscarDashboardJornadaMotoristas()}}},[_vm._v("Jornadas por Motorista")])]),_vm._v(" "),_c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabDash3","data-toggle":"tab"},on:{"click":function($event){_vm.buscarDashboardJornadaVeiculos()}}},[_vm._v("Motoristas Embarcados")])]),_vm._v(" "),_vm._m(26),_vm._v(" "),_vm._m(27),_vm._v(" "),_vm._m(28)]),_vm._v(" "),_c('div',{staticClass:"tab-content"},[_c('div',{staticClass:"tab-pane active",attrs:{"id":"tabDash1"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('div',{staticClass:"card text-center"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Total de Veículos")]),_vm._v(" "),_c('p',{staticClass:"card-text",staticStyle:{"font-size":"50px"}},[_vm._v(_vm._s(_vm.totalVeiculos))])])])]),_vm._v(" "),_c('div',{staticClass:"col-sm-6 col-md-6 col-lg-6"},[_c('div',{staticClass:"card text-center"},[_c('div',{staticClass:"card-body"},[_c('h4',{staticClass:"card-title"},[_vm._v("Veículos Monitorados")]),_vm._v(" "),_c('p',{staticClass:"card-text",staticStyle:{"font-size":"50px"}},[_vm._v(_vm._s(_vm.totalVeiculosMonitorados))])])])])]),_vm._v(" "),_c('div',{},[_c('div',{},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-8 col-md-8 col-lg-8 form-group"},[_c('label',[_vm._v("Busca")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.busca),expression:"busca"}],staticClass:"form-control",attrs:{"id":"busca","name":"busca","type":"text"},domProps:{"value":(_vm.busca)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarAlertaSemTransmissao($event)},"input":function($event){if($event.target.composing){ return; }_vm.busca=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2 col-lg-2 no-gutter"},[_c('label',[_vm._v("Sem Transmissao")]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.semTransmissao),expression:"semTransmissao"}],staticClass:"form-control",attrs:{"id":"velocidade","name":"velocidade","type":"text"},domProps:{"value":(_vm.semTransmissao)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }return _vm.buscarAlertaSemTransmissao($event)},"input":function($event){if($event.target.composing){ return; }_vm.semTransmissao=$event.target.value}}})]),_vm._v(" "),_c('div',{staticClass:"col-sm-2 col-md-2 col-lg-2 atualizacao no-gutter"},[_c('label',[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('button',{staticClass:"btn btn-success btn-block",on:{"click":_vm.buscarAlertaSemTransmissao}},[_vm._v("Buscar")])])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-12 col-md-12 col-lg-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Veículos Sem Transmissão")]),_vm._v(" "),_c('div',{attrs:{"id":"dados-grid-sem-transmissao"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(29),_vm._v(" "),_vm._l((_vm.veiculosAlertaSemTransmissao),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.veiculosAlertaSemTransmissao[i].clienteIdVeiculo != _vm.veiculosAlertaSemTransmissao[i-1].clienteIdVeiculo)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"10"}},[_c('strong',[_vm._v(_vm._s(grid.clienteVeiculo))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.dataHora))])]),_vm._v(" "),_c('td',[(grid.vencidos > 0)?[_c('img',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Possui débitos vencidos'),expression:"'Possui débitos vencidos'"}],attrs:{"src":"/static/images/dinheiro.png"}})]:_vm._e(),_vm._v(" "),(_vm.$auth.check('P110'))?[_c('small',{staticClass:"text-muted"},[_c('a',{attrs:{"href":"#"},on:{"click":function($event){_vm.mostrarDadosVeiculo(grid.idVeiculo)}}},[_vm._v(" "+_vm._s(grid.descricaoVeiculo))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.descricaoVeiculo))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.pontoMaisProximo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(grid.velocidade)))])]),_vm._v(" "),_c('td',[(grid.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(grid.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(grid.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(grid.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(grid.tensao)))])])])],2)})],2)]),_vm._v(" "),_c('div',{staticClass:"rodape"},[_vm._v("\n                        Total de veículos em alerta: "+_vm._s(_vm.veiculosAlertaSemTransmissaoTotal)+" \n                      ")])])])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabDash2"}},[_c('span',{staticClass:"pull-right"},[(!_vm.atualizandoDashboardJornadaMotoristas)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizar'),expression:"'Atualizar'"}],on:{"click":function($event){_vm.buscarDashboardJornadaMotoristas()}}},[_vm._v("\n                        Atualizar\n                        "),_c('i',{staticClass:"fas fa-sync"})])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizando'),expression:"'Atualizando'"}]},[_vm._v(" \n                        Atualizando\n                        "),(_vm.atualizandoDashboardJornadaMotoristas)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizando'),expression:"'Atualizando'"}],staticClass:"fas fa-sync fa-spin"}):_vm._e()])]],2),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(30),_vm._v(" "),_vm._l((_vm.dashboardJornadaMotoristas),function(grid,i){return _c('tbody',[_c('tr',[(grid.ultimaMacro !== null)?[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.clienteNome))])]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.veiculoDescricao)),_c('br')]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.ultimaMacro))]),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.ultimaMacroTempo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_c('strong',[_vm._v(_vm._s(grid.ultimaMacroDataHora))])]),_vm._v(" "),(grid.latitudeMacro === null || grid.latitudeMacro === 0)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição não disponível'),expression:"'Posição não disponível'"}],staticClass:"text-secondary",staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})]),_c('br')]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição da Macro'),expression:"'Posição da Macro'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.visualizarMapa(grid, 'macro')}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})]),_c('br')],_vm._v(" "),_c('small',{staticClass:"text-muted"},[_c('strong',[_vm._v(_vm._s(grid.ultimaAliveDataHora))])]),_vm._v(" "),(grid.latitudeAlive === null || grid.latitudeAlive === 0)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição não disponível'),expression:"'Posição não disponível'"}],staticClass:"text-secondary",staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição do Keep Alive'),expression:"'Posição do Keep Alive'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.visualizarMapa(grid, 'alive')}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[(grid.bateriaMacro > 20)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria Macro'),expression:"'Bateria Macro'"}],staticClass:"text-success"},[_vm._v(" "+_vm._s((grid.bateriaMacro > 0 ? parseFloat(grid.bateriaMacro).toFixed(0) : ''))+" ")]),_c('br')]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria Macro'),expression:"'Bateria Macro'"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s((grid.bateriaMacro > 0 ? parseFloat(grid.bateriaMacro).toFixed(0) : ''))+" ")]),_c('br')],_vm._v(" "),(grid.bateriaAlive > 20)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria Keep Alive'),expression:"'Bateria Keep Alive'"}],staticClass:"text-success"},[_vm._v(" "+_vm._s((grid.bateriaAlive > 0 ? parseFloat(grid.bateriaAlive).toFixed(0) : ''))+" ")])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria Keep Alive'),expression:"'Bateria Keep Alive'"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s((grid.bateriaAlive > 0 ? parseFloat(grid.bateriaAlive).toFixed(0) : ''))+" ")])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.inicioJornadaDia))]),_c('br'),_vm._v(" "),(grid.latitudeJornadaDia === null || grid.latitudeJornadaDia === 0)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição não disponível'),expression:"'Posição não disponível'"}],staticClass:"text-secondary",staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição da Inicio'),expression:"'Posição da Inicio'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.visualizarMapa(grid, 'jornada')}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])],_vm._v(" "),(grid.bateriaJornadaDia > 20)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria da Inicio'),expression:"'Bateria da Inicio'"}],staticClass:"text-success"},[_vm._v(" "+_vm._s((grid.bateriaJornadaDia > 0 ? parseFloat(grid.bateriaJornadaDia).toFixed(0) : ''))+" ")])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria da Inicio'),expression:"'Bateria da Inicio'"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s((grid.bateriaJornadaDia > 0 ? parseFloat(grid.bateriaJornadaDia).toFixed(0) : ''))+" ")])]],2),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.alimentacaoJornadaDia))]),_c('br'),_vm._v(" "),(grid.alimentacaoJornadaDia !== null)?_c('span',{staticClass:"text-success"},[_c('i',{staticClass:"fas fa-utensils"})]):_vm._e(),_vm._v(" "),(grid.alimentacaoJornadaDia == null)?_c('span',{staticClass:"text-danger"},[_c('i',{staticClass:"fas fa-utensils"})]):_vm._e(),_vm._v(" "),(grid.latitudeAlimentacaoJornadaDia === null || grid.latitudeAlimentacaoJornadaDia === 0)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição não disponível'),expression:"'Posição não disponível'"}],staticClass:"text-secondary",staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Posição da Alimentação'),expression:"'Posição da Alimentação'"}],staticClass:"text-success",staticStyle:{"font-size":"20px"},on:{"click":function($event){_vm.visualizarMapa(grid, 'alimentacao')}}},[_c('i',{staticClass:"fas fa-map-marker-alt"})])],_vm._v(" "),(grid.bateriaAlimentacaoJornadaDia > 20)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria da Alimentação'),expression:"'Bateria da Alimentação'"}],staticClass:"text-success"},[_vm._v(" "+_vm._s((grid.bateriaAlimentacaoJornadaDia > 0 ? parseFloat(grid.bateriaAlimentacaoJornadaDia).toFixed(0) : ''))+" ")])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Bateria da Alimentação'),expression:"'Bateria da Alimentação'"}],staticClass:"text-danger"},[_vm._v(" "+_vm._s((grid.bateriaAlimentacaoJornadaDia > 0 ? parseFloat(grid.bateriaAlimentacaoJornadaDia).toFixed(0) : ''))+" ")])]],2)]:[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.clienteNome))])]),_vm._v(" "),_vm._m(31,true)]],2)])})],2)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabDash3"}},[_c('span',{staticClass:"pull-right"},[(!_vm.atualizandoDashboardJornadaVeiculos)?[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizar'),expression:"'Atualizar'"}],on:{"click":function($event){_vm.buscarDashboardJornadaVeiculos()}}},[_vm._v("\n                        Atualizar\n                        "),_c('i',{staticClass:"fas fa-sync"})])]:[_c('span',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizando'),expression:"'Atualizando'"}]},[_vm._v(" \n                        Atualizando\n                        "),(_vm.atualizandoDashboardJornadaVeiculos)?_c('i',{directives:[{name:"tooltip",rawName:"v-tooltip",value:('Atualizando'),expression:"'Atualizando'"}],staticClass:"fas fa-sync fa-spin"}):_vm._e()])]],2),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(32),_vm._v(" "),_vm._l((_vm.dashboardJornadaVeiculos),function(grid,i){return _c('tbody',[_c('tr',[(grid.ultimaMacro !== null)?[_c('td',[_vm._v("\n                            "+_vm._s(grid.veiculoDescricao)),_c('br'),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.clienteNome))])]),_vm._v(" "),_c('td',[(grid.motoristaData !== grid.dataHoje)?[_c('span',{staticClass:"text-danger"},[_vm._v(_vm._s(grid.motoristaNome)),_c('br')])]:[_vm._v("\n                              "+_vm._s(grid.motoristaNome)),_c('br')]],2),_vm._v(" "),_c('td',[(grid.distanciaPercorrida !== null && grid.distanciaPercorrida >= 0)?[_vm._v("\n                              "+_vm._s(parseFloat(grid.distanciaPercorrida).toFixed(0))+" Km\n                            ")]:[_vm._v("\n                              0 Km\n                            ")]],2)]:[_c('td',[_vm._v("\n                             "+_vm._s(grid.veiculoDescricao)),_c('br')]),_vm._v(" "),_vm._m(33,true)]],2)])})],2)]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabDash4"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-sm-9 col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campoBuscaDashboardJornadaDiario),expression:"campoBuscaDashboardJornadaDiario"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.campoBuscaDashboardJornadaDiario)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarDashboardJornadaDiario()},"input":function($event){if($event.target.composing){ return; }_vm.campoBuscaDashboardJornadaDiario=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.dataDashboardJornadaDiario),callback:function ($$v) {_vm.dataDashboardJornadaDiario=$$v},expression:"dataDashboardJornadaDiario"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscarDashboardJornadaDiario()}}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"dashboardJornadaDiario"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"table-layout":"fixed"},attrs:{"id":"tableDashboardJornadaDiario"}},[_vm._m(34),_vm._v(" "),_vm._l((_vm.dashboardJornadaDiario),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dashboardJornadaDiario[i].clienteNome !== _vm.dashboardJornadaDiario[i-1].clienteNome)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[(grid.dataHoraInicial !== null)?[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.veiculoDescricao)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tipo)+"\n                            ")]),_vm._v(" "),_c('td',[(grid.dataHoraInicial === '01/01/0001 00:00:00')?[_vm._v("\n                                ---\n                              ")]:[_vm._v("\n                                "+_vm._s(grid.dataHoraInicial)+"\n                              ")]],2),_vm._v(" "),_c('td',[(grid.dataHoraFinal === '01/01/0001 00:00:00')?[_vm._v("\n                                ---\n                              ")]:[_vm._v("\n                                "+_vm._s(grid.dataHoraFinal)+"\n                              ")]],2),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoInterJornada)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoJornada)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoTrabalhado)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraTotal)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoAdicionalNoturno)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraIndenizada)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoDescansoDirecao)+"\n                            ")]),_vm._v(" "),_c('td',[(grid.tempoAlimentacaoErro)?[_c('span',{staticClass:"text-danger"},[_vm._v("\n                                  "+_vm._s(grid.tempoAlimentacao)+"\n                                ")])]:[_vm._v("\n                                "+_vm._s(grid.tempoAlimentacao)+"\n                              ")]],2)]:[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)),_c('br')]),_vm._v(" "),_vm._m(35,true)]],2),_vm._v(" "),(i < _vm.dashboardJornadaDiario.length-1)?[_c('tr',[(_vm.dashboardJornadaDiario[i].clienteNome !== _vm.dashboardJornadaDiario[i+1].clienteNome)?[_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAdicionalNoturno))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraIndenizada))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAlimentacao))])])])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaDiario.length-1))?[_c('tr',[_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAdicionalNoturno))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraIndenizada))])])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAlimentacao))])])])])]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaDiario.length-1))?[_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraTotal))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoAdicionalNoturno))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraIndenizada))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoAlimentacao))])])]:_vm._e()],2)})],2)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabDash5"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-9"},[_c('div',{staticClass:"form-group has-feedback"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Buscar:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.campoBuscaDashboardJornadaHoraExtra),expression:"campoBuscaDashboardJornadaHoraExtra"}],staticClass:"form-control hasclear",attrs:{"type":"text"},domProps:{"value":(_vm.campoBuscaDashboardJornadaHoraExtra)},on:{"keyup":function($event){if(!('button' in $event)&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }_vm.buscarDashboardJornadaHoraExtra()},"input":function($event){if($event.target.composing){ return; }_vm.campoBuscaDashboardJornadaHoraExtra=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"glyphicon glyphicon-remove-circle",attrs:{"id":"limparbusca"}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.dataDashboardJornadaHoraExtra),callback:function ($$v) {_vm.dataDashboardJornadaHoraExtra=$$v},expression:"dataDashboardJornadaHoraExtra"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscarDashboardJornadaHoraExtra()}}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"dashboardJornadaDiario"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",staticStyle:{"table-layout":"fixed"},attrs:{"id":"tableDashboardJornadaDiario"}},[_vm._m(36),_vm._v(" "),_vm._l((_vm.dashboardJornadaHoraExtra),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dashboardJornadaHoraExtra[i].clienteNome !== _vm.dashboardJornadaHoraExtra[i-1].clienteNome)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[(grid.dataHoraInicial !== null)?[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.veiculoDescricao)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tipo)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.dataHoraInicial)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.dataHoraFinal)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoJornada)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoTrabalhado)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraNormal1)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraNormal2)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraNoturna1)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraNoturna2)+"\n                            ")]),_vm._v(" "),_c('td',[_vm._v("\n                              "+_vm._s(grid.tempoHoraExtraTotal)+"\n                            ")])]:[_c('td',[_vm._v("\n                              "+_vm._s(grid.motoristaNome)),_c('br')]),_vm._v(" "),_vm._m(37,true)]],2),_vm._v(" "),(i < _vm.dashboardJornadaHoraExtra.length-1)?[_c('tr',[(_vm.dashboardJornadaHoraExtra[i].clienteNome !== _vm.dashboardJornadaHoraExtra[i+1].clienteNome)?[_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaHoraExtra.length-1))?[_c('tr',[_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])])])]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaHoraExtra.length-1))?[_c('td'),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td'),_c('td'),_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNormal1))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNormal2))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNoturna1))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNoturna2))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraTotal))])])]:_vm._e()],2)})],2)])]),_vm._v(" "),_c('div',{staticClass:"tab-pane",attrs:{"id":"tabDash6"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Inicial:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.dataInicialDashboardJornadaAcumulado),callback:function ($$v) {_vm.dataInicialDashboardJornadaAcumulado=$$v},expression:"dataInicialDashboardJornadaAcumulado"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-2"},[_c('label',{staticClass:"label-filtros"},[_vm._v("Data Final:")]),_c('br'),_vm._v(" "),_c('input-data-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.dataFinalDashboardJornadaAcumulado),callback:function ($$v) {_vm.dataFinalDashboardJornadaAcumulado=$$v},expression:"dataFinalDashboardJornadaAcumulado"}})],1),_vm._v(" "),_c('div',{staticClass:"col-md-1"},[_c('div',{staticClass:"form-group"},[_c('label',{staticClass:"label-filtros"},[_vm._v(" ")]),_c('br'),_vm._v(" "),_c('input',{staticClass:"btn btn-block btn-success",attrs:{"type":"button","value":"Buscar"},on:{"click":function($event){_vm.buscarDashboardJornadaAcumulado()}}})])])]),_vm._v(" "),_c('div',{attrs:{"id":"dashboardJornadaDiario"}},[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0",attrs:{"id":"tableDashboardJornadaDiario"}},[_vm._m(38),_vm._v(" "),_vm._l((_vm.dashboardJornadaAcumulado),function(grid,i){return _c('tbody',[(i === 0)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e(),_vm._v(" "),(i > 0)?[(_vm.dashboardJornadaAcumulado[i].clienteNome !== _vm.dashboardJornadaAcumulado[i-1].clienteNome)?[_c('tr',{staticClass:"group ui-selectee",staticStyle:{"height":"32px","background":"#FFA726","color":"#FFF"}},[_c('td',{attrs:{"colspan":"14"}},[_c('strong',[_vm._v(_vm._s(grid.clienteNome))])])])]:_vm._e()]:_vm._e(),_vm._v(" "),_c('tr',[(grid.data !== null)?[_c('td',[_vm._v("\n                                "+_vm._s(grid.data)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraExtraNormal1)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraExtraNormal2)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraExtraNoturna1)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraExtraNoturna2)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraExtraTotal)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoAdicionalNoturno)+"\n                              ")]),_vm._v(" "),_c('td',[_vm._v("\n                                "+_vm._s(grid.tempoHoraIndenizada)+"\n                              ")]),_vm._v(" "),_c('td',[(grid.tempoAlimentacaoErro)?[_c('span',{staticClass:"text-danger"},[_vm._v("\n                                    "+_vm._s(grid.tempoAlimentacao)+"\n                                  ")])]:[_vm._v("\n                                  "+_vm._s(grid.tempoAlimentacao)+"\n                                ")]],2)]:[_c('td',[_vm._v("\n                                "+_vm._s(grid.motoristaNome)),_c('br')]),_vm._v(" "),_vm._m(39,true)]],2),_vm._v(" "),(i < _vm.dashboardJornadaAcumulado.length-1)?[_c('tr',[(_vm.dashboardJornadaAcumulado[i].clienteNome !== _vm.dashboardJornadaAcumulado[i+1].clienteNome)?[_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAdicionalNoturno))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraIndenizada))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAlimentacao))])])])]:_vm._e()],2)]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaAcumulado.length-1))?[_c('tr',[_c('td'),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNormal2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna1))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraNoturna2))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraExtraTotal))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAdicionalNoturno))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoHoraIndenizada))])])]),_vm._v(" "),_c('td',[_c('strong',[_c('span',{staticClass:"text-center text-primary"},[_vm._v(_vm._s(grid.somaTempoAlimentacao))])])])])]:_vm._e(),_vm._v(" "),(i === (_vm.dashboardJornadaAcumulado.length-1))?[_c('td'),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNormal1))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNormal2))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNoturna1))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraNoturna2))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraExtraTotal))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoAdicionalNoturno))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoHoraIndenizada))])]),_vm._v(" "),_c('td',[_c('strong',[_vm._v(_vm._s(grid.somaTotalTempoAlimentacao))])])]:_vm._e()],2)})],2)])])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Dados do Veículo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tab1","data-toggle":"tab"}},[_vm._v("Veículo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Data da Cadastro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Marca")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Modelo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Data da instalação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Serial")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Marca")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Modelo")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Operadora")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Numero do Chip")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Observação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Observação")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Senha")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Cliente")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Telefone")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Cliente Paga")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Telefone")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',[_c('strong',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',[_vm._v("Nome")]),_vm._v(" "),_c('th',[_vm._v("Telefone")]),_vm._v(" "),_c('th',[_vm._v("Email")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12 form-group"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Lançar Interação")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('th',{attrs:{"width":"60"}},[_vm._v("Código")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Contato")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Lançamento")]),_vm._v(" "),_c('th',[_vm._v("Descrição")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Usuário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item active"},[_c('a',{staticClass:"nav-link active",attrs:{"href":"#tabDash1","data-toggle":"tab"}},[_vm._v("Veículos")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabDash4","data-toggle":"tab"}},[_vm._v("Jornadas Diário")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabDash5","data-toggle":"tab"}},[_vm._v("Jornadas Hora Extra")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('li',{staticClass:"nav-item"},[_c('a',{staticClass:"nav-link",attrs:{"href":"#tabDash6","data-toggle":"tab"}},[_vm._v("Jornadas Acumulado")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Data e Hora")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"}},[_vm._v("Descrição do Veículo")]),_vm._v(" "),_c('th',[_vm._v("Ponto mais próximo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"60px"}},[_vm._v("Km/h")]),_vm._v(" "),_c('th',{staticStyle:{"width":"20px"}},[_vm._v("IGN")]),_vm._v(" "),_c('th',{staticStyle:{"width":"21px"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{staticStyle:{"width":"24px"}},[_vm._v("GSM")]),_vm._v(" "),_c('th',{staticStyle:{"width":"26px"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{staticStyle:{"width":"31px"}},[_vm._v("Tensão")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Motorista")]),_vm._v(" "),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"120px"}},[_vm._v("Última Macro")]),_vm._v(" "),_c('th',{staticStyle:{"width":"150px"}},[_vm._v("Horário Macro")]),_vm._v(" "),_c('th',{staticStyle:{"width":"30px"}},[_vm._v("Bat.")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Início de Jornada")]),_vm._v(" "),_c('th',{staticStyle:{"width":"70px"}},[_vm._v("Alim.")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-danger",attrs:{"colspan":"6"}},[_c('h4',[_vm._v("SEM DADOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Veículo")]),_vm._v(" "),_c('th',{staticStyle:{"width":"350px"}},[_vm._v("Motorista")]),_vm._v(" "),_c('th',{staticStyle:{"width":"250px"}},[_vm._v("Distancia Percorrida")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-danger",attrs:{"colspan":"6"}},[_c('h4',[_vm._v("SEM DADOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"350"}},[_vm._v("Funcionário")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Hora Inicial")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Hora Final")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Interjornada")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Jornada")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Trabalhado")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("Hora extra Total")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("Adicional Noturno")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Hora Indenizada")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Descanso Direção")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Alimentação")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-danger",attrs:{"colspan":"11"}},[_c('h4',[_vm._v("SEM DADOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"350"}},[_vm._v("Funcionário")]),_vm._v(" "),_c('th',{attrs:{"width":"250"}},[_vm._v("Veículo")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Tipo")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Hora Inicial")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Data Hora Final")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Jornada")]),_vm._v(" "),_c('th',{attrs:{"width":"100"}},[_vm._v("Trabalhado")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Hora Extra Normal 1")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Hora Extra Normal 2")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Hora Extra Noturna 1")]),_vm._v(" "),_c('th',{attrs:{"width":"150"}},[_vm._v("Hora Extra Noturna 2")]),_vm._v(" "),_c('th',{attrs:{"width":"130"}},[_vm._v("Hora Extra Total")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-danger",attrs:{"colspan":"11"}},[_c('h4',[_vm._v("SEM DADOS")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("Dia")]),_vm._v(" "),_c('th',[_vm._v("Hora Extra Normal 1")]),_vm._v(" "),_c('th',[_vm._v("Hora Extra Normal 2")]),_vm._v(" "),_c('th',[_vm._v("Hora Extra Noturna 1")]),_vm._v(" "),_c('th',[_vm._v("Hora Extra Noturna 2")]),_vm._v(" "),_c('th',[_vm._v("Hora Extra Total")]),_vm._v(" "),_c('th',[_vm._v("Adicional Noturno")]),_vm._v(" "),_c('th',[_vm._v("Hora Indenizada")]),_vm._v(" "),_c('th',[_vm._v("Alimentação Irregular")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('td',{staticClass:"text-center text-danger",attrs:{"colspan":"11"}},[_c('h4',[_vm._v("SEM DADOS")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vH6h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app",attrs:{"id":"app"}},[_c('router-view')],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vJtg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue__ = __webpack_require__("UeKE");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78052c42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarTitular_vue__ = __webpack_require__("T4AT");
function injectStyle (ssrContext) {
  __webpack_require__("Yyib")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkBuscarTitular_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_78052c42_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkBuscarTitular_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "vSZx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('input')}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "vd8F":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: '',
  props: {
    showModalPonto: Boolean,
    latitude: Number,
    longitude: Number
  },
  data: function data() {
    return {
      processando: false,

      showModalConfirmarGravacao: false,
      mensagemConfirmarGravacao: '',
      mensagemConfirmarGravacaoQuantidade: '',
      pontosTipos: [],
      ponto: {
        id: '0',
        latitude: '0',
        longitude: '0',
        descricao: '',
        clienteId: '0',
        pontoTipoId: '11'
      }
    };
  },
  mounted: function mounted() {
    this.buscarPontosTipos();
  },

  methods: {
    buscarPontosTipos: function buscarPontosTipos() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/pontosTipos/buscarPontosTipos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        self.pontosTipos = response.data;
      });
    },
    setarClientePonto: function setarClientePonto(cliente) {
      this.ponto.clienteId = cliente.id;
      this.ponto.clienteNomeFantasia = cliente.nomeFantasia;
      $(this.$el).find('#pontoClienteNome').val(cliente.nomeFantasia);
    },
    verificarClientePonto: function verificarClientePonto() {
      if ($(this.$el).find('#pontoClienteId').val() === '0') {
        this.ponto.clienteId = 0;
        this.ponto.clienteNome = '';
        $(this.$el).find('#pontoClienteId').val(0);
        $(this.$el).find('#pontoClienteNome').val('');
      }
      if ($(this.$el).find('#pontoClienteNomePonto').val() === '') {
        this.ponto.clienteId = 0;
        this.ponto.clienteNome = '';
        $(this.$el).find('#pontoClienteId').val(0);
        $(this.$el).find('#pontoClienteNome').val('');
      }
    },
    gravarPonto: function gravarPonto() {
      var self = this;
      console.log('Gravar lati ' + self.latitude);

      if (self.ponto.descricao === '') {
        this.$toastr('error', 'Adicione a descrição do ponto.', 'Atenção');
        return;
      }
      self.ponto.latitude = self.latitude;
      self.ponto.longitude = self.longitude;
      self.processando = true;
      var config = {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/pontos/salvar';
      _axios2.default.post(url, (0, _stringify2.default)(self.ponto), config).then(function (response) {
        console.log(response);
        if (response.data === 'OK') {
          self.processando = false;
          self.mensagemConfirmarGravacao = '<h2>Parabéns<h2><h4>Ponto gravado com sucesso!</h4><br/>';
          self.mensagemConfirmarGravacaoQuantidade = '<p>Restam <strong>0</strong> pontos para cadastro</p>';
          self.showModalConfirmarGravacao = true;
          self.closeModal();
          self.ponto = { id: '0', latitude: '0', longitude: '0', descricao: '', clienteId: '0', pontoTipoId: '0' };
        }
      }).catch(function (error) {
        self.processando = false;
        console.log(error);
      });
    },
    closeModal: function closeModal() {
      this.showModalPonto = false;
      this.$emit('showModalPonto', false);
      this.$emit('eventname', false);
    }
  }
};

/***/ }),

/***/ "vlR9":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-telefone',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).mask('(99) 9999-9999?9');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).mask('(99) 9999-9999?9');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "w1sO":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue__ = __webpack_require__("z1Ie");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0ed69ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPeso_vue__ = __webpack_require__("vSZx");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputPeso_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_f0ed69ca_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputPeso_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "wH/M":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "wOYj":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var EventListener = {
  listen: function listen(target, eventType, callback) {
    if (target.addEventListener) {
      target.addEventListener(eventType, callback, false);
      return {
        remove: function remove() {
          target.removeEventListener(eventType, callback, false);
        }
      };
    } else if (target.attachEvent) {
      target.attachEvent('on' + eventType, callback);
      return {
        remove: function remove() {
          target.detachEvent('on' + eventType, callback);
        }
      };
    }
  }
};
exports.default = {
  data: function data() {
    return {
      model: {
        id: '1',
        nomeFantasia: '',
        nome: '',
        tipoEmpresa: 'J',
        documento: '',
        inscricaoEstadual: '',
        inscricaoMunicipal: '',
        inscricaoSuframa: '',
        endereco: '',
        numero: '',
        complemento: '',
        bairro: '',
        cidadeId: '',
        cidadeNome: '',
        cep: '',
        estado: '',
        contato: '',
        telefone: '',
        email: '',
        regimeTributario: '1',
        cnae: '',
        tipoAtividade: '',
        regimeEspecialServicos: '',
        incentivadorCultural: '',
        grauRisco: '',
        codigoGPS: '',
        codigoFRAPS: ''
      },
      interacao: {
        dataLancamento: this.dataHoraAtual(),
        titularId: '0',
        titularTipo: '',
        titularNome: '',
        titular: '',
        descricao: '',
        motivoInteracaoId: '0',
        motivoInteracaoNome: ''
      },
      motivosInteracoes: [],
      showModalInteracoes: false,
      isLoading: false
    };
  },

  created: function created() {},
  methods: {
    buscarEmpresa: function buscarEmpresa() {
      var self = this;
      var config = {
        headers: {
          'Authorization': 'Bearer ' + this.$store.state.token
        }
      };
      var url = '/api/empresas/1';
      _axios2.default.get(url, config).then(function (response) {
        self.model.id = response.data.id;
        self.model.nomeFantasia = response.data.nomeFantasia;
        self.model.nome = response.data.nome;
        self.model.tipoEmpresa = response.data.tipoEmpresa;
        self.model.documento = response.data.documento;
        self.model.inscricaoEstadual = response.data.inscricaoEstadual;
        self.model.inscricaoMunicipal = response.data.inscricaoMunicipal;
        self.model.inscricaoSuframa = response.data.inscricaoSuframa;
        self.model.endereco = response.data.endereco;
        self.model.numero = response.data.numero;
        self.model.complemento = response.data.complemento;
        self.model.bairro = response.data.bairro;
        self.model.cidadeId = response.data.cidadeId;
        self.model.cidadeNome = response.data.cidadeNome;
        self.model.cep = response.data.cep;
        self.model.estado = response.data.estado;
        self.model.contato = response.data.contato;
        self.model.telefone = response.data.telefone;
        self.model.email = response.data.email;
      });
    },
    interacoesModal: function interacoesModal() {
      this.showModalInteracoes = true;
      this.buscarMotivosInteracoes();
      this.interacao.dataLancamento = this.dataHoraAtual();
      this.interacao.titularId = '0';
      this.interacao.titularTipo = '';
      this.interacao.titularNome = '';
      this.interacao.titular = '';
      this.interacao.descricao = '';
      this.interacao.motivoInteracaoId = '0';
      this.interacao.motivoInteracaoNome = '';
      this.isLoading = false;
    },
    buscarMotivosInteracoes: function buscarMotivosInteracoes() {
      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarMotivoInteracoesAtivos?busca=';
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        self.motivosInteracoes = response.data;
        for (var i = 0; i < self.motivosInteracoes.length; i++) {
          if (i === 0) {
            self.interacao.motivoInteracaoId = self.motivosInteracoes[i].id;
          }
        }
      });
    },
    setarTitularInteracoes: function setarTitularInteracoes(titular) {
      this.interacao.titularId = titular.id;
      this.interacao.titularTipo = titular.tipoCadastro[0];
      this.interacao.titular = titular.nomeFantasia;
      $(this.$el).find('#titularInteracoes').val(titular.nomeFantasia);
    },
    verificarTitularInteracoes: function verificarTitularInteracoes() {
      if ($(this.$el).find('#titularInteracoesId').val() === '0') {
        this.interacao.titularId = 0;
        this.interacao.titular = '';
        this.interacao.titularTipo = '';
        $(this.$el).find('#titularInteracoesId').val(0);
        $(this.$el).find('#titularInteracoes').val('');
      }
      if ($(this.$el).find('#titularInteracoes').val() === '') {
        this.interacao.titularId = 0;
        this.interacao.titular = '';
        this.interacao.titularTipo = '';
        $(this.$el).find('#titularInteracoesId').val(0);
        $(this.$el).find('#titularInteracoes').val('');
      }
      console.log($(this.$el).find('#titularInteracoes').val());
    },
    gravarInteracao: function gravarInteracao(titular) {
      var _this = this;

      var self = this;
      this.$validator.validateAll().then(function (result) {
        if (result) {
          console.log((0, _stringify2.default)(self.interacao));
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.isLoading = true;
          var url = '/api/titularesInteracoes/salvar';
          _axios2.default.post(url, (0, _stringify2.default)(self.interacao), config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Interação gravada com sucesso.', 'Atenção');
              self.showModalInteracoes = false;
              self.isLoading = false;
            }
          }).catch(function (error) {
            console.log(error);
          });
        } else {
          _this.$toastr('error', 'Complete os campos destacados.', 'Atenção');
        }
      });
    },
    esconderMenu: function esconderMenu() {
      this.$store.state.sistema.collapsed = !this.$store.state.sistema.collapsed;
    },
    logout: function logout() {
      this.$auth.logout();
      this.$router.replace('/login');
    }
  },
  ready: function ready() {
    var dropdowns = document.querySelectorAll('.dropdown > .dropdown-toggle');
    if (dropdowns) {
      for (var i = 0; i < dropdowns.length; i++) {
        dropdowns[i].addEventListener('click', function (e) {
          e.preventDefault();
          e.target.offsetParent.classList.add('open');
        });
      }
    }
    this._closeEvent = EventListener.listen(window, 'click', function (e) {
      if (e.target.classList.contains('dropdown-toggle')) {
        return;
      }
      var dropdowns = document.querySelectorAll('.dropdown');
      for (var _i = 0; _i < dropdowns.length; _i++) {
        dropdowns[_i].classList.remove('open');
      }
    });
  },
  carregarJivoChat: function carregarJivoChat() {
    var widgetId = 'nAkknTQd03';
    var d = document;
    var w = window;
    function l() {
      var s = document.createElement('script');
      s.type = 'text/javascript';
      s.async = true;
      s.src = '//code.jivosite.com/script/widget/' + widgetId;
      var ss = document.getElementsByTagName('script')[0];
      ss.parentNode.insertBefore(s, ss);
    }
    if (d.readyState === 'complete') {
      l();
    } else {
      if (w.attachEvent) {
        w.attachEvent('onload', l);
      } else {
        w.addEventListener('load', l, false);
      }
    }
  },
  beforeDestroy: function beforeDestroy() {
    if (this._closeEvent) {
      this._closeEvent.remove();
    }
  }
};

/***/ }),

/***/ "wteZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue__ = __webpack_require__("zhU6");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33776b38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorios_vue__ = __webpack_require__("rKAy");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Relatorios_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_33776b38_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Relatorios_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "xJD8":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _layout = __webpack_require__("6KT8");

var _layout2 = _interopRequireDefault(_layout);

var _AuthLayout = __webpack_require__("v6Pz");

var _AuthLayout2 = _interopRequireDefault(_AuthLayout);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  name: 'app',
  components: {
    AuthLayout: _AuthLayout2.default,
    Layout: _layout2.default
  },
  computed: {
    isAuth: function isAuth() {
      return this.$route.path.match('auth');
    }
  }
};

/***/ }),

/***/ "xKc6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _progress = __webpack_require__("E9Zr");

var _progress2 = _interopRequireDefault(_progress);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _progress2.default;

/***/ }),

/***/ "xMKZ":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _moment = __webpack_require__("PJh5");

var _moment2 = _interopRequireDefault(_moment);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      clienteId: '0',
      veiculoId: '0',
      dataInicial: this.dataAtual(),
      horaInicial: '00:00:00',
      dataFinal: this.dataAtual(),
      horaFinal: '23:59:59',
      relatorio: '0',
      buscaVeiculo: '',
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      processando: false,
      busca: '',
      tensao: '',
      velocidade: '',
      semTransmissao: '',
      onLine: false,
      bateriaBaixa: false,
      vencidos: false
    };
  },
  mounted: function mounted() {
    this.buscarGrid();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.idVeiculo;
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.veiculoId = 0;
        this.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    buscarVeiculos: function buscarVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/listarVeiculos?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosVeiculos = dadosCadastro;
        self.processando = false;
      });
    },
    gerarAnalise: function gerarAnalise() {
      var self = this;
      var veiculoId = self.selecionada;
      var dataHoraInicial = self.dataInicial + ' ' + self.horaInicial;
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-');
      var dataHoraFinal = (0, _moment2.default)(dataHoraInicial, 'DD/MM/YYYY HH:mm:ss');
      dataHoraFinal.add(3, 'days');
      dataHoraFinal = (0, _moment2.default)(dataHoraFinal).format('DD/MM/YYYY HH:mm:ss');
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-');
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção');
        return;
      }
      self.processando = true;

      this.$router.replace('/analiseJornadaView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal);
    },
    gerarAnaliseFrota: function gerarAnaliseFrota() {
      var self = this;
      var veiculoId = self.selecionada;
      var dataHoraInicial = self.dataInicial + ' 00:00:00';
      var dataHoraFinal = self.dataInicial + ' 23:59:59';
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };

      var url = '/api/verificarAnaliseJornadasMultiplas?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);

        {
          var message = 'Deseja realmente gerar as Jornadas ?';
          var options = {
            html: false,
            loader: true,
            reverse: false,
            okText: 'Sim',
            cancelText: 'Não',
            animation: 'zoom',
            type: 'basic',
            verification: 'continue',
            clicksCount: 3 };
          self.$dialog.confirm(message, options).then(function (dialog) {
            self.processando = true;
            url = '/api/analiseJornadasMultiplasFrota?veiculoId=' + veiculoId + '&dataHoraInicial=' + dataHoraInicial + '&dataHoraFinal=' + dataHoraFinal;
            _axios2.default.get(url, config).then(function (response) {
              console.log(response.data);
              dadosCadastro = response.data;
              self.dadosAnalise = dadosCadastro;
              self.dadosAnaliseMacros = dadosCadastro.dadosMacros;
              self.dadosAnaliseProblemas = dadosCadastro.problemasEncontrados;
              self.processando = false;
              dialog.close();
            });
          }).catch(function () {
            console.log('Clicked on cancel');
          });
        }
      });
    }
  }
};

/***/ }),

/***/ "xam5":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _vuePages = __webpack_require__("PrD3");

var _vuePages2 = _interopRequireDefault(_vuePages);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _blobjs = __webpack_require__("CpbR");

var _blobjs2 = _interopRequireDefault(_blobjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      filtros: {
        buscas: this.$store.state.filtrosCliente.buscas,
        pagina: this.$store.state.filtrosCliente.pagina,
        quantidade: this.$store.state.filtrosCliente.quantidade,
        status: this.$store.state.filtrosCliente.status
      },
      relatorios: {
        tipo: 0,
        dataInicial: this.primeiroDiaMes(''),
        dataFinal: this.ultimoDiaMes('')
      },
      selecionada: '0',
      dadosTabela: [],
      url: '#',
      totalPaginas: 1,
      counts: 10,
      showModalRelatorios: false,
      isLoading: false
    };
  },

  created: function created() {
    this.buscar(this.$store.state.filtrosCliente.pagina);
  },
  components: {
    vuePages: _vuePages2.default
  },
  mounted: function mounted() {
    $('.pula').keypress(function (e) {
      var tecla = e.keyCode ? e.keyCode : e.which;
      if (tecla === 13) {
        var campo = $('.pula');
        var indice = campo.index(this);
        if (this.className.includes('adicionar')) {
          $('#adicionar').focus();
        }
        if (campo[indice + 1] != null) {
          var proximo = campo[indice + 1];
          proximo.focus();
        }
        e.preventDefault(e);
        return false;
      }
    });
  },
  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.id;
    },
    selecionado: function selecionado(item) {
      return this.selecionada === item.id;
    },
    paginacao: function paginacao(d, e) {
      this.filtros.pagina = d;
      this.buscar(this.filtros.pagina);
    },

    buscar: function buscar(pagina) {
      this.filtros.pagina = pagina;
      var self = this;
      this.$store.commit('SET_FILTROS_CLIENTE', self.filtros);
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/clientes?buscas=' + this.filtros.buscas + '&pagina=' + this.filtros.pagina + '&quantidade=' + this.filtros.quantidade + '&status=' + this.filtros.status;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosTabela = dadosCadastro.dados;
        self.totalPaginas = dadosCadastro.totalPaginas;
      });
    },
    editar: function editar(id) {
      this.$router.replace('/clientes/editar/' + id);
    },
    relatoriosModal: function relatoriosModal() {
      this.showModalRelatorios = true;
    },
    imprimirRelatorios: function imprimirRelatorios() {
      var self = this;
      self.isLoading = true;

      var config = {
        headers: {
          'Content-Type': 'application/pdf',
          'Authorization': 'Bearer ' + this.$store.state.token
        },
        responseType: 'blob'
      };
      var url = '/api/clientes/relatorio?tipo=' + self.relatorios.tipo + '&dataInicial=' + self.relatorios.dataInicial + '&dataFinal=' + self.relatorios.dataFinal;
      _axios2.default.get(url, config).then(function (response) {
        var url = window.URL.createObjectURL(new _blobjs2.default([response.data], { type: 'application/pdf' }));
        var link = document.createElement('a');
        link.href = url;
        link.setAttribute('target', '_blank');
        document.getElementById('imprimirLinks').appendChild(link);
        link.click();
        self.isLoading = false;
      });
    },
    deletar: function deletar(id) {
      var _this = this;

      var self = this;
      var dadosCadastro = void 0;
      var message = 'Deseja realmente deletar esse Cliente?';
      var options = {
        html: false,
        loader: true,
        reverse: false,
        okText: 'Confirmar',
        cancelText: 'Fechar',
        animation: 'zoom',
        type: 'basic',
        verification: 'continue',
        clicksCount: 3 };
      this.$dialog.confirm(message, options).then(function (dialog) {
        setTimeout(function () {
          var config = {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + _this.$store.state.token
            }
          };
          self.loading = true;
          var url = '/api/clientes/deletar/' + id;
          _axios2.default.get(url, config).then(function (response) {
            console.log(response);
            if (response.data === 'OK') {
              self.$toastr('success', 'Cliente deletado com sucesso.', 'Atenção');
              url = '/api/clientes?buscas=' + self.filtros.buscas + '&pagina=' + self.filtros.pagina + '&quantidade=' + self.filtros.quantidade + '&status=' + self.filtros.status;
              _axios2.default.get(url, config).then(function (response) {
                console.log(response.data);
                dadosCadastro = response.data;
                self.dadosTabela = dadosCadastro.dados;
                self.totalPaginas = dadosCadastro.totalPaginas;
                dialog.close();
              });
            } else {
              self.$toastr('error', 'Esse Cliente está em USO e não pode ser deletado.', 'Atenção');
              dialog.close();
            }
          }).catch(function (error) {
            console.log(error);
          });
        }, 2500);
      }).catch(function () {
        console.log('Clicked on cancel');
      });
    }
  }
};

/***/ }),

/***/ "yalW":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  sistema: {
    collapsed: false
  },
  filtrosGestaoJornada: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    status: 'todos',
    exibir: 'T',
    ordem: 'motorista'
  },
  filtrosRelatorios: {
    clienteId: '0',
    veiculoId: '0',
    veiculoDescricao: '',
    dataInicial: '',
    horaInicial: '00:00',
    dataFinal: '',
    horaFinal: '23:59',
    relatorio: '0',
    buscaVeiculo: '',
    selecionada: '0',
    filtroVelocidade: '0',
    filtroVelocidadeMinima: '0',
    filtroVelocidadeMaxima: '0',
    desprezarVelocidade: '5',
    agruparPosicoes: '0',
    entrada: 'ignicao',
    entradaVelocidade: '0',
    obdIgnicao: 'todas',
    obdRpm: '0',
    obdTemperatura: '0',
    obdErro: 'todas',
    agrupar: 'N',
    formato: 'visualizacao'
  },
  filtrosCliente: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosFornecedor: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosTransportador: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosVeiculo: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosVendedor: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosProduto: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosServico: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosDepositoMovimento: {
    dataInicial: '',
    dataFinal: '',
    produtoId: '0',
    produtoNome: '',
    tipo: '0',
    depositoId: '0'
  },
  filtrosDepositoBalanco: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    depositoId: '0'
  },
  filtrosFinanceiro: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    titularId: '0',
    titularTipo: '',
    titularNome: '',
    titular: '',
    exibir: 'todos',
    ordenarPor: 'vencimento',
    selecionada: '0'
  },
  filtrosFinanceiroContaCaixa: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosBanco: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosBancoMovimento: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    bancoId: '0',
    exibir: '0',
    ordenarPor: 'vencimento'
  },
  filtrosBancoBoleto: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    bancoId: '0',
    exibir: 'T',
    ordenarPor: 'vencimento'
  },
  filtrosCheque: {
    dataInicial: '',
    dataFinal: '',
    busca: '',
    titularId: '0',
    titularTipo: '',
    titularNome: '',
    titular: '',
    status: '0',
    ordenarPor: 'vencimento',
    selecionada: '0'
  },
  filtrosCompra: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosCompraCotacao: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosCompraOrdemCompra: {
    dataInicial: '',
    dataFinal: '',
    fornecedorId: '0',
    fornecedorNome: '',
    numero: '0',
    status: '',
    selecionada: '0',
    selecionadaCompra: ''
  },
  filtrosVenda: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosDevolucao: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosVendaServico: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosVendaComodato: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },
  filtrosNotaFiscal: {
    dataInicial: '',
    dataFinal: '',
    clienteId: '0',
    clienteNome: '',
    numero: '0',
    status: ''
  },

  filtrosFormaPagamento: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosCodigoNcm: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosCidade: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosMotorista: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosEvento: {
    buscas: '',
    pagina: 1,
    quantidade: 15,
    status: 'A',
    selecionada: '0'
  },
  filtrosEventoDisparado: {
    dataInicial: '',
    dataFinal: '',
    buscas: '',
    eventoId: '0',
    status: 'T'
  },
  user: {
    name: '',
    email: ''
  },
  token: ''
};

/***/ }),

/***/ "ycH7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 58px)","height":"calc(100vh - 158px)"},attrs:{"center":_vm.center,"zoom":12}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalMapa = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km\n              ")])]),_vm._v(" "),_c('br')])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataHoraOn))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.dataHoraOff))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.duracao))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.distancia))+" Km")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidadeMaxima))+" Km/h / "+_vm._s(dados.rotacaoMaxima)+" / "+_vm._s(dados.temperaturaMaxima)+" º")])]),_vm._v(" "),_c('td',{staticClass:"text-center"},[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.bruscaAceleracao)+" / "+_vm._s(dados.bruscaDesaceleracao)+" / "+_vm._s(dados.curvaAcentuada)+" / "+_vm._s(dados.trocaFaixaRapida))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.paradoTempo))])])])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Viagem")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"110"}},[_vm._v("INICIO")]),_vm._v(" "),_c('th',{attrs:{"width":"110"}},[_vm._v("FINAL")]),_vm._v(" "),_c('th',[_vm._v("DURACAO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DISTANCIA")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"150"}},[_vm._v("Valores Máximos"),_c('br'),_vm._v("VEL / RPM / TEMP")]),_vm._v(" "),_c('th',{staticClass:"text-center",attrs:{"width":"300"}},[_vm._v("Movimentos Bruscos"),_c('br'),_vm._v("Acel. / Desacel. / Curva / T. de faixa")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("TEMPO PARADO")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ys1d":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yukh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":15,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('download-excel',{staticClass:"btn btn-default",attrs:{"fields":{'Data': 'data', 'Hora': 'hora',  'Ponto Mais Próximo': 'pontoMaisProximo',
              'Velocidade': 'velocidade', 'Deslocamento': 'deslocamento', 'Ignição': 'ignicao', 'GPS': 'gps', 'GPRS': 'gprs', 'Movimento': 'movimento', 'Volt': 'tensao', 'Motivo Transmissão': 'motivoTransmissao'  },"data":_vm.dadosRelatorios.dados,"title":'Data: '+_vm.dadosRelatorios.data + '\n  Veículo: ' + _vm.dadosRelatorios.veiculo +  '\n  Empresa: ' + _vm.dadosRelatorios.empresa + '\n\n' + '  Distância Percorrida: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida) + 'Km' + '\n  Odômetro do GPS: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro) + ' Km ' + '\n  Velocidade Média: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia) + ' Km/h ' + '\n  Velocidade Máxima: ' + _vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima) + ' Km/h ',"footer":_vm.dadosRelatorios.data,"worksheet":"My Worksheet","name":"filename.xls"}},[_c('button',{staticClass:"btn btn-success"},[_vm._v("Download XLS")])]),_vm._v(" "),_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Odômetro do GPS: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[(dados.alertaVelocidade === 'true')?[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicaoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimentoDesativada)?[_c('img',{attrs:{"src":"/static/images/disable.png"}})]:[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]]],2),_vm._v(" "),_c('td',[(dados.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(dados.tensao))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))]),_vm._v(" "),(dados.motorista !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])]:_vm._e()],2)])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "ywe9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalEditarMacro)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modalAdicioarCredito","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"modal-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-md-6"},[_c('label',[_vm._v("Data Hora:")]),_c('br'),_vm._v(" "),_c('input-data-hora-picker',{directives:[{name:"validate",rawName:"v-validate",value:('required'),expression:"'required'"}],class:{'input pula form-control data': true, 'is-danger': _vm.errors.has('data') },attrs:{"name":"data","data-vv-delay":"500"},model:{value:(_vm.macro.dataHora),callback:function ($$v) {_vm.$set(_vm.macro, "dataHora", $$v)},expression:"macro.dataHora"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motivo:")]),_c('br'),_vm._v(" "),_c('select',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.macro),expression:"macro.macro"}],staticClass:"pula form-control",on:{"change":function($event){var $$selectedVal = Array.prototype.filter.call($event.target.options,function(o){return o.selected}).map(function(o){var val = "_value" in o ? o._value : o.value;return val}); _vm.$set(_vm.macro, "macro", $event.target.multiple ? $$selectedVal : $$selectedVal[0])}}},[_c('option',{attrs:{"value":"0"}},[_vm._v("01 - INICIO JORNADA")]),_vm._v(" "),_c('option',{attrs:{"value":"1"}},[_vm._v("02 - FIM JORNADA")]),_vm._v(" "),_c('option',{attrs:{"value":"2"}},[_vm._v("03 - ESPERA")]),_vm._v(" "),_c('option',{attrs:{"value":"3"}},[_vm._v("04 - ALIMENTACAO")]),_vm._v(" "),_c('option',{attrs:{"value":"4"}},[_vm._v("05 - DESCANSO DIRECAO")]),_vm._v(" "),_c('option',{attrs:{"value":"5"}},[_vm._v("06 - ABASTECIMENTO")]),_vm._v(" "),_c('option',{attrs:{"value":"6"}},[_vm._v("07 - FISCALIZACAO")]),_vm._v(" "),_c('option',{attrs:{"value":"7"}},[_vm._v("08 - MANUTECAO")]),_vm._v(" "),_c('option',{attrs:{"value":"20"}},[_vm._v("21 - EMBARQUE")]),_vm._v(" "),_c('option',{attrs:{"value":"21"}},[_vm._v("22 - DESEMBARQUE")]),_vm._v(" "),_c('option',{attrs:{"value":"33"}},[_vm._v("34 - EM ATIVIDADE")]),_vm._v(" "),_c('option',{attrs:{"value":"50"}},[_vm._v("51 - TEXTO")]),_vm._v(" "),_c('option',{attrs:{"value":"100"}},[_vm._v("101 - MOVIMENTO")])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Motorista:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.motoristaId),expression:"macro.motoristaId"}],staticClass:"form-control",attrs:{"id":"motoristaId","type":"hidden"},domProps:{"value":(_vm.macro.motoristaId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.macro, "motoristaId", $event.target.value)}}}),_vm._v(" "),_c('buscar-lista-motorista',{attrs:{"id":"motoristaNome","placeholder":"Selecione um motorista..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarMotorista,"on-blur":_vm.verificarMotorista},model:{value:(_vm.macro.motoristaNome),callback:function ($$v) {_vm.$set(_vm.macro, "motoristaNome", $$v)},expression:"macro.motoristaNome"}})],1)]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"form-group col-sm-12 col-md-12"},[_c('label',[_vm._v("Veículo:")]),_c('br'),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.macro.veiculoId),expression:"macro.veiculoId"}],staticClass:"form-control",attrs:{"id":"veiculoId","type":"hidden"},domProps:{"value":(_vm.macro.veiculoId)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(_vm.macro, "veiculoId", $event.target.value)}}}),_vm._v(" "),_c('buscar-veiculo',{attrs:{"type":"search","id":"veiculoDescricao","placeholder":"Selecione um veículo..","classes":{ input: 'input pula form-control', wrapper: 'input-wrapper'},"on-select":_vm.setarVeiculo,"on-blur":_vm.verificarVeiculo},model:{value:(_vm.macro.veiculoDescricao),callback:function ($$v) {_vm.$set(_vm.macro, "veiculoDescricao", $$v)},expression:"macro.veiculoDescricao"}})],1)])])]),_vm._v(" "),_c('div',{staticClass:"modal-footer"},[_c('button',{staticClass:"btn btn-success",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":_vm.adicionarMacro}},[(_vm.botaoProcessando)?_c('i',{staticClass:"fa fa-spinner fa-spin"}):_vm._e(),_vm._v(" Gerar")]),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",attrs:{"type":"button","data-dismiss":"modal"},on:{"click":function($event){_vm.showModalEditarMacro = false}}},[_vm._v("Fechar")])])])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-12"},[_c('strong',[_vm._v("Periodo: ")]),_vm._v(" De: "+_vm._s(_vm.dadosAnalise.dataInicial)+" até "+_vm._s(_vm.dadosAnalise.dataFinal)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosAnalise.veiculo)+"\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-6"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosAnalise.empresa)+"\n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.kmRodados).toFixed(2))+" Km \n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMedia).toFixed(2))+" Km/h\n            ")]),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(parseFloat(_vm.dadosAnalise.velocidadeMaxima).toFixed(2))+" Km/h \n            ")])]),_vm._v(" "),_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Motorista: ")]),_vm._v(_vm._s(_vm.dadosAnalise.motorista)+"\n            ")])])]),_vm._v(" "),_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row row-margin"},[_c('div',{staticClass:"col-md-4"},[_c('div',[_c('strong',[_vm._v("Problemas encontrados na Análise")]),_vm._v(" "),_c('div',{staticClass:"description",domProps:{"innerHTML":_vm._s(_vm.dadosAnaliseProblemas)}})])]),_vm._v(" "),_c('div',{staticClass:"col-md-4"}),_vm._v(" "),_c('div',{staticClass:"col-md-4"},[_c('div',{staticClass:"pull-right"},[_c('input',{staticClass:"btn btn-primary",attrs:{"id":"botaoMudarMotivo","type":"submit","value":"Adicionar Macro"},on:{"click":function($event){_vm.showModalEditarMacro = true}}}),_vm._v(" "),_c('router-link',{staticClass:"btn btn-warning",attrs:{"to":"/analiseJornadaTabela"}},[_c('span',{staticClass:"glyphicon glyphicon-back"}),_vm._v(" Salvar\n                ")]),_vm._v(" "),_c('button',{staticClass:"btn btn-success ",attrs:{"id":"gravarAnalise","type":"button"},on:{"click":_vm.gravarAnalise}},[_c('span',{staticClass:"glyphicon glyphicon-save",attrs:{"aria-hidden":"true"}}),_vm._v(" Gravar Análise\n                ")])],1)])])]),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(2),_vm._v(" "),_vm._l((_vm.dadosAnaliseMacros),function(grid,i){return _c('tbody',[_c('tr',[_c('td',[_vm._v(_vm._s(grid.dataHoraInicio))]),_vm._v(" "),_c('td',[_vm._v(_vm._s(grid.macro))])])])})],2),_vm._v(" "),_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_vm._l((_vm.dadosAnalise.dados),function(grid,i){return _c('tbody',[(i > 0 && _vm.dadosAnalise.dados[i].data !== _vm.dadosAnalise.dados[i-1].data)?[_vm._m(4,true)]:_vm._e(),_vm._v(" "),_c('tr',{class:{ 'gestao-jornada-atencao': (grid.statusVeiculo === 'VEICULO PARADO' && grid.motivo === '') }},[_c('td',{attrs:{"width":"140"}},[_c('small',[(grid.dataHoraInicialViagem)?[_c('span',{staticClass:"text-success"},[_c('strong',[_vm._v("\n                        "+_vm._s(grid.data)+" \n                        "+_vm._s(grid.dataHoraInicio)+"\n                      ")])])]:[_vm._v("\n                    "+_vm._s(grid.data)+" \n                    "+_vm._s(grid.dataHoraInicio)+"\n                  ")],_vm._v(" "),_c('br'),_vm._v(" "),(grid.dataHoraFinalViagem)?[_c('span',{staticClass:"text-danger"},[_c('strong',[_vm._v("\n                        "+_vm._s(grid.data)+" \n                        "+_vm._s(grid.dataHoraFinal)+"\n                      ")])])]:[_vm._v("\n                    "+_vm._s(grid.data)+" \n                    "+_vm._s(grid.dataHoraFinal)+"\n                  ")]],2)]),_vm._v(" "),_c('td',{attrs:{"width":"85"}},[_c('small',[_vm._v(_vm._s(grid.dataHoraDuracao))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.statusVeiculo))]),_vm._v(" "),(grid.statusVeiculo === 'VEICULO EM MOVIMENTO')?[_c('small',[_vm._v(" - "+_vm._s(_vm.formatarVelocidadeMetros(grid.kmRodados))+" metros ")])]:_vm._e()],2),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.motivo))])]),_vm._v(" "),_c('td',[_c('small',[_vm._v(_vm._s(grid.tipoMotivo))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(grid.observacao))])]),_vm._v(" "),_c('td'),_vm._v(" "),_c('td')])],2)})],2)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"modal-header"},[_c('h4',{staticClass:"modal-title"},[_vm._v("Adicionar Macro")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("MACRO")])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',[_vm._v("PERIODO")]),_vm._v(" "),_c('th',[_vm._v("DURAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th',[_vm._v("MOTIVO")]),_vm._v(" "),_c('th',[_vm._v("TIPO")]),_vm._v(" "),_c('th',[_vm._v("OBSERVAÇÃO")]),_vm._v(" "),_c('th'),_vm._v(" "),_c('th')])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tr',{staticStyle:{"background-color":"#FF0400","height":"20px"}},[_c('td',{attrs:{"colspan":"6"}})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "z1Ie":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var vm = {
  name: 'input-peso',
  props: {
    value: [String, Number],
    speed: {
      default: 20
    }
  },
  mounted: function mounted() {
    var vmm = this;
    $(this.$el).maskMoney({
      prefix: '',
      allowZero: true,
      allowNegative: true,
      thousands: '',
      decimal: ',',
      affixesStay: true
    });
    $(this.$el).maskMoney('mask');
    $(this.$el).trigger('paste');
    $(this.$el).trigger('input');
    $(this.$el).val(this.value);
    $(this.$el).on('change', function () {
      vmm.$emit('input', this.value);
    });
  },

  watch: {
    value: function value(_value) {
      $(this.$el).val(_value);
      $(this.$el).maskMoney('mask');
      $(this.$el).trigger('paste');
      $(this.$el).trigger('input');
    }
  }
};
module.exports = vm;

/***/ }),

/***/ "z7My":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"animated fadeIn"},[_c('div',{staticClass:"col-sm-12 col-md-12"},[(_vm.processando)?_c('div',{staticClass:"loading"},[_vm._m(0)]):_vm._e(),_vm._v(" "),(_vm.showModalMapa)?_c('div',{staticClass:"modal fade show ",attrs:{"id":"modal-mapa","tabindex":"-1","role":"dialog","aria-labelledby":"myModalLabel","aria-hidden":"true","data-keyboard":"false","data-backdrop":"static"}},[_c('div',{staticClass:"modal-dialog modal-lg"},[_c('div',{staticClass:"modal-content"},[_c('div',{staticClass:"modal-body"},[_c('a',{staticClass:"close",staticStyle:{"z-index":"1000000","font-size":"69px","color":"#000","float":"right","right":"0","position":"absolute","top":"-40px","opacity":"1"},attrs:{"data-dismiss":"modal","aria-label":"Fechar"},on:{"click":function($event){_vm.showModalMapa = false}}},[_c('span',{attrs:{"aria-hidden":"true"}},[_vm._v("×")])]),_vm._v(" "),_c('gmap-map',{ref:"map",staticStyle:{"width":"calc(100vw - 28px)","height":"calc(100vh - 64px)"},attrs:{"center":_vm.center,"zoom":12,"options":{ gestureHandling: 'greedy'}}},[_c('gmap-info-window',{attrs:{"options":_vm.infoOptions,"position":_vm.infoWindowPos,"opened":_vm.infoWinOpen},on:{"closeclick":function($event){_vm.infoWinOpen=false}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.infoContent)}})]),_vm._v(" "),_vm._l((_vm.markers),function(m,index){return _c('gmap-marker',{key:index,attrs:{"position":m.position},on:{"click":function($event){_vm.toggleInfoWindow(m,index)}}})}),_vm._v(" "),(_vm.path.length > 0)?_c('gmap-polyline',{ref:"polyline",attrs:{"path":_vm.path,"editable":false}}):_vm._e()],2)],1)])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"card",attrs:{"id":"relatorio"}},[_vm._m(1),_vm._v(" "),_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"row"},[_vm._m(2),_vm._v(" "),_c('div',{staticClass:"col-md-6 text-right"},[_c('button',{staticClass:"btn btn-success",on:{"click":function($event){_vm.visualizarMapa()}}},[_vm._v("Ver no Mapa")]),_vm._v(" "),_c('router-link',{staticClass:"btn btn-danger",attrs:{"id":"btnNovoVeiculo","to":"/relatorios"}},[_c('span',{staticClass:"glyphicon glyphicon-plus"}),_vm._v(" Fechar\n            ")])],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"12px","margin-bottom":"12px"}},[_c('div',{staticClass:"col-md-12"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Data: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.data)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Veículo: ")]),_vm._v(" "+_vm._s(_vm.dadosRelatorios.veiculo)+"\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Empresa: ")]),_vm._v(_vm._s(_vm.dadosRelatorios.empresa)+"\n              ")])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-4"},[_c('strong',[_vm._v("Distância Percorrida: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorrida))+" Km"),_c('br'),_vm._v(" "),_c('strong',[_vm._v("Odômetro do GPS: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.distanciaPercorridaOdometro))+" Km\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-3"},[_c('strong',[_vm._v("Velocidade Média: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMedia))+" Km/h\n              ")]),_vm._v(" "),_c('div',{staticClass:"col-md-5"},[_c('strong',[_vm._v("Velocidade Máxima: ")]),_vm._v(_vm._s(_vm.formatarVelocidade(_vm.dadosRelatorios.velocidadeMaxima))+" Km/h\n              ")])])])]),_vm._v(" "),(_vm.processando === false)?[(_vm.dadosRelatorios.dados.length > 0)?[_c('table',{staticClass:"table table-responsive-sm table-hover table-outline mb-0"},[_vm._m(3),_vm._v(" "),_c('tbody',_vm._l((_vm.dadosRelatorios.dados),function(dados,i){return _c('tr',{class:{ 'selecionado': _vm.selecionado(dados) },on:{"click":function($event){_vm.selecionarItem(dados, $event)}}},[_c('td',[_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.latitude),expression:"dados.latitude"}],attrs:{"id":'latitude_'+i,"type":"hidden"},domProps:{"value":(dados.latitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "latitude", $event.target.value)}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(dados.longitude),expression:"dados.longitude"}],attrs:{"id":'longitude_'+i,"type":"hidden"},domProps:{"value":(dados.longitude)},on:{"input":function($event){if($event.target.composing){ return; }_vm.$set(dados, "longitude", $event.target.value)}}}),_vm._v(" "),_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.hora))])]),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.pontoMaisProximo))])]),_vm._v(" "),_c('td',[(dados.alertaVelocidade === 'true')?[_c('small',{staticClass:"text-danger"},[_c('strong',[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(_vm.formatarVelocidade(dados.velocidade))+" Km/h")])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.deslocamento)+" Km")])]),_vm._v(" "),_c('td',[(dados.ignicao)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gps)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.gprs)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.movimento)?[_c('img',{attrs:{"src":"/static/images/true.png"}})]:[_c('img',{attrs:{"src":"/static/images/false.png"}})]],2),_vm._v(" "),_c('td',[(dados.alertaTensao === 'true')?[_c('small',{staticClass:"text-warning"},[_c('strong',[_vm._v(_vm._s(dados.tensao))])])]:[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.tensao))])]],2),_vm._v(" "),_c('td',[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motivoTransmissao))]),_vm._v(" "),(dados.motorista !== '')?[_c('small',{staticClass:"text-muted"},[_vm._v(_vm._s(dados.motorista))])]:_vm._e()],2)])}))])]:[_c('div',{attrs:{"id":"relatorio-sem-dados"}},[_c('h1',[_c('bold',[_vm._v("Sem dados para o período")])],1)])]]:_vm._e()],2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"progress"},[_c('div',{staticClass:"progress-bar progress-bar-striped progress-bar-animated bg-success",staticStyle:{"width":"100%"},attrs:{"role":"progressbar","aria-valuenow":"100","aria-valuemin":"0","aria-valuemax":"100"}})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card-title"},[_c('strong')])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-md-6"},[_c('h3',[_vm._v("Relatório de Posições")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('thead',{staticClass:"thead-light"},[_c('tr',[_c('th',{attrs:{"width":"80"}},[_vm._v("HORA")]),_vm._v(" "),_c('th',[_vm._v("PONTO MAIS PROXIMO")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("VELOCIDADE")]),_vm._v(" "),_c('th',{attrs:{"width":"120"}},[_vm._v("DESLOCAMENTO")]),_vm._v(" "),_c('th',{attrs:{"width":"65"}},[_vm._v("IGNIÇÃO")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("GPRS")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("MOV")]),_vm._v(" "),_c('th',{attrs:{"width":"50"}},[_vm._v("VOLT")]),_vm._v(" "),_c('th',{attrs:{"width":"70"}},[_vm._v("MOT T")])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zQeX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue__ = __webpack_require__("lQJf");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b026a58c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputMonetario10_vue__ = __webpack_require__("6bfs");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SparkInputMonetario10_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b026a58c_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SparkInputMonetario10_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ }),

/***/ "zewB":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _keys = __webpack_require__("fZjL");

var _keys2 = _interopRequireDefault(_keys);

var _stringify = __webpack_require__("mvHQ");

var _stringify2 = _interopRequireDefault(_stringify);

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var vm = {
  name: 'buscar-motorista',
  props: {
    id: String,
    name: String,
    className: String,
    value: [String, Number],
    classes: {
      type: Object,
      default: function _default() {
        return {
          wrapper: false,
          input: false,
          list: false,
          item: false
        };
      }
    },
    placeholder: String,
    required: Boolean,

    filterByAnchor: {
      type: Boolean,
      default: true
    },

    anchor: {
      type: String,
      required: false
    },

    label: String,

    debounce: Number,

    url: {
      type: String,
      required: false
    },

    param: {
      type: String,
      default: 'q'
    },
    encodeParams: {
      type: Boolean,
      default: true
    },

    customParams: Object,

    customHeaders: Object,

    min: {
      type: Number,
      default: 0
    },

    onShouldRenderChild: Function,

    process: Function,

    onInput: Function,
    onShow: Function,
    onBlur: Function,
    onHide: Function,
    onFocus: Function,
    onSelect: Function,
    onBeforeAjax: Function,
    onAjaxProgress: Function,
    onAjaxLoaded: Function,
    onShouldGetData: Function
  },
  data: function data() {
    return {
      showList: false,
      type: '',
      json: [],
      focusList: '',
      debounceTask: undefined
    };
  },

  watch: {
    value: function value(_value) {
      this.setValue(_value);
    },
    options: function options(newVal, oldVal) {
      if (this.filterByAnchor) {
        var type = this.type,
            anchor = this.anchor;

        var regex = new RegExp('' + type, 'i');
        var filtered = newVal.filter(function (item) {
          var found = item[anchor].search(regex) !== -1;
          return found;
        });
        this.json = filtered;
      } else {
        this.json = newVal;
      }
    }
  },
  methods: {
    getClassName: function getClassName(part) {
      var classes = this.classes,
          className = this.className;

      if (classes[part]) return '' + classes[part];
      return className ? className + '-' + part : '';
    },
    clearInput: function clearInput() {
      this.showList = false;
      this.type = '';
      this.json = [];
      this.focusList = '';
    },
    cleanUp: function cleanUp(data) {
      return JSON.parse((0, _stringify2.default)(data));
    },
    handleInput: function handleInput(e) {
      var _this = this;

      var value = e.target.value;

      this.showList = true;

      if (this.onInput) this.onInput(value);

      if (this.debounce) {
        if (this.debounceTask !== undefined) clearTimeout(this.debounceTask);
        this.debounceTask = setTimeout(function () {
          return _this.getData(value);
        }, this.debounce);
      } else {
        return this.getData(value);
      }
    },
    handleKeyDown: function handleKeyDown(e) {
      var key = e.keyCode;

      if (!this.showList) return;

      var DOWN = 40;
      var UP = 38;
      var ENTER = 13;
      var ESC = 27;
      var altura = 0;
      var posicao = 0;
      var listLength = this.json.length - 1;

      switch (key) {
        case DOWN:
          e.preventDefault();
          altura = listLength * 58;
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (posicao < altura && this.focusList < listLength) {
            this.focusList++;
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao + 58 }, 50);
          }
          break;
        case UP:
          e.preventDefault();
          posicao = $(this.$el).find('.autocomplete ul').scrollTop();
          if (this.focusList > 0) {
            this.focusList--;
          }
          if (posicao > 0) {
            $(this.$el).find('.autocomplete ul').animate({ scrollTop: posicao - 58 }, 50);
          }
          break;
        case ENTER:
          e.preventDefault();
          this.selectList(this.json[this.focusList]);
          this.showList = false;
          break;
        case ESC:
          this.showList = false;
          break;
      }
    },
    setValue: function setValue(val) {
      $(this.$el).find('#motoristaNome').val(val);
    },
    handleDoubleClick: function handleDoubleClick() {
      this.json = [];
      this.getData('');

      if (this.onShow) {
        this.onShow();
      }
      this.showList = true;
    },
    handleBlur: function handleBlur(e) {
      var _this2 = this;

      if (this.onBlur) {
        this.onBlur(e);
      }
      setTimeout(function () {
        if (_this2.onHide) {
          _this2.onHide();
        }
        _this2.showList = false;
      }, 250);
    },
    handleFocus: function handleFocus(e) {
      this.focusList = 0;

      if (this.onFocus) {
        this.onFocus(e);
      }
    },
    mousemove: function mousemove(i) {
      this.focusList = i;
    },
    activeClass: function activeClass(i) {
      var focusClass = i === this.focusList ? 'focus-list' : '';
      return '' + focusClass;
    },
    selectList: function selectList(data) {
      this.$emit('input', data.nomeFantasia);

      var clean = this.cleanUp(data);

      this.type = clean[this.anchor];

      this.showList = false;

      if (this.onSelect) {
        this.onSelect(clean);
        $(this.$el).find('#motoristaNome').val(clean.nomeFantasia);
      }
    },
    deepValue: function deepValue(obj, path) {
      var arrayPath = path.split('.');
      for (var i = 0; i < arrayPath.length; i++) {
        obj = obj[arrayPath[i]];
      }
      return obj;
    },
    composeParams: function composeParams(val) {
      var _this3 = this;

      var encode = function encode(val) {
        return _this3.encodeParams ? encodeURIComponent(val) : val;
      };
      var params = this.param + '=' + encode(val);
      if (this.customParams) {
        (0, _keys2.default)(this.customParams).forEach(function (key) {
          params += '&' + key + '=' + encode(_this3.customParams[key]);
        });
      }
      return params;
    },
    composeHeader: function composeHeader(ajax) {
      var _this4 = this;

      if (this.customHeaders) {
        (0, _keys2.default)(this.customHeaders).forEach(function (key) {
          ajax.setRequestHeader(key, _this4.customHeaders[key]);
        });
      }
    },
    doAjax: function doAjax(val) {
      if (this.onBeforeAjax) {
        this.onBeforeAjax(val);
      }

      var self = this;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/buscarMotoristasAtivos?busca=' + val;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        var dados = response.data;
        self.json = dados;
      });
    },
    getData: function getData(value) {
      if (value.length < 3) return;

      this.doAjax(value);
    },
    manualGetData: function manualGetData(val) {
      var _this5 = this;

      var task = this.onShouldGetData(val);
      if (task && task.then) {
        return task.then(function (options) {
          _this5.json = options;
        });
      }
    }
  },
  created: function created() {
    this.type = this.initValue ? this.initValue : null;
    $(this.$el).val(this.value);
  },
  mounted: function mounted() {
    $(this.$el).val(this.value);
    $(this.$el).find('#' + this.id).val(this.value);
    if (this.required) this.$refs.input.setAttribute('required', this.required);
  }
};
module.exports = vm;

/***/ }),

/***/ "zfG0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-map-container"},[_c('div',{ref:"vue-map",staticClass:"vue-map"}),_vm._v(" "),_c('div',{staticClass:"vue-map-hidden"},[_vm._t("default")],2),_vm._v(" "),_vm._t("visible")],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "zhU6":
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _axios = __webpack_require__("mtWM");

var _axios2 = _interopRequireDefault(_axios);

var _LineChart = __webpack_require__("O/JI");

var _LineChart2 = _interopRequireDefault(_LineChart);

var _PieChart = __webpack_require__("D+CC");

var _PieChart2 = _interopRequireDefault(_PieChart);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  components: {
    LineChart: _LineChart2.default,
    PieChart: _PieChart2.default
  },
  data: function data() {
    return {
      filtros: {
        clienteId: this.$store.state.filtrosRelatorios.clienteId,
        veiculoId: this.$store.state.filtrosRelatorios.veiculoId,
        veiculoMarcaEquipamento: '',
        veiculoDescricao: this.$store.state.filtrosRelatorios.veiculoDescricao,
        dataInicial: this.$store.state.filtrosRelatorios.dataInicial === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataInicial,
        horaInicial: this.$store.state.filtrosRelatorios.horaInicial,
        dataFinal: this.$store.state.filtrosRelatorios.dataFinal === '' ? this.dataAtual() : this.$store.state.filtrosRelatorios.dataFinal,
        horaFinal: this.$store.state.filtrosRelatorios.horaFinal,
        relatorio: this.$store.state.filtrosRelatorios.relatorio,
        buscaVeiculo: this.$store.state.filtrosRelatorios.buscaVeiculo,
        selecionada: this.$store.state.filtrosRelatorios.selecionada,
        filtroVelocidade: this.$store.state.filtrosRelatorios.filtroVelocidade,
        filtroVelocidadeMinima: this.$store.state.filtrosRelatorios.filtroVelocidadeMinima,
        filtroVelocidadeMaxima: this.$store.state.filtrosRelatorios.filtroVelocidadeMaxima,
        desprezarVelocidade: '5',
        agruparPosicoes: this.$store.state.filtrosRelatorios.agruparPosicoes,
        entrada: this.$store.state.filtrosRelatorios.entrada,
        entradaVelocidade: this.$store.state.filtrosRelatorios.entradaVelocidade,
        obdIgnicao: this.$store.state.filtrosRelatorios.obdIgnicao,
        obdRpm: this.$store.state.filtrosRelatorios.obdRpm,
        obdTemperatura: this.$store.state.filtrosRelatorios.obdTemperatura,
        obdErro: this.$store.state.filtrosRelatorios.obdErro,
        agrupar: this.$store.state.filtrosRelatorios.agrupar,
        formato: 'visualizacao'
      },
      selecionada: '0',
      dadosVeiculos: [],
      dadosGrid: [],
      buscaVeiculo: '',
      processando: false
    };
  },
  mounted: function mounted() {
    this.buscarVeiculos();
  },

  methods: {
    selecionarItem: function selecionarItem(item) {
      console.log(item.id);
      this.selecionada = item.idVeiculo;
      this.filtros.veiculoId = item.idVeiculo;
      this.filtros.veiculoMarcaEquipamento = item.marcaEquipamento;
    },
    selecionado: function selecionado(item) {
      return this.filtros.veiculoId === item.idVeiculo;
    },
    buscarGrid: function buscarGrid() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/listarVeiculosComJornadaTrabalho?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    buscarVeiculos: function buscarVeiculos() {
      var self = this;
      self.processando = true;
      var dadosCadastro;
      var config = {
        headers: { 'Authorization': 'Bearer ' + this.$store.state.token }
      };
      var url = '/api/veiculos/buscarVeiculosAtivos?busca=' + this.buscaVeiculo;
      _axios2.default.get(url, config).then(function (response) {
        console.log(response.data);
        dadosCadastro = response.data;
        self.dadosGrid = dadosCadastro;
        self.processando = false;
      });
    },
    setarDataInicial: function setarDataInicial(e) {
      console.log('set inicial');
      console.log(e);
      console.log(e.target);

      this.filtros.dataInicial = $(this.$el).find('#dataInicial').val();
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val();
      this.filtros.dataFinal = this.filtros.dataInicial;
      console.log($(this.$el).find('#dataFinal').val($(this.$el).find('#dataInicial').val()));
    },
    setarDataFinal: function setarDataFinal() {
      console.log('set final');
      this.filtros.dataFinal = $(this.$el).find('#dataFinal').val();
    },
    setarVeiculo: function setarVeiculo(veiculo) {
      this.model.veiculoId = veiculo.id;
      this.model.veiculoDescricao = veiculo.descricaoVeiculo;
      $(this.$el).find('#veiculoDescricao').val(veiculo.descricaoVeiculo);
    },
    verificarVeiculo: function verificarVeiculo() {
      if ($(this.$el).find('#veiculoId').val() === '0') {
        this.filtros.veiculoId = 0;
        this.filtros.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
      if ($(this.$el).find('#veiculoDescricao').val() === '') {
        this.filtros.veiculoId = 0;
        this.filtros.veiculoDescricao = '';
        $(this.$el).find('#veiculoId').val(0);
        $(this.$el).find('#veiculoDescricao').val('');
      }
    },

    gerarRelatorio: function gerarRelatorio() {
      var self = this;
      var clienteId = self.filtros.veiculoId;
      var veiculoId = self.filtros.veiculoId;
      var dataHoraInicial = self.filtros.dataInicial + ' ' + self.filtros.horaInicial + ':00';
      dataHoraInicial = dataHoraInicial.replace(/\//g, '-');
      var dataHoraFinal = self.filtros.dataFinal + ' ' + self.filtros.horaFinal + ':59';
      dataHoraFinal = dataHoraFinal.replace(/\//g, '-');
      if (veiculoId === '0' || veiculoId === 0) {
        self.$toastr('error', 'Selecione o Veículo.', 'Atenção');
        return;
      }
      if (this.diasEntreDadas(this.filtros.dataInicial, this.filtros.dataFinal) < 0) {
        self.$toastr('error', 'Verifique o Período do relatório.', 'Atenção');
        return;
      }
      if (self.filtros.relatorio === '0' || self.filtros.relatorio === '1') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 2) {
          self.$toastr('error', 'O Período não pode ser superior a 2 dias.', 'Atenção');
          return;
        }
      }
      if (self.filtros.relatorio === '2') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 16) {
          self.$toastr('error', 'O Período não pode ser superior a 16 dias.', 'Atenção');
          return;
        }
      }
      if (self.filtros.relatorio === '3') {
        if (self.diasEntreDadas(self.filtros.dataInicial, self.filtros.dataFinal) > 16) {
          self.$toastr('error', 'O Período não pode ser superior a 16 dias.', 'Atenção');
          return;
        }
      }
      self.$store.commit('SET_FILTROS_RELATORIOS', self.filtros);

      if (self.filtros.relatorio === 0 || self.filtros.relatorio === '0') {
        self.$router.replace('/relatorioDePosicoesView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes);
      } else if (self.filtros.relatorio === 1 || self.filtros.relatorio === '1') {
        self.$router.replace('/relatorioDePosicoesObdView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes + '/' + self.filtros.obdIgnicao + '/' + self.filtros.obdRpm + '/' + self.filtros.obdTemperatura + '/' + self.filtros.obdErro);
      } else if (self.filtros.relatorio === 2 || self.filtros.relatorio === '2') {
        self.$router.replace('/relatorioDeAnaliseTrabalhoProducaoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada + '/' + self.filtros.entradaVelocidade);
      } else if (self.filtros.relatorio === 3 || self.filtros.relatorio === '3') {
        self.$router.replace('/relatorioDeAnaliseTrabalhoProducaoSinteticoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada + '/' + self.filtros.entradaVelocidade);
      } else if (self.filtros.relatorio === 4 || self.filtros.relatorio === '4') {
        self.$router.replace('/relatorioDePosicoesObdTripView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes + '/' + self.filtros.obdIgnicao + '/' + self.filtros.obdRpm + '/' + self.filtros.obdTemperatura + '/' + self.filtros.obdErro);
      } else if (self.filtros.relatorio === 5 || self.filtros.relatorio === '5') {
        self.$router.replace('/relatorioDeAcionamentoDeEntradaView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidadeMinima + '/' + self.filtros.filtroVelocidadeMaxima + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.entrada);
      } else if (self.filtros.relatorio === 6 || self.filtros.relatorio === '6') {
        self.$router.replace('/relatorioDeKmRodadoVeiculoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal);
      } else if (self.filtros.relatorio === 7 || self.filtros.relatorio === '7') {
        self.$router.replace('/relatorioDeKmRodadoFrotaView/' + clienteId + '/' + dataHoraInicial + '/' + dataHoraFinal);
      } else if (self.filtros.relatorio === 100 || self.filtros.relatorio === '100') {
        self.$router.replace('/relatorioDePosicoesNovoView/' + veiculoId + '/' + dataHoraInicial + '/' + dataHoraFinal + '/' + self.filtros.filtroVelocidade + '/' + self.filtros.desprezarVelocidade + '/' + self.filtros.agruparPosicoes);
      }
    }
  }
};

/***/ }),

/***/ "zixC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__ = __webpack_require__("Wlh7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__);
/* harmony namespace reexport (unknown) */ for(var __WEBPACK_IMPORT_KEY__ in __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__) if(__WEBPACK_IMPORT_KEY__ !== 'default') (function(key) { __webpack_require__.d(__webpack_exports__, key, function() { return __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__[key]; }) }(__WEBPACK_IMPORT_KEY__));
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8c4a040_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__ = __webpack_require__("2Rxb");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue___default.a,
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b8c4a040_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_RelatorioTelemetriaViagemPorVeiculoView_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["default"] = (Component.exports);


/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.60699108087b68416d4c.js